import AuthService from '../../business-api/AuthService'

//import HARDCODE from '../HardCode/HardCode'

import {
    moedaPrefixSuffix
} from '../../business-components/Formata/Formata'

import {
    pesquisaList
} from '../../business-rules/List/ListService'

import tipoIdiomaList from '../../business-rules/List/tipoIdiomaList'

const { prefix, suffix } = moedaPrefixSuffix()

const tipoIdioma = AuthService.obterTipoIdioma()

//const aposentadoria = tipoIdioma === HARDCODE.tipoIdiomaPtPt ? 'Reforma' : 'Aposentadoria'

const linhaTipoIdiomaList = pesquisaList(tipoIdiomaList, tipoIdioma)

const indTraducao = linhaTipoIdiomaList.indTraducao

const traduzir = (arrayLabel) => {

    let labelTraduzido = arrayLabel[indTraducao]

    if (!labelTraduzido) {

        labelTraduzido = arrayLabel[0]
    }

    return labelTraduzido
}

const LABEL = {

    a: traduzir([
        /*pt-br*/' a ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    e: traduzir([
        /*pt-br*/' e ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    ou: traduzir([
        /*pt-br*/' ou ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    de: traduzir([
        /*pt-br*/'de',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    ate: traduzir([
        /*pt-br*/' até ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    virgula: traduzir([
        /*pt-br*/', ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    acimaDe: traduzir([
        /*pt-br*/'acima de ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    traco: traduzir([
        /*pt-br*/' - ',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    tracoXtraco: traduzir([
        /*pt-br*/'-x-',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    espaco: traduzir([
        /*pt-br*/'&nbsp',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),



    naoInformar: traduzir([
        /*pt-br*/'Não informar',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    naoInformada: traduzir([
        /*pt-br*/'Não Informada',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),



    login: traduzir([
        /*pt-br*/'Login',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
        cadastreSe: traduzir([
        /*pt-br*/'Cadastre-se',
        /*pt-pt*/'',
        /*en-us*/'Sign up',
        /*es-es*/'Registrarse'
    ]),
    esqueceuSenha: traduzir([
        /*pt-br*/'Esqueceu a senha?',
        /*pt-pt*/'',
        /*en-us*/'Forgot your password?',
        /*es-es*/'Olvidé mi contraseña?'
    ]),
    email: traduzir([
        /*pt-br*/'E-mail',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/'Correo electrónico'
    ]),
    senha: traduzir([
        /*pt-br*/'Senha',
        /*pt-pt*/'',
        /*en-us*/'Password',
        /*es-es*/'Contraseña'
    ]),
    repetirSenha: traduzir([
        /*pt-br*/'Repetir Senha',
        /*pt-pt*/'',
        /*en-us*/'Confirm your Password',
        /*es-es*/'Ingrese su contraseña novamente'
    ]),
    pin: traduzir([
        /*pt-br*/'Informe o PIN',
        /*pt-pt*/'',
        /*en-us*/'Enter the PIN',
        /*es-es*/'Introduce el PIN'
    ]),
    linkEnviarPinEmail: traduzir([
        /*pt-br*/'Enviar PIN por E-mail',
        /*pt-pt*/'',
        /*en-us*/'Send PIN via e-mail',
        /*es-es*/'Enviar PIN por correo electrónico'
    ]),
    linkReenviarPinEmail: traduzir([
        /*pt-br*/'Reenviar PIN por E-mail',
        /*pt-pt*/'',
        /*en-us*/'Resend PIN code via e-mail',
        /*es-es*/'Reenviar PIN por correo electrónico'
    ]),



    home: traduzir([
        /*pt-br*/'Home',
        /*pt-pt*/'Início',
        /*en-us*/'Home',
        /*es-es*/'Inicio'
    ]),
    configuracao: traduzir([
        /*pt-br*/'Configuração',
        /*pt-pt*/'Configuração',
        /*en-us*/'Settings',
        /*es-es*/'Configuración'
    ]),
    sair: traduzir([
        /*pt-br*/'Sair',
        /*pt-pt*/'Sair',
        /*en-us*/'Exit',
        /*es-es*/'Salir'
    ]),



    dashboard: traduzir([
        /*pt-br*/'Dashboard',
        /*pt-pt*/'Dashboard',
        /*en-us*/'Dashboard',
        /*es-es*/'Panel de Control'
    ]),
    dashboardCliente: traduzir([
        /*pt-br*/'Dashboard: Clientes',
        /*pt-pt*/'Dashboard: Clientes',
        /*en-us*/'Dashboard: Clients',
        /*es-es*/'Panel de Control: Clientes'
    ]),
    agenda: traduzir([
        /*pt-br*/'Agenda',
        /*pt-pt*/'Agenda',
        /*en-us*/'Schedule',
        /*es-es*/'Agenda'
    ]),
    //cliqueParaVisualizarAtividadesAgenda: traduzir([
    //    /*pt-br*/'Clique para visualizar os clientes com atividades agendadas',
    //    /*pt-pt*/'Clique para visualizar os clientes com atividades agendadas',
    //    /*en-us*/'Click to view clients with scheduled activities',
    //    /*es-es*/'Haga clic para ver clientes con actividades programadas'
    //]),
    pendenciasComDataPrevista: traduzir([
        /*pt-br*/'Pendências c/Data Prevista',
        /*pt-pt*/'Pendências c/Data Prevista',
        /*en-us*/'Pending Items with Expected Date',
        /*es-es*/'Pendencias con Fecha Prevista'
    ]),
    //cliqueParaVisualizarPendenciasComDataPrevista: traduzir([
    //    /*pt-br*/'Clique para visualizar os clientes com pendências que tem data prevista',
    //    /*pt-pt*/'Clique para visualizar os clientes com pendências que têm data prevista',
    //    /*en-us*/'Click to view clients with pending items that have an expected date',
    //    /*es-es*/'Haga clic para ver clientes con pendencias que tienen fecha prevista'
    //]),
    aniversario: traduzir([
        /*pt-br*/'Aniversário',
        /*pt-pt*/'Aniversário',
        /*en-us*/'Birthday',
        /*es-es*/'Cumpleaños'
    ]),
    //cliqueParaVisualizarAniversariantes: traduzir([
    //    /*pt-br*/'Clique para visualizar os clientes e familiares aniversariantes',
    //    /*pt-pt*/'Clique para visualizar os clientes e familiares aniversariantes',
    //    /*en-us*/'Click to view clients and family members with birthdays',
    //    /*es-es*/'Haga clic para ver clientes y familiares que cumplen años'
    //]),
    aniversarioPlanejFinanceiro: traduzir([
        /*pt-br*/'Aniversário Planej.Financeiro',
        /*pt-pt*/'Agenda',
        /*en-us*/'Schedule',
        /*es-es*/'Agenda'
    ]),
    planejFinanceiroEmAtraso: traduzir([
        /*pt-br*/'Planej.Financeiro Em Atraso',
        /*pt-pt*/'Agenda',
        /*en-us*/'Schedule',
        /*es-es*/'Agenda'
    ]),
    clientesComPrevidenciaPrivada: traduzir([
        /*pt-br*/'Clientes com Previdência',
        /*pt-pt*/'Clientes com Previdência',
        /*en-us*/'Clients with Pension Plans',
        /*es-es*/'Clientes con Plan de Pensiones'
    ]),

    dashboardFamilia: traduzir([
        /*pt-br*/'Dashboard: Familiares',
        /*pt-pt*/'Dashboard: Familiares',
        /*en-us*/'Dashboard: Family Members',
        /*es-es*/'Panel de Control: Familiares'
    ]),

    dashboardFunilEtapa: traduzir([
        /*pt-br*/'Dashboard: Funis/Etapas',
        /*pt-pt*/'Dashboard: Funis/Etapas',
        /*en-us*/'Dashboard: Funnels/Stages',
        /*es-es*/'Panel de Control: Embudos/Etapas'
    ]),
    etapas: traduzir([
        /*pt-br*/'Etapas',
        /*pt-pt*/'Etapas',
        /*en-us*/'Stages',
        /*es-es*/'Etapas'
    ]),
    funisEtapas: traduzir([
        /*pt-br*/'Funis e Etapas',
        /*pt-pt*/'Funis e Etapas',
        /*en-us*/'Funnels and Stages',
        /*es-es*/'Embudos y Etapas'
    ]),

    dashboardPendencia: traduzir([
        /*pt-br*/'Dashboard: Pendências',
        /*pt-pt*/'Dashboard: Pendências',
        /*en-us*/'Dashboard: Pending Items',
        /*es-es*/'Panel de Control: Pendencias'
    ]),

    dashboardConsorcio: traduzir([
        /*pt-br*/'Dashboard: Consórcios',
        /*pt-pt*/'Dashboard: Consórcios',
        /*en-us*/'Dashboard: Consortiums',
        /*es-es*/'Panel de Control: Consorcios'
    ]),
    consorcios: traduzir([
        /*pt-br*/'Consórcios',
        /*pt-pt*/'Consórcios',
        /*en-us*/'Consortiums',
        /*es-es*/'Consorcios'
    ]),
    consorciosPorAdministradoraConsorcio: traduzir([
        /*pt-br*/'Consórcios por Administradora',
        /*pt-pt*/'Consórcios por Administradora',
        /*en-us*/'Consortiums by Administrator',
        /*es-es*/'Consorcios por Administradora'
    ]),
    consorciosPorTipoConsorcio: traduzir([
        /*pt-br*/'Consórcios por Tipo',
        /*pt-pt*/'Consórcios por Tipo',
        /*en-us*/'Consortiums by Type',
        /*es-es*/'Consorcios por Tipo'
    ]),
    consorciosPorStatusGrupoConsorcio: traduzir([
        /*pt-br*/'Consórcios por Status Grupo',
        /*pt-pt*/'Consórcios por Status Grupo',
        /*en-us*/'Consortiums by Group Status',
        /*es-es*/'Consorcios por Estado del Grupo'
    ]),
    consorciosPorFormaPagtoConsorcio: traduzir([
        /*pt-br*/'Consórcios por Forma Pagto.',
        /*pt-pt*/'Consórcios por Forma Pagto.',
        /*en-us*/'Consortiums by Payment Method',
        /*es-es*/'Consorcios por Forma de Pago'
    ]),
    consorciosPorCidade: traduzir([
        /*pt-br*/'Consórcios por Cidade',
        /*pt-pt*/'Consórcios por Cidade',
        /*en-us*/'Consortiums by City',
        /*es-es*/'Consorcios por Ciudad'
    ]),

    dashboardProjetoVidaSonho: traduzir([
        /*pt-br*/'Dashboard: Projetos de Vida/Sonho',
        /*pt-pt*/'Dashboard: Projetos de Vida/Sonho',
        /*en-us*/'Dashboard: Life Projects/Dreams',
        /*es-es*/'Panel de Control: Proyectos de Vida/Sueño'
    ]),

    dashboardPatrimonioImobilizado: traduzir([
        /*pt-br*/'Dashboard: PatrimonioImobilizado',
        /*pt-pt*/'Dashboard: Património Imobilizado',
        /*en-us*/'Dashboard: Fixed Assets',
        /*es-es*/'Dashboard: Inmovilizado'
    ]),

    dashboardRecursosFinanceiros: traduzir([
        /*pt-br*/'Dashboard: Recursos Financeiros',
        /*pt-pt*/'Dashboard: Recursos Financeiros',
        /*en-us*/'Dashboard: Financial Resources',
        /*es-es*/'Panel de Control: Recursos Financieros'
    ]),

    dashboardProposta: traduzir([
        /*pt-br*/'Dashboard: Propostas',
        /*pt-pt*/'Dashboard: Propostas',
        /*en-us*/'Dashboard: Proposals',
        /*es-es*/'Panel de Control: Propuestas'
    ]),
    dataAssinaturaInicial: traduzir([
        /*pt-br*/'Data Assinatura Inicial',
        /*pt-pt*/'Data Assinatura Inicial',
        /*en-us*/'Initial Signature Date',
        /*es-es*/'Fecha Firma Inicial'
    ]),
    dataAssinaturaFinal: traduzir([
        /*pt-br*/'Data Assinatura Final',
        /*pt-pt*/'Data Assinatura Final',
        /*en-us*/'Final Signature Date',
        /*es-es*/'Fecha Firma Final'
    ]),
    dataUltimaAlteracaoInicial: traduzir([
        /*pt-br*/'Data Ultima Alteração Inicial',
        /*pt-pt*/'Data Última Alteração Inicial',
        /*en-us*/'Initial Last Change Date',
        /*es-es*/'Fecha Último Cambio Inicial'
    ]),
    dataUltimaAlteracaoFinal: traduzir([
        /*pt-br*/'Data Ultima Alteração Final',
        /*pt-pt*/'Data Última Alteração Final',
        /*en-us*/'Final Last Change Date',
        /*es-es*/'Fecha Último Cambio Final'
    ]),
    propostasPorMes: traduzir([
        /*pt-br*/'Propostas por Mês',
        /*pt-pt*/'Propostas por Mês',
        /*en-us*/'Proposals by Month',
        /*es-es*/'Propuestas por Mes'
    ]),
    propostasPorGestorLider: traduzir([
        /*pt-br*/'Propostas por Gestor/Líder',
        /*pt-pt*/'Propostas por Gestor/Líder',
        /*en-us*/'Proposals by Manager/Leader',
        /*es-es*/'Propuestas por Gestor/Líder'
    ]),
    propostasPorUsuario: traduzir([
        /*pt-br*/'Propostas por Usuário',
        /*pt-pt*/'Propostas por Utilizador',
        /*en-us*/'Proposals by User',
        /*es-es*/'Propuestas por Usuario'
    ]),
    propostasPorSeguradora: traduzir([
        /*pt-br*/'Propostas por Seguradora',
        /*pt-pt*/'Propostas por Seguradora',
        /*en-us*/'Proposals by Insurance Company',
        /*es-es*/'Propuestas por Aseguradora'
    ]),
    propostasPorPeriodicidadePagto: traduzir([
        /*pt-br*/'Prop. por Periodic. Pagto.',
        /*pt-pt*/'Prop. por Period. Pagto.',
        /*en-us*/'Proposals by Payment Frequency',
        /*es-es*/'Prop. por Periodic. Pago'
    ]),
    propostasPorFormaPagto: traduzir([
        /*pt-br*/'Propostas por Forma Pagto.',
        /*pt-pt*/'Propostas por Forma Pagto.',
        /*en-us*/'Proposals by Payment Method',
        /*es-es*/'Propuestas por Forma de Pago'
    ]),
    propostasPorStatus: traduzir([
        /*pt-br*/'Propostas por Status',
        /*pt-pt*/'Propostas por Estado',
        /*en-us*/'Proposals by Status',
        /*es-es*/'Propuestas por Estado'
    ]),

    dashboardApolice: traduzir([
        /*pt-br*/'Dashboard: Apólices',
        /*pt-pt*/'Dashboard: Apólices',
        /*en-us*/'Dashboard: Policies',
        /*es-es*/'Panel de Control: Pólizas'
    ]),
    dataEmissaoInicial: traduzir([
        /*pt-br*/'Data Emissão Inicial',
        /*pt-pt*/'Data Emissão Inicial',
        /*en-us*/'Initial Issue Date',
        /*es-es*/'Fecha Emisión Inicial'
    ]),
    dataEmissaoFinal: traduzir([
        /*pt-br*/'Data Emissão Final',
        /*pt-pt*/'Data Emissão Final',
        /*en-us*/'Final Issue Date',
        /*es-es*/'Fecha Emisión Final'
    ]),
    apolicesEmitidasPorMes: traduzir([
        /*pt-br*/'Emissões por Mês',
        /*pt-pt*/'Emissões por Mês',
        /*en-us*/'Issues by Month',
        /*es-es*/'Emisiones por Mes'
    ]),
    apolicesEmitidasPorGestorLider: traduzir([
        /*pt-br*/'Emissões por Gestor/Líder',
        /*pt-pt*/'Emissões por Gestor/Líder',
        /*en-us*/'Issues by Manager/Leader',
        /*es-es*/'Emisiones por Gestor/Líder'
    ]),
    apolicesEmitidasPorUsuario: traduzir([
        /*pt-br*/'Emissões por Usuário',
        /*pt-pt*/'Emissões por Utilizador',
        /*en-us*/'Issues by User',
        /*es-es*/'Emisiones por Usuario'
    ]),
    apolicesEmitidasPorSeguradora: traduzir([
        /*pt-br*/'Emissões por Seguradora',
        /*pt-pt*/'Emissões por Seguradora',
        /*en-us*/'Issues by Insurance Company',
        /*es-es*/'Emisiones por Aseguradora'
    ]),
    apolicesEmitidasPorProfissao: traduzir([
        /*pt-br*/'Emissões por Profissao',
        /*pt-pt*/'Emissões por Profissão',
        /*en-us*/'Issues by Profession',
        /*es-es*/'Emisiones por Profesión'
    ]),
    apolicesEmitidasPorPeriodicidadePagto: traduzir([
        /*pt-br*/'Emissões por Period.Pagto.',
        /*pt-pt*/'Emissões por Period.Pagto.',
        /*en-us*/'Issues by Payment Frequency',
        /*es-es*/'Emisiones por Period.Pago'
    ]),
    apolicesEmitidasPorFormaPagto: traduzir([
        /*pt-br*/'Emissões por Forma Pagto.',
        /*pt-pt*/'Emissões por Forma Pagto.',
        /*en-us*/'Issues by Payment Method',
        /*es-es*/'Emisiones por Forma de Pago'
    ]),
    apolicesEmitidasPorPrazoPagto: traduzir([
        /*pt-br*/'Emissões por Prazo Pagto.',
        /*pt-pt*/'Emissões por Prazo Pagto.',
        /*en-us*/'Issues by Payment Term',
        /*es-es*/'Emisiones por Plazo Pago'
    ]),
    apolicesEmitidasPorDiaVencimento: traduzir([
        /*pt-br*/'Emissões por Dia Vencimento',
        /*pt-pt*/'Emissões por Dia Vencimento',
        /*en-us*/'Issues by Due Day',
        /*es-es*/'Emisiones por Día Vencimiento'
    ]),
    apolicesEmitidasPorCidade: traduzir([
        /*pt-br*/'Emissões por Cidade',
        /*pt-pt*/'Emissões por Cidade',
        /*en-us*/'Issues by City',
        /*es-es*/'Emisiones por Ciudad'
    ]),
    apolicesEmitidasPorSexo: traduzir([
        /*pt-br*/'Emissões por Sexo',
        /*pt-pt*/'Emissões por Sexo',
        /*en-us*/'Issues by Gender',
        /*es-es*/'Emisiones por Sexo'
    ]),
    apolicesEmitidasPorStatusAtual: traduzir([
        /*pt-br*/'Emissões por Status Atual',
        /*pt-pt*/'Emissões por Estado Atual',
        /*en-us*/'Issues by Current Status',
        /*es-es*/'Emisiones por Estado Actual'
    ]),
    apolicesEmitidasPorParentesco: traduzir([
        /*pt-br*/'Emissões por Parentesco',
        /*pt-pt*/'Emissões por Parentesco',
        /*en-us*/'Issues by Relationship',
        /*es-es*/'Emisiones por Parentesco'
    ]),

    dashboardApoliceCobertura: traduzir([
        /*pt-br*/'Dashboard: Cobertura',
        /*pt-pt*/'Dashboard: Cobertura',
        /*en-us*/'Dashboard: Coverage',
        /*es-es*/'Panel de Control: Cobertura'
    ]),
    coberturasPorMes: traduzir([
        /*pt-br*/'Coberturas por Mês',
        /*pt-pt*/'Coberturas por Mês',
        /*en-us*/'Coverages by Month',
        /*es-es*/'Coberturas por Mes'
    ]),
    coberturasPorGestorLider: traduzir([
        /*pt-br*/'Coberturas por Gestor/Líder',
        /*pt-pt*/'Coberturas por Gestor/Líder',
        /*en-us*/'Coverages by Manager/Leader',
        /*es-es*/'Coberturas por Gestor/Líder'
    ]),
    coberturasPorUsuario: traduzir([
        /*pt-br*/'Coberturas por Usuário',
        /*pt-pt*/'Coberturas por Utilizador',
        /*en-us*/'Coverages by User',
        /*es-es*/'Coberturas por Usuario'
    ]),
    coberturasPorSeguradora: traduzir([
        /*pt-br*/'Coberturas por Seguradora',
        /*pt-pt*/'Coberturas por Seguradora',
        /*en-us*/'Coverages by Insurance Company',
        /*es-es*/'Coberturas por Aseguradora'
    ]),
    coberturasPorStatusApolice: traduzir([
        /*pt-br*/'Coberturas por Status Apólice',
        /*pt-pt*/'Coberturas por Estado Apólice',
        /*en-us*/'Coverages by Policy Status',
        /*es-es*/'Coberturas por Estado Póliza'
    ]),
    coberturasPorGrupoCoberturaSeguroVida: traduzir([
        /*pt-br*/'Coberturas por Grupo Cobertura',
        /*pt-pt*/'Coberturas por Grupo de Cobertura',
        /*en-us*/'Coverages by Coverage Group',
        /*es-es*/'Coberturas por Grupo de Cobertura'
    ]),
    coberturasPorTipoCoberturaSeguroVida: traduzir([
        /*pt-br*/'Coberturas por Tipo Cobertura',
        /*pt-pt*/'Coberturas por Tipo de Cobertura',
        /*en-us*/'Coverages by Coverage Type',
        /*es-es*/'Coberturas por Tipo de Cobertura'
    ]),
    coberturasPorPeriodicidadePagto: traduzir([
        /*pt-br*/'Coberturas por Period.Pagto.',
        /*pt-pt*/'Coberturas por Period.Pagto.',
        /*en-us*/'Coverages by Payment Frequency',
        /*es-es*/'Coberturas por Period.Pago'
    ]),
    coberturasPorFormaPagto: traduzir([
        /*pt-br*/'Coberturas por Forma Pagto.',
        /*pt-pt*/'Coberturas por Forma Pagto.',
        /*en-us*/'Coverages by Payment Method',
        /*es-es*/'Coberturas por Forma de Pago'
    ]),

    dashboardApoliceCobranca: traduzir([
        /*pt-br*/'Dashboard: Cobrança',
        /*pt-pt*/'Dashboard: Cobrança',
        /*en-us*/'Dashboard: Collection',
        /*es-es*/'Panel de Control: Cobranza'
    ]),
    parcelas: traduzir([
        /*pt-br*/'Parcelas',
        /*pt-pt*/'Prestações',
        /*en-us*/'Installments',
        /*es-es*/'Cuotas'
    ]),
    parcelasPagas: traduzir([
        /*pt-br*/'Parcelas Pagas',
        /*pt-pt*/'Prestações Pagas',
        /*en-us*/'Paid Installments',
        /*es-es*/'Cuotas Pagadas'
    ]),
    parcelasEmAberto: traduzir([
        /*pt-br*/'Parcelas em Aberto',
        /*pt-pt*/'Prestações em Aberto',
        /*en-us*/'Outstanding Installments',
        /*es-es*/'Cuotas Pendientes'
    ]),
    parcelasPorGestorLider: traduzir([
        /*pt-br*/'Parcelas por Gestor/Líder',
        /*pt-pt*/'Prestações por Gestor/Líder',
        /*en-us*/'Installments by Manager/Leader',
        /*es-es*/'Cuotas por Gestor/Líder'
    ]),
    parcelasPorUsuario: traduzir([
        /*pt-br*/'Parcelas por Usuário',
        /*pt-pt*/'Prestações por Utilizador',
        /*en-us*/'Installments by User',
        /*es-es*/'Cuotas por Usuario'
    ]),
    parcelasPorSeguradora: traduzir([
        /*pt-br*/'Parcelas por Seguradora',
        /*pt-pt*/'Prestações por Seguradora',
        /*en-us*/'Installments by Insurance Company',
        /*es-es*/'Cuotas por Aseguradora'
    ]),
    parcelasPorBanco: traduzir([
        /*pt-br*/'Parcelas por Banco',
        /*pt-pt*/'Prestações por Banco',
        /*en-us*/'Installments by Bank',
        /*es-es*/'Cuotas por Banco'
    ]),
    parcelasPorDiaVencimento: traduzir([
        /*pt-br*/'Parcelas por Dia de Vencto.',
        /*pt-pt*/'Prestações por Dia de Vencto.',
        /*en-us*/'Installments by Due Day',
        /*es-es*/'Cuotas por Día de Venc.'
    ]),
    parcelasPorStatus: traduzir([
        /*pt-br*/'Parcelas por Status',
        /*pt-pt*/'Prestações por Estado',
        /*en-us*/'Installments by Status',
        /*es-es*/'Cuotas por Estado'
    ]),
    parcelasPorPeriodicidadePagto: traduzir([
        /*pt-br*/'Parcelas por Periodic. Pagto.',
        /*pt-pt*/'Prestações por Period. Pagto.',
        /*en-us*/'Installments by Payment Frequency',
        /*es-es*/'Cuotas por Periodic. Pago'
    ]),

    dashboardApoliceComissao: traduzir([
        /*pt-br*/'Dashboard: Comissão',
        /*pt-pt*/'Dashboard: Comissão',
        /*en-us*/'Dashboard: Commission',
        /*es-es*/'Panel de Control: Comisión'
    ]),
    comissoesPorMes: traduzir([
        /*pt-br*/'Comissões por Mês',
        /*pt-pt*/'Comissões por Mês',
        /*en-us*/'Commissions by Month',
        /*es-es*/'Comisiones por Mes'
    ]),
    comissoesPorGestorLider: traduzir([
        /*pt-br*/'Comissões por Gestor/Líder',
        /*pt-pt*/'Comissões por Gestor/Líder',
        /*en-us*/'Commissions by Manager/Leader',
        /*es-es*/'Comisiones por Gestor/Líder'
    ]),
    comissoesPorUsuario: traduzir([
        /*pt-br*/'Comissões por Usuário',
        /*pt-pt*/'Comissões por Utilizador',
        /*en-us*/'Commissions by User',
        /*es-es*/'Comisiones por Usuario'
    ]),
    comissoesPorSeguradora: traduzir([
        /*pt-br*/'Comissões por Seguradora',
        /*pt-pt*/'Comissões por Seguradora',
        /*en-us*/'Commissions by Insurance Company',
        /*es-es*/'Comisiones por Aseguradora'
    ]),
    comissoesPorPeriodicidadePagto: traduzir([
        /*pt-br*/'Comissões por Period.Pagto.',
        /*pt-pt*/'Comissões por Period.Pagto.',
        /*en-us*/'Commissions by Payment Frequency',
        /*es-es*/'Comisiones por Period.Pago'
    ]),
    comissoesPorFormaPagto: traduzir([
        /*pt-br*/'Comissões por Forma Pagto.',
        /*pt-pt*/'Comissões por Forma Pagto.',
        /*en-us*/'Commissions by Payment Method',
        /*es-es*/'Comisiones por Forma de Pago'
    ]),

    dashboardUsuarioEstatistica: traduzir([
        /*pt-br*/'Dashboard: Usuários',
        /*pt-pt*/'Painel: Utilizadores',
        /*en-us*/'Dashboard: Users',
        /*es-es*/'Panel de control: Usuarios'
    ]),
    usuarios: traduzir([
        /*pt-br*/'Usuários',
        /*pt-pt*/'Utilizadores',
        /*en-us*/'Users',
        /*es-es*/'Usuarios'
    ]),
    usuariosAssinantes: traduzir([
        /*pt-br*/'Usuários Assinantes',
        /*pt-pt*/'Utilizadores Assinantes',
        /*en-us*/'Subscribed Users',
        /*es-es*/'Usuarios Suscriptores'
    ]),
    usuariosPorPerfil: traduzir([
        /*pt-br*/'Usuários por Perfil',
        /*pt-pt*/'Utilizadores por Perfil',
        /*en-us*/'Users by Profile',
        /*es-es*/'Usuarios por Perfil'
    ]),
    usuariosPorTipoLicenca: traduzir([
        /*pt-br*/'Usuários por Tipo Licença',
        /*pt-pt*/'Utilizadores por Tipo de Licença',
        /*en-us*/'Users by License Type',
        /*es-es*/'Usuarios por Tipo de Licencia'
    ]),
    usuariosPorCidade: traduzir([
        /*pt-br*/'Usuários por Cidade',
        /*pt-pt*/'Utilizadores por Cidade',
        /*en-us*/'Users by City',
        /*es-es*/'Usuarios por Ciudad'
    ]),
    usuariosPorUf: traduzir([
        /*pt-br*/'Usuários por UF',
        /*pt-pt*/'Utilizadores por Distrito',
        /*en-us*/'Users by State',
        /*es-es*/'Usuarios por Estado'
    ]),
    usuariosPorGrupo: traduzir([
        /*pt-br*/'Usuários por Grupo',
        /*pt-pt*/'Utilizadores por Grupo',
        /*en-us*/'Users by Group',
        /*es-es*/'Usuarios por Grupo'
    ]),
    usuariosPorSubgrupo: traduzir([
        /*pt-br*/'Usuários por Subrupo',
        /*pt-pt*/'Utilizadores por Subgrupo',
        /*en-us*/'Users by Subgroup',
        /*es-es*/'Usuarios por Subgrupo'
    ]),
    usuariosPorResponsavelPersistencia: traduzir([
        /*pt-br*/'Usuários por Resp.Persistência',
        /*pt-pt*/'Utilizadores por Resp. pela Persistência',
        /*en-us*/'Users by Persistence Responsible',
        /*es-es*/'Usuarios por Resp. de Persistencia'
    ]),
    usuariosAtivos: traduzir([
        /*pt-br*/'Usuários Ativos',
        /*pt-pt*/'Utilizadores Ativos',
        /*en-us*/'Active Users',
        /*es-es*/'Usuarios Activos'
    ]),

    dashboardClienteAgente: traduzir([
        /*pt-br*/'Dashboard: Clientes x Agentes',
        /*pt-pt*/'Dashboard: Clientes x Agentes',
        /*en-us*/'Dashboard: Clients x Agents',
        /*es-es*/'Panel de Control: Clientes x Agentes'
    ]),
    clientesAgentes: traduzir([
        /*pt-br*/'Clientes x Agentes',
        /*pt-pt*/'Clientes x Agentes',
        /*en-us*/'Clients x Agents',
        /*es-es*/'Clientes x Agentes'
    ]),
    clientesAgentesPorGestorLider: traduzir([
        /*pt-br*/'Clientes por Gestor/Líder',
        /*pt-pt*/'Clientes por Gestor/Líder',
        /*en-us*/'Clients by Manager/Leader',
        /*es-es*/'Clientes por Gestor/Líder'
    ]),
    clientesAgentesPorUsuario: traduzir([
        /*pt-br*/'Clientes por Usuário',
        /*pt-pt*/'Clientes por Utilizador',
        /*en-us*/'Clients by User',
        /*es-es*/'Clientes por Usuario'
    ]),
    clientesAgentesPorInstituicaoFinanceira: traduzir([
        /*pt-br*/'Clientes por Inst.Financeira',
        /*pt-pt*/'Clientes por Inst.Financeira',
        /*en-us*/'Clients by Financial Institution',
        /*es-es*/'Clientes por Inst.Financiera'
    ]),
    clientesAgentesPorStatus: traduzir([
        /*pt-br*/'Clientes por Status',
        /*pt-pt*/'Clientes por Estado',
        /*en-us*/'Clients by Status',
        /*es-es*/'Clientes por Estado'
    ]),

    dashboardAporte: traduzir([
        /*pt-br*/'Dashboard: Aportes',
        /*pt-pt*/'Dashboard: Contribuições',
        /*en-us*/'Dashboard: Contributions',
        /*es-es*/'Panel de Control: Aportes'
    ]),
    aporte: traduzir([
        /*pt-br*/'Aporte',
        /*pt-pt*/'Contribuição',
        /*en-us*/'Contribution',
        /*es-es*/'Aporte'
    ]),
    aportes: traduzir([
        /*pt-br*/'Aportes',
        /*pt-pt*/'Contribuições',
        /*en-us*/'Contributions',
        /*es-es*/'Aportes'
    ]),
    cliqueParaVisualizarAportesPrevistos: traduzir([
        /*pt-br*/'Clique para visualizar os clientes com aportes previstos',
        /*pt-pt*/'Clique para visualizar os clientes com contribuições previstas',
        /*en-us*/'Click to view clients with expected contributions',
        /*es-es*/'Haga clic para ver clientes con aportes previstos'
    ]),
    dataInicial: traduzir([
        /*pt-br*/'Data Inicial',
        /*pt-pt*/'Data Inicial',
        /*en-us*/'Start Date',
        /*es-es*/'Fecha Inicial'
    ]),
    dataFinal: traduzir([
        /*pt-br*/'Data Final',
        /*pt-pt*/'Data Final',
        /*en-us*/'End Date',
        /*es-es*/'Fecha Final'
    ]),
    aportesTotalPeriodo: traduzir([
        /*pt-br*/'Aportes: Total do Período',
        /*pt-pt*/'Contribuições: Total do Período',
        /*en-us*/'Contributions: Period Total',
        /*es-es*/'Aportes: Total del Período'
    ]),
    aportesDiarios: traduzir([
        /*pt-br*/'Aportes Diários',
        /*pt-pt*/'Contribuições Diárias',
        /*en-us*/'Daily Contributions',
        /*es-es*/'Aportes Diarios'
    ]),
    cliqueParaEditarAportesDia: traduzir([
        /*pt-br*/'Clique para editar os aportes do dia',
        /*pt-pt*/'Clique para editar as contribuições do dia',
        /*en-us*/'Click to edit the day contributions',
        /*es-es*/'Haga clic para editar los aportes del día'
    ]),
    previsto: traduzir([
        /*pt-br*/'Previsto',
        /*pt-pt*/'Previsto',
        /*en-us*/'Expected',
        /*es-es*/'Previsto'
    ]),
    realizado: traduzir([
        /*pt-br*/'Realizado',
        /*pt-pt*/'Realizado',
        /*en-us*/'Completed',
        /*es-es*/'Realizado'
    ]),
    pendente: traduzir([
        /*pt-br*/'Pendente',
        /*pt-pt*/'Pendente',
        /*en-us*/'Pending',
        /*es-es*/'Pendiente'
    ]),
    clientes: traduzir([
        /*pt-br*/'Clientes',
        /*pt-pt*/'Clientes',
        /*en-us*/'Clients',
        /*es-es*/'Clientes'
    ]),

    pageAgenda: traduzir([
        /*pt-br*/'Agenda',
        /*pt-pt*/'Agenda',
        /*en-us*/'Schedule',
        /*es-es*/'Agenda'
    ]),
    pageClienteList: traduzir([
        /*pt-br*/'Clientes',
        /*pt-pt*/'Clientes',
        /*en-us*/'Clients',
        /*es-es*/'Clientes'
    ]),
    pageAporteList: traduzir([
        /*pt-br*/'Aportes',
        /*pt-pt*/'Contribuições',
        /*en-us*/'Contributions',
        /*es-es*/'Aportes'
    ]),
    pageClienteFormNovoCliente: traduzir([
        /*pt-br*/'Novo Cliente',
        /*pt-pt*/'Novo Cliente',
        /*en-us*/'New Client',
        /*es-es*/'Nuevo Cliente'
    ]),
    pageClienteFormEditarCliente: traduzir([
        /*pt-br*/'Editar Cliente',
        /*pt-pt*/'Editar Cliente',
        /*en-us*/'Edit Client',
        /*es-es*/'Editar Cliente'
    ]),
    pageImportarClienteExcelForm: traduzir([
        /*pt-br*/'Importar um arquivo Excel',
        /*pt-pt*/'Importar um ficheiro Excel',
        /*en-us*/'Import an Excel file',
        /*es-es*/'Importar un archivo Excel'
    ]),
    pageIntegracaoClienteArquivoList: traduzir([
        /*pt-br*/'Integração',
        /*pt-pt*/'Integração',
        /*en-us*/'Integration',
        /*es-es*/'Integración'
    ]),
    pageFintracks: traduzir([
        /*pt-br*/'Fin-tracks',
        /*pt-pt*/'Fin-tracks',
        /*en-us*/'Fin-tracks',
        /*es-es*/'Fin-tracks'
    ]),
    pageConfiguracao: traduzir([
        /*pt-br*/'Configuração',
        /*pt-pt*/'Configuração',
        /*en-us*/'Settings',
        /*es-es*/'Configuración'
    ]),


    totalClientes: traduzir([
        /*pt-br*/'Clientes',
        /*pt-pt*/'Clientes',
        /*en-us*/'Clients',
        /*es-es*/'Clientes'
    ]),
    totalPropostasSeguroVidaMapaPropostas: traduzir([
        /*pt-br*/'Seguro de Vida<br/><u>Mapa de Propostas</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*pt-pt*/'Seguro de Vida<br/><u>Mapa de Propostas</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*en-us*/'Life Insurance<br/><u>Proposals Map</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*es-es*/'Seguro de Vida<br/><u>Mapa de Propuestas</u><br/><br/><b>PA</b> = <b>$valor$<b>'
    ]),
    totalPropostasSeguroVidaPendentesMesAtual2Meses: traduzir([
        /*pt-br*/'Seguro de Vida: Propostas<br/><u>Pendentes Atual + 2 Meses</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*pt-pt*/'Seguro de Vida: Propostas<br/><u>Pendentes Actual + 2 Meses</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*en-us*/'Life Insurance: Proposals<br/><u>Pending Current + 2 Months</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*es-es*/'Seguro de Vida: Propuestas<br/><u>Pendientes Actual + 2 Meses</u><br/><br/><b>PA</b> = <b>$valor$<b>'
    ]),
    totalPropostasSeguroVidaPagasMesAtual: traduzir([
        /*pt-br*/'Seguro de Vida: Propostas<br/><u>Pagas Mês Atual</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*pt-pt*/'Seguro de Vida: Propostas<br/><u>Pagas Mês Actual</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*en-us*/'Life Insurance: Proposals<br/><u>Paid Current Month</u><br/><br/><b>PA</b> = <b>$valor$<b>',
        /*es-es*/'Seguro de Vida: Propuestas<br/><u>Pagadas Mes Actual</u><br/><br/><b>PA</b> = <b>$valor$<b>'
    ]),
    receitaMensalMaiorIgual10000: traduzir([
        /*pt-br*/'Receita Mensal<br/>>= ' + prefix + '10K' + suffix + '<br/><br/><br/>',
        /*pt-pt*/'Receita Mensal<br/>>= ' + prefix + '10K' + suffix + '<br/><br/><br/>',
        /*en-us*/'Monthly Revenue<br/>>= ' + prefix + '10K' + suffix + '<br/><br/><br/>',
        /*es-es*/'Ingresos Mensuales<br/>>= ' + prefix + '10K' + suffix + '<br/><br/><br/>'
    ]),
    patrimonioImobilizadoMaiorIgual1000000: traduzir([
        /*pt-br*/'Patrimônio Imobilizado<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*pt-pt*/'Património Imobilizado<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*en-us*/'Fixed Assets<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*es-es*/'Patrimonio Inmovilizado<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>'
    ]),
    recursosFinanceirosMaiorIgual1000000: traduzir([
        /*pt-br*/'Recursos Financeiros<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*pt-pt*/'Recursos Financeiros<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*en-us*/'Financial Resources<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>',
        /*es-es*/'Recursos Financieros<br/>>= ' + prefix + '1M' + suffix + '<br/><br/><br/>'
    ]),
    cliqueParaEditarCliente: traduzir([
        /*pt-br*/'Clique para editar o cliente',
        /*pt-pt*/'Clique para editar o cliente',
        /*en-us*/'Click to edit the client',
        /*es-es*/'Haga clic para editar el cliente'
    ]),
    qtdeFilhos: traduzir([
        /*pt-br*/'Filhos',
        /*pt-pt*/'Filhos',
        /*en-us*/'Children',
        /*es-es*/'Hijos'
    ]),
    receitaMensalClienteConjuge: traduzir([
        /*pt-br*/'Receita Mensal',
        /*pt-pt*/'Receita Mensal',
        /*en-us*/'Monthly Income',
        /*es-es*/'Ingresos Mensuales'
    ]),
    patrimonioImobilizadoClienteConjuge: traduzir([
        /*pt-br*/'Patrimônio Imobilizado',
        /*pt-pt*/'Património Imobilizado',
        /*en-us*/'Fixed Assets',
        /*es-es*/'Patrimonio Inmovilizado'
    ]),
    recursosFinanceirosClienteConjuge: traduzir([
        /*pt-br*/'Recursos Financeiros',
        /*pt-pt*/'Recursos Financeiros',
        /*en-us*/'Financial Resources',
        /*es-es*/'Recursos Financieros'
    ]),
    previdenciaPrivadaClienteConjuge: traduzir([
        /*pt-br*/'Previdência Privada',
        /*pt-pt*/'Previdência Privada',
        /*en-us*/'Private Pension',
        /*es-es*/'Previsión Privada'
    ]),
    retiradaMensalDepoisAposentarCliente: traduzir([
        /*pt-br*/'Renda Mensal Desejada',
        /*pt-pt*/'Renda Mensal Desejada',
        /*en-us*/'Desired Monthly Income',
        /*es-es*/'Renta Mensual Deseada'
    ]),
    aporteMensalAdicionalConsumirReservaAposentadoria: traduzir([
        /*pt-br*/'Aporte Mensal Consumir Reserva',
        /*pt-pt*/'Contribuição Mensal Consumir Reserva',
        /*en-us*/'Monthly Contribution Consume Reserve',
        /*es-es*/'Aporte Mensual Consumir Reserva'
    ]),
    aporteMensalAdicionalPreservarReservaAposentadoria: traduzir([
        /*pt-br*/'Aporte Mensal Preservar Reserva',
        /*pt-pt*/'Contribuição Mensal Preservar Reserva',
        /*en-us*/'Monthly Contribution Preserve Reserve',
        /*es-es*/'Aporte Mensual Preservar Reserva'
    ]),
    funilEtapa: traduzir([
        /*pt-br*/'Funil/Etapa',
        /*pt-pt*/'Funil/Etapa',
        /*en-us*/'Funnel/Stage',
        /*es-es*/'Embudo/Etapa'
    ]),

    pesquisa: traduzir([
        /*pt-br*/'Pesquisa',
        /*pt-pt*/'Pesquisa',
        /*en-us*/'Search',
        /*es-es*/'Búsqueda'
    ]),
    filtro: traduzir([
        /*pt-br*/'Filtro',
        /*pt-pt*/'Filtro',
        /*en-us*/'Filter',
        /*es-es*/'Filtro'
    ]),

    usuarioDestino: traduzir([
        /*pt-br*/'Usuário Destino',
        /*pt-pt*/'Utilizador Destino',
        /*en-us*/'Destination User',
        /*es-es*/'Usuario Destino'
    ]),

    nomeArquivo: traduzir([
        /*pt-br*/'Nome Arquivo',
        /*pt-pt*/'Nome Ficheiro',
        /*en-us*/'File Name',
        /*es-es*/'Nombre Archivo'
    ]),
    tipoArquivo: traduzir([
        /*pt-br*/'Tipo Arquivo',
        /*pt-pt*/'Tipo Ficheiro',
        /*en-us*/'File Type',
        /*es-es*/'Tipo Archivo'
    ]),
    statusProcessamento: traduzir([
        /*pt-br*/'Status Processamento',
        /*pt-pt*/'Estado Processamento',
        /*en-us*/'Processing Status',
        /*es-es*/'Estado Procesamiento'
    ]),
    registrosProcessados: traduzir([
        /*pt-br*/'Registros Processados',
        /*pt-pt*/'Registos Processados',
        /*en-us*/'Processed Records',
        /*es-es*/'Registros Procesados'
    ]),
    errosProcessamento: traduzir([
        /*pt-br*/'Erros Processamento',
        /*pt-pt*/'Erros Processamento',
        /*en-us*/'Processing Errors',
        /*es-es*/'Errores Procesamiento'
    ]),
    dataHoraStatusProcessamento: traduzir([
        /*pt-br*/'Data/Hora Status Processamento',
        /*pt-pt*/'Data/Hora Estado Processamento',
        /*en-us*/'Date/Time Processing Status',
        /*es-es*/'Fecha/Hora Estado Procesamiento'
    ]),
    arquivo: traduzir([
        /*pt-br*/'Arquivo',
        /*pt-pt*/'Ficheiro',
        /*en-us*/'File',
        /*es-es*/'Archivo'
    ]),
    arquivos: traduzir([
        /*pt-br*/'Arquivos',
        /*pt-pt*/'Ficheiros',
        /*en-us*/'Files',
        /*es-es*/'Archivos'
    ]),
    retornarParaCliente: traduzir([
        /*pt-br*/'Retornar para o Cliente:',
        /*pt-pt*/'Regressar para o Cliente:',
        /*en-us*/'Return to Client:',
        /*es-es*/'Volver al Cliente:'
    ]),

    apolices: traduzir([
        /*pt-br*/'Apólices',
        /*pt-pt*/'Apólices',
        /*en-us*/'Policies',
        /*es-es*/'Pólizas'
    ]),
    pageApoliceList: traduzir([
        /*pt-br*/'Apólices',
        /*pt-pt*/'Apólices',
        /*en-us*/'Policies',
        /*es-es*/'Pólizas'
    ]),
    nomeSegurado: traduzir([
        /*pt-br*/'Nome do Segurado',
        /*pt-pt*/'Nome do Segurado',
        /*en-us*/'Insured Name',
        /*es-es*/'Nombre del Asegurado'
    ]),
    coberturaBasica: traduzir([
        /*pt-br*/'Cobertura Básica',
        /*pt-pt*/'Cobertura Básica',
        /*en-us*/'Basic Coverage',
        /*es-es*/'Cobertura Básica'
    ]),
    inicioVigencia: traduzir([
        /*pt-br*/'Início Vigência',
        /*pt-pt*/'Início Vigência',
        /*en-us*/'Policy Start Date',
        /*es-es*/'Inicio Vigencia'
    ]),
    dataCancelamento: traduzir([
        /*pt-br*/'Data Cancelamento',
        /*pt-pt*/'Data Cancelamento',
        /*en-us*/'Cancellation Date',
        /*es-es*/'Fecha Cancelación'
    ]),
    motivoCancelamento: traduzir([
        /*pt-br*/'Motivo Cancelamento',
        /*pt-pt*/'Motivo Cancelamento',
        /*en-us*/'Cancellation Reason',
        /*es-es*/'Motivo Cancelación'
    ]),
    periodicidadePagamento: traduzir([
        /*pt-br*/'Periodicidade Pagamento',
        /*pt-pt*/'Periodicidade Pagamento',
        /*en-us*/'Payment Frequency',
        /*es-es*/'Periodicidad Pago'
    ]),
    capitalSegurado: traduzir([
        /*pt-br*/'Capital Segurado',
        /*pt-pt*/'Capital Segurado',
        /*en-us*/'Insured Amount',
        /*es-es*/'Capital Asegurado'
    ]),
    vidaInteira: traduzir([
        /*pt-br*/'Vida Inteira',
        /*pt-pt*/'Vida Inteira',
        /*en-us*/'Whole Life',
        /*es-es*/'Vida Entera'
    ]),
    premio: traduzir([
        /*pt-br*/'Prêmio',
        /*pt-pt*/'Prémio',
        /*en-us*/'Premium',
        /*es-es*/'Prima'
    ]),
    status: traduzir([
        /*pt-br*/'Status',
        /*pt-pt*/'Estado',
        /*en-us*/'Status',
        /*es-es*/'Estado'
    ]),
    idCorretorSeguros: traduzir([
        /*pt-br*/'Corretor de Seguros',
        /*pt-pt*/'Corretor de Seguros',
        /*en-us*/'Insurance Broker',
        /*es-es*/'Corredor de Seguros'
    ]),
    codigoAgenteCorretorSeguros: traduzir([
        /*pt-br*/'Código Corretor de Seguros',
        /*pt-pt*/'Código Corretor de Seguros',
        /*en-us*/'Insurance Broker Code',
        /*es-es*/'Código Corredor Seguros'
    ]),
    percDivisaoComissao: traduzir([
        /*pt-br*/'% Divisão Comissão',
        /*pt-pt*/'% Divisão Comissão',
        /*en-us*/'% Commission Split',
        /*es-es*/'% División Comisión'
    ]),
    idCorretorSeguros2: traduzir([
        /*pt-br*/'Corretor de Seguros 2',
        /*pt-pt*/'Corretor de Seguros 2',
        /*en-us*/'Insurance Broker 2',
        /*es-es*/'Corredor Seguros 2'
    ]),
    codigoAgenteCorretorSeguros2: traduzir([
        /*pt-br*/'Código Corretor de Seguros 2',
        /*pt-pt*/'Código Corretor de Seguros 2',
        /*en-us*/'Insurance Broker Code 2',
        /*es-es*/'Código Corredor Seguros 2'
    ]),
    percDivisaoComissao2: traduzir([
        /*pt-br*/'% Divisão Comissão 2',
        /*pt-pt*/'% Divisão Comissão 2',
        /*en-us*/'% Commission Split 2',
        /*es-es*/'% División Comisión 2'
    ]),
    codigoAgenteAssessorInvestimentos: traduzir([
        /*pt-br*/'Código Assessor de Investimentos',
        /*pt-pt*/'Código Assessor de Investimentos',
        /*en-us*/'Investment Advisor Code',
        /*es-es*/'Código Asesor de Inversiones'
    ]),
    urlApolice: traduzir([
        /*pt-br*/'URL Apólice',
        /*pt-pt*/'URL Apólice',
        /*en-us*/'Policy URL',
        /*es-es*/'URL Póliza'
    ]),

    propostas: traduzir([
        /*pt-br*/'Propostas',
        /*pt-pt*/'Propostas',
        /*en-us*/'Proposals',
        /*es-es*/'Propuestas'
    ]),

    cobrancas: traduzir([
        /*pt-br*/'Cobranças',
        /*pt-pt*/'Cobranças',
        /*en-us*/'Collections',
        /*es-es*/'Cobranzas'
    ]),

    comissoes: traduzir([
        /*pt-br*/'Comissões',
        /*pt-pt*/'Comissões',
        /*en-us*/'Commissions',
        /*es-es*/'Comisiones'
    ]),



    pageVideoList: traduzir([
        /*pt-br*/'Vídeos',
        /*pt-pt*/'Vídeos',
        /*en-us*/'Videos',
        /*es-es*/'Videos'
    ]),
    selecioneVideoDesejado: traduzir([
        /*pt-br*/'Selecione o Vídeo Desejado',
        /*pt-pt*/'Selecione o Vídeo Pretendido',
        /*en-us*/'Select the Desired Video',
        /*es-es*/'Selecciona el Video Deseado'
    ]),
    funcionalidade: traduzir([
        /*pt-br*/'Funcionalidade',
        /*pt-pt*/'Funcionalidade',
        /*en-us*/'Functionality',
        /*es-es*/'Funcionalidad'
    ]),
    casoNegocio: traduzir([
        /*pt-br*/'Caso de Negócio',
        /*pt-pt*/'Caso de Negócio',
        /*en-us*/'Business Case',
        /*es-es*/'Caso de Negocio'
    ]),
    video: traduzir([
        /*pt-br*/'Vídeo',
        /*pt-pt*/'Vídeo',
        /*en-us*/'Video',
        /*es-es*/'Video'
    ]),
    trilhaConhecimento: traduzir([
        /*pt-br*/'Trilha do Conhecimento',
        /*pt-pt*/'Percurso do Conhecimento',
        /*en-us*/'Knowledge Path',
        /*es-es*/'Ruta del Conocimiento'
    ]),

    treinamentos: traduzir([
        /*pt-br*/'Treinamentos',
        /*pt-pt*/'Formações',
        /*en-us*/'Training',
        /*es-es*/'Entrenamientos'
    ]),
    pageTreinamentoList: traduzir([
        /*pt-br*/'Treinamentos',
        /*pt-pt*/'Formações',
        /*en-us*/'Training',
        /*es-es*/'Entrenamientos'
    ]),
    data: traduzir([
        /*pt-br*/'Data',
        /*pt-pt*/'Data',
        /*en-us*/'Date',
        /*es-es*/'Fecha'
    ]),
    horario: traduzir([
        /*pt-br*/'Horário',
        /*pt-pt*/'Horário',
        /*en-us*/'Schedule',
        /*es-es*/'Horario'
    ]),
    linkIncricao: traduzir([
        /*pt-br*/'Link Inscrição',
        /*pt-pt*/'Link de Inscrição',
        /*en-us*/'Registration Link',
        /*es-es*/'Link de Inscripción'
    ]),

    gerarPDF: traduzir([
        /*pt-br*/'Gerar PDF',
        /*pt-pt*/'Gerar PDF',
        /*en-us*/'Generate PDF',
        /*es-es*/'Generar PDF'
    ]),
    gerarPDFGrid: traduzir([
        /*pt-br*/'Gerar a Grid em PDF',
        /*pt-pt*/'Gerar a Tabela em PDF',
        /*en-us*/'Generate Grid to PDF',
        /*es-es*/'Generar la Tabla en PDF'
    ]),
    exportarDadosExcel: traduzir([
        /*pt-br*/'Exportar Dados para Excel',
        /*pt-pt*/'Exportar Dados para Excel',
        /*en-us*/'Export Data to Excel',
        /*es-es*/'Exportar Datos a Excel'
    ]),
    configurarCamposRelatorio: traduzir([
        /*pt-br*/'Configurar os Campos do Relatório',
        /*pt-pt*/'Configurar os Campos do Relatório',
        /*en-us*/'Configure Report Fields',
        /*es-es*/'Configurar los Campos del Informe'
    ]),
    gerarExtratoApolice: traduzir([
        /*pt-br*/'Gerar o Extrato da Apólice em PDF',
        /*pt-pt*/'Gerar o Extracto da Apólice em PDF',
        /*en-us*/'Generate Policy Statement to PDF',
        /*es-es*/'Generar el Extracto de la Póliza en PDF'
    ]),
    extratoApolice: traduzir([
        /*pt-br*/'Extrato da Apólice',
        /*pt-pt*/'Extracto da Apólice',
        /*en-us*/'Policy Statement',
        /*es-es*/'Extracto de la Póliza'
    ]),

    pageDashboardUsuarioEstatistica: traduzir([
        /*pt-br*/'Estatísticas Usuários',
        /*pt-pt*/'Estatísticas dos Utilizadores',
        /*en-us*/'User Statistics',
        /*es-es*/'Estadísticas de Usuarios'
    ]),
    usuarioEstatistica: traduzir([
        /*pt-br*/'Estatísticas Usuários',
        /*pt-pt*/'Estatísticas dos Utilizadores',
        /*en-us*/'User Statistics',
        /*es-es*/'Estadísticas de Usuarios'
    ]),
    dataInicioFreetrack: traduzir([
        /*pt-br*/'Data Início Free-track',
        /*pt-pt*/'Data de Início Free-track',
        /*en-us*/'Free-track Start Date',
        /*es-es*/'Fecha de Inicio Free-track'
    ]),
    turma: traduzir([
        /*pt-br*/'Turma',
        /*pt-pt*/'Turma',
        /*en-us*/'Class',
        /*es-es*/'Clase'
    ]),
    qtdeClientes: traduzir([
        /*pt-br*/'Clientes',
        /*pt-pt*/'Clientes',
        /*en-us*/'Clients',
        /*es-es*/'Clientes'
    ]),
    qtdeTransacoes: traduzir([
        /*pt-br*/'Transações',
        /*pt-pt*/'Transacções',
        /*en-us*/'Transactions',
        /*es-es*/'Transacciones'
    ]),
    qtdeTransacoes30dias: traduzir([
        /*pt-br*/'30 dias',
        /*pt-pt*/'30 dias',
        /*en-us*/'30 days',
        /*es-es*/'30 días'
    ]),
    qtdeTransacoes15dias: traduzir([
        /*pt-br*/'15 dias',
        /*pt-pt*/'15 dias',
        /*en-us*/'15 days',
        /*es-es*/'15 días'
    ]),
    qtdeTransacoes7dias: traduzir([
        /*pt-br*/'7 dias',
        /*pt-pt*/'7 dias',
        /*en-us*/'7 days',
        /*es-es*/'7 días'
    ]),
    qtdeTransacoes3dias: traduzir([
        /*pt-br*/'3 dias',
        /*pt-pt*/'3 dias',
        /*en-us*/'3 days',
        /*es-es*/'3 días'
    ]),
    qtdeTransacoes2dias: traduzir([
        /*pt-br*/'2 dias',
        /*pt-pt*/'2 dias',
        /*en-us*/'2 days',
        /*es-es*/'2 días'
    ]),
    qtdeTransacoes1dia: traduzir([
        /*pt-br*/'1 dia',
        /*pt-pt*/'1 dia',
        /*en-us*/'1 day',
        /*es-es*/'1 día'
    ]),
    qtdeTransacoesHoje: traduzir([
        /*pt-br*/'Hoje',
        /*pt-pt*/'Hoje',
        /*en-us*/'Today',
        /*es-es*/'Hoy'
    ]),
    dataHoraUltimoAcesso: traduzir([
        /*pt-br*/'Data/Hora Último Acesso',
        /*pt-pt*/'Data/Hora do Último Acesso',
        /*en-us*/'Date/Time of Last Access',
        /*es-es*/'Fecha/Hora del Último Acceso'
    ]),
    diasUltimoAcesso: traduzir([
        /*pt-br*/'Dias Último Acesso',
        /*pt-pt*/'Dias desde o Último Acesso',
        /*en-us*/'Days Since Last Access',
        /*es-es*/'Días desde el Último Acceso'
    ]),
    dataInicioCobranca: traduzir([
        /*pt-br*/'Data Início Cobrança',
        /*pt-pt*/'Data de Início de Cobrança',
        /*en-us*/'Billing Start Date',
        /*es-es*/'Fecha de Inicio de Facturación'
    ]),
    dataUltimaCobrancaAte: traduzir([
        /*pt-br*/'Data Última Cobrança Até',
        /*pt-pt*/'Data da Última Cobrança Até',
        /*en-us*/'Last Billing Date Until',
        /*es-es*/'Fecha Última Facturación Hasta'
    ]),
    dataPrecoModuloBaseAtual: traduzir([
        /*pt-br*/'Data Preço Módulo Base Atual',
        /*pt-pt*/'Data do Preço do Módulo Base Actual',
        /*en-us*/'Current Base Module Price Date',
        /*es-es*/'Fecha Precio Módulo Base Actual'
    ]),
    precoModuloBaseAtual: traduzir([
        /*pt-br*/'Preço Módulo Base Atual',
        /*pt-pt*/'Preço do Módulo Base Actual',
        /*en-us*/'Current Base Module Price',
        /*es-es*/'Precio Módulo Base Actual'
    ]),

    pageEquipeList: traduzir([
        /*pt-br*/'Equipe',
        /*pt-pt*/'Equipa',
        /*en-us*/'Team',
        /*es-es*/'Equipo'
    ]),

    razaoSocial: traduzir([
        /*pt-br*/'Razão Social',
        /*pt-pt*/'Denominação Social',
        /*en-us*/'Corporate Name',
        /*es-es*/'Razón Social'
    ]),
    nomeFantasia: traduzir([
        /*pt-br*/'Nome Fantasia',
        /*pt-pt*/'Nome Comercial',
        /*en-us*/'Trade Name',
        /*es-es*/'Nombre Comercial'
    ]),
    cnpj: traduzir([
        /*pt-br*/'CNPJ',
        /*pt-pt*/'NIPC',
        /*en-us*/'Tax ID',
        /*es-es*/'NIF'
    ]),
    cnpjEmpresa: traduzir([
        /*pt-br*/'CNPJ Empresa',
        /*pt-pt*/'NIPC da Empresa',
        /*en-us*/'Company Tax ID',
        /*es-es*/'NIF de la Empresa'
    ]),
    cnpjConversao: traduzir([
        /*pt-br*/'CNPJ Conversão',
        /*pt-pt*/'NIPC de Conversão',
        /*en-us*/'Conversion Tax ID',
        /*es-es*/'NIF de Conversión'
    ]),
    processoSeguradora: traduzir([
        /*pt-br*/'Processo Seguradora',
        /*pt-pt*/'Processo da Seguradora',
        /*en-us*/'Insurance Case',
        /*es-es*/'Expediente de la Aseguradora'
    ]),
    inscricaoEstadual: traduzir([
        /*pt-br*/'Inscrição Estadual',
        /*pt-pt*/'Número de Contribuinte',
        /*en-us*/'State Registration',
        /*es-es*/'Inscripción Estatal'
    ]),
    numeroSusep: traduzir([
        /*pt-br*/'SUSEP',
        /*pt-pt*/'ASF',
        /*en-us*/'SUSEP',
        /*es-es*/'DGSFP'
    ]),
    site: traduzir([
        /*pt-br*/'Site',
        /*pt-pt*/'Website',
        /*en-us*/'Website',
        /*es-es*/'Sitio Web'
    ]),
    linkLogoTopbar: traduzir([
        /*pt-br*/'Link Logo Top Bar (Ex: https://www.seusite.com.br)',
        /*pt-pt*/'Link do logótipo na barra superior (Ex: https://www.seusite.com.pt)',
        /*en-us*/'Top bar logo link (e.g. https://www.yoursite.com)',
        /*es-es*/'Enlace del logotipo en la barra superior (Ej: https://www.tusitio.com)'
    ]),
    possuiMultiplasMarcas: traduzir([
        /*pt-br*/'Possui múltiplas marcas',
        /*pt-pt*/'Possui múltiplas marcas',
        /*en-us*/'Has multiple brands',
        /*es-es*/'Posee múltiples marcas'
    ]),
    permitirUsuarioAlterarWhiteLabel: traduzir([
        /*pt-br*/'Permitir que cada Usuário altere o seu White Label',
        /*pt-pt*/'Permitir que cada Utilizador altere o seu White Label',
        /*en-us*/'Allow each User to change their White Label',
        /*es-es*/'Permitir que cada Usuario cambie su White Label'
    ]),
    grupo: traduzir([
        /*pt-br*/'Grupo',
        /*pt-pt*/'Grupo',
        /*en-us*/'Group',
        /*es-es*/'Grupo'
    ]),
    subgrupo: traduzir([
        /*pt-br*/'Subgrupo',
        /*pt-pt*/'Subgrupo',
        /*en-us*/'Subgroup',
        /*es-es*/'Subgrupo'
    ]),
    responsavelPersistencia: traduzir([
        /*pt-br*/'Responsável Persistência',
        /*pt-pt*/'Responsável pela Persistência',
        /*en-us*/'Persistence Responsible',
        /*es-es*/'Responsable de Persistencia'
    ]),

    tokenIntegracao: traduzir([
        /*pt-br*/'Token Integração',
        /*pt-pt*/'Token de Integração',
        /*en-us*/'Integration Token',
        /*es-es*/'Token de Integración'
    ]),
    token1: traduzir([
        /*pt-br*/'Token 1',
        /*pt-pt*/'Token 1',
        /*en-us*/'Token 1',
        /*es-es*/'Token 1'
    ]),
    token2: traduzir([
        /*pt-br*/'Token 2',
        /*pt-pt*/'Token 2',
        /*en-us*/'Token 2',
        /*es-es*/'Token 2'
    ]),

    usuario: traduzir([
        /*pt-br*/'Usuário',
        /*pt-pt*/'Utilizador',
        /*en-us*/'User',
        /*es-es*/'Usuario'
    ]),
    nenhumUsuarioFoiSelecionado: traduzir([
        /*pt-br*/'Nenhum usuário foi selecionado',
        /*pt-pt*/'Nenhum utilizador foi selecionado',
        /*en-us*/'No user was selected',
        /*es-es*/'Ningún usuario fue seleccionado'
    ]),
    equipe: traduzir([
        /*pt-br*/'Equipe',
        /*pt-pt*/'Equipa',
        /*en-us*/'Team',
        /*es-es*/'Equipo'
    ]),

    perfil: traduzir([
        /*pt-br*/'Perfil',
        /*pt-pt*/'Perfil',
        /*en-us*/'Profile',
        /*es-es*/'Perfil'
    ]),
    tipoLicenca: traduzir([
        /*pt-br*/'Tipo de Licença',
        /*pt-pt*/'Tipo de Licença',
        /*en-us*/'License Type',
        /*es-es*/'Tipo de Licencia'
    ]),
    gestorLider: traduzir([
        /*pt-br*/'Gestor / Líder',
        /*pt-pt*/'Gestor / Líder',
        /*en-us*/'Manager / Leader',
        /*es-es*/'Gestor / Líder'
    ]),
    whiteLabel: traduzir([
        /*pt-br*/'White Label',
        /*pt-pt*/'White Label',
        /*en-us*/'White Label',
        /*es-es*/'White Label'
    ]),
    ativo: traduzir([
        /*pt-br*/'Ativo',
        /*pt-pt*/'Activo',
        /*en-us*/'Active',
        /*es-es*/'Activo'
    ]),
    dataInativacaoUsuario: traduzir([
        /*pt-br*/'Data Inativação',
        /*pt-pt*/'Data de Inativação',
        /*en-us*/'Deactivation Date',
        /*es-es*/'Fecha de desactivación'
    ]),
    nome: traduzir([
        /*pt-br*/'Nome',
        /*pt-pt*/'Nome',
        /*en-us*/'Name',
        /*es-es*/'Nombre'
    ]),
    telefone: traduzir([
        /*pt-br*/'Telefone',
        /*pt-pt*/'Telefone',
        /*en-us*/'Phone',
        /*es-es*/'Teléfono'
    ]),
    celular: traduzir([
        /*pt-br*/'Celular',
        /*pt-pt*/'Telemóvel',
        /*en-us*/'Mobile',
        /*es-es*/'Móvil'
    ]),
    profissaoQualificacao: traduzir([
        /*pt-br*/'Profissão/Qualificação',
        /*pt-pt*/'Profissão/Qualificação',
        /*en-us*/'Profession/Qualification',
        /*es-es*/'Profesión/Cualificación'
    ]),
    codigoAgente: traduzir([
        /*pt-br*/'Código Agente',
        /*pt-pt*/'Código do Agente',
        /*en-us*/'Agent Code',
        /*es-es*/'Código del Agente'
    ]),
    utilizarEstudoCompleto: traduzir([
        /*pt-br*/'Utilizar Estudo Completo',
        /*pt-pt*/'Utilizar Estudo Completo',
        /*en-us*/'Use Complete Study',
        /*es-es*/'Utilizar Estudio Completo'
    ]),
    permitirInformarRiscos: traduzir([
        /*pt-br*/'Permitir informar os Riscos',
        /*pt-pt*/'Permitir informar os Riscos',
        /*en-us*/'Allow Risk Information',
        /*es-es*/'Permitir informar los Riesgos'
    ]),
    utilizarSimulacaoFinanceiraEstudo: traduzir([
        /*pt-br*/'Utilizar Simulação Financeira no Estudo',
        /*pt-pt*/'Utilizar Simulação Financeira no Estudo',
        /*en-us*/'Use Financial Simulation in Study',
        /*es-es*/'Utilizar Simulación Financiera en el Estudio'
    ]),
    gerandoLinkCaptacaoLeads: traduzir([
        /*pt-br*/'Gerando o link para captação de leads ...',
        /*pt-pt*/'A gerar o link para captação de leads ...',
        /*en-us*/'Generating lead capture link ...',
        /*es-es*/'Generando el enlace para captación de leads ...'
    ]),
    linkCaptacaoLeads: traduzir([
        /*pt-br*/'Link para Captação de Leads',
        /*pt-pt*/'Link para Captação de Leads',
        /*en-us*/'Lead Capture Link',
        /*es-es*/'Enlace para Captación de Leads'
    ]),
    linkCaptacaoLeadsOrigem: traduzir([
        /*pt-br*/'Onde o Link para Captação de Leads será divulgado?',
        /*pt-pt*/'Onde o Link para Captação de Leads será divulgado?',
        /*en-us*/'Where will the Lead Capture Link be published?',
        /*es-es*/'¿Dónde se publicará el Enlace para Captación de Leads?'
    ]),

    numeroConta: traduzir([
        /*pt-br*/'Número Conta',
        /*pt-pt*/'Número da Conta',
        /*en-us*/'Account Number',
        /*es-es*/'Número de Cuenta'
    ]),
    numeroContaCliente: traduzir([
        /*pt-br*/'Número Conta',
        /*pt-pt*/'Número da Conta',
        /*en-us*/'Account Number',
        /*es-es*/'Número de Cuenta'
    ]),

    integracaoSeguradoras: traduzir([
        /*pt-br*/'Integração Seguradoras',
        /*pt-pt*/'Integração Seguradoras',
        /*en-us*/'Insurance Companies Integration',
        /*es-es*/'Integración Aseguradoras'
    ]),

    statusIntegracao: traduzir([
        /*pt-br*/'Status Integração',
        /*pt-pt*/'Estado da Integração',
        /*en-us*/'Integration Status',
        /*es-es*/'Estado de Integración'
    ]),

    desejaAssinar: traduzir([
        /*pt-br*/'Deseja Assinar o Fin-tracks ?',
        /*pt-pt*/'Deseja Subscrever o Fin-tracks ?',
        /*en-us*/'Do you want to Subscribe to Fin-tracks?',
        /*es-es*/'¿Desea Suscribirse a Fin-tracks?'
    ]),
    freetrack: traduzir([
        /*pt-br*/'Free-track',
        /*pt-pt*/'Free-track',
        /*en-us*/'Free-track',
        /*es-es*/'Free-track'
    ]),
    assinante: traduzir([
        /*pt-br*/'Assinante',
        /*pt-pt*/'Assinante',
        /*en-us*/'Subscriber',
        /*es-es*/'Suscriptor'
    ]),
    realizarAssinatura: traduzir([
        /*pt-br*/'Realizar Assinatura do Fin-tracks',
        /*pt-pt*/'Realizar Subscrição do Fin-tracks',
        /*en-us*/'Subscribe to Fin-tracks',
        /*es-es*/'Realizar Suscripción de Fin-tracks'
    ]),
    alterarCartaoCredito: traduzir([
        /*pt-br*/'Alterar Cartão de Crédito',
        /*pt-pt*/'Alterar Cartão de Crédito',
        /*en-us*/'Change Credit Card',
        /*es-es*/'Cambiar Tarjeta de Crédito'
    ]),
    dataAssinaturaModuloBase: traduzir([
        /*pt-br*/'Data da Assinatura do Módulo Base',
        /*pt-pt*/'Data da Subscrição do Módulo Base',
        /*en-us*/'Base Module Subscription Date',
        /*es-es*/'Fecha de Suscripción del Módulo Base'
    ]),
    precoModuloBase: traduzir([
        /*pt-br*/ 'Preço da assinatura individual do Módulo Base Completo',
        /*pt-pt*/ 'Preço da subscrição individual do Módulo Base Completo',
        /*en-us*/ 'Individual Full Base Module Subscription Price',
        /*es-es*/ 'Precio de la suscripción individual del Módulo Base Completo'
    ]),
    precoValidoAte: traduzir([
        /*pt-br*/'Preço válido para assinaturas até',
        /*pt-pt*/'Preço válido para subscrições até',
        /*en-us*/'Price valid for subscriptions until',
        /*es-es*/'Precio válido para suscripciones hasta'
    ]),
    descontoVolumeAssinaturas: traduzir([
        /*pt-br*/'Desconto por volume de assinaturas',
        /*pt-pt*/'Desconto por volume de subscrições',
        /*en-us*/'Volume subscription discount',
        /*es-es*/'Descuento por volumen de suscripciones'
    ]),
    reajusteAnualIPCA: traduzir([
        /*pt-br*/'O preço será reajustado anualmente pelo IPCA com base na data de assinatura.',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    assinaturaVigente: traduzir([
        /*pt-br*/'Assinatura Vigente',
        /*pt-pt*/'Subscrição Vigente',
        /*en-us*/'Active Subscription',
        /*es-es*/'Suscripción Vigente'
    ]),
    pagamentoBoleto: traduzir([
        /*pt-br*/'Pagamento com Boleto',
        /*pt-pt*/'Pagamento com Referência Multibanco',
        /*en-us*/'Bank Slip Payment',
        /*es-es*/'Pago con Boleta'
    ]),
    cartaoCreditoAtivo: traduzir([
        /*pt-br*/'Cartão de Crédito Ativo',
        /*pt-pt*/'Cartão de Crédito Activo',
        /*en-us*/'Active Credit Card',
        /*es-es*/'Tarjeta de Crédito Activa'
    ]),
    nomeCartaoCredito: traduzir([
        /*pt-br*/'Nome Impresso no Cartão',
        /*pt-pt*/'Nome Impresso no Cartão',
        /*en-us*/'Name on Card',
        /*es-es*/'Nombre Impreso en la Tarjeta'
    ]),
    cpfCartaoCredito: traduzir([
        /*pt-br*/'CPF Titular Cartão',
        /*pt-pt*/'NIF Titular do Cartão',
        /*en-us*/'Cardholder Tax ID',
        /*es-es*/'DNI Titular de la Tarjeta'
    ]),
    cancelarAssinatura: traduzir([
        /*pt-br*/'Cancelar Assinatura',
        /*pt-pt*/'Cancelar Subscrição',
        /*en-us*/'Cancel Subscription',
        /*es-es*/'Cancelar Suscripción'
    ]),
    confirmaCancelamentoAssinatura: traduzir([
        /*pt-br*/'Confirma o Cancelamento da Assinatura ?',
        /*pt-pt*/'Confirma o Cancelamento da Subscrição ?',
        /*en-us*/'Confirm Subscription Cancellation?',
        /*es-es*/'¿Confirma la Cancelación de la Suscripción?'
    ]),

    importarClienteExcelFormErro: traduzir([
        /*pt-br*/'Cadastramento não realizado.',
        /*pt-pt*/'Registo não realizado.',
        /*en-us*/'Registration not completed.',
        /*es-es*/'Registro no realizado.'
    ]),
    importarClienteExcelFormOk: traduzir([
        /*pt-br*/'Cadastramento concluído',
        /*pt-pt*/'Registo concluído',
        /*en-us*/'Registration completed',
        /*es-es*/'Registro completado'
    ]),

    filialUnidade: traduzir([
        /*pt-br*/'Filial/Unidade',
        /*pt-pt*/'Filial/Unidade',
        /*en-us*/'Branch/Unit',
        /*es-es*/'Sucursal/Unidad'
    ]),

    funis: traduzir([
        /*pt-br*/'Funis',
        /*pt-pt*/'Funis',
        /*en-us*/'Funnels',
        /*es-es*/'Embudos'
    ]),
    funil: traduzir([
        /*pt-br*/'Funil',
        /*pt-pt*/'Funil',
        /*en-us*/'Funnel',
        /*es-es*/'Embudo'
    ]),
    etapa: traduzir([
        /*pt-br*/'Etapa',
        /*pt-pt*/'Etapa',
        /*en-us*/'Stage',
        /*es-es*/'Etapa'
    ]),
    limpouFunil: traduzir([
        /*pt-br*/'Limpou o Funil',
        /*pt-pt*/'Limpou o Funil',
        /*en-us*/'Cleared Funnel',
        /*es-es*/'Limpió el Embudo'
    ]),
    informarDataHoraPrevista: traduzir([
        /*pt-br*/'Informar Data/Hora Prevista',
        /*pt-pt*/'Informar Data/Hora Prevista',
        /*en-us*/'Enter Expected Date/Time',
        /*es-es*/'Informar Fecha/Hora Prevista'
    ]),
    informarDataRealizacao: traduzir([
        /*pt-br*/'Informar Data Realização',
        /*pt-pt*/'Informar Data de Realização',
        /*en-us*/'Enter Completion Date',
        /*es-es*/'Informar Fecha de Realización'
    ]),
    exibirPotencialNegocios: traduzir([
        /*pt-br*/'Exibir Potencial Negócios',
        /*pt-pt*/'Exibir Potencial de Negócios',
        /*en-us*/'Show Business Potential',
        /*es-es*/'Mostrar Potencial de Negocios'
    ]),
    ordem: traduzir([
        /*pt-br*/'Ordem',
        /*pt-pt*/'Ordem',
        /*en-us*/'Order',
        /*es-es*/'Orden'
    ]),
    dataHoraPrevista: traduzir([
        /*pt-br*/'Data/Hora Prevista',
        /*pt-pt*/'Data/Hora Prevista',
        /*en-us*/'Expected Date/Time',
        /*es-es*/'Fecha/Hora Prevista'
    ]),
    dataRealizacao: traduzir([
        /*pt-br*/'Data Realização',
        /*pt-pt*/'Data de Realização',
        /*en-us*/'Completion Date',
        /*es-es*/'Fecha de Realización'
    ]),
    potencialNegocios: traduzir([
        /*pt-br*/'Potencial Negócios',
        /*pt-pt*/'Potencial de Negócios',
        /*en-us*/'Business Potential',
        /*es-es*/'Potencial de Negocios'
    ]),
    semanaDataHoraInclusaoFunilEtapa: traduzir([
        /*pt-br*/'Semana',
        /*pt-pt*/'Semana',
        /*en-us*/'Week',
        /*es-es*/'Semana'
    ]),
    responsavelFunilEtapa: traduzir([
        /*pt-br*/'Responsável Funil/Etapa',
        /*pt-pt*/'Responsável Funil/Etapa',
        /*en-us*/'Pipeline/Stage Owner',
        /*es-es*/'Responsable del Embudo/Etapa'
    ]),
    funilEtapaAtual: traduzir([
        /*pt-br*/'Funil/Etapa Atual',
        /*pt-pt*/'Funil/Etapa Actual',
        /*en-us*/'Current Funnel/Stage',
        /*es-es*/'Embudo/Etapa Actual'
    ]),

    logos: traduzir([
        /*pt-br*/'Logos',
        /*pt-pt*/'Logótipos',
        /*en-us*/'Logos',
        /*es-es*/'Logos'
    ]),
    capaRelatorio: traduzir([
        /*pt-br*/'Capa Relatório',
        /*pt-pt*/'Capa do Relatório',
        /*en-us*/'Report Cover',
        /*es-es*/'Portada del Informe'
    ]),
    paginasRelatorio: traduzir([
        /*pt-br*/'Páginas Relatório',
        /*pt-pt*/'Páginas do Relatório',
        /*en-us*/'Report Pages',
        /*es-es*/'Páginas del Informe'
    ]),
    alturaLogoTopbar: traduzir([
        /*pt-br*/'Altura Logo Top Bar',
        /*pt-pt*/'Altura do Logótipo da Barra Superior',
        /*en-us*/'Top Bar Logo Height',
        /*es-es*/'Altura del Logo de la Barra Superior'
    ]),
    larguraLogoTopbar: traduzir([
        /*pt-br*/'Largura Logo Top Bar',
        /*pt-pt*/'Largura do Logótipo da Barra Superior',
        /*en-us*/'Top Bar Logo Width',
        /*es-es*/'Anchura del Logo de la Barra Superior'
    ]),
    exibirLogoTopbarParceiros: traduzir([
        /*pt-br*/'Exibir a Logo na Top Bar dos Parceiros',
        /*pt-pt*/'Exibir o Logótipo na Barra Superior dos Parceiros',
        /*en-us*/'Show Logo in Partners Top Bar',
        /*es-es*/'Mostrar el Logo en la Barra Superior de Socios'
    ]),
    naoExibirLogoCapaRelatorio: traduzir([
        /*pt-br*/'Não exibir a Logo na Capa do Relatório',
        /*pt-pt*/'Não exibir o Logótipo na Capa do Relatório',
        /*en-us*/'Do not show Logo on Report Cover',
        /*es-es*/'No mostrar el Logo en la Portada del Informe'
    ]),
    alinhamentoLogoCapaRelatorio: traduzir([
        /*pt-br*/'Alinhamento da Logo na Capa do Relatório',
        /*pt-pt*/'Alinhamento do Logótipo na Capa do Relatório',
        /*en-us*/'Logo Alignment on Report Cover',
        /*es-es*/'Alineación del Logo en la Portada del Informe'
    ]),
    alturaLogoReport: traduzir([
        /*pt-br*/'Altura Logo Relatório',
        /*pt-pt*/'Altura do Logótipo do Relatório',
        /*en-us*/'Report Logo Height',
        /*es-es*/'Altura del Logo del Informe'
    ]),
    larguraLogoReport: traduzir([
        /*pt-br*/'Largura Logo Relatório',
        /*pt-pt*/'Largura do Logótipo do Relatório',
        /*en-us*/'Report Logo Width',
        /*es-es*/'Anchura del Logo del Informe'
    ]),
    backgroundCapaRelatorioPaginaInteira: traduzir([
        /*pt-br*/'Utilizar a página inteira',
        /*pt-pt*/'Utilizar a página inteira',
        /*en-us*/'Use full page',
        /*es-es*/'Utilizar la página completa'
    ]),
    backgroundPaginaRelatorioNaoExibirLogoCabecalho: traduzir([
        /*pt-br*/'Não exibir logo no cabeçalho',
        /*pt-pt*/'Não exibir logótipo no cabeçalho',
        /*en-us*/'Do not show logo in header',
        /*es-es*/'No mostrar logo en el encabezado'
    ]),
    backgroundPaginaRelatorioPaisagemNaoExibirLogoCabecalho: traduzir([
        /*pt-br*/'Não exibir logo no cabeçalho',
        /*pt-pt*/'Não exibir logótipo no cabeçalho',
        /*en-us*/'Do not show logo in header',
        /*es-es*/'No mostrar logo en el encabezado'
    ]),
    backgroundPaginaRelatorioNaoExibirLinhaDivisoriaCabecalho: traduzir([
        /*pt-br*/'Não exibir linha divisória do cabeçalho',
        /*pt-pt*/'Não exibir linha divisória do cabeçalho',
        /*en-us*/'Do not show header divider line',
        /*es-es*/'No mostrar línea divisoria del encabezado'
    ]),
    backgroundPaginaRelatorioMargemEsquerdaCabecalho: traduzir([
        /*pt-br*/'Margem esquerda do cabeçalho',
        /*pt-pt*/'Margem esquerda do cabeçalho',
        /*en-us*/'Left header margin',
        /*es-es*/'Margen izquierda del encabezado'
    ]),
    backgroundPaginaRelatorioMargemTopoRodape: traduzir([
        /*pt-br*/'Margem topo do rodapé',
        /*pt-pt*/'Margem superior do rodapé',
        /*en-us*/'Footer top margin',
        /*es-es*/'Margen superior del pie de página'
    ]),
    backgroundPaginaRelatorioPaisagemNaoExibirLinhaDivisoriaCabecalho: traduzir([
        /*pt-br*/'Não exibir linha divisória do cabeçalho',
        /*pt-pt*/'Não exibir linha divisória do cabeçalho',
        /*en-us*/'Do not show header divider line',
        /*es-es*/'No mostrar línea divisoria del encabezado'
    ]),

    fontFamily: traduzir([
        /*pt-br*/'Font Family',
        /*pt-pt*/'Font Family',
        /*en-us*/'Font Family',
        /*es-es*/'Font Family'
    ]),

    naoExibirAvatarClienteConjuge: traduzir([
        /*pt-br*/'Não exibir o Avatar do Cliente e Cônjuge',
        /*pt-pt*/'Não exibir o Avatar do Cliente e Cônjuge',
        /*en-us*/'Do not show Client and Spouse Avatar',
        /*es-es*/'No mostrar el Avatar del Cliente y Cónyuge'
    ]),

    cor: traduzir([
        /*pt-br*/'Cor',
        /*pt-pt*/'Cor',
        /*en-us*/'Color',
        /*es-es*/'Color'
    ]),
    corPadrao1: traduzir([
        /*pt-br*/'Cor Padrão 1: Fundo da Tela de Login e da Ferramenta',
        /*pt-pt*/'Cor Padrão 1: Fundo do Ecrã de Login e da Ferramenta',
        /*en-us*/'Default Color 1: Login Screen and Tool Background',
        /*es-es*/'Color Predeterminado 1: Fondo de Pantalla de Inicio y Herramienta'
    ]),
    corPadrao2: traduzir([
        /*pt-br*/'Cor Padrão 2: Login, Menu Lateral, Painéis de Seleção',
        /*pt-pt*/'Cor Padrão 2: Login, Menu Lateral, Painéis de Selecção',
        /*en-us*/'Default Color 2: Login, Side Menu, Selection Panels',
        /*es-es*/'Color Predeterminado 2: Inicio, Menú Lateral, Paneles de Selección'
    ]),
    corPadrao3: traduzir([
        /*pt-br*/'Cor Padrão 3: Botões, Menu de Seleção Horizontal',
        /*pt-pt*/'Cor Padrão 3: Botões, Menu de Selecção Horizontal',
        /*en-us*/'Default Color 3: Buttons, Horizontal Selection Menu',
        /*es-es*/'Color Predeterminado 3: Botones, Menú de Selección Horizontal'
    ]), 
    corPadrao4: traduzir([
        /*pt-br*/'Cor Padrão 4: Texto do Menu Lateral',
        /*pt-pt*/'Cor Padrão 4: Texto do Menu Lateral',
        /*en-us*/'Default Color 4: Side Menu Text',
        /*es-es*/'Color Predeterminado 4: Texto del Menú Lateral'
    ]), 
    corPadrao5: traduzir([
        /*pt-br*/'Cor Padrão 5: Texto do Cabeçalho do Relatório',
        /*pt-pt*/'Cor Padrão 5: Texto do Cabeçalho do Relatório',
        /*en-us*/'Default Color 5: Report Header Text',
        /*es-es*/'Color Predeterminado 5: Texto del Encabezado del Informe'
    ]), 

    calculos: traduzir([
        /*pt-br*/'Cálculos',
        /*pt-pt*/'Cálculos',
        /*en-us*/'Calculations',
        /*es-es*/'Cálculos'
    ]),
    mesesSugestaoDoencasGraves: traduzir([
        /*pt-br*/'Meses Sugestão Doenças Graves',
        /*pt-pt*/'Meses de Sugestão para Doenças Graves',
        /*en-us*/'Critical Illness Suggestion Months',
        /*es-es*/'Meses de Sugerencia para Enfermedades Graves'
    ]),
    tipoCalculoSugestaoDoencasGraves: traduzir([
        /*pt-br*/'Tipo Cálculo Sugestão Doenças Graves',
        /*pt-pt*/'Tipo de Cálculo para Sugestão de Doenças Graves',
        /*en-us*/'Critical Illness Suggestion Calculation Type',
        /*es-es*/'Tipo de Cálculo para Sugerencia de Enfermedades Graves'
    ]),
    tituloSubTotal1InputDiaDia: traduzir([
        /*pt-br*/'Título Subtotal 1 do Input Dia a Dia (Default: Cartão de Crédito)',
        /*pt-pt*/'Título do Subtotal 1 do Input Dia-a-Dia (Padrão: Cartão de Crédito)',
        /*en-us*/'Subtitle 1 Title for Day-to-Day Input (Default: Credit Card)',
        /*es-es*/'Título del Subtotal 1 del Input Día a Día (Por defecto: Tarjeta de Crédito)'
    ]),
    tituloSubTotal2InputDiaDia: traduzir([
        /*pt-br*/'Título Subtotal 2 do Input Dia a Dia (Default: Débito/Dinheiro)',
        /*pt-pt*/'Título do Subtotal 2 do Input Dia-a-Dia (Padrão: Débito/Dinheiro)',
        /*en-us*/'Subtitle 2 Title for Day-to-Day Input (Default: Debit/Cash)',
        /*es-es*/'Título del Subtotal 2 del Input Día a Día (Por defecto: Débito/Efectivo)'
    ]),
    habilitarDivisaoComissaoSeguroVida: traduzir([
        /*pt-br*/'Habilitar a Divisão de Comissão no Seguro de Vida',
        /*pt-pt*/'Habilitar a Divisão de Comissão no Seguro de Vida',
        /*en-us*/'Enable Commission Split in Life Insurance',
        /*es-es*/'Habilitar la División de Comisión en el Seguro de Vida'
    ]),
    percImpostosComissaoSeguroVida: traduzir([
        /*pt-br*/'% Impostos Comissão Seguro de Vida',
        /*pt-pt*/'% Impostos sobre a Comissão do Seguro de Vida',
        /*en-us*/'% Taxes on Life Insurance Commission',
        /*es-es*/'% Impuestos sobre la Comisión del Seguro de Vida'
    ]),

    educacaoValoresDefault: traduzir([
        /*pt-br*/'Educação: Valores Default',
        /*pt-pt*/'Educação: Valores por Omissão',
        /*en-us*/'Education: Default Values',
        /*es-es*/'Educación: Valores Predeterminados'
    ]),

    textos: traduzir([
        /*pt-br*/'Textos',
        /*pt-pt*/'Textos',
        /*en-us*/'Texts',
        /*es-es*/'Textos'
    ]),
    
    textoMorte: traduzir([
        /*pt-br*/'Texto Morte',
        /*pt-pt*/'Texto sobre Morte',
        /*en-us*/'Death Text',
        /*es-es*/'Texto de Muerte'
    ]),
    textoCoberturaSugeridaDITDITA: traduzir([
        /*pt-br*/'Texto Cobertura Sugerida DIT/DITA',
        /*pt-pt*/'Texto de Cobertura Sugerida DIT/DITA',
        /*en-us*/'Suggested Coverage Text DIT/DITA',
        /*es-es*/'Texto de Cobertura Sugerida DIT/DITA'
    ]),
    textoCoberturaSugeridaInvalidez: traduzir([
        /*pt-br*/'Texto Cobertura Sugerida Invalidez',
        /*pt-pt*/'Texto de Cobertura Sugerida para Invalidez',
        /*en-us*/'Suggested Disability Coverage Text',
        /*es-es*/'Texto de Cobertura Sugerida para Invalidez'
    ]),
    naoExibirCoracaoProtecaoSugerida: traduzir([
        /*pt-br*/'Não Exibir o Coração na Proteção Sugerida',
        /*pt-pt*/'Não Mostrar o Coração na Proteção Sugerida',
        /*en-us*/'Do not Show Heart in Suggested Protection',
        /*es-es*/'No Mostrar el Corazón en la Protección Sugerida'
    ]),
    anonimizarRelatorio: traduzir([
        /*pt-br*/'Anonimizar o Relatório',
        /*pt-pt*/'Anonimizar o Relatório',
        /*en-us*/'Anonymize the Report',
        /*es-es*/'Anonimizar el Informe'
    ]),
    estudoReportPrimeiraReuniaoTextoAbertura: traduzir([
        /*pt-br*/'Texto Relatório - Abertura 1ª Reunião',
        /*pt-pt*/'Texto do Relatório - Abertura da 1ª Reunião',
        /*en-us*/'Report Text - 1st Meeting Opening',
        /*es-es*/'Texto del Informe - Apertura de la 1ª Reunión'
    ]),

    estudoReportCapa: traduzir([
        /*pt-br*/'Capa',
        /*pt-pt*/'Capa',
        /*en-us*/'Cover',
        /*es-es*/'Portada'
    ]),

    estudoReportCapaTitulo1: traduzir([
        /*pt-br*/'Texto Relatório - Capa - Título 1 (Default: Planejamento Financeiro de Padrão de Vida)',
        /*pt-pt*/'Texto do Relatório - Capa - Título 1 (Padrão: Planeamento Financeiro de Padrão de Vida)',
        /*en-us*/'Report Text - Cover - Title 1 (Default: Financial Life Standard Planning)',
        /*es-es*/'Texto del Informe - Portada - Título 1 (Por defecto: Planificación Financiera de Estándar de Vida)'
    ]),
    estudoReportCapaTitulo1MargemTopo: traduzir([
        /*pt-br*/'Margem Topo Título 1 na Capa',
        /*pt-pt*/'Margem Superior do Título 1 na Capa',
        /*en-us*/'Title 1 Top Margin on Cover',
        /*es-es*/'Margen Superior del Título 1 en la Portada'
    ]),
    estudoReportCapaNaoExibirTitulo1: traduzir([
        /*pt-br*/'Não exibir Título 1 na Capa',
        /*pt-pt*/'Não exibir Título 1 na Capa',
        /*en-us*/'Do not show Title 1 on Cover',
        /*es-es*/'No mostrar Título 1 en la Portada'
    ]),
    estudoReportCapaNaoExibirUsuario: traduzir([
        /*pt-br*/'Não exibir Usuário na Capa',
        /*pt-pt*/'Não exibir Utilizador na Capa',
        /*en-us*/'Do not show User on Cover',
        /*es-es*/'No mostrar Usuario en la Portada'
    ]),
    estudoReportCapaNaoExibirProfissaoQualificacao: traduzir([
        /*pt-br*/'Não exibir Profissão/Qualificação na Capa',
        /*pt-pt*/'Não exibir Profissão/Qualificação na Capa',
        /*en-us*/'Do not show Profession/Qualification on Cover',
        /*es-es*/'No mostrar Profesión/Cualificación en la Portada'
    ]),
    estudoReportCapaTitulo2: traduzir([
        /*pt-br*/'Texto Relatório - Capa - Título 2 (Default: a sua trilha financeira)',
        /*pt-pt*/'Texto do Relatório - Capa - Título 2 (Padrão: o seu percurso financeiro)',
        /*en-us*/'Report Text - Cover - Title 2 (Default: your financial path)',
        /*es-es*/'Texto del Informe - Portada - Título 2 (Por defecto: su ruta financiera)'
    ]),
    estudoReportCapaClienteConjugeTitulo2MargemTopo: traduzir([
        /*pt-br*/'Margem Topo Cliente/Cônjuge e Título 2 na Capa',
        /*pt-pt*/'Margem Superior Cliente/Cônjuge e Título 2 na Capa',
        /*en-us*/'Top Margin Client/Spouse and Title 2 on Cover',
        /*es-es*/'Margen Superior Cliente/Cónyuge y Título 2 en la Portada'
    ]),
    estudoReportCapaClienteConjugeTitulo2MargemEsquerda: traduzir([
        /*pt-br*/'Margem Esquerda Cliente/Cônjuge e Título 2 na Capa',
        /*pt-pt*/'Margem Esquerda Cliente/Cônjuge e Título 2 na Capa',
        /*en-us*/'Left Margin Client/Spouse and Title 2 on Cover',
        /*es-es*/'Margen Izquierdo Cliente/Cónyuge y Título 2 en la Portada'
    ]),
    estudoReportCapaNaoExibirClienteConjuge: traduzir([
        /*pt-br*/'Não exibir Cliente/Cônjuge na Capa',
        /*pt-pt*/'Não exibir Cliente/Cônjuge na Capa',
        /*en-us*/'Do not show Client/Spouse on Cover',
        /*es-es*/'No mostrar Cliente/Cónyuge en la Portada'
    ]),
    estudoReportCapaNaoExibirTitulo2: traduzir([
        /*pt-br*/'Não exibir Título 2 na Capa',
        /*pt-pt*/'Não exibir Título 2 na Capa',
        /*en-us*/'Do not show Title 2 on Cover',
        /*es-es*/'No mostrar Título 2 en la Portada'
    ]),

    estudoReportOQueEsperarDesseTrabalho: traduzir([
        /*pt-br*/'Texto Relatório - O que esperar desse Trabalho?',
        /*pt-pt*/'Texto do Relatório - O que esperar deste Trabalho?',
        /*en-us*/'Report Text - What to expect from this Work?',
        /*es-es*/'Texto del Informe - ¿Qué esperar de este Trabajo?'
    ]),

    estudoReportDetalhamentoDiaDiaDespesasVitaliciasTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Dia a Dia - Despesas Vitalícias',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Dia-a-Dia - Despesas Vitalícias',
        /*en-us*/'Report Text - Day-to-Day Details Header - Lifelong Expenses',
        /*es-es*/'Texto del Informe - Encabezado Detalle Día a Día - Gastos Vitalicios'
    ]),
    estudoReportDetalhamentoEducacaoTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Educação',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Educação',
        /*en-us*/'Report Text - Education Details Header',
        /*es-es*/'Texto del Informe - Encabezado Detalle Educación'
    ]),
    estudoReportDetalhamentoFinanciamentoTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Financiamento',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Financiamento',
        /*en-us*/'Report Text - Financing Details Header',
        /*es-es*/'Texto del Informe - Encabezado Detalle Financiación'
    ]),
    estudoReportDetalhamentoDiaDiaDespesasTemporariasTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Dia a Dia - Despesas Temporárias',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Dia-a-Dia - Despesas Temporárias',
        /*en-us*/'Report Text - Day-to-Day Details Header - Temporary Expenses',
        /*es-es*/'Texto del Informe - Encabezado Detalle Día a Día - Gastos Temporales'
    ]),

    estudoReportDetalhamentoPatrimonioImobilizadoTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Patrimônio Imobilizado',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Património Imobilizado',
        /*en-us*/'Report Text - Fixed Assets Details Header',
        /*es-es*/'Texto del Informe - Encabezado Detalle Patrimonio Inmovilizado'
    ]),
    estudoReportDetalhamentoReceitaMensalTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Receita Mensal',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Receita Mensal',
        /*en-us*/'Report Text - Monthly Income Details Header',
        /*es-es*/'Texto del Informe - Encabezado Detalle Ingresos Mensuales'
    ]),
    estudoReportDetalhamentoRecursosFinanceirosTextoCabecalho: traduzir([
        /*pt-br*/'Texto Relatório - Cabeçalho Detalhamento Recursos Financeiros',
        /*pt-pt*/'Texto do Relatório - Cabeçalho Detalhamento Recursos Financeiros',
        /*en-us*/'Report Text - Financial Resources Details Header',
        /*es-es*/'Texto del Informe - Encabezado Detalle Recursos Financieros'
    ]),

    estudoReportDisclaimer: traduzir([
        /*pt-br*/'Texto Relatório - Disclaimer',
        /*pt-pt*/'Texto do Relatório - Disclaimer',
        /*en-us*/'Report Text - Disclaimer',
        /*es-es*/'Texto del Informe - Disclaimer'
    ]),

    textoCaptacaoLeadsPlanejamentoCompleto: traduzir([
        /*pt-br*/'Texto Captação de Leads - Planejamento Completo',
        /*pt-pt*/'Texto de Captação de Leads - Planeamento Completo',
        /*en-us*/'Lead Capture Text - Complete Planning',
        /*es-es*/'Texto de Captación de Leads - Planificación Completa'
    ]),
    tipoLinkCaptacaoLeads: traduzir([
        /*pt-br*/'Tipo Link Captação de Leads',
        /*pt-pt*/'Tipo de Link de Captação de Leads',
        /*en-us*/'Lead Capture Link Type',
        /*es-es*/'Tipo de Enlace de Captación de Leads'
    ]),

    textoWhatsAppAniversario: traduzir([
        /*pt-br*/'Texto WhatsApp - Aniversário',
        /*pt-pt*/'Texto WhatsApp - Aniversário',
        /*en-us*/'WhatsApp Message - Birthday',
        /*es-es*/'Texto de WhatsApp - Cumpleaños'
    ]),

    tiposPendencias: traduzir([
        /*pt-br*/'Tipos de Pendências',
        /*pt-pt*/'Tipos de Pendências',
        /*en-us*/'Pending Types',
        /*es-es*/'Tipos de Pendientes'
    ]),
    tipoPendencia: traduzir([
        /*pt-br*/'Tipo de Pendência',
        /*pt-pt*/'Tipo de Pendência',
        /*en-us*/'Pending Type',
        /*es-es*/'Tipo de Pendiente'
    ]),
    responsavelPendencia: traduzir([
        /*pt-br*/'Responsável Pendência',
        /*pt-pt*/'Responsável pela Pendência',
        /*en-us*/'Pending Issue Owner',
        /*es-es*/'Responsable de la Pendencia'
    ]),
    delegar: traduzir([
        /*pt-br*/'Delegar',
        /*pt-pt*/'Delegar',
        /*en-us*/'Delegate',
        /*es-es*/'Delegar'
    ]),
    qtdePendenciasEmAberto: traduzir([
        /*pt-br*/'Pendências',
        /*pt-pt*/'Pendências',
        /*en-us*/'Pending',
        /*es-es*/'Pendientes'
    ]),
    pendencias: traduzir([
        /*pt-br*/'Pendências',
        /*pt-pt*/'Pendências',
        /*en-us*/'Pending',
        /*es-es*/'Pendientes'
    ]),
    totalPendencias: traduzir([
        /*pt-br*/'Clientes com Pendências',
        /*pt-pt*/'Clientes com Pendências',
        /*en-us*/'Clients with Pending Items',
        /*es-es*/'Clientes con Pendientes'
    ]),

    tituloAnotacao: traduzir([
        /*pt-br*/'Título Anotação',
        /*pt-pt*/'Título da Anotação',
        /*en-us*/'Note Title',
        /*es-es*/'Título de la Anotación'
    ]),
    dataAnotacao: traduzir([
        /*pt-br*/'Data Anotação',
        /*pt-pt*/'Data da Anotação',
        /*en-us*/'Note Date',
        /*es-es*/'Fecha de la Anotación'
    ]),

    enviarLembreteAporte: traduzir([
        /*pt-br*/'Enviar Lembrete Aporte',
        /*pt-pt*/'Enviar Lembrete de Aporte',
        /*en-us*/'Send Contribution Reminder',
        /*es-es*/'Enviar Recordatorio de Aporte'
    ]),
    diasAntecedenciaEnvioLembreteAporte: traduzir([
        /*pt-br*/'Dias Antecedência Envio Lembrete Aporte',
        /*pt-pt*/'Dias de Antecedência para Envio do Lembrete de Aporte',
        /*en-us*/'Days in Advance for Contribution Reminder',
        /*es-es*/'Días de Antelación para Envío de Recordatorio de Aporte'
    ]),
    textoDescricaoAporteEnvioLembreteAporte: traduzir([
        /*pt-br*/'Texto Descrição Aporte',
        /*pt-pt*/'Texto de Descrição do Aporte',
        /*en-us*/'Contribution Description Text',
        /*es-es*/'Texto de Descripción del Aporte'
    ]),

    valorAportePrevisto: traduzir([
        /*pt-br*/'Valor Aporte Previsto',
        /*pt-pt*/'Valor do Aporte Previsto',
        /*en-us*/'Expected Contribution Amount',
        /*es-es*/'Valor de Aporte Previsto'
    ]),
    dataPrevistaAporte: traduzir([
        /*pt-br*/'Data Prevista Aporte',
        /*pt-pt*/'Data Prevista do Aporte',
        /*en-us*/'Expected Contribution Date',
        /*es-es*/'Fecha Prevista del Aporte'
    ]),
    valorAporteRealizado: traduzir([
        /*pt-br*/'Valor Aporte Realizado',
        /*pt-pt*/'Valor do Aporte Realizado',
        /*en-us*/'Actual Contribution Amount',
        /*es-es*/'Valor de Aporte Realizado'
    ]),
    dataRealizacaoAporte: traduzir([
        /*pt-br*/'Data Realização Aporte',
        /*pt-pt*/'Data de Realização do Aporte',
        /*en-us*/'Contribution Completion Date',
        /*es-es*/'Fecha de Realización del Aporte'
    ]),
    statusAporte: traduzir([
        /*pt-br*/'Status Aporte',
        /*pt-pt*/'Estado do Aporte',
        /*en-us*/'Contribution Status',
        /*es-es*/'Estado del Aporte'
    ]),
    exibirStatusAportePendente: traduzir([
        /*pt-br*/'Exibir Aportes Pendentes',
        /*pt-pt*/'Exibir Aportes Pendentes',
        /*en-us*/'Show Pending Contributions',
        /*es-es*/'Mostrar Aportes Pendientes'
    ]),
    exibirStatusAporteNaoRealizado: traduzir([
        /*pt-br*/'Exibir Aportes Não Realizados',
        /*pt-pt*/'Exibir Aportes Não Realizados',
        /*en-us*/'Show Unrealized Contributions',
        /*es-es*/'Mostrar Aportes No Realizados'
    ]),
    exibirStatusAporteRealizado: traduzir([
        /*pt-br*/'Exibir Aportes Realizados',
        /*pt-pt*/'Exibir Aportes Realizados',
        /*en-us*/'Show Completed Contributions',
        /*es-es*/'Mostrar Aportes Realizados'
    ]),

    compartilhamento: traduzir([
        /*pt-br*/'Compartilhamento',
        /*pt-pt*/'Partilha',
        /*en-us*/'Sharing',
        /*es-es*/'Compartir'
    ]),
    habilitaCompartilhamentoClientes: traduzir([
        /*pt-br*/'Habilitar o Compartilhamento de Clientes',
        /*pt-pt*/'Habilitar a Partilha de Clientes',
        /*en-us*/'Enable Client Sharing',
        /*es-es*/'Habilitar el Compartir Clientes'
    ]),

    naoPermitirInclusaoNovosClientes: traduzir([
        /*pt-br*/'Não permitir a inclusão de novos clientes pela Fin-Tracks',
        /*pt-pt*/'Não permitir a inclusão de novos clientes pela Fin-Tracks',
        /*en-us*/'Do not allow inclusion of new clients through Fin-Tracks',
        /*es-es*/'No permitir la inclusión de nuevos clientes por Fin-Tracks'
    ]),
    naoPermitirAlterarNomeCliente: traduzir([
        /*pt-br*/'Não permitir alterar o nome do cliente pela Fin-Tracks',
        /*pt-pt*/'Não permitir alterar o nome do cliente pela Fin-Tracks',
        /*en-us*/'Do not allow changing client name through Fin-Tracks',
        /*es-es*/'No permitir cambiar el nombre del cliente por Fin-Tracks'
    ]),
    naoPermitirAlterarCpfCliente: traduzir([
        /*pt-br*/'Não permitir alterar o CPF do cliente pela Fin-Tracks',
        /*pt-pt*/'Não permitir alterar o NIF do cliente pela Fin-Tracks',
        /*en-us*/'Do not allow changing client Tax ID through Fin-Tracks',
        /*es-es*/'No permitir cambiar el DNI del cliente por Fin-Tracks'
    ]),
    tornarCpfClienteObrigatorio: traduzir([
        /*pt-br*/'Tornar o CPF do cliente obrigatório',
        /*pt-pt*/'Tornar o NIF do cliente obrigatório',
        /*en-us*/'Make client Tax ID mandatory',
        /*es-es*/'Hacer obligatorio el DNI del cliente'
    ]),
    tornarEmailClienteObrigatorio: traduzir([
        /*pt-br*/'Tornar o e-mail do cliente obrigatório',
        /*pt-pt*/'Tornar o e-mail do cliente obrigatório',
        /*en-us*/'Make customer email required',
        /*es-es*/'Hacer obligatorio el correo electrónico del cliente'
    ]),
    permitirExclusaoClientesSomentePeloAdministrador: traduzir([
        /*pt-br*/'Permitir a exclusão de clientes somente pelo Administrador',
        /*pt-pt*/'Permitir a eliminação de clientes apenas pelo Administrador',
        /*en-us*/'Allow customer deletion only by the Administrator',
        /*es-es*/'Permitir la eliminación de clientes solo por el Administrador'
    ]),

    faixasComissao: traduzir([
        /*pt-br*/'Faixas Comissão',
        /*pt-pt*/'Escalões de Comissão',
        /*en-us*/'Commission Brackets',
        /*es-es*/'Rangos de Comisión'
    ]),
    codigoCoberturas: traduzir([
        /*pt-br*/'Código Coberturas (ex: WL ou HC/PD ou 2191/2392',
        /*pt-pt*/'Código das Coberturas (ex: WL ou HC/PD ou 2191/2392',
        /*en-us*/'Coverage Code (ex: WL or HC/PD or 2191/2392',
        /*es-es*/'Código de Coberturas (ej: WL o HC/PD o 2191/2392'
    ]),
    prazosPagto: traduzir([
        /*pt-br*/'Prazos de Pagamento (ex: 10 ou 10/20 ou 10/20/30)',
        /*pt-pt*/'Prazos de Pagamento (ex: 10 ou 10/20 ou 10/20/30)',
        /*en-us*/'Payment Terms (ex: 10 or 10/20 or 10/20/30)',
        /*es-es*/'Plazos de Pago (ej: 10 o 10/20 o 10/20/30)'
    ]),
    valorCSMinimo: traduzir([
        /*pt-br*/'Valor CS Mínimo',
        /*pt-pt*/'Valor CS Mínimo',
        /*en-us*/'Minimum CS Value',
        /*es-es*/'Valor CS Mínimo'
    ]),
    valorCSMaximo: traduzir([
        /*pt-br*/'Valor CS Máximo',
        /*pt-pt*/'Valor CS Máximo',
        /*en-us*/'Maximum CS Value',
        /*es-es*/'Valor CS Máximo'
    ]),
    anoComissao: traduzir([
        /*pt-br*/'Ano Comissão',
        /*pt-pt*/'Ano da Comissão',
        /*en-us*/'Commission Year',
        /*es-es*/'Año de Comisión'
    ]),
    anoComissaoInicial: traduzir([
        /*pt-br*/'Ano Comissão Inicial',
        /*pt-pt*/'Ano de Comissão Inicial',
        /*en-us*/'Initial Commission Year',
        /*es-es*/'Año de Comisión Inicial'
    ]),
    anoComissaoFinal: traduzir([
        /*pt-br*/'Ano Comissão Final',
        /*pt-pt*/'Ano de Comissão Final',
        /*en-us*/'Final Commission Year',
        /*es-es*/'Año de Comisión Final'
    ]),
    percComissaoPrimeiroMes: traduzir([
        /*pt-br*/'% Comissão 1º Mês',
        /*pt-pt*/'% Comissão 1º Mês',
        /*en-us*/'% Commission 1st Month',
        /*es-es*/'% Comisión 1er Mes'
    ]),
    percComissaoDemaisMeses: traduzir([
        /*pt-br*/'% Comissão Demais Meses',
        /*pt-pt*/'% Comissão dos Restantes Meses',
        /*en-us*/'% Commission Other Months',
        /*es-es*/'% Comisión Demás Meses'
    ]),
    percComissaoAnual: traduzir([
        /*pt-br*/'% Comissão Anual',
        /*pt-pt*/'% Comissão Anual',
        /*en-us*/'% Annual Commission',
        /*es-es*/'% Comisión Anual'
    ]),

    pageParceiroList: traduzir([
        /*pt-br*/'Parceiros',
        /*pt-pt*/'Parceiros',
        /*en-us*/'Partners',
        /*es-es*/'Socios'
    ]),

    globalizacao: traduzir([
        /*pt-br*/'Globalização',
        /*pt-pt*/'Globalização',
        /*en-us*/'Globalization',
        /*es-es*/'Globalización'
    ]),
    tipoIdioma: traduzir([
        /*pt-br*/'Tipo Idioma',
        /*pt-pt*/'Tipo de Idioma',
        /*en-us*/'Language Type',
        /*es-es*/'Tipo de Idioma'
    ]),
    tipoMoeda: traduzir([
        /*pt-br*/'Tipo Moeda',
        /*pt-pt*/'Tipo de Moeda',
        /*en-us*/'Currency Type',
        /*es-es*/'Tipo de Moneda'
    ]),

    parceiro: traduzir([
        /*pt-br*/'Parceiro',
        /*pt-pt*/'Parceiro',
        /*en-us*/'Partner',
        /*es-es*/'Socio'
    ]),

    default: traduzir([
        /*pt-br*/'Default',
        /*pt-pt*/'Padrão',
        /*en-us*/'Default',
        /*es-es*/'Por Defecto'
    ]),
    defaultCaptacaoLeads: traduzir([
        /*pt-br*/'Default Captação de Leads',
        /*pt-pt*/'Padrão de Captação de Leads',
        /*en-us*/'Default Lead Capture',
        /*es-es*/'Por Defecto Captación de Leads'
    ]),
    compartilhar: traduzir([
        /*pt-br*/'Compartihar',
        /*pt-pt*/'Partilhar',
        /*en-us*/'Share',
        /*es-es*/'Compartir'
    ]),
    formulario: traduzir([
        /*pt-br*/'Formulário',
        /*pt-pt*/'Formulário',
        /*en-us*/'Form',
        /*es-es*/'Formulario'
    ]),
    formularioCaptacaoLeads: traduzir([
        /*pt-br*/'Formulário Captação Leads',
        /*pt-pt*/'Formulário de Captação de Leads',
        /*en-us*/'Lead Capture Form',
        /*es-es*/'Formulario de Captación de Leads'
    ]),
    configuracaoPerguntasFormulario: traduzir([
        /*pt-br*/'Configuração das Perguntas do Formulário',
        /*pt-pt*/'Configuração das Perguntas do Formulário',
        /*en-us*/'Form Questions Configuration',
        /*es-es*/'Configuración de las Preguntas del Formulario'
    ]),
    relatorio: traduzir([
        /*pt-br*/'Relatório',
        /*pt-pt*/'Relatório',
        /*en-us*/'Report',
        /*es-es*/'Informe'
    ]),
    previewRelatorio: traduzir([
        /*pt-br*/'Preview do Relatório',
        /*pt-pt*/'Pré-visualização do Relatório',
        /*en-us*/'Report Preview',
        /*es-es*/'Vista Previa del Informe'
    ]),
    template: traduzir([
        /*pt-br*/'Template',
        /*pt-pt*/'Modelo',
        /*en-us*/'Template',
        /*es-es*/'Plantilla'
    ]),
    configuracaoRelatorioTemplate: traduzir([
        /*pt-br*/'Configuração do Template de Relatório',
        /*pt-pt*/'Configuração do Modelo de Relatório',
        /*en-us*/'Report Template Configuration',
        /*es-es*/'Configuración de la Plantilla del Informe'
    ]),
    padrao: traduzir([
        /*pt-br*/'Padrão',
        /*pt-pt*/'Padrão',
        /*en-us*/'Standard',
        /*es-es*/'Estándar'
    ]),

    configuracaoCenariosCenario: traduzir([
        /*pt-br*/'Configuração do Cenário',
        /*pt-pt*/'Configuração do Cenário',
        /*en-us*/'Scenario Configuration',
        /*es-es*/'Configuración del Escenario'
    ]),

    pagina: traduzir([
        /*pt-br*/'Página',
        /*pt-pt*/'Página',
        /*en-us*/'Page',
        /*es-es*/'Página'
    ]),
    tituloPagina: traduzir([
        /*pt-br*/'Título da Página',
        /*pt-pt*/'Título da Página',
        /*en-us*/'Page Title',
        /*es-es*/'Título de la Página'
    ]),
    alterarTituloPagina: traduzir([
        /*pt-br*/'Alterar Título da Página',
        /*pt-pt*/'Alterar Título da Página',
        /*en-us*/'Change Page Title',
        /*es-es*/'Cambiar Título de la Página'
    ]),
    paginaInteira: traduzir([
        /*pt-br*/'Página Inteira',
        /*pt-pt*/'Página Inteira',
        /*en-us*/'Full Page',
        /*es-es*/'Página Completa'
    ]),
    capa: traduzir([
        /*pt-br*/'Capa',
        /*pt-pt*/'Capa',
        /*en-us*/'Cover',
        /*es-es*/'Portada'
    ]),
    configuracaoPagina: traduzir([
        /*pt-br*/'Configuração da Página',
        /*pt-pt*/'Configuração da Página',
        /*en-us*/'Page Configuration',
        /*es-es*/'Configuración de la Página'
    ]),
    tipoItemPagina: traduzir([
        /*pt-br*/'Tipo',
        /*pt-pt*/'Tipo',
        /*en-us*/'Type',
        /*es-es*/'Tipo'
    ]),
    variaveis: traduzir([
        /*pt-br*/'Variáveis',
        /*pt-pt*/'Variáveis',
        /*en-us*/'Variables',
        /*es-es*/'Variables'
    ]),
    margemTop: traduzir([
        /*pt-br*/'Margem Topo',
        /*pt-pt*/'Margem Superior',
        /*en-us*/'Top Margin',
        /*es-es*/'Margen Superior'
    ]),
    margemLeft: traduzir([
        /*pt-br*/'Margem Esquerda',
        /*pt-pt*/'Margem Esquerda',
        /*en-us*/'Left Margin',
        /*es-es*/'Margen Izquierdo'
    ]),
    ufInventario: traduzir([
        /*pt-br*/'UF Inventário',
        /*pt-pt*/'Distrito do Inventário',
        /*en-us*/'Inventory State',
        /*es-es*/'Provincia del Inventario'
    ]),
    html: traduzir([
        /*pt-br*/'HTML',
        /*pt-pt*/'HTML',
        /*en-us*/'HTML',
        /*es-es*/'HTML'
    ]),
    graficoTabela: traduzir([
        /*pt-br*/'Gráfico / Tabela',
        /*pt-pt*/'Gráfico / Tabela',
        /*en-us*/'Chart / Table',
        /*es-es*/'Gráfico / Tabla'
    ]),
    copia: traduzir([
        /*pt-br*/'Cópia',
        /*pt-pt*/'Cópia',
        /*en-us*/'Copy',
        /*es-es*/'Copia'
    ]),
    exemplo: traduzir([
        /*pt-br*/'Exemplo',
        /*pt-pt*/'Exemplo',
        /*en-us*/'Example',
        /*es-es*/'Ejemplo'
    ]),

    moverParaBaixo: traduzir([
        /*pt-br*/'Mover para baixo',
        /*pt-pt*/'Mover para baixo',
        /*en-us*/'Move down',
        /*es-es*/'Mover hacia abajo'
    ]),
    moverParaCima: traduzir([
        /*pt-br*/'Mover para cima',
        /*pt-pt*/'Mover para cima',
        /*en-us*/'Move up',
        /*es-es*/'Mover hacia arriba'
    ]),
    


    tabConfiguracaoFormListDadosCadastrais: traduzir([
        /*pt-br*/'Dados Cadastrais',
        /*pt-pt*/'Dados Cadastrais',
        /*en-us*/'Registration Data',
        /*es-es*/'Datos de Registro'
    ]),
    tabConfiguracaoFormListDadosPessoais: traduzir([
        /*pt-br*/'Dados Pessoais',
        /*pt-pt*/'Dados Pessoais',
        /*en-us*/'Personal Data',
        /*es-es*/'Datos Personales'
    ]),
    tabConfiguracaoFormListEquipe: traduzir([
        /*pt-br*/'Equipe',
        /*pt-pt*/'Equipa',
        /*en-us*/'Team',
        /*es-es*/'Equipo'
    ]),
    tabConfiguracaoFormListAssinatura: traduzir([
        /*pt-br*/'Assinatura',
        /*pt-pt*/'Assinatura',
        /*en-us*/'Signature',
        /*es-es*/'Firma'
    ]),
    tabConfiguracaoFormListParametros: traduzir([
        /*pt-br*/'Parâmetros',
        /*pt-pt*/'Parâmetros',
        /*en-us*/'Parameters',
        /*es-es*/'Parámetros'
    ]),
    tabConfiguracaoFormListParceiros: traduzir([
        /*pt-br*/'Parceiros',
        /*pt-pt*/'Parceiros',
        /*en-us*/'Partners',
        /*es-es*/'Socios'
    ]),
    tabConfiguracaoFormListPerguntas: traduzir([
        /*pt-br*/'Formulários',
        /*pt-pt*/'Formulários',
        /*en-us*/'Forms',
        /*es-es*/'Formularios'
    ]),
    tabConfiguracaoFormListCenarios: traduzir([
        /*pt-br*/'Cenários',
        /*pt-pt*/'Cenários',
        /*en-us*/'Scenarios',
        /*es-es*/'Escenarios'
    ]),
    tabConfiguracaoFormListRelatorio: traduzir([
        /*pt-br*/'Templates',
        /*pt-pt*/'Modelos',
        /*en-us*/'Templates',
        /*es-es*/'Plantillas'
    ]),
    tabConfiguracaoFormListPagina: traduzir([
        /*pt-br*/'Páginas',
        /*pt-pt*/'Páginas',
        /*en-us*/'Pages',
        /*es-es*/'Páginas'
    ]),

    tabConfiguracaoFormEquipeListEquipe: traduzir([
        /*pt-br*/'Equipe',
        /*pt-pt*/'Equipa',
        /*en-us*/'Team',
        /*es-es*/'Equipo'
    ]),
    tabConfiguracaoFormEquipeListFiliaisUnidades: traduzir([
        /*pt-br*/'Filiais/Unidades',
        /*pt-pt*/'Filiais/Unidades',
        /*en-us*/'Branches/Units',
        /*es-es*/'Sucursales/Unidades'
    ]),
    tabConfiguracaoFormEquipeDashboardClienteAgente: traduzir([
        /*pt-br*/'Clientes x Agentes',
        /*pt-pt*/'Clientes x Agentes',
        /*en-us*/'Clients x Agents',
        /*es-es*/'Clientes x Agentes'
    ]),

    tabConfiguracaoFormParametrosListFunis: traduzir([
        /*pt-br*/'Funis',
        /*pt-pt*/'Funis',
        /*en-us*/'Funnels',
        /*es-es*/'Embudos'
    ]),
    tabConfiguracaoFormParametrosListImagemLogosCapaPaginas: traduzir([
        /*pt-br*/'Logos/Capa/Páginas',
        /*pt-pt*/'Logos/Capa/Páginas',
        /*en-us*/'Logos/Cover/Pages',
        /*es-es*/'Logos/Portada/Páginas'
    ]),
    tabConfiguracaoFormParametrosListCores: traduzir([
        /*pt-br*/'Cores',
        /*pt-pt*/'Cores',
        /*en-us*/'Colors',
        /*es-es*/'Colores'
    ]),
    tabConfiguracaoFormParametrosListParametrosCalculos: traduzir([
        /*pt-br*/'Cálculos',
        /*pt-pt*/'Cálculos',
        /*en-us*/'Calculations',
        /*es-es*/'Cálculos'
    ]),
    tabConfiguracaoFormParametrosListParametrosTextos: traduzir([
        /*pt-br*/'Textos',
        /*pt-pt*/'Textos',
        /*en-us*/'Texts',
        /*es-es*/'Textos'
    ]),
    tabConfiguracaoFormParametrosListParametrosTipoPendencia: traduzir([
        /*pt-br*/'Tipos de Pendências',
        /*pt-pt*/'Tipos de Pendências',
        /*en-us*/'Pending Types',
        /*es-es*/'Tipos de Pendencias'
    ]),
    tabConfiguracaoFormParametrosListParametrosCompartilhamento: traduzir([
        /*pt-br*/'Compartilhamento',
        /*pt-pt*/'Partilha',
        /*en-us*/'Sharing',
        /*es-es*/'Compartir'
    ]),
    tabConfiguracaoFormParametrosListParametrosPDF: traduzir([
        /*pt-br*/'PDF',
        /*pt-pt*/'PDF',
        /*en-us*/'PDF',
        /*es-es*/'PDF'
    ]),
    tabConfiguracaoFormParametrosListParametrosIntegracao: traduzir([
        /*pt-br*/'Integração',
        /*pt-pt*/'Integração',
        /*en-us*/'Integration',
        /*es-es*/'Integración'
    ]),
    tabConfiguracaoFormParametrosListParametrosComissaoSeguroVida: traduzir([
        /*pt-br*/'Comissão Seguro Vida',
        /*pt-pt*/'Comissão Seguro Vida',
        /*en-us*/'Life Insurance Commission',
        /*es-es*/'Comisión Seguro de Vida'
    ]),
    tabConfiguracaoFormParametrosListParametrosAporte: traduzir([
        /*pt-br*/'Aportes',
        /*pt-pt*/'Aportes',
        /*en-us*/'Contributions',
        /*es-es*/'Aportes'
    ]),
    tabConfiguracaoFormParametrosListParametrosGlobalizacao: traduzir([
        /*pt-br*/'Globalização',
        /*pt-pt*/'Globalização',
        /*en-us*/'Globalization',
        /*es-es*/'Globalización'
    ]),
    tabConfiguracaoFormParametrosListGestaoPatrimonial: traduzir([
        /*pt-br*/'Gestão Patrimonial',
        /*pt-pt*/'Gestão Patrimonial',
        /*en-us*/'Wealth Management',
        /*es-es*/'Gestión Patrimonial'
    ]),

    tabDashboardGraficos: traduzir([
        /*pt-br*/'Gráficos',
        /*pt-pt*/'Gráficos',
        /*en-us*/'Charts',
        /*es-es*/'Gráficos'
    ]),
    tabDashboardRelatorios: traduzir([
        /*pt-br*/'Relatórios',
        /*pt-pt*/'Relatórios',
        /*en-us*/'Reports',
        /*es-es*/'Informes'
    ]),

    tabClienteFormListDadosBasicos: traduzir([
        /*pt-br*/'Dados Básicos',
        /*pt-pt*/'Dados Básicos',
        /*en-us*/'Basic Data',
        /*es-es*/'Datos Básicos'
    ]),
    tabClienteFormListSimulacaoFinanceira: traduzir([
        /*pt-br*/'Simulação Financeira',
        /*pt-pt*/'Simulação Financeira',
        /*en-us*/'Financial Simulation',
        /*es-es*/'Simul. Financiera'//'Simulación Financiera'
    ]),

    tabClienteFormListCadastro: traduzir([
        /*pt-br*/'Cadastro',
        /*pt-pt*/'Registo',
        /*en-us*/'Registration',
        /*es-es*/'Registro'
    ]),
    tabClienteFormListFluxoCaixa: traduzir([
        /*pt-br*/'Fluxo de Caixa',
        /*pt-pt*/'Fluxo de Caixa',
        /*en-us*/'Cash Flow',
        /*es-es*/'Flujo de Caja'
    ]),
    tabClienteFormListPatrimonio: traduzir([
        /*pt-br*/'Patrimônio',
        /*pt-pt*/'Património',
        /*en-us*/'Assets',
        /*es-es*/'Patrimonio'
    ]),
    tabClienteFormListEstudo: traduzir([
        /*pt-br*/'Estudo',
        /*pt-pt*/'Estudo',
        /*en-us*/'Study',
        /*es-es*/'Estudio'
    ]),
    tabClienteFormListGestaoPatrimonial: traduzir([
        /*pt-br*/'Gestão Patrimonial',
        /*pt-pt*/'Gestão Patrimonial',
        /*en-us*/'Wealth Management',
        /*es-es*/'Gestión Patrimonial'
    ]),
    tabClienteFormListConsideracoesFinais: traduzir([
        /*pt-br*/'Considerações Finais',
        /*pt-pt*/'Considerações Finais',
        /*en-us*/'Final Considerations',
        /*es-es*/'Consid. Finales', //'Consideraciones Finales'
    ]),
    tabClienteFormListPlanoAcao: traduzir([
        /*pt-br*/'Plano de Ação',
        /*pt-pt*/'Plano de Acção',
        /*en-us*/'Action Plan',
        /*es-es*/'Plan de Acción'
    ]),
    tabClienteFormListRelatorio: traduzir([
        /*pt-br*/'Relatório',
        /*pt-pt*/'Relatório',
        /*en-us*/'Report',
        /*es-es*/'Informe'
    ]),
    tabClienteFormListAcompanhamento: traduzir([
        /*pt-br*/'Acompanhamento',
        /*pt-pt*/'Acompanhamento',
        /*en-us*/'Follow-up',
        /*es-es*/'Seguimiento'
    ]),
    tabClienteFormListPrevidenciaPrivada: traduzir([
        /*pt-br*/'Previdência Privada',
        /*pt-pt*/'Previdência Privada',
        /*en-us*/'Private Pension',
        /*es-es*/'Previsión Privada'
    ]),

    tabSimulacaoFinanceiraSimulacao: traduzir([
        /*pt-br*/'Simulação',
        /*pt-pt*/'Simulação',
        /*en-us*/'Simulation',
        /*es-es*/'Simulación'
    ]),
    tabSimulacaoFinanceiraMapaFinanceiro: traduzir([
        /*pt-br*/'Mapa Financeiro',
        /*pt-pt*/'Mapa Financeiro',
        /*en-us*/'Financial Map',
        /*es-es*/'Mapa Financiero'
    ]),
    tabSimulacaoFinanceiraReportPrimeiraReuniaoCliente: traduzir([
        /*pt-br*/'Relatorio',
        /*pt-pt*/'Relatório',
        /*en-us*/'Report',
        /*es-es*/'Informe'
    ]),
    tabSimulacaoFinanceiraReportPrimeiraReuniaoInvestimento: traduzir([
        /*pt-br*/'Investimentos',
        /*pt-pt*/'Investimentos',
        /*en-us*/'Investments',
        /*es-es*/'Inversiones'
    ]),
    tabSimulacaoFinanceiraReportPrimeiraReuniaoSeguroVida: traduzir([
        /*pt-br*/'Seguro de Vida',
        /*pt-pt*/'Seguro de Vida',
        /*en-us*/'Life Insurance',
        /*es-es*/'Seguro de Vida'
    ]),

    tabAcompanhamentoFormListPendencias: traduzir([
        /*pt-br*/'Pendências',
        /*pt-pt*/'Pendências',
        /*en-us*/'Pending Items',
        /*es-es*/'Pendencias'
    ]),
    tabAcompanhamentoFormListFunisEtapas: traduzir([
        /*pt-br*/'Funis / Etapas',
        /*pt-pt*/'Funis / Etapas',
        /*en-us*/'Funnels / Stages',
        /*es-es*/'Embudos / Etapas'
    ]),
    tabAcompanhamentoFormListAnotacoes: traduzir([
        /*pt-br*/'Anotações',
        /*pt-pt*/'Anotações',
        /*en-us*/'Notes',
        /*es-es*/'Notas'
    ]),
    tabAcompanhamentoFormListAportes: traduzir([
        /*pt-br*/'Aportes',
        /*pt-pt*/'Aportes',
        /*en-us*/'Contributions',
        /*es-es*/'Aportes'
    ]),
    tabAcompanhamentoFormListConsorcio: traduzir([
        /*pt-br*/'Consórcio',
        /*pt-pt*/'Consórcio',
        /*en-us*/'Consortium',
        /*es-es*/'Consorcio'
    ]),
    tabAcompanhamentoFormListSeguroVida: traduzir([
        /*pt-br*/'Seguro de Vida',
        /*pt-pt*/'Seguro de Vida',
        /*en-us*/'Life Insurance',
        /*es-es*/'Seguro de Vida'
    ]),
    tabAcompanhamentoFormListArquivo: traduzir([
        /*pt-br*/'Arquivo',
        /*pt-pt*/'Arquivo',
        /*en-us*/'File',
        /*es-es*/'Archivo'
    ]),

    tabApoliceFormFiltrosCamposListFiltros: traduzir([
        /*pt-br*/'Filtro',
        /*pt-pt*/'Filtro',
        /*en-us*/'Filter',
        /*es-es*/'Filtro'
    ]),
    tabApoliceFormFiltrosCamposListCampos: traduzir([
        /*pt-br*/'Campos',
        /*pt-pt*/'Campos',
        /*en-us*/'Fields',
        /*es-es*/'Campos'
    ]),

    tabApoliceFormDadosListLista: traduzir([
        /*pt-br*/'Lista',
        /*pt-pt*/'Lista',
        /*en-us*/'List',
        /*es-es*/'Lista'
    ]),
    tabApoliceFormDadosListDashboard: traduzir([
        /*pt-br*/'Dashboard',
        /*pt-pt*/'Dashboard',
        /*en-us*/'Dashboard',
        /*es-es*/'Panel de Control'
    ]),
    tabApoliceFormDadosListExtratoApolice: traduzir([
        /*pt-br*/'Extrato da Apólice',
        /*pt-pt*/'Extrato da Apólice',
        /*en-us*/'Policy Statement',
        /*es-es*/'Estado de la Póliza'
    ]),

    tabApoliceFormExtratoApoliceListApolice: traduzir([
        /*pt-br*/'Apólice',
        /*pt-pt*/'Apólice',
        /*en-us*/'Policy',
        /*es-es*/'Póliza'
    ]),
    tabApoliceFormExtratoApoliceListProposta: traduzir([
        /*pt-br*/'Proposta',
        /*pt-pt*/'Proposta',
        /*en-us*/'Proposal',
        /*es-es*/'Propuesta'
    ]),
    tabApoliceFormExtratoApoliceListSegurado: traduzir([
        /*pt-br*/'Segurado',
        /*pt-pt*/'Segurado',
        /*en-us*/'Insured',
        /*es-es*/'Asegurado'
    ]),
    tabApoliceFormExtratoApoliceListResponsávelPagamento: traduzir([
        /*pt-br*/'Resp.Pagamento',
        /*pt-pt*/'Resp.Pagamento',
        /*en-us*/'Payment Resp.',
        /*es-es*/'Resp.Pago'
    ]),	
    tabApoliceFormExtratoApoliceListCoberturas: traduzir([
        /*pt-br*/'Coberturas',
        /*pt-pt*/'Coberturas',
        /*en-us*/'Coverage',
        /*es-es*/'Coberturas'
    ]),
    tabApoliceFormExtratoApoliceListAssistências: traduzir([
        /*pt-br*/'Assistências',
        /*pt-pt*/'Assistências',
        /*en-us*/'Assistance',
        /*es-es*/'Asistencias'
    ]),
    tabApoliceFormExtratoApoliceListDadosPagamento: traduzir([
        /*pt-br*/'Dados Pagto.',
        /*pt-pt*/'Dados Pagamento',
        /*en-us*/'Payment Data',
        /*es-es*/'Datos Pago'
    ]),
    tabApoliceFormExtratoApoliceListPagamentosEmAtraso: traduzir([
        /*pt-br*/'Pagtos. Atraso',
        /*pt-pt*/'Pagamentos Atrasados',
        /*en-us*/'Overdue Payments',
        /*es-es*/'Pagos Atrasados'
    ]),
    tabApoliceFormExtratoApoliceListHistoricoPagamentos: traduzir([
        /*pt-br*/'Histórico Pagtos.',
        /*pt-pt*/'Histórico Pagamentos',
        /*en-us*/'Payment History',
        /*es-es*/'Historial Pagos'
    ]),
    tabApoliceFormExtratoApoliceListBeneficiarios: traduzir([
        /*pt-br*/'Beneficiários',
        /*pt-pt*/'Beneficiários',
        /*en-us*/'Beneficiaries',
        /*es-es*/'Beneficiarios'
    ]),
    tabApoliceFormExtratoApoliceListDocumentos: traduzir([
        /*pt-br*/'Documentos',
        /*pt-pt*/'Documentos',
        /*en-us*/'Documents',
        /*es-es*/'Documentos'
    ]),
    tabApoliceFormExtratoApoliceListEndossos: traduzir([
        /*pt-br*/'Endossos',
        /*pt-pt*/'Endossos',
        /*en-us*/'Endorsements',
        /*es-es*/'Endosos'
    ]),
    tabApoliceFormExtratoApoliceListAreaComercial: traduzir([
        /*pt-br*/'Área Comercial',
        /*pt-pt*/'Área Comercial',
        /*en-us*/'Commercial Area',
        /*es-es*/'Área Comercial'
    ]),

    premioAnualizado: traduzir([
        /*pt-br*/'Prêmio Anualizado',
        /*pt-pt*/'Prémio Anualizado',
        /*en-us*/'Annualized Premium',
        /*es-es*/'Prima Anualizada'
    ]),

    modoInteracaoCliente: traduzir([
        /*pt-br*/'Ativar modo coleta de dados / apresentação',
        /*pt-pt*/'Ativar modo recolha de dados / apresentação',
        /*en-us*/'Activate data collection / presentation mode',
        /*es-es*/'Activar modo recolección de datos / presentación'
    ]),

    emailUsuarioOwnerCliente: traduzir([
        /*pt-br*/'E-mail Usuário Owner Cliente',
        /*pt-pt*/'E-mail Utilizador Owner Cliente',
        /*en-us*/'Client Owner User Email',
        /*es-es*/'Email Usuario Propietario Cliente'
    ]),
    cliente: traduzir([
        /*pt-br*/'Cliente',
        /*pt-pt*/'Cliente',
        /*en-us*/'Client',
        /*es-es*/'Cliente'
    ]),
    nomeCliente: traduzir([
        /*pt-br*/'Cliente',
        /*pt-pt*/'Cliente',
        /*en-us*/'Client',
        /*es-es*/'Cliente'
    ]),
    nomeCompleto: traduzir([
        /*pt-br*/'Nome Completo',
        /*pt-pt*/'Nome Completo',
        /*en-us*/'Full Name',
        /*es-es*/'Nombre Completo'
    ]),
    conjuge: traduzir([
        /*pt-br*/'Cônjuge',
        /*pt-pt*/'Cônjuge',
        /*en-us*/'Spouse',
        /*es-es*/'Cónyuge'
    ]),
    nomeConjuge: traduzir([
        /*pt-br*/'Cônjuge',
        /*pt-pt*/'Cônjuge',
        /*en-us*/'Spouse',
        /*es-es*/'Cónyuge'
    ]),
    nomeCurto: traduzir([
        /*pt-br*/'Nome Curto',
        /*pt-pt*/'Nome Curto',
        /*en-us*/'Short Name',
        /*es-es*/'Nombre Corto'
    ]),
    cpf: traduzir([
        /*pt-br*/'CPF',
        /*pt-pt*/'CPF',
        /*en-us*/'Tax ID',
        /*es-es*/'Cédula'
    ]),
    rg: traduzir([
        /*pt-br*/'RG',
        /*pt-pt*/'Cartão de Cidadão',
        /*en-us*/'ID Card',
        /*es-es*/'DNI'
    ]),
    cpfCliente: traduzir([
        /*pt-br*/'CPF Cliente',
        /*pt-pt*/'CPF Cliente',
        /*en-us*/'Client Tax ID',
        /*es-es*/'Cédula Cliente'
    ]),
    emailCliente: traduzir([
        /*pt-br*/'E-mail Cliente',
        /*pt-pt*/'E-mail Cliente',
        /*en-us*/'Client Email',
        /*es-es*/'Email Cliente'
    ]),
    idClienteIntegracaoCRM: traduzir([
        /*pt-br*/'Id Integração CRM',
        /*pt-pt*/'Id Integração CRM',
        /*en-us*/'CRM Integration ID',
        /*es-es*/'ID Integración CRM'
    ]),
    cpfConjuge: traduzir([
        /*pt-br*/'CPF Cônjuge',
        /*pt-pt*/'CPF Cônjuge',
        /*en-us*/'Spouse Tax ID',
        /*es-es*/'Cédula Cónyuge'
    ]),
    emailConjuge: traduzir([
        /*pt-br*/'E-mail Cônjuge',
        /*pt-pt*/'E-mail Cônjuge',
        /*en-us*/'Spouse Email',
        /*es-es*/'Email Cónyuge'
    ]),
    nascimento: traduzir([
        /*pt-br*/'Nascimento',
        /*pt-pt*/'Nascimento',
        /*en-us*/'Birth Date',
        /*es-es*/'Fecha de Nacimiento'
    ]),
    nascimentoCliente: traduzir([
        /*pt-br*/'Nascimento Cliente',
        /*pt-pt*/'Nascimento Cliente',
        /*en-us*/'Client Birth Date',
        /*es-es*/'Fecha Nacimiento Cliente'
    ]),
    nascimentoConjuge: traduzir([
        /*pt-br*/'Nascimento Cônjuge',
        /*pt-pt*/'Nascimento Cônjuge',
        /*en-us*/'Spouse Birth Date',
        /*es-es*/'Fecha Nacimiento Cónyuge'
    ]),
    diaMesNascimento: traduzir([
        /*pt-br*/'Dia/Mês Nascimento',
        /*pt-pt*/'Dia/Mês Nascimento',
        /*en-us*/'Day/Month Birth',
        /*es-es*/'Día/Mes Nacimiento'
    ]),
    idade: traduzir([
        /*pt-br*/'Idade',
        /*pt-pt*/'Idade',
        /*en-us*/'Age',
        /*es-es*/'Edad'
    ]),
    sexo: traduzir([
        /*pt-br*/'Sexo',
        /*pt-pt*/'Sexo',
        /*en-us*/'Gender',
        /*es-es*/'Sexo'
    ]),
    tipoOrigemCliente: traduzir([
        /*pt-br*/'Origem do Cliente',
        /*pt-pt*/'Origem do Cliente',
        /*en-us*/'Client Origin',
        /*es-es*/'Origen del Cliente'
    ]),
    clienteRecomendou: traduzir([
        /*pt-br*/'Recomendado por',
        /*pt-pt*/'Recomendado por',
        /*en-us*/'Recommended by',
        /*es-es*/'Recomendado por'
    ]),
    tipoOrigemClienteOutras: traduzir([
        /*pt-br*/'Origem do Cliente - Outras',
        /*pt-pt*/'Origem do Cliente - Outras',
        /*en-us*/'Client Origin - Others',
        /*es-es*/'Origen del Cliente - Otros'
    ]),
    tipoOrigemClienteMarketingDigital: traduzir([
        /*pt-br*/'Origem do Cliente - Marketing Digital',
        /*pt-pt*/'Origem do Cliente - Marketing Digital',
        /*en-us*/'Client Origin - Digital Marketing',
        /*es-es*/'Origen del Cliente - Marketing Digital'
    ]),
    tipoCarteiraInvestimentoCliente: traduzir([
        /*pt-br*/'Tipo da Carteira de Investimento',
        /*pt-pt*/'Tipo da Carteira de Investimento',
        /*en-us*/'Investment Portfolio Type',
        /*es-es*/'Tipo de Cartera de Inversión'
    ]),
    momentoCliente: traduzir([
        /*pt-br*/'Momento do Cliente',
        /*pt-pt*/'Momento do Cliente',
        /*en-us*/'Client Moment',
        /*es-es*/'Momento del Cliente'
    ]),
    grauInstrucao: traduzir([
        /*pt-br*/'Grau Instrução',
        /*pt-pt*/'Grau de Instrução',
        /*en-us*/'Education Level',
        /*es-es*/'Nivel de Instrucción'
    ]),
    formacao: traduzir([
        /*pt-br*/'Formação',
        /*pt-pt*/'Formação',
        /*en-us*/'Education',
        /*es-es*/'Formación'
    ]),
    profissao: traduzir([
        /*pt-br*/'Profissão',
        /*pt-pt*/'Profissão',
        /*en-us*/'Profession',
        /*es-es*/'Profesión'
    ]),
    profissaoOutras: traduzir([
        /*pt-br*/'Profissão - Outras',
        /*pt-pt*/'Profissão - Outras',
        /*en-us*/'Profession - Others',
        /*es-es*/'Profesión - Otros'
    ]),
    empresa: traduzir([
        /*pt-br*/'Empresa',
        /*pt-pt*/'Empresa',
        /*en-us*/'Company',
        /*es-es*/'Empresa'
    ]),
    empresaCliente: traduzir([
        /*pt-br*/'Empresa Cliente',
        /*pt-pt*/'Empresa Cliente',
        /*en-us*/'Client Company',
        /*es-es*/'Empresa Cliente'
    ]),
    empresaConjuge: traduzir([
        /*pt-br*/'Empresa Cônjuge',
        /*pt-pt*/'Empresa Cônjuge',
        /*en-us*/'Spouse Company',
        /*es-es*/'Empresa Cónyuge'
    ]),
    ocupacao: traduzir([
        /*pt-br*/'Ocupação',
        /*pt-pt*/'Ocupação',
        /*en-us*/'Occupation',
        /*es-es*/'Ocupación'
    ]),
    ocupacaoCliente: traduzir([
        /*pt-br*/'Ocupação Cliente',
        /*pt-pt*/'Ocupação Cliente',
        /*en-us*/'Client Occupation',
        /*es-es*/'Ocupación Cliente'
    ]),
    ocupacaoConjuge: traduzir([
        /*pt-br*/'Ocupação Conjuge',
        /*pt-pt*/'Ocupação Cônjuge',
        /*en-us*/'Spouse Occupation',
        /*es-es*/'Ocupación Cónyuge'
    ]),
    possuiConjuge: traduzir([
        /*pt-br*/'Possui Cônjuge',
        /*pt-pt*/'Possui Cônjuge',
        /*en-us*/'Has Spouse',
        /*es-es*/'Tiene Cónyuge'
    ]),
    tipoRegimeBens: traduzir([
        /*pt-br*/'Regime de Bens',
        /*pt-pt*/'Regime de Bens',
        /*en-us*/'Property Regime',
        /*es-es*/'Régimen de Bienes'
    ]),
    percMeacao: traduzir([
        /*pt-br*/'% Meação',
        /*pt-pt*/'% Meação',
        /*en-us*/'% Marital Share',
        /*es-es*/'% Gananciales'
    ]),
    percHerancaFamiliarDiferenteConjuge: traduzir([
        /*pt-br*/'% Herança do Cliente é diferente do Cônjuge',
        /*pt-pt*/'% Herança do Cliente é diferente do Cônjuge',
        /*en-us*/'% Client Inheritance differs from Spouse',
        /*es-es*/'% Herencia del Cliente es diferente del Cónyuge'
    ]),
    estadoCivil: traduzir([
        /*pt-br*/'Estado Civil',
        /*pt-pt*/'Estado Civil',
        /*en-us*/'Marital Status',
        /*es-es*/'Estado Civil'
    ]),
    tipoIR: traduzir([
        /*pt-br*/'Tipo I.R.',
        /*pt-pt*/'Tipo I.R.',
        /*en-us*/'Income Tax Type',
        /*es-es*/'Tipo de Impuesto sobre la Renta'
    ]),
    familiarGeracao2: traduzir([
        /*pt-br*/'Familiar 2ª  Geração',
        /*pt-pt*/'Familiar 2.ª Geração',
        /*en-us*/'2nd Generation Family Member',
        /*es-es*/'Familiar de 2.ª Generación'
    ]),
    celularCliente: traduzir([
        /*pt-br*/'Celular Cliente',
        /*pt-pt*/'Telemóvel Cliente',
        /*en-us*/'Client Mobile',
        /*es-es*/'Celular Cliente'
    ]),
    celularConjuge: traduzir([
        /*pt-br*/'Celular Cônjuge',
        /*pt-pt*/'Telemóvel Cônjuge',
        /*en-us*/'Spouse Mobile',
        /*es-es*/'Celular Cónyuge'
    ]),

    selecionarImagem: traduzir([
        /*pt-br*/'Selecionar Imagem',
        /*pt-pt*/'Seleccionar Imagem',
        /*en-us*/'Select Image',
        /*es-es*/'Seleccionar Imagen'
    ]),

    disponibilizarInclusaoRevisaoDadosBasicos: traduzir([
        /*pt-br*/'Disponibilizar a inclusão ou revisão dos Dados Básicos: a) Dados Cadastrais b) Familiares c) Objetivos d) Perguntas',
        /*pt-pt*/'Disponibilizar a inclusão ou revisão dos Dados Básicos: a) Dados de Registo b) Familiares c) Objectivos d) Perguntas',
        /*en-us*/'Make available inclusion or revision of Basic Data: a) Registration Data b) Family c) Goals d) Questions',
        /*es-es*/'Hacer disponible la inclusión o revisión de Datos Básicos: a) Datos de Registro b) Familiares c) Objetivos d) Preguntas'
    ]),
    disponibilizarInclusaoRevisaoRiscos: traduzir([
        /*pt-br*/'Disponibilizar a inclusão ou revisão dos Riscos',
        /*pt-pt*/'Disponibilizar a inclusão ou revisão dos Riscos',
        /*en-us*/'Make available inclusion or revision of Risks',
        /*es-es*/'Hacer disponible la inclusión o revisión de Riesgos'
    ]),
    disponibilizarRelatorioSimulacaoFinanceira: traduzir([
        /*pt-br*/'Disponibilizar o Relatório da Simulação Financeira (1ª Reunião)',
        /*pt-pt*/'Disponibilizar o Relatório da Simulação Financeira (1ª Reunião)',
        /*en-us*/'Make available Financial Simulation Report (1st Meeting)',
        /*es-es*/'Hacer disponible el Informe de Simulación Financiera (1ª Reunión)'
    ]),
    disponibilizarRelatorioEstudo: traduzir([
        /*pt-br*/'Disponibilizar o Relatório do Estudo (Cliente 360º)',
        /*pt-pt*/'Disponibilizar o Relatório do Estudo (Cliente 360º)',
        /*en-us*/'Make available Study Report (360º Client)',
        /*es-es*/'Hacer disponible el Informe del Estudio (Cliente 360º)'
    ]),
    disponibilizarAcompanhamento: traduzir([
        /*pt-br*/'Disponibilizar o Acompanhamento',
        /*pt-pt*/'Disponibilizar o Acompanhamento',
        /*en-us*/'Make available Follow-up',
        /*es-es*/'Hacer disponible el Seguimiento'
    ]),
    dataHoraValidadeLink: traduzir([
        /*pt-br*/'Data/Hora Validade Link',
        /*pt-pt*/'Data/Hora Validade Link',
        /*en-us*/'Date/Time Link Validity',
        /*es-es*/'Fecha/Hora Validez Link'
    ]),
    dataHoraValidadeMaxima: traduzir([
        /*pt-br*/'A data/hora de validade máxima permitida para o Link do Cliente é $1$',
        /*pt-pt*/'A data/hora de validade máxima permitida para o Link do Cliente é $1$',
        /*en-us*/'The maximum validity date/time allowed for the Client Link is $1$',
        /*es-es*/'La fecha/hora de validez máxima permitida para el Link del Cliente es $1$'
    ]),
    gerandoLinkCliente: traduzir([
        /*pt-br*/'Gerando o link para o cliente ...',
        /*pt-pt*/'Gerando o link para o cliente ...',
        /*en-us*/'Generating client link ...',
        /*es-es*/'Generando enlace del cliente ...'
    ]),
    linkCliente: traduzir([
        /*pt-br*/'Link para o Cliente',
        /*pt-pt*/'Link para o Cliente',
        /*en-us*/'Client Link',
        /*es-es*/'Enlace del Cliente'
    ]),

    casal: traduzir([
        /*pt-br*/'CASAL',
        /*pt-pt*/'CASAL',
        /*en-us*/'COUPLE',
        /*es-es*/'PAREJA'
    ]),

    dataHoraInclusao: traduzir([
        /*pt-br*/'Data/Hora Inclusão',
        /*pt-pt*/'Data/Hora Inclusão',
        /*en-us*/'Date/Time Created',
        /*es-es*/'Fecha/Hora Inclusión'
    ]),
    dataInclusao: traduzir([
        /*pt-br*/'Data Inclusão',
        /*pt-pt*/'Data Inclusão',
        /*en-us*/'Creation Date',
        /*es-es*/'Fecha Inclusión'
    ]),
    dataHoraAlteracao: traduzir([
        /*pt-br*/'Data/Hora Alteração',
        /*pt-pt*/'Data/Hora Alteração',
        /*en-us*/'Date/Time Modified',
        /*es-es*/'Fecha/Hora Modificación'
    ]),

    familiares: traduzir([
        /*pt-br*/'Familiares',
        /*pt-pt*/'Familiares',
        /*en-us*/'Family Members',
        /*es-es*/'Familiares'
    ]),
    parentesco: traduzir([
        /*pt-br*/'Parentesco',
        /*pt-pt*/'Parentesco',
        /*en-us*/'Kinship',
        /*es-es*/'Parentesco'
    ]),
    percHeranca: traduzir([
        /*pt-br*/'% Herança',
        /*pt-pt*/'% Herança',
        /*en-us*/'% Inheritance',
        /*es-es*/'% Herencia'
    ]),
    percHerancaCliente: traduzir([
        /*pt-br*/'% Herança Cliente',
        /*pt-pt*/'% Herança Cliente',
        /*en-us*/'% Client Inheritance',
        /*es-es*/'% Herencia Cliente'
    ]),
    percHerancaConjuge: traduzir([
        /*pt-br*/'% Herança Cônjuge',
        /*pt-pt*/'% Herança Cônjuge',
        /*en-us*/'% Spouse Inheritance',
        /*es-es*/'% Herencia Cónyuge'
    ]),

    estruturaFamiliar: traduzir([
        /*pt-br*/'Estrutura Familiar',
        /*pt-pt*/'Estrutura Familiar',
        /*en-us*/'Family Structure',
        /*es-es*/'Estructura Familiar'
    ]),
    meacao: traduzir([
        /*pt-br*/'Meação',
        /*pt-pt*/'Meação',
        /*en-us*/'Marital Share',
        /*es-es*/'Gananciales'
    ]),
    heranca: traduzir([
        /*pt-br*/'Herança',
        /*pt-pt*/'Herança',
        /*en-us*/'Inheritance',
        /*es-es*/'Herencia'
    ]),
    direitoSucessorio: traduzir([
        /*pt-br*/'Direito Sucessório',
        /*pt-pt*/'Direito Sucessório',
        /*en-us*/'Succession Rights',
        /*es-es*/'Derecho Sucesorio'
    ]),

    tipoContato: traduzir([
        /*pt-br*/'Tipo Contato',
        /*pt-pt*/'Tipo Contacto',
        /*en-us*/'Contact Type',
        /*es-es*/'Tipo Contacto'
    ]),
    contato: traduzir([
        /*pt-br*/'Contato',
        /*pt-pt*/'Contacto',
        /*en-us*/'Contact',
        /*es-es*/'Contacto'
    ]),
    contatos: traduzir([
        /*pt-br*/'Contatos',
        /*pt-pt*/'Contactos',
        /*en-us*/'Contacts',
        /*es-es*/'Contactos'
    ]),

    enderecos: traduzir([
        /*pt-br*/'Endereços',
        /*pt-pt*/'Endereços',
        /*en-us*/'Addresses',
        /*es-es*/'Direcciones'
    ]),
    tipoEndereco: traduzir([
        /*pt-br*/'Tipo End.',
        /*pt-pt*/'Tipo End.',
        /*en-us*/'Address Type',
        /*es-es*/'Tipo Dir.'
    ]),
    cep: traduzir([
        /*pt-br*/'CEP',
        /*pt-pt*/'Código Postal',
        /*en-us*/'ZIP Code',
        /*es-es*/'Código Postal'
    ]),
    cepResidencial: traduzir([
        /*pt-br*/'CEP Residencial',
        /*pt-pt*/'Código Postal Residencial',
        /*en-us*/'Residential ZIP Code',
        /*es-es*/'Código Postal Residencial'
    ]),
    endereco: traduzir([
        /*pt-br*/'Endereço',
        /*pt-pt*/'Endereço',
        /*en-us*/'Address',
        /*es-es*/'Dirección'
    ]),
    numero: traduzir([
        /*pt-br*/'Número',
        /*pt-pt*/'Número',
        /*en-us*/'Number',
        /*es-es*/'Número'
    ]),
    complemento: traduzir([
        /*pt-br*/'Complemento',
        /*pt-pt*/'Complemento',
        /*en-us*/'Complement',
        /*es-es*/'Complemento'
    ]),
    bairro: traduzir([
        /*pt-br*/'Bairro',
        /*pt-pt*/'Bairro',
        /*en-us*/'Neighborhood',
        /*es-es*/'Barrio'
    ]),
    cidade: traduzir([
        /*pt-br*/'Cidade',
        /*pt-pt*/'Cidade',
        /*en-us*/'City',
        /*es-es*/'Ciudad'
    ]),
    uf: traduzir([
        /*pt-br*/'UF',
        /*pt-pt*/'Distrito',
        /*en-us*/'State',
        /*es-es*/'Estado'
    ]),

    grupoPerguntaContextoPessoalFamilia: traduzir([
        /*pt-br*/'Contexto pessoal e familiar',
        /*pt-pt*/'Contexto pessoal e familiar',
        /*en-us*/'Personal and family context',
        /*es-es*/'Contexto personal y familiar'
    ]),
    grupoPerguntaContextoProfissional: traduzir([
        /*pt-br*/'Contexto Profissional',
        /*pt-pt*/'Contexto Profissional',
        /*en-us*/'Professional Context',
        /*es-es*/'Contexto Profesional'
    ]),
    grupoPerguntaSeguranca: traduzir([
        /*pt-br*/'Segurança',
        /*pt-pt*/'Segurança',
        /*en-us*/'Security',
        /*es-es*/'Seguridad'
    ]),
    grupoPerguntaIndependenciaFinanceira: traduzir([
        /*pt-br*/'Independência Financeira',
        /*pt-pt*/'Independência Financeira',
        /*en-us*/'Financial Independence',
        /*es-es*/'Independencia Financiera'
    ]),

    objetivos: traduzir([
        /*pt-br*/'Objetivos',
        /*pt-pt*/'Objectivos',
        /*en-us*/'Goals',
        /*es-es*/'Objetivos'
    ]),
    objetivosPrincipaisPreocupacoesPFCMLP: traduzir([
        /*pt-br*/'Objetivos e Principais Preocupações com o Planejamento Financeiro de Curto, Médio e Longo Prazo',
        /*pt-pt*/'Objectivos e Principais Preocupações com o Planeamento Financeiro de Curto, Médio e Longo Prazo',
        /*en-us*/'Goals and Main Concerns with Short, Medium and Long Term Financial Planning',
        /*es-es*/'Objetivos y Principales Preocupaciones con la Planificación Financiera de Corto, Mediano y Largo Plazo'
    ]),

    riscos: traduzir([
        /*pt-br*/'Riscos',
        /*pt-pt*/'Riscos',
        /*en-us*/'Risks',
        /*es-es*/'Riesgos'
    ]),
    historicoSaudeRiscos: traduzir([
        /*pt-br*/'Histórico de Saúde/Riscos',
        /*pt-pt*/'Histórico de Saúde/Riscos',
        /*en-us*/'Health/Risk History',
        /*es-es*/'Historial de Salud/Riesgos'
    ]),
    peso: traduzir([
        /*pt-br*/'Peso (kg) (ex:75)',
        /*pt-pt*/'Peso (kg) (ex:75)',
        /*en-us*/'Weight (kg) (ex:75)',
        /*es-es*/'Peso (kg) (ej:75)'
    ]),
    altura: traduzir([
        /*pt-br*/'Altura (cm) (ex:180)',
        /*pt-pt*/'Altura (cm) (ex:180)',
        /*en-us*/'Height (cm) (ex:180)',
        /*es-es*/'Altura (cm) (ej:180)'
    ]),
    imc: traduzir([
        /*pt-br*/'IMC',
        /*pt-pt*/'IMC',
        /*en-us*/'BMI',
        /*es-es*/'IMC'
    ]),
    tipoClassificacaoImc: traduzir([
        /*pt-br*/'Classificação IMC',
        /*pt-pt*/'Classificação IMC',
        /*en-us*/'BMI Classification',
        /*es-es*/'Clasificación IMC'
    ]),
    fumante: traduzir([
        /*pt-br*/'Fumante',
        /*pt-pt*/'Fumador',
        /*en-us*/'Smoker',
        /*es-es*/'Fumador'
    ]),
    tipoFumo: traduzir([
        /*pt-br*/'Tipo de Fumo',
        /*pt-pt*/'Tipo de Tabaco',
        /*en-us*/'Smoking Type',
        /*es-es*/'Tipo de Fumo'
    ]),
    tipoFumoOutros: traduzir([
        /*pt-br*/'Tipo de Fumo - Outros',
        /*pt-pt*/'Tipo de Tabaco - Outros',
        /*en-us*/'Smoking Type - Others',
        /*es-es*/'Tipo de Fumo - Otros'
    ]),
    qtdeFumoSemanal: traduzir([
        /*pt-br*/'Qtde. Semanal',
        /*pt-pt*/'Qtd. Semanal',
        /*en-us*/'Weekly Amount',
        /*es-es*/'Cantidad Semanal'
    ]),
    utilizaMoto: traduzir([
        /*pt-br*/'Utiliza Moto',
        /*pt-pt*/'Utiliza Moto',
        /*en-us*/'Uses Motorcycle',
        /*es-es*/'Utiliza Moto'
    ]),
    tipoUtilizacaoMoto: traduzir([
        /*pt-br*/'Tipo de Utilização da Moto',
        /*pt-pt*/'Tipo de Utilização da Moto',
        /*en-us*/'Motorcycle Usage Type',
        /*es-es*/'Tipo de Utilización de Moto'
    ]),
    tipoEsporteHobbyRisco: traduzir([
        /*pt-br*/'Esporte/Hobbie de Risco',
        /*pt-pt*/'Desporto/Hobbie de Risco',
        /*en-us*/'Risk Sport/Hobby',
        /*es-es*/'Deporte/Afición de Riesgo'
    ]),
    tipoEsporteHobbyRiscoOutros: traduzir([
        /*pt-br*/'Esporte/Hobbie de Risco - Outros',
        /*pt-pt*/'Desporto/Hobbie de Risco - Outros',
        /*en-us*/'Risk Sport/Hobby - Others',
        /*es-es*/'Deporte/Afición de Riesgo - Otros'
    ]),
    informarHistoricoSaudeFamiliaresEnteadao: traduzir([
        /*pt-br*/'Informar Histórico de Saúde Familiares',
        /*pt-pt*/'Informar Histórico de Saúde Familiares',
        /*en-us*/'Report Family Health History',
        /*es-es*/'Informar Historial de Salud Familiar'
    ]),

    tipoCondicaoSaude: traduzir([
        /*pt-br*/'Condição de Saúde',
        /*pt-pt*/'Condição de Saúde',
        /*en-us*/'Health Condition',
        /*es-es*/'Condición de Salud'
    ]),
    informacoesComplementares: traduzir([
        /*pt-br*/'Informações Complementares',
        /*pt-pt*/'Informações Complementares',
        /*en-us*/'Additional Information',
        /*es-es*/'Información Complementaria'
    ]),
    idadeDesdeDoenca: traduzir([
        /*pt-br*/'Desde (Idade)',
        /*pt-pt*/'Desde (Idade)',
        /*en-us*/'Since (Age)',
        /*es-es*/'Desde (Edad)'
    ]),
    tipoSituacaoDoenca: traduzir([
        /*pt-br*/'Situação Atual',
        /*pt-pt*/'Situação Actual',
        /*en-us*/'Current Situation',
        /*es-es*/'Situación Actual'
    ]),
    idadeCirurgia: traduzir([
        /*pt-br*/'Quando (Idade)',
        /*pt-pt*/'Quando (Idade)',
        /*en-us*/'When (Age)',
        /*es-es*/'Cuándo (Edad)'
    ]),
    procedimentoCirurgia: traduzir([
        /*pt-br*/'Procedimento',
        /*pt-pt*/'Procedimento',
        /*en-us*/'Procedure',
        /*es-es*/'Procedimiento'
    ]),

    historicoSaudeFamiliares: traduzir([
        /*pt-br*/'Histórico de Saúde Familiares',
        /*pt-pt*/'Histórico de Saúde Familiares',
        /*en-us*/'Family Health History',
        /*es-es*/'Historial de Salud Familiar'
    ]),
    tipoFamiliar: traduzir([
        /*pt-br*/'Familiar',
        /*pt-pt*/'Familiar',
        /*en-us*/'Family Member',
        /*es-es*/'Familiar'
    ]),
    vivo: traduzir([
        /*pt-br*/'Vivo?',
        /*pt-pt*/'Vivo?',
        /*en-us*/'Alive?',
        /*es-es*/'¿Vivo?'
    ]),
    idadeObito: traduzir([
        /*pt-br*/'Idade óbito',
        /*pt-pt*/'Idade óbito',
        /*en-us*/'Death Age',
        /*es-es*/'Edad de fallecimiento'
    ]),
    causaObito: traduzir([
        /*pt-br*/'Causa óbito',
        /*pt-pt*/'Causa óbito',
        /*en-us*/'Cause of Death',
        /*es-es*/'Causa de fallecimiento'
    ]),

    descricao: traduzir([
        /*pt-br*/'Descrição',
        /*pt-pt*/'Descrição',
        /*en-us*/'Description',
        /*es-es*/'Descripción'
    ]),
    observacao: traduzir([
        /*pt-br*/'Observação',
        /*pt-pt*/'Observação',
        /*en-us*/'Observation',
        /*es-es*/'Observación'
    ]),

    integracaoInclusaoSiteInstitucionalCaptacaoLeadsDiagnosticoAposentadoria: traduzir([
        /*pt-br*/'Você sabe o que precisa fazer para alcançar a sua <b>Independência Financeira</b>?',
        /*pt-pt*/'Sabe o que precisa fazer para alcançar a sua <b>Independência Financeira</b>?',
        /*en-us*/'Do you know what you need to do to achieve your <b>Financial Independence</b>?',
        /*es-es*/'Sabes lo que necesitas hacer para lograr tu <b>Independencia Financiera</b>?'
    ]),
    integracaoInclusaoSiteInstitucionalCaptacaoLeadsConsorcio: traduzir([
        /*pt-br*/'Compre o imóvel desejado com um <b>Consórcio</b>?',
        /*pt-pt*/'Comprar o imóvel pretendido com um <b>Consórcio</b>?',
        /*en-us*/'Buy your desired property with a <b>Consortium</b>?',
        /*es-es*/'Comprar la propiedad deseada con un <b>Consorcio</b>?'
    ]),
    integracaoInclusaoSiteInstitucionalCaptacaoLeadsQuestionario: traduzir([
        /*pt-br*/'Perguntas chave',
        /*pt-pt*/'Perguntas-chave',
        /*en-us*/'Key Questions',
        /*es-es*/'Preguntas clave'
    ]),

    grupoDespesa: traduzir([
        /*pt-br*/'Grupo Despesa',
        /*pt-pt*/'Grupo Despesa',
        /*en-us*/'Expense Group',
        /*es-es*/'Grupo Gasto'
    ]),
    descricaoGrupoDespesaOutras: traduzir([
        /*pt-br*/'Grupo Despesa - Outras',
        /*pt-pt*/'Grupo Despesa - Outras',
        /*en-us*/'Expense Group - Others',
        /*es-es*/'Grupo Gasto - Otros'
    ]),

    despesaMensal: traduzir([
        /*pt-br*/'Despesa Mensal',
        /*pt-pt*/'Despesa Mensal',
        /*en-us*/'Monthly Expense',
        /*es-es*/'Gasto Mensual'
    ]),
    tipoDespesaMensal: traduzir([
        /*pt-br*/'Tipo Despesa Mensal',
        /*pt-pt*/'Tipo Despesa Mensal',
        /*en-us*/'Monthly Expense Type',
        /*es-es*/'Tipo Gasto Mensual'
    ]),
    
    diaDia: traduzir([
        /*pt-br*/'Dia a Dia',
        /*pt-pt*/'Dia a Dia',
        /*en-us*/'Day to Day',
        /*es-es*/'Día a Día'
    ]),
    diaDiaDespesasTemporarias: traduzir([
        /*pt-br*/'Dia a Dia - Despesas Temporárias',
        /*pt-pt*/'Dia a Dia - Despesas Temporárias',
        /*en-us*/'Day to Day - Temporary Expenses',
        /*es-es*/'Día a Día - Gastos Temporales'
    ]),
    diaDiaDespesasTemporariasDescricaoCurta: traduzir([
        /*pt-br*/'Despesas Temporárias',
        /*pt-pt*/'Despesas Temporárias',
        /*en-us*/'Temporary Expenses',
        /*es-es*/'Gastos Temporales'
    ]),
    diaDiaDespesasVitalicias: traduzir([
        /*pt-br*/'Dia a Dia - Despesas Vitalícias',
        /*pt-pt*/'Dia a Dia - Despesas Vitalícias',
        /*en-us*/'Day to Day - Lifetime Expenses',
        /*es-es*/'Día a Día - Gastos Vitalicios'
    ]),
    tipoDiaDia: traduzir([
        /*pt-br*/'Tipo Dia a Dia',
        /*pt-pt*/'Tipo Dia a Dia',
        /*en-us*/'Day to Day Type',
        /*es-es*/'Tipo Día a Día'
    ]),
    mesesAteAposentarQuebraEspecial: traduzir([
        /*pt-br*/'Meses antes<br/>Aposentar',
        /*pt-pt*/'Meses antes<br/>Aposentar',
        /*en-us*/'Months before<br/>Retirement',
        /*es-es*/'Meses antes<br/>Jubilación'
    ]),
    mesesAposAposentarQuebraEspecial: traduzir([
        /*pt-br*/'Meses após<br/>Aposentar',
        /*pt-pt*/'Meses após<br/>Aposentar',
        /*en-us*/'Months after<br/>Retirement',
        /*es-es*/'Meses después<br/>Jubilación'
    ]),
    valorDespesa: traduzir([
        /*pt-br*/'Valor Despesa',
        /*pt-pt*/'Valor Despesa',
        /*en-us*/'Expense Amount',
        /*es-es*/'Importe de Gasto'
    ]),
    valorNaAposentadoria: traduzir([
        /*pt-br*/'Valor Despesa Aposentadoria',
        /*pt-pt*/'Valor Despesa Aposentadoria',
        /*en-us*/'Retirement Expense Amount',
        /*es-es*/'Importe de Gasto en Jubilación'
    ]),
    //valorNaAposentadoriaCurto: traduzir([
    //    /*pt-br*/'Vr. Despesa Aposentadoria',
    //    /*pt-pt*/'Vr. Despesa Aposentadoria',
    //    /*en-us*/'Retirement Expense Amount',
    //    /*es-es*/'Importe de Gasto en Jubilación'
    //]),
    tipoPeriodicidadePagto: traduzir([
        /*pt-br*/'Periodicidade',
        /*pt-pt*/'Periodicidade',
        /*en-us*/'Frequency',
        /*es-es*/'Periodicidad'
    ]),
    tipoFormaPagto: traduzir([
        /*pt-br*/'Forma de Pagamento',
        /*pt-pt*/'Forma de Pagamento',
        /*en-us*/'Payment Method',
        /*es-es*/'Forma de Pago'
    ]),
    anoFinal: traduzir([
        /*pt-br*/'Ano Final',
        /*pt-pt*/'Ano Final',
        /*en-us*/'Final Year',
        /*es-es*/'Año Final'
    ]),
    valorAcumulado: traduzir([
        /*pt-br*/'Valor Acumulado',
        /*pt-pt*/'Valor Acumulado',
        /*en-us*/'Accumulated Value',
        /*es-es*/'Valor Acumulado'
    ]),
    despesaPessoal: traduzir([
        /*pt-br*/'Despesa Pessoal',
        /*pt-pt*/'Despesa Pessoal',
        /*en-us*/'Personal Expense',
        /*es-es*/'Gasto Personal'
    ]),
    despesaPessoalCurto: traduzir([
        /*pt-br*/'Desp. Pessoal',
        /*pt-pt*/'Desp. Pessoal',
        /*en-us*/'Personal Exp.',
        /*es-es*/'Gasto Pers.'
    ]),
    consumirRecursosFinanceirosEmVezDaReceitaMensal: traduzir([
        /*pt-br*/'Consumir Recursos Financeiros em vez da Receita Mensal',
        /*pt-pt*/'Consumir Recursos Financeiros em vez da Receita Mensal',
        /*en-us*/'Consume Financial Resources instead of Monthly Income',
        /*es-es*/'Consumir Recursos Financieros en lugar del Ingreso Mensual'
    ]),
    idRecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal: traduzir([
        /*pt-br*/'Recurso Financeiro Consumir',
        /*pt-pt*/'Recurso Financeiro Consumir',
        /*en-us*/'Financial Resource Consumption',
        /*es-es*/'Consumo de Recursos Financieros'
    ]),
    pessoal: traduzir([
        /*pt-br*/'Pessoal',
        /*pt-pt*/'Pessoal',
        /*en-us*/'Personal',
        /*es-es*/'Personal'
    ]),
    periodoDiaDia: traduzir([
        /*pt-br*/'Período do Dia a Dia',
        /*pt-pt*/'Período do Dia a Dia',
        /*en-us*/'Day to Day Period',
        /*es-es*/'Período del Día a Día'
    ]),
    alterarPeriodoDiaDia: traduzir([
        /*pt-br*/'Alterar Período',
        /*pt-pt*/'Alterar Período',
        /*en-us*/'Change Period',
        /*es-es*/'Cambiar Período'
    ]),
    diaDiaIraOcorrerAteExpectativaVida: traduzir([
        /*pt-br*/'Despesa irá ocorrer até a Expectativa de Vida',
        /*pt-pt*/'Despesa irá ocorrer até a Expectativa de Vida',
        /*en-us*/'Expense will occur until Life Expectancy',
        /*es-es*/'Gasto ocurrirá hasta la Esperanza de Vida'
    ]),
    valorCompra: traduzir([
        /*pt-br*/'Valor Compra',
        /*pt-pt*/'Valor de Compra',
        /*en-us*/'Purchase Value',
        /*es-es*/'Valor de Compra'
    ]),
    titularRespValorCompra: traduzir([
        /*pt-br*/'Responsável',
        /*pt-pt*/'Responsável',
        /*en-us*/'Responsible',
        /*es-es*/'Responsable'
    ]),

    educacao: traduzir([
        /*pt-br*/'Educação',
        /*pt-pt*/'Educação',
        /*en-us*/'Education',
        /*es-es*/'Educación'
    ]),
    tipoEducacao: traduzir([
        /*pt-br*/'Tipo Educação',
        /*pt-pt*/'Tipo de Educação',
        /*en-us*/'Education Type',
        /*es-es*/'Tipo de Educación'
    ]),
    familiar: traduzir([
        /*pt-br*/'Familiar',
        /*pt-pt*/'Familiar',
        /*en-us*/'Family Member',
        /*es-es*/'Familiar'
    ]),
    familiarInventario: traduzir([
        /*pt-br*/'Familiar Inventário',
        /*pt-pt*/'Familiar Inventário',
        /*en-us*/'Family Member Inventory',
        /*es-es*/'Inventario Familiar'
    ]),
    idadeInicial: traduzir([
        /*pt-br*/'Idade Inicial',
        /*pt-pt*/'Idade Inicial',
        /*en-us*/'Starting Age',
        /*es-es*/'Edad Inicial'
    ]),
    idadeFinal: traduzir([
        /*pt-br*/'Idade Final',
        /*pt-pt*/'Idade Final',
        /*en-us*/'Final Age',
        /*es-es*/'Edad Final'
    ]),
    tipoSegurado: traduzir([
        /*pt-br*/'Segurado',
        /*pt-pt*/'Segurado',
        /*en-us*/'Insured',
        /*es-es*/'Asegurado'
    ]),

    financiamento: traduzir([
        /*pt-br*/'Financiamento',
        /*pt-pt*/'Financiamento',
        /*en-us*/'Financing',
        /*es-es*/'Financiamiento'
    ]),
    tipoFinanciamento: traduzir([
        /*pt-br*/'Tipo Financiamento',
        /*pt-pt*/'Tipo de Financiamento',
        /*en-us*/'Financing Type',
        /*es-es*/'Tipo de Financiamiento'
    ]),
    tabelaSAC: traduzir([
        /*pt-br*/'Tabela SAC',
        /*pt-pt*/'Tabela SAC',
        /*en-us*/'SAC Table',
        /*es-es*/'Tabla SAC'
    ]),
    tabelaSACAbreviado: traduzir([
        /*pt-br*/'SAC',
        /*pt-pt*/'SAC',
        /*en-us*/'SAC',
        /*es-es*/'SAC'
    ]),
    taxaAnualTR: traduzir([
        /*pt-br*/'TR Anual (%)',
        /*pt-pt*/'TR Anual (%)',
        /*en-us*/'Annual TR (%)',
        /*es-es*/'TR Anual (%)'
    ]),

    consorcio: traduzir([
        /*pt-br*/'Consórcio',
        /*pt-pt*/'Consórcio',
        /*en-us*/'Consortium',
        /*es-es*/'Consorcio'
    ]),
    simulacaoConsorcio: traduzir([
        /*pt-br*/'Simulação de Consórcio',
        /*pt-pt*/'Simulação de Consórcio',
        /*en-us*/'Consortium Simulation',
        /*es-es*/'Simulación de Consorcio'
    ]),
    primeiroReajuste: traduzir([
        /*pt-br*/'Primeiro ou Próximo Reajuste',
        /*pt-pt*/'Primeiro ou Próximo Ajuste',
        /*en-us*/'First or Next Adjustment',
        /*es-es*/'Primer o Próximo Ajuste'
    ]),
    mesAnoPrimeiroReajuste: traduzir([
        /*pt-br*/'Mês/Ano Prim. ou Próx. Reajuste',
        /*pt-pt*/'Mês/Ano do Primeiro ou Próximo Ajuste',
        /*en-us*/'Month/Year of First or Next Adjustment',
        /*es-es*/'Mes/Año del Primer o Próximo Ajuste'
    ]),
    valorParcela: traduzir([
        /*pt-br*/'Valor Parcela',
        /*pt-pt*/'Valor da Parcela',
        /*en-us*/'Installment Amount',
        /*es-es*/'Valor de Cuota'
    ]),
    valorParcelaAtual: traduzir([
        /*pt-br*/'Valor Parcela Atual',
        /*pt-pt*/'Valor da Parcela Atual',
        /*en-us*/'Current Installment Amount',
        /*es-es*/'Valor de Cuota Actual'
    ]),
    qtdeParcelas: traduzir([
        /*pt-br*/'Parcelas Pendentes',
        /*pt-pt*/'Parcelas Pendentes',
        /*en-us*/'Pending Installments',
        /*es-es*/'Cuotas Pendientes'
    ]),
    qtdeParcelasAbreviado: traduzir([
        /*pt-br*/'Parc.Pend.',
        /*pt-pt*/'Parc.Pend.',
        /*en-us*/'Pend.Inst.',
        /*es-es*/'Cuot.Pend.'
    ]),
    valorTotalParcelas: traduzir([
        /*pt-br*/'Valor Parcelas Pendentes',
        /*pt-pt*/'Valor das Parcelas Pendentes',
        /*en-us*/'Total Pending Installments',
        /*es-es*/'Valor de Cuotas Pendientes'
    ]),
    valorTotalParcelasAbreviado: traduzir([
        /*pt-br*/'Vr.Parcelas Pendentes',
        /*pt-pt*/'Vr.Parcelas Pendentes',
        /*en-us*/'Amt.Pending Inst.',
        /*es-es*/'Vr.Cuotas Pendientes'
    ]),
    valorSaldoDevedor: traduzir([
        /*pt-br*/'Saldo Devedor',
        /*pt-pt*/'Saldo Devedor',
        /*en-us*/'Outstanding Balance',
        /*es-es*/'Saldo Deudor'
    ]),
    possuiParcelasAdicionais: traduzir([
        /*pt-br*/'Possui parcelas adicionais',
        /*pt-pt*/'Possui parcelas adicionais',
        /*en-us*/'Has additional installments',
        /*es-es*/'Tiene cuotas adicionales'
    ]),
    temSeguro: traduzir([
        /*pt-br*/'Tem Seguro?',
        /*pt-pt*/'Tem Seguro?',
        /*en-us*/'Has Insurance?',
        /*es-es*/'¿Tiene Seguro?'
    ]),
    financiamentoFuturo: traduzir([
        /*pt-br*/'Financiamento irá ocorrer no futuro',
        /*pt-pt*/'Financiamento irá ocorrer no futuro',
        /*en-us*/'Financing will occur in the future',
        /*es-es*/'El financiamiento ocurrirá en el futuro'
    ]),
    financiamentoFuturoAindaNaoContratado: traduzir([
        /*pt-br*/'Financiamento ainda não foi contratado',
        /*pt-pt*/'Financiamento ainda não foi contratado',
        /*en-us*/'Financing has not been contracted yet',
        /*es-es*/'El financiamiento aún no ha sido contratado'
    ]),
    financiamentoSeraQuitadoAntesUltimaParcela: traduzir([
        /*pt-br*/'Financiamento será quitado antes da última parcela',
        /*pt-pt*/'Financiamento será quitado antes da última parcela',
        /*en-us*/'Financing will be paid off before the last installment',
        /*es-es*/'El financiamiento será liquidado antes de la última cuota'
    ]),
    ultimaParcela: traduzir([
        /*pt-br*/'Última Parcela',
        /*pt-pt*/'Última Parcela',
        /*en-us*/'Last Installment',
        /*es-es*/'Última Cuota'
    ]),
    alterarPercSeguroConjuge: traduzir([
        /*pt-br*/'Alterar %',
        /*pt-pt*/'Alterar %',
        /*en-us*/'Change %',
        /*es-es*/'Cambiar %'
    ]),
    resumoParcelas: traduzir([
        /*pt-br*/'Resumo das Parcelas',
        /*pt-pt*/'Resumo das Parcelas',
        /*en-us*/'Installments Summary',
        /*es-es*/'Resumen de Cuotas'
    ]),
    parcelasMesAMes: traduzir([
        /*pt-br*/'Parcelas Mês a Mês',
        /*pt-pt*/'Parcelas Mês a Mês',
        /*en-us*/'Month by Month Installments',
        /*es-es*/'Cuotas Mes a Mes'
    ]),

    calcularTaxaMensalAnualResumoComBaseCreditoLiberado: traduzir([
        /*pt-br*/'Calcular as Taxas Mensal e Anual do Resumo com base no Crédito Liberado',
        /*pt-pt*/'Calcular as Taxas Mensal e Anual do Resumo com base no Crédito Disponibilizado',
        /*en-us*/'Calculate the Summary Monthly and Annual Rates based on the Released Credit',
        /*es-es*/'Calcular las Tasas Mensual y Anual del Resumen en función del Crédito Liberado'
    ]),
    naoExibirLogo: traduzir([
        /*pt-br*/'Não exibir a logo desta Simulação de Consórcio nem na opção "Visualizar Resumo" nem no relatório',
        /*pt-pt*/'Não exibir o logótipo desta Simulação de Consórcio nem na opção "Visualizar Resumo" nem no relatório',
        /*en-us*/'Do not display the logo of this Consortium Simulation either in the "View Summary" option or in the report',
        /*es-es*/'No mostrar el logo de esta Simulación de Consorcio ni en la opción "Ver Resumen" ni en el informe'
    ]),
    naoExibirRelatorio: traduzir([
        /*pt-br*/'Não exibir esta Simulação de Consórcio no relatório',
        /*pt-pt*/'Não exibir esta Simulação de Consórcio no relatório',
        /*en-us*/'Do not display this Consortium Simulation in the report',
        /*es-es*/'No mostrar esta Simulación de Consorcio en el informe'
    ]),

    numeroConsorcio: traduzir([
        /*pt-br*/'Número Consórcio',
        /*pt-pt*/'Número do Consórcio',
        /*en-us*/'Consortium Number',
        /*es-es*/'Número de Consorcio'
    ]),
    nomeConsorciado: traduzir([
        /*pt-br*/'Consorciado',
        /*pt-pt*/'Consorciado',
        /*en-us*/'Consortium Member',
        /*es-es*/'Consorcista'
    ]),
    administradoraConsorcio: traduzir([
        /*pt-br*/'Administradora Consórcio',
        /*pt-pt*/'Administradora do Consórcio',
        /*en-us*/'Consortium Administrator',
        /*es-es*/'Administradora del Consorcio'
    ]),
    tipoConsorcio: traduzir([
        /*pt-br*/'Tipo Consórcio',
        /*pt-pt*/'Tipo de Consórcio',
        /*en-us*/'Consortium Type',
        /*es-es*/'Tipo de Consorcio'
    ]),
    grupoConsorcio: traduzir([
        /*pt-br*/'Grupo',
        /*pt-pt*/'Grupo',
        /*en-us*/'Group',
        /*es-es*/'Grupo'
    ]),
    cotaConsorcio: traduzir([
        /*pt-br*/'Cota',
        /*pt-pt*/'Cota',
        /*en-us*/'Share',
        /*es-es*/'Cuota'
    ]),
    pessoaFisicaJuridica: traduzir([
        /*pt-br*/'Pessoa Física/Jurídica',
        /*pt-pt*/'Pessoa Física/Jurídica',
        /*en-us*/'Individual/Legal Entity',
        /*es-es*/'Persona Física/Jurídica'
    ]),
    statusGrupoConsorcio: traduzir([
        /*pt-br*/'Status do Grupo',
        /*pt-pt*/'Estado do Grupo',
        /*en-us*/'Group Status',
        /*es-es*/'Estado del Grupo'
    ]),
    dataAssembleia: traduzir([
        /*pt-br*/'Data Assembleia',
        /*pt-pt*/'Data da Assembleia',
        /*en-us*/'Assembly Date',
        /*es-es*/'Fecha de Asamblea'
    ]),
    numeroAssembleiaParticipacao: traduzir([
        /*pt-br*/'Nº Assembleia de Participação',
        /*pt-pt*/'Nº Assembleia de Participação',
        /*en-us*/'Participation Assembly No.',
        /*es-es*/'N° Asamblea de Participación'
    ]),
    valorCreditoConsorcio: traduzir([
        /*pt-br*/'Valor Crédito',
        /*pt-pt*/'Valor do Crédito',
        /*en-us*/'Credit Amount',
        /*es-es*/'Valor del Crédito'
    ]),
    valorUpGradeCreditoConsorcio: traduzir([
        /*pt-br*/'Up Grade',
        /*pt-pt*/'Up Grade',
        /*en-us*/'Up Grade',
        /*es-es*/'Up Grade'
    ]),
    valorParcelaInicial: traduzir([
        /*pt-br*/'Valor Parcela Inicial',
        /*pt-pt*/'Valor da Parcela Inicial',
        /*en-us*/'Initial Installment Amount',
        /*es-es*/'Valor de Cuota Inicial'
    ]),
    dataVenctoBoleto: traduzir([
        /*pt-br*/'Data Vencimento Boleto',
        /*pt-pt*/'Data de Vencimento do Boleto',
        /*en-us*/'Payment Due Date',
        /*es-es*/'Fecha de Vencimiento del Boleto'
    ]),
    prazoTotalGrupoConsorcio: traduzir([
        /*pt-br*/'Prazo Total Grupo',
        /*pt-pt*/'Prazo Total do Grupo',
        /*en-us*/'Total Group Term',
        /*es-es*/'Plazo Total del Grupo'
    ]),
    prazoAtualGrupoConsorcio: traduzir([
        /*pt-br*/'Prazo Atual Grupo',
        /*pt-pt*/'Prazo Atual do Grupo',
        /*en-us*/'Current Group Term',
        /*es-es*/'Plazo Actual del Grupo'
    ]),
    prazoOriginalGrupoConsorcio: traduzir([
        /*pt-br*/'Prazo Original Grupo',
        /*pt-pt*/'Prazo Original do Grupo',
        /*en-us*/'Original Group Term',
        /*es-es*/'Plazo Original del Grupo'
    ]),
    prazoTotalCotaConsorcio: traduzir([
        /*pt-br*/'Prazo Total Cota',
        /*pt-pt*/'Prazo Total da Cota',
        /*en-us*/'Total Quota Term',
        /*es-es*/'Plazo Total de la Cuota'
    ]),
    numeroTotalParticipantesGrupoConsorcio: traduzir([
        /*pt-br*/'Total Participantes',
        /*pt-pt*/'Total de Participantes',
        /*en-us*/'Total Participants',
        /*es-es*/'Total de Participantes'
    ]),
    taxaAdministracaoTotal: traduzir([
        /*pt-br*/'Taxa Adm. Total',
        /*pt-pt*/'Taxa de Administração Total',
        /*en-us*/'Total Admin Fee',
        /*es-es*/'Tasa de Adm. Total'
    ]),
    percFundoReserva: traduzir([
        /*pt-br*/'% Fundo Reserva',
        /*pt-pt*/'% Fundo de Reserva',
        /*en-us*/'% Reserve Fund',
        /*es-es*/'% Fondo de Reserva'
    ]),
    fundoReservaSeraDevolvidoFinal: traduzir([
        /*pt-br*/'Fundo Reserva será devolvido no final',
        /*pt-pt*/'Fundo de Reserva será devolvido no final',
        /*en-us*/'Reserve Fund will be returned at the end',
        /*es-es*/'El Fondo de Reserva será devuelto al final'
    ]),
    mesesDevolucaoFundoReserva: traduzir([
        /*pt-br*/'Meses p/ Devolução (1, 2, 3, ...)',
        /*pt-pt*/'Meses para Devolução (1, 2, 3, ...)',
        /*en-us*/'Months for Return (1, 2, 3, ...)',
        /*es-es*/'Meses para Devolución (1, 2, 3, ...)'
    ]),
    percDevolucaoFundoReserva: traduzir([
        /*pt-br*/'% Devolução (100%, 50%, ...)',
        /*pt-pt*/'% Devolução (100%, 50%, ...)',
        /*en-us*/'% Return (100%, 50%, ...)',
        /*es-es*/'% Devolución (100%, 50%, ...)'
    ]),
    devolucaoFundoReserva: traduzir([
        /*pt-br*/'Devolução do Fundo de Reserva',
        /*pt-pt*/'Devolução do Fundo de Reserva',
        /*en-us*/'Reserve Fund Return',
        /*es-es*/'Devolución del Fondo de Reserva'
    ]),
    percSeguroPrestamista: traduzir([
        /*pt-br*/'% Seguro Prestamista (taxa mensal)',
        /*pt-pt*/'% Seguro Prestamista (taxa mensal)',
        /*en-us*/'% Credit Life Insurance (monthly rate)',
        /*es-es*/'% Seguro de Desgravamen (tasa mensual)'
    ]),
    percLanceEmbutido: traduzir([
        /*pt-br*/'% Lance Embutido',
        /*pt-pt*/'% Lance Embutido',
        /*en-us*/'% Embedded Bid',
        /*es-es*/'% Oferta Integrada'
    ]),
    percLanceFixo: traduzir([
        /*pt-br*/'% Lance Fixo',
        /*pt-pt*/'% Lance Fixo',
        /*en-us*/'% Fixed Bid',
        /*es-es*/'% Oferta Fija'
    ]),
    idCorretorConsorcios: traduzir([
        /*pt-br*/'Corretor de Consórcios',
        /*pt-pt*/'Consultor de Consórcios',
        /*en-us*/'Consortium Broker',
        /*es-es*/'Corredor de Consorcios'
    ]),
    codigoAgenteCorretorConsorcios: traduzir([
        /*pt-br*/'Código Corretor Consórcios',
        /*pt-pt*/'Código Corretor Consórcios',
        /*en-us*/'Consortium Broker Code',
        /*es-es*/'Código Corredor Consorcios'
    ]),

    credito: traduzir([
        /*pt-br*/'Crédito',
        /*pt-pt*/'Crédito',
        /*en-us*/'Credit',
        /*es-es*/'Crédito'
    ]),
    parcelaAteComtemplacao: traduzir([
        /*pt-br*/'Parcela até Contemplação',
        /*pt-pt*/'Parcela até Contemplação',
        /*en-us*/'Installment until Contemplation',
        /*es-es*/'Cuota hasta Contemplación'
    ]),
    estrategiaLance: traduzir([
        /*pt-br*/'Estratégia do Lance',
        /*pt-pt*/'Estratégia do Lance',
        /*en-us*/'Bid Strategy',
        /*es-es*/'Estrategia de Oferta'
    ]),
    lanceTotal: traduzir([
        /*pt-br*/'Lance Total',
        /*pt-pt*/'Lance Total',
        /*en-us*/'Total Bid',
        /*es-es*/'Oferta Total'
    ]),
    lanceRecursosProprios: traduzir([
        /*pt-br*/'Recursos Próprios',
        /*pt-pt*/'Recursos Próprios',
        /*en-us*/'Own Resources',
        /*es-es*/'Recursos Propios'
    ]),
    valorLanceRecursosProprios: traduzir([
        /*pt-br*/'Valor Lance Recursos Próprios',
        /*pt-pt*/'Valor do Lance com Recursos Próprios',
        /*en-us*/'Own Funds Bid Amount',
        /*es-es*/'Valor de la Oferta con Recursos Propios'
    ]),
    cacularPercLanceRecursosProprios: traduzir([
        /*pt-br*/'Calcular % Lance Recursos Próprios',
        /*pt-pt*/'Calcular % do Lance com Recursos Próprios',
        /*en-us*/'Calculate % of Own Funds Bid',
        /*es-es*/'Calcular % de la Oferta con Recursos Propios'
    ]),
    lanceEmbutido: traduzir([
        /*pt-br*/'Lance Embutido',
        /*pt-pt*/'Lance Embutido',
        /*en-us*/'Embedded Bid',
        /*es-es*/'Oferta Integrada'
    ]),
    valorLanceEmbutido: traduzir([
        /*pt-br*/'Valor Lance Embutido',
        /*pt-pt*/'Valor do Lance Embutido',
        /*en-us*/'Embedded Bid Amount',
        /*es-es*/'Valor de la Oferta Embebida'
    ]),
    cacularPercLanceEmbutido: traduzir([
        /*pt-br*/'Calcular % Lance Embutido',
        /*pt-pt*/'Calcular % do Lance Embutido',
        /*en-us*/'Calculate % of Embedded Bid',
        /*es-es*/'Calcular % de la Oferta Embebida'
    ]),
    lanceIntegrado: traduzir([
        /*pt-br*/'Lance Integrado',
        /*pt-pt*/'Lance Integrado',
        /*en-us*/'Integrated Bid',
        /*es-es*/'Oferta Integrada'
    ]),
    formaAbaterLance: traduzir([
        /*pt-br*/'Forma de Abater o Lance',
        /*pt-pt*/'Forma de Abater o Lance',
        /*en-us*/'Way to Deduct the Bid',
        /*es-es*/'Forma de Reducir la Oferta'
    ]),
    percLanceSobreCredito: traduzir([
        /*pt-br*/'Lance sobre o Crédito',
        /*pt-pt*/'Lance sobre o Crédito',
        /*en-us*/'Bid on Credit',
        /*es-es*/'Oferta sobre el Crédito'
    ]),
    percLanceEfetivo: traduzir([
        /*pt-br*/'Lance Efetivo',
        /*pt-pt*/'Lance Efetivo',
        /*en-us*/'Effective Bid',
        /*es-es*/'Oferta Efectiva'
    ]),
    estimativaPosContemplacao: traduzir([
        /*pt-br*/'Pós-Contemplação',
        /*pt-pt*/'Pós-Contemplação',
        /*en-us*/'Post-Contemplation',
        /*es-es*/'Post-Contemplación'
    ]),
    taxasGrupo: traduzir([
        /*pt-br*/'Taxas do Grupo',
        /*pt-pt*/'Taxas do Grupo',
        /*en-us*/'Group Fees',
        /*es-es*/'Tasas del Grupo'
    ]),
    taxaAdesao: traduzir([
        /*pt-br*/'Taxa Antecipação',
        /*pt-pt*/'Taxa de Antecipação',
        /*en-us*/'Anticipation Fee',
        /*es-es*/'Tasa de Anticipación'
    ]),
    adesao: traduzir([
        /*pt-br*/'Antecipação',
        /*pt-pt*/'Antecipação',
        /*en-us*/'Anticipation',
        /*es-es*/'Anticipación'
    ]),
    taxa: traduzir([
        /*pt-br*/'taxa',
        /*pt-pt*/'taxa',
        /*en-us*/'rate',
        /*es-es*/'tasa'
    ]),
    reajusteAbreviado: traduzir([
        /*pt-br*/'Reaj.',
        /*pt-pt*/'Reaj.',
        /*en-us*/'Adjus.',
        /*es-es*/'Ajuste'
    ]),
    taxaEfetivaMensal: traduzir([
        /*pt-br*/'a.m.',
        /*pt-pt*/'a.m.',
        /*en-us*/'p.m.',
        /*es-es*/'m.m.'
    ]),
    taxaEfetivaAnual: traduzir([
        /*pt-br*/'a.a.',
        /*pt-pt*/'a.a.',
        /*en-us*/'p.a.',
        /*es-es*/'a.a.'
    ]),
    valorParcelaInicialSemRedutor: traduzir([
        /*pt-br*/'Parcela sem Redutor',
        /*pt-pt*/'Parcela sem Redutor',
        /*en-us*/'Installment without Reducer',
        /*es-es*/'Cuota sin Reductor'
    ]),
    percRedutorParcela: traduzir([
        /*pt-br*/'% Redutor Parcela',
        /*pt-pt*/'% Redutor da Parcela',
        /*en-us*/'% Installment Reducer',
        /*es-es*/'% Reductor de Cuota'
    ]),
    valorEconomiaRedutorParcela: traduzir([
        /*pt-br*/'Economia Redutor Parcela',
        /*pt-pt*/'Economia do Redutor da Parcela',
        /*en-us*/'Installment Reducer Savings',
        /*es-es*/'Ahorro del Reductor de Cuota'
    ]),
    //categoria: traduzir([
    //    /*pt-br*/'Categoria',
    //    /*pt-pt*/'Categoria',
    //    /*en-us*/'Category',
    //    /*es-es*/'Categoría'
    //]),
    //lanceFixo: traduzir([
    //    /*pt-br*/'Lance Fixo',
    //    /*pt-pt*/'Lance Fixo',
    //    /*en-us*/'Fixed Bid',
    //    /*es-es*/'Oferta Fija'
    //]),
    //lanceLivre: traduzir([
    //    /*pt-br*/'Lance Livre',
    //    /*pt-pt*/'Lance Livre',
    //    /*en-us*/'Free Bid',
    //    /*es-es*/'Oferta Libre'
    //]),
    creditoDisponivel: traduzir([
        /*pt-br*/'Crédito Disponível',
        /*pt-pt*/'Crédito Disponível',
        /*en-us*/'Available Credit',
        /*es-es*/'Crédito Disponible'
    ]),
    contemplacaoParcela: traduzir([
        /*pt-br*/'Contemplação na Parcela',
        /*pt-pt*/'Contemplação na Parcela',
        /*en-us*/'Contemplation at Installment',
        /*es-es*/'Contemplación en la Cuota'
    ]),
    valorCreditoConsorcioContemplacao: traduzir([
        /*pt-br*/'Crédito Contemplação (%Reaj=$1$%a.a.)',
        /*pt-pt*/'Crédito Contemplação (%Reaj=$1$%a.a.)',
        /*en-us*/'Contemplation Credit (%Adj=$1$%p.a.)',
        /*es-es*/'Crédito Contemplación (%Reaj=$1$%a.a.)'
    ]),
    valorCreditoConsorcioContemplacaoAbreviado: traduzir([
        /*pt-br*/'Crédito Contemplação',
        /*pt-pt*/'Crédito Contemplação',
        /*en-us*/'Contemplation Credit',
        /*es-es*/'Crédito Contemplación'
    ]),
    valorImovel: traduzir([
        /*pt-br*/'Valor Imóvel',
        /*pt-pt*/'Valor do Imóvel',
        /*en-us*/'Property Value',
        /*es-es*/'Valor del Inmueble'
    ]),
    parcelasTCV: traduzir([
        /*pt-br*/'Parcelas TCV',
        /*pt-pt*/'Parcelas TCV',
        /*en-us*/'TCV Installments',
        /*es-es*/'Cuotas TCV'
    ]),
    //prazoRestanteAposContemplacao: traduzir([
    //    /*pt-br*/'Prazo Restante após Contemplação',
    //    /*pt-pt*/'Prazo Restante após Contemplação',
    //    /*en-us*/'Remaining Term after Contemplation',
    //    /*es-es*/'Plazo Restante después de Contemplación'
    //]),
    //tipoGrupoConsorcio: traduzir([
    //    /*pt-br*/'Tipo Grupo',
    //    /*pt-pt*/'Tipo de Grupo',
    //    /*en-us*/'Group Type',
    //    /*es-es*/'Tipo de Grupo'
    //]),
    parcelaAposComtemplacao: traduzir([
        /*pt-br*/'Parcela após Contemplação',
        /*pt-pt*/'Parcela após Contemplação',
        /*en-us*/'Installment after Contemplation',
        /*es-es*/'Cuota después de Contemplación'
    ]),
    vezes: traduzir([
        /*pt-br*/'x',
        /*pt-pt*/'x',
        /*en-us*/'x',
        /*es-es*/'x'
    ]),
    //prazoRestanteAposContemplacaoReducaoParcela: traduzir([
    //    /*pt-br*/'Redução Parcela: Prazo Restante',
    //    /*pt-pt*/'Redução de Parcela: Prazo Restante',
    //    /*en-us*/'Installment Reduction: Remaining Term',
    //    /*es-es*/'Reducción de Cuota: Plazo Restante'
    //]),
    //parcelaAposComtemplacaoReducaoParcela: traduzir([
    //   /*pt-br*/'Redução Parcela: Valor Parcela',
    //   /*pt-pt*/'Redução de Parcela: Valor da Parcela',
    //   /*en-us*/'Installment Reduction: Installment Amount',
    //   /*es-es*/'Reducción de Cuota: Valor de Cuota'
    //]),
    //prazoRestanteAposContemplacaoReducaoPrazo: traduzir([
    //    /*pt-br*/'Redução Prazo: Valor Parcela',
    //    /*pt-pt*/'Redução de Prazo: Valor da Parcela',
    //    /*en-us*/'Term Reduction: Installment Amount',
    //    /*es-es*/'Reducción de Plazo: Valor de Cuota'
    //]),
    naoSeAplica: traduzir([
        /*pt-br*/'N/A',
        /*pt-pt*/'N/A',
        /*en-us*/'N/A',
        /*es-es*/'N/A'
    ]),
    parcelaAposComtemplacaoReducaoPrazo: traduzir([
        /*pt-br*/'Redução Prazo',
        /*pt-pt*/'Redução de Prazo',
        /*en-us*/'Term Reduction',
        /*es-es*/'Reducción de Plazo'
    ]),
    saldoDevedorAposComtemplacao: traduzir([
        /*pt-br*/'Saldo Devedor após Contemplação',
        /*pt-pt*/'Saldo Devedor após Contemplação',
        /*en-us*/'Outstanding Balance after Contemplation',
        /*es-es*/'Saldo Deudor después de Contemplación'
    ]),
    analisarAluguelAposContemplacao: traduzir([
        /*pt-br*/'Analisar Aluguel após Contemplação',
        /*pt-pt*/'Analisar Renda após Contemplação',
        /*en-us*/'Analyze Rent after Contemplation',
        /*es-es*/'Analizar Alquiler después de la Contemplación'
    ]),
    mesesIniciarAluguelAposContemplacao: traduzir([
        /*pt-br*/'Meses Iniciar (1, 2, 3, ...)',
        /*pt-pt*/'Meses para Iniciar (1, 2, 3, ...)',
        /*en-us*/'Months to Start (1, 2, 3, ...)',
        /*es-es*/'Meses para Iniciar (1, 2, 3, ...)'
    ]),
    percAluguelMensalAposContemplacao: traduzir([
        /*pt-br*/'% Aluguel a.m. (0,6%, 0,7%, ...)',
        /*pt-pt*/'% Renda a.m. (0,6%, 0,7%, ...)',
        /*en-us*/'% Monthly Rent (0.6%, 0.7%, ...)',
        /*es-es*/'% Alquiler mensual (0,6%, 0,7%, ...)'
    ]),
    percReajusteAluguelAnualAposContemplacao: traduzir([
        /*pt-br*/'% Reajuste Aluguel a.a. (4%, 5%, ...)',
        /*pt-pt*/'% Atualização Anual da Renda (4%, 5%, ...)',
        /*en-us*/'Annual Rent Increase % (4%, 5%, ...)',
        /*es-es*/'% Incremento Anual del Alquiler (4%, 5%, ...)'
    ]),
    mesAnoInicialAluguelAposContemplacao: traduzir([
        /*pt-br*/'Mês/Ano Início Aluguel',
        /*pt-pt*/'Mês/Ano Início Renda',
        /*en-us*/'Month/Year Rent Start',
        /*es-es*/'Mes/Año Inicio Alquiler'
    ]),
    valorAluguelAposContemplacao: traduzir([
        /*pt-br*/'Valor Aluguel',
        /*pt-pt*/'Valor Renda',
        /*en-us*/'Rent Amount',
        /*es-es*/'Valor Alquiler'
    ]),
    saldoAluguelAposContemplacao: traduzir([
        /*pt-br*/'Saldo Aluguel',
        /*pt-pt*/'Saldo de Aluguer',
        /*en-us*/'Rent Balance',
        /*es-es*/'Saldo de Alquiler'
    ]),
    saldoInvestimentoAluguelAposContemplacao: traduzir([
        /*pt-br*/'Saldo Investimento',
        /*pt-pt*/'Saldo Renda',
        /*en-us*/'Rent Balance',
        /*es-es*/'Saldo Alquiler'
    ]),
    percValorizacaoImovelAluguelAposContemplacao: traduzir([
        /*pt-br*/'% Valorização Imóvel a.a.',
        /*pt-pt*/'% Valorização do Imóvel a.a.',
        /*en-us*/'% Property Appreciation p.a.',
        /*es-es*/'% Revalorización del Inmueble a.a.'
    ]),
    valorImovelAluguelAposContemplacao: traduzir([
        /*pt-br*/'Valor Imóvel (informar se diferente do Crédito Disponível)',
        /* pt-pt*/'Valor do Imóvel (indicar se for diferente do Crédito Disponível)',
        /* en-us*/'Property Value (specify if different from the Available Credit)',
        /* es-es*/'Valor del Inmueble (indicar si es diferente del Crédito Disponible)'
    ]),
    valorizacaoImovelAluguelAposContemplacao: traduzir([
        /*pt-br*/'Valorização Imóvel',
        /*pt-pt*/'Valorização Imóvel',
        /*en-us*/'Property Appreciation',
        /*es-es*/'Valorización Inmueble'
    ]),
    resultado: traduzir([
        /*pt-br*/'Resultado',
        /*pt-pt*/'Resultado',
        /*en-us*/'Result',
        /*es-es*/'Resultado'
    ]),
    analisarVendaAposQuitacao: traduzir([
        /*pt-br*/'Analisar Venda após Quitação',
        /*pt-pt*/'Analisar Venda após Liquidação',
        /*en-us*/'Analyze Sale After Full Settlement',
        /*es-es*/'Analizar Venta Después de la Liquidación Total'
    ]),
    mesesVendaAposContemplacao: traduzir([
        /*pt-br*/'Meses Venda (1, 2, 3, ...)',
        /*pt-pt*/'Meses Venda (1, 2, 3, ...)',
        /*en-us*/'Sale Months (1, 2, 3, ...)',
        /*es-es*/'Meses de Venta (1, 2, 3, ...)'
    ]),
    mesAnoVendaAposQuitacao: traduzir([
        /*pt-br*/'Mês/Ano Venda Após Quitação',
        /*pt-pt*/'Mês/Ano Venda Após Liquidação',
        /*en-us*/'Sale Month/Year After Full Settlement',
        /*es-es*/'Mes/Año de Venta Después de la Liquidación Total'
    ]),
    vendaAposQuitacao: traduzir([
        /*pt-br*/'Venda após<br/>Quitação',
        /*pt-pt*/'Venda após<br/>Liquidação',
        /*en-us*/'Sale After<br/>Full Settlement',
        /*es-es*/'Venta Después de la<br/>Liquidación Total'
    ]),
    aluguelAposQuitacao: traduzir([
        /*pt-br*/'Aluguel após<br/>Quitação',
        /*pt-pt*/'Renda após<br/>Liquidação',
        /*en-us*/'Rent After<br/>Full Settlement',
        /*es-es*/'Alquiler Después de la<br/>Liquidación Total'
    ]),
    
    projetoVidaSonho: traduzir([
        /*pt-br*/'Projeto de Vida/Sonho',
        /*pt-pt*/'Projeto de Vida/Sonho',
        /*en-us*/'Life/Dream Project',
        /*es-es*/'Proyecto de Vida/Sueño'
    ]),
    projetosVidaSonho: traduzir([
        /*pt-br*/'Projetos de Vida/Sonho',
        /*pt-pt*/'Projetos de Vida/Sonho',
        /*en-us*/'Life/Dream Projects',
        /*es-es*/'Proyectos de Vida/Sueño'
    ]),
    projetoVidaSonhoTracarMeta: traduzir([
        /*pt-br*/'Projeto de Vida/Sonhos - Metas',
        /*pt-pt*/'Projeto de Vida/Sonhos - Metas',
        /*en-us*/'Life/Dream Project - Goals',
        /*es-es*/'Proyecto de Vida/Sueños - Metas'
    ]),
    projetoVidaSonho1aParte: traduzir([
        /*pt-br*/'Projeto de',
        /*pt-pt*/'Projeto de',
        /*en-us*/'Project of',
        /*es-es*/'Proyecto de'
    ]),
    projetoVidaSonho2aParte: traduzir([
        /*pt-br*/'Vida/Sonho',
        /*pt-pt*/'Vida/Sonho',
        /*en-us*/'Life/Dream',
        /*es-es*/'Vida/Sueño'
    ]),
    tipoProjetoVidaSonho: traduzir([
        /*pt-br*/'Projeto de Vida/Sonho',
        /*pt-pt*/'Projeto de Vida/Sonho',
        /*en-us*/'Life/Dream Project',
        /*es-es*/'Proyecto de Vida/Sueño'
    ]),
    idadeRealizacao: traduzir([
        /*pt-br*/'Idade Realização',
        /*pt-pt*/'Idade de Realização',
        /*en-us*/'Achievement Age',
        /*es-es*/'Edad de Realización'
    ]),
    anoRealizacao: traduzir([
        /*pt-br*/'Ano Realização',
        /*pt-pt*/'Ano de Realização',
        /*en-us*/'Achievement Year',
        /*es-es*/'Año de Realización'
    ]),
    idadeAnoRealizacao: traduzir([
        /*pt-br*/'Idade/Ano Realização',
        /*pt-pt*/'Idade/Ano de Realização',
        /*en-us*/'Age/Year Achievement',
        /*es-es*/'Edad/Año de Realización'
    ]),
    tracarMeta: traduzir([
        /*pt-br*/'Traçar Meta',
        /*pt-pt*/'Traçar Meta',
        /*en-us*/'Set Goal',
        /*es-es*/'Establecer Meta'
    ]),
    mesAnoInicioAcumulacao: traduzir([
        /*pt-br*/'Mês/Ano Início Acumulação',
        /*pt-pt*/'Mês/Ano Início da Acumulação',
        /*en-us*/'Month/Year Start Accumulation',
        /*es-es*/'Mes/Año Inicio Acumulación'
    ]),
    mesAnoInicioAcumulacaoQuebraEspecial: traduzir([
        /*pt-br*/'Mês/Ano Início<br/>Acumulação',
        /*pt-pt*/'Mês/Ano Início<br/>Acumulação',
        /*en-us*/'Month/Year Start<br/>Accumulation',
        /*es-es*/'Mes/Año Inicio<br/>Acumulación'
    ]),
    mesAnoFimAcumulacao: traduzir([
        /*pt-br*/'Mês/Ano Fim Acumulação',
        /*pt-pt*/'Mês/Ano Fim da Acumulação',
        /*en-us*/'Month/Year End Accumulation',
        /*es-es*/'Mes/Año Fin Acumulación'
    ]),
    mesAnoFimAcumulacaoQuebraEspecial: traduzir([
        /*pt-br*/'Mês/Ano Fim <br/>Acumulação',
        /*pt-pt*/'Mês/Ano Fim <br/>Acumulação',
        /*en-us*/'Month/Year End <br/>Accumulation',
        /*es-es*/'Mes/Año Fin <br/>Acumulación'
    ]),
    periodoAcumulacao: traduzir([
        /*pt-br*/'Período Acumulação',
        /*pt-pt*/'Período de Acumulação',
        /*en-us*/'Accumulation Period',
        /*es-es*/'Período de Acumulación'
    ]),
    mesRealizacao: traduzir([
        /*pt-br*/'Mês Realização',
        /*pt-pt*/'Mês de Realização',
        /*en-us*/'Achievement Month',
        /*es-es*/'Mes de Realización'
    ]),
    mesAnoRealizacao: traduzir([
        /*pt-br*/'Mês/Ano Realização',
        /*pt-pt*/'Mês/Ano de Realização',
        /*en-us*/'Month/Year Achievement',
        /*es-es*/'Mes/Año de Realización'
    ]),
    tipoPeriodicidadeAporte: traduzir([
        /*pt-br*/'Periodicidade Aporte',
        /*pt-pt*/'Periodicidade do Aporte',
        /*en-us*/'Contribution Frequency',
        /*es-es*/'Periodicidad del Aporte'
    ]),
    valorAcumulacaoJaRealizado: traduzir([
        /*pt-br*/'Valor já Acumulado',
        /*pt-pt*/'Valor já Acumulado',
        /*en-us*/'Amount Already Accumulated',
        /*es-es*/'Valor ya Acumulado'
    ]),
    valorAcumulacaoJaRealizadoQuebraEspecial: traduzir([
        /*pt-br*/'Valor já<br/>Acumulado',
        /*pt-pt*/'Valor já<br/>Acumulado',
        /*en-us*/'Amount Already<br/>Accumulated',
        /*es-es*/'Valor ya<br/>Acumulado'
    ]),
    recorrencia: traduzir([
        /*pt-br*/'Recorrência',
        /*pt-pt*/'Recorrência',
        /*en-us*/'Recurrence',
        /*es-es*/'Recurrencia'
    ]),
    anoLimiteRecorrencia: traduzir([
        /*pt-br*/'Ano Limite Recorrência',
        /*pt-pt*/'Ano Limite da Recorrência',
        /*en-us*/'Recurrence Limit Year',
        /*es-es*/'Año Límite de Recurrencia'
    ]),
    controlarAportes: traduzir([
        /*pt-br*/'Controlar Aportes',
        /*pt-pt*/'Controlar Aportes',
        /*en-us*/'Control Contributions',
        /*es-es*/'Controlar Aportes'
    ]),
    diaAporte: traduzir([
        /*pt-br*/'Dia do Aporte',
        /*pt-pt*/'Dia do Aporte',
        /*en-us*/'Contribution Day',
        /*es-es*/'Día del Aporte'
    ]),
    valorAcumulacaoJaRealizadoVF: traduzir([
        /*pt-br*/'Valor já Acumulado (VF)',
        /*pt-pt*/'Valor já Acumulado (VF)',
        /*en-us*/'Amount Already Accumulated (FV)',
        /*es-es*/'Valor ya Acumulado (VF)'
    ]),
    valorAcumulacaoJaRealizadoVFQuebraEspecial: traduzir([
        /*pt-br*/'Valor já<br/>Acumulado (VF)',
        /*pt-pt*/'Valor já<br/>Acumulado (VF)',
        /*en-us*/'Amount Already<br/>Accumulated (FV)',
        /*es-es*/'Valor ya<br/>Acumulado (VF)'
    ]),
    valorAcumulacaoJaRealizadoVFAbreviado: traduzir([
        /*pt-br*/'Valor Acumulado(VF)',
        /*pt-pt*/'Valor Acumulado(VF)',
        /*en-us*/'Accumulated Amount(FV)',
        /*es-es*/'Valor Acumulado(VF)'
    ]),
    valorAcumulacaoNecessarioVP: traduzir([
        /*pt-br*/'Vr.Necessário(VP)',
        /*pt-pt*/'Vr.Necessário(VP)',
        /*en-us*/'Required Amt(PV)',
        /*es-es*/'Vr.Necesario(VP)'
    ]),
    valorAcumulacaoPendenteQuebraEspecial: traduzir([
        /*pt-br*/'Valor Pendente<br/>Acumulação',
        /*pt-pt*/'Valor Pendente<br/>Acumulação',
        /*en-us*/'Pending Amount<br/>Accumulation',
        /*es-es*/'Valor Pendiente<br/>Acumulación'
    ]),
    qtdeAportes: traduzir([
        /*pt-br*/'Qtde. Aportes',
        /*pt-pt*/'Qtde. de Aportes',
        /*en-us*/'Qty. Contributions',
        /*es-es*/'Cant. Aportes'
    ]),
    valorAporteProjetoVidaSonho: traduzir([
        /*pt-br*/'Valor Aporte',
        /*pt-pt*/'Valor do Aporte',
        /*en-us*/'Contribution Amount',
        /*es-es*/'Valor del Aporte'
    ]),

    patrimonioImobilizado: traduzir([
        /*pt-br*/'Patrimônio Imobilizado',
        /*pt-pt*/'Património Imobilizado',
        /*en-us*/'Fixed Assets',
        /*es-es*/'Patrimonio Inmovilizado'
    ]),
    patrimonioImobilizado1aParte: traduzir([
        /*pt-br*/'Patrimônio',
        /*pt-pt*/'Património',
        /*en-us*/'Assets',
        /*es-es*/'Patrimonio'
    ]),
    patrimonioImobilizado2aParte: traduzir([
        /*pt-br*/'Imobilizado',
        /*pt-pt*/'Imobilizado',
        /*en-us*/'Fixed',
        /*es-es*/'Inmovilizado'
    ]),
    patrimonioImobilizadoBensMoveisImoveis: traduzir([
        /*pt-br*/'Bens Móveis e Imóveis',
        /*pt-pt*/'Bens Móveis e Imóveis',
        /*en-us*/'Movable and Immovable Assets',
        /*es-es*/'Bienes Muebles e Inmuebles'
    ]),
    patrimonioImobilizadoNegocios: traduzir([
        /*pt-br*/'Negócios',
        /*pt-pt*/'Negócios',
        /*en-us*/'Business',
        /*es-es*/'Negocios'
    ]),
    tipoPatrimonioImobilizado: traduzir([
        /*pt-br*/'Tipo Patrimônio Imobilizado',
        /*pt-pt*/'Tipo de Património Imobilizado',
        /*en-us*/'Fixed Assets Type',
        /*es-es*/'Tipo de Patrimonio Inmovilizado'
    ]),
    tipoFinalidadePatrimonioImobilizado: traduzir([
        /*pt-br*/'Finalidade',
        /*pt-pt*/'Finalidade',
        /*en-us*/'Purpose',
        /*es-es*/'Finalidad'
    ]),
    valorMercado: traduzir([
        /*pt-br*/'Valor de Mercado',
        /*pt-pt*/ 'Valor de Mercado',
        /*en-us*/ 'Market Value',
        /*es-es*/ 'Valor de Mercado'
    ]),
    valorMercadoQuebraEspecial: traduzir([
        /*pt-br*/'Valor de<br/>Mercado',
        /*pt-pt*/ 'Valor de<br/>Mercado',
        /*en-us*/ 'Market Value',
        /*es-es*/ 'Valor de<br/>Mercado'
    ]),
    alugado: traduzir([
        /*pt-br*/'Alugado',
        /*pt-pt*/'Alugado',
        /*en-us*/'Rented',
        /*es-es*/'Alquilado'
    ]),
    valorAluguel: traduzir([
        /*pt-br*/'Valor Aluguel',
        /*pt-pt*/'Valor do Aluguer',
        /*en-us*/'Rent Amount',
        /*es-es*/'Valor del Alquiler'
    ]),
    perc: traduzir([
        /*pt-br*/'%',
        /*pt-pt*/'%',
        /*en-us*/'%',
        /*es-es*/'%'
    ]),
    naoInventariar: traduzir([
        /*pt-br*/'Não Inventariar',
        /*pt-pt*/'Não Inventariar',
        /*en-us*/'Do Not Inventory',
        /*es-es*/'No Inventariar'
    ]),
    considerarGarantiaMorteInvalidez: traduzir([
        /*pt-br*/'Considerar como Garantia na Morte/Invalidez',
        /*pt-pt*/'Considerar como Garantia na Morte/Invalidez',
        /*en-us*/'Consider as Guarantee in Death/Disability',
        /*es-es*/'Considerar como Garantía en Muerte/Invalidez'
    ]),
    //tipoImovel: traduzir([
    //    /*pt-br*/'Tipo de Imóvel',
    //    /*pt-pt*/'Tipo de Imóvel',
    //    /*en-us*/'Property Type',
    //    /*es-es*/'Tipo de Inmueble'
    //]),
    valorContabil: traduzir([
        /*pt-br*/'Valor Contábil',
        /*pt-pt*/'Valor Contabilístico',
        /*en-us*/'Book Value',
        /*es-es*/'Valor Contable'
    ]),
    dataCompra: traduzir([
        /*pt-br*/'Data Compra',
        /*pt-pt*/'Data da Compra',
        /*en-us*/'Purchase Date',
        /*es-es*/'Fecha de Compra'
    ]),
    tipoEmpresa: traduzir([
        /*pt-br*/'Tipo de Empresa',
        /*pt-pt*/'Tipo de Empresa',
        /*en-us*/'Company Type',
        /*es-es*/'Tipo de Empresa'
    ]),
    tipoRegimeTributarioEmpresa: traduzir([
        /*pt-br*/'Regime Tributário',
        /*pt-pt*/'Regime Tributário',
        /*en-us*/'Tax Regime',
        /*es-es*/'Régimen Tributario'
    ]),
    tipoPlanejamentoSucessorio: traduzir([
        /*pt-br*/'Planejamento Sucessário',
        /*pt-pt*/'Planeamento Sucessório',
        /*en-us*/'Succession Planning',
        /*es-es*/'Planificación Sucesoria'
    ]),

    receitaMensal: traduzir([
        /*pt-br*/'Receita Mensal',
        /*pt-pt*/'Receita Mensal',
        /*en-us*/'Monthly Income',
        /*es-es*/'Ingreso Mensual'
    ]),
    receitaMensal1aParte: traduzir([
        /*pt-br*/'Receita',
        /*pt-pt*/'Receita',
        /*en-us*/'Income',
        /*es-es*/'Ingreso'
    ]),
    receitaMensal2aParte: traduzir([
        /*pt-br*/'Mensal',
        /*pt-pt*/'Mensal',
        /*en-us*/'Monthly',
        /*es-es*/'Mensual'
    ]),
    tipoReceitaMensal: traduzir([
        /*pt-br*/'Tipo Receita Mensal',
        /*pt-pt*/'Tipo de Receita Mensal',
        /*en-us*/'Monthly Income Type',
        /*es-es*/'Tipo de Ingreso Mensual'
    ]),
    tipoPeriodicidadeRecebto: traduzir([
        /*pt-br*/'Periodicidade',
        /*pt-pt*/'Periodicidade',
        /*en-us*/'Frequency',
        /*es-es*/'Periodicidad'
    ]),
    valor: traduzir([
        /*pt-br*/'Valor',
        /*pt-pt*/'Valor',
        /*en-us*/'Amount',
        /*es-es*/'Valor'
    ]),
    valorTotal: traduzir([
        /*pt-br*/'Valor Total',
        /*pt-pt*/'Valor Total',
        /*en-us*/'Total Amount',
        /*es-es*/'Valor Total'
    ]),
    receitaLiquida: traduzir([
        /*pt-br*/'Receita Líquida',
        /*pt-pt*/'Receita Líquida',
        /*en-us*/'Net Revenue',
        /*es-es*/'Ingresos Neto'
    ]),
    receitaBruta: traduzir([
        /*pt-br*/'Receita Bruta',
        /*pt-pt*/'Receita Bruta',
        /*en-us*/'Gross Revenue',
        /*es-es*/'Ingresos Brutos'
        ]),
    valorInssRendaPrevista: traduzir([
        /*pt-br*/'INSS (Renda Prevista)',
        /*pt-pt*/'INSS (Renda Prevista)',
        /*en-us*/'INSS (Expected Income)',
        /*es-es*/'INSS (Renta Prevista)'
    ]),
    valorPensaoRendaPrevista: traduzir([
        /*pt-br*/'Pensão (Renda Prevista)',
        /*pt-pt*/'Pensão (Renda Prevista)',
        /*en-us*/'Pension (Expected Income)',
        /*es-es*/'Pensión (Renta Prevista)'
    ]),
    valorInssInvalidez: traduzir([
        /*pt-br*/'INSS Invalidez',
        /*pt-pt*/'INSS Invalidez',
        /*en-us*/'INSS Disability',
        /*es-es*/'INSS Invalidez'
    ]),
    valorPensaoInvalidez: traduzir([
        /*pt-br*/'Pensão Invalidez',
        /*pt-pt*/'Pensão de Invalidez',
        /*en-us*/'Disability Pension',
        /*es-es*/'Pensión de Invalidez'
    ]),
    valorInssMorte: traduzir([
        /*pt-br*/'INSS Morte',
        /*pt-pt*/'INSS Morte',
        /*en-us*/'INSS Death',
        /*es-es*/'INSS Muerte'
    ]),
    valorPensaoMorte: traduzir([
        /*pt-br*/'Pensão Morte',
        /*pt-pt*/'Pensão de Morte',
        /*en-us*/'Death Pension',
        /*es-es*/'Pensión por Muerte'
    ]),
    valorInssAposentadoria: traduzir([
        /*pt-br*/'INSS Aposentadoria',
        /*pt-pt*/'INSS Aposentação',
        /*en-us*/'INSS Retirement',
        /*es-es*/'INSS Jubilación'
    ]),
    valorPensaoAposentadoria: traduzir([
        /*pt-br*/'Pensão Aposentadoria',
        /*pt-pt*/'Pensão de Aposentação',
        /*en-us*/'Retirement Pension',
        /*es-es*/'Pensión de Jubilación'
    ]),
    alterarValorInssMorteAposentadoria: traduzir([
        /*pt-br*/'Alterar INSS Morte/Aposentadoria',
        /*pt-pt*/'Alterar INSS Morte/Aposentação',
        /*en-us*/'Change INSS Death/Retirement',
        /*es-es*/'Cambiar INSS Muerte/Jubilación'
    ]),
    alterarValorPensaoMorteAposentadoria: traduzir([
        /*pt-br*/'Alterar Pensão Morte/Aposentadoria',
        /*pt-pt*/'Alterar Pensão Morte/Aposentação',
        /*en-us*/'Change Pension Death/Retirement',
        /*es-es*/'Cambiar Pensión Muerte/Jubilación'
    ]),
    periodoReceitaMensal: traduzir([
        /*pt-br*/'Período da Receita',
        /*pt-pt*/'Período da Receita',
        /*en-us*/'Income Period',
        /*es-es*/'Período del Ingreso'
    ]),
    alterarTipoCalculoAcumulado: traduzir([
        /*pt-br*/'Alterar Período',
        /*pt-pt*/'Alterar Período',
        /*en-us*/'Change Period',
        /*es-es*/'Cambiar Período'
    ]),
    mesAnoInicial: traduzir([
        /*pt-br*/'Mês/Ano Inicial',
        /*pt-pt*/'Mês/Ano Inicial',
        /*en-us*/'Initial Month/Year',
        /*es-es*/'Mes/Año Inicial'
    ]),
    mesAnoInicialIdadeQuebraEspecial: traduzir([
        /*pt-br*/'Mês/Ano Inicial',
        /*pt-pt*/'Mês/Ano Inicial',
        /*en-us*/'Initial Month/Year',
        /*es-es*/'Mes/Año Inicial'
    ]),
    mesAnoFinal: traduzir([
        /*pt-br*/'Mês/Ano Final',
        /*pt-pt*/'Mês/Ano Final',
        /*en-us*/'Final Month/Year',
        /*es-es*/'Mes/Año Final'
    ]),
    mesAnoFinalIdadeQuebraEspecial: traduzir([
        /*pt-br*/'Mês/Ano Final',
        /*pt-pt*/'Mês/Ano Final',
        /*en-us*/'Final Month/Year',
        /*es-es*/'Mes/Año Final'
    ]),
    receitaMensalAteAposentadoria: traduzir([
        /*pt-br*/'Receita Mensal até Aposentadoria',
        /*pt-pt*/'Receita Mensal até Aposentação',
        /*en-us*/'Monthly Income until Retirement',
        /*es-es*/'Ingreso Mensual hasta Jubilación'
    ]),
    inssInvalidezMorteAposentadoria: traduzir([
        /*pt-br*/'INSS Invalidez/Morte/Aposentadoria',
        /*pt-pt*/'INSS Invalidez/Morte/Aposentação',
        /*en-us*/'INSS Disability/Death/Retirement',
        /*es-es*/'INSS Invalidez/Muerte/Jubilación'
    ]),
    temSeguroVidaEmGrupo: traduzir([
        /*pt-br*/'Tem Seguro Vida em Grupo',
        /*pt-pt*/'Tem Seguro de Vida em Grupo',
        /*en-us*/'Has Group Life Insurance',
        /*es-es*/'Tiene Seguro de Vida Grupal'
    ]),
    tipoMultiploSalarioSeguroVidaEmGrupo: traduzir([
        /*pt-br*/'Múltiplo Salário',
        /*pt-pt*/'Múltiplo do Salário',
        /*en-us*/'Salary Multiple',
        /*es-es*/'Múltiplo del Salario'
    ]),
    valorCSSeguroVidaEmGrupoMorte: traduzir([
        /*pt-br*/'CS Morte',
        /*pt-pt*/'CS Morte',
        /*en-us*/'CS Death',
        /*es-es*/'CS Muerte'
    ]),
    valorCSSeguroVidaEmGrupoMorteAcidental: traduzir([
        /*pt-br*/'CS Morte Acidental',
        /*pt-pt*/'CS Morte Acidental',
        /*en-us*/'CS Accidental Death',
        /*es-es*/'CS Muerte Accidental'
    ]),
    valorCSSeguroVidaEmGrupoInvalidezPorAcidente: traduzir([
        /*pt-br*/'CS Invalidez por Acidente',
        /*pt-pt*/'CS Invalidez por Acidente',
        /*en-us*/'CS Disability by Accident',
        /*es-es*/'CS Invalidez por Accidente'
    ]),
    valorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca: traduzir([
        /*pt-br*/'CS Invalidez Funcional por Doença',
        /*pt-pt*/'CS Invalidez Funcional por Doença',
        /*en-us*/'CS Functional Disability by Disease',
        /*es-es*/'CS Invalidez Funcional por Enfermedad'
    ]),
    valorCSSeguroVidaEmGrupoDoencasGraves: traduzir([
        /*pt-br*/'Doenças Graves',
        /*pt-pt*/'Doenças Graves',
        /*en-us*/'Critical Illnesses',
        /*es-es*/'Enfermedades Graves'
    ]),
    valorCSSeguroVidaEmGrupoFuneral: traduzir([
        /*pt-br*/'Assistência Funeral',
        /*pt-pt*/'Assistência Funeral',
        /*en-us*/'Funeral Assistance',
        /*es-es*/'Asistencia Funeral'
    ]),
    extensivelClienteConjuge: traduzir([
        /*pt-br*/'Extensível',
        /*pt-pt*/'Extensível',
        /*en-us*/'Extensible',
        /*es-es*/'Extensible'
    ]),
    extensivelFilhao: traduzir([
        /*pt-br*/'Extensível Filhas(os)',
        /*pt-pt*/'Extensível Filhas(os)',
        /*en-us*/'Extensible Children',
        /*es-es*/'Extensible Hijas(os)'
    ]),
    inicio: traduzir([
        /*pt-br*/'Início',
        /*pt-pt*/'Início',
        /*en-us*/'Start',
        /*es-es*/'Inicio'
    ]),

    

    recursosFinanceiros: traduzir([
        /*pt-br*/'Recursos Financeiros',
        /*pt-pt*/'Recursos Financeiros',
        /*en-us*/'Financial Resources',
        /*es-es*/'Recursos Financieros'
    ]),
    recursosFinanceirosAbreviado: traduzir([
        /*pt-br*/'Rec. Financeiros',
        /*pt-pt*/'Rec. Financeiros',
        /*en-us*/'Finan. Resources',
        /*es-es*/'Rec. Financieros'
    ]),
    recursosFinanceirosAbreviado2: traduzir([
        /*pt-br*/'Rec. Financ.',
        /*pt-pt*/'Rec. Financ.',
        /*en-us*/'Finan. Resources',
        /*es-es*/'Rec. Financ.'
    ]),
    recursosFinanceiros1aParte: traduzir([
        /*pt-br*/'Recursos',
        /*pt-pt*/'Recursos',
        /*en-us*/'Resources',
        /*es-es*/'Recursos'
    ]),
    recursosFinanceiros2aParte: traduzir([
        /*pt-br*/'Financeiros',
        /*pt-pt*/'Financeiros',
        /*en-us*/'Financial',
        /*es-es*/'Financieros'
    ]),
    recursoFinanceiro: traduzir([
        /*pt-br*/'Recurso Financeiro',
        /*pt-pt*/'Recurso Financeiro',
        /*en-us*/'Financial Resource',
        /*es-es*/'Recurso Financiero'
    ]),
    tipoRecursoFinanceiro: traduzir([
        /*pt-br*/'Tipo de Recurso Financeiro',
        /*pt-pt*/'Tipo de Recurso Financeiro',
        /*en-us*/'Financial Resource Type',
        /*es-es*/'Tipo de Recurso Financiero'
    ]),
    valorReservaAtual: traduzir([
        /*pt-br*/'Reserva Atual',
        /*pt-pt*/'Reserva Actual',
        /*en-us*/'Current Reserve',
        /*es-es*/'Reserva Actual'
    ]),
    valorAporte: traduzir([
        /*pt-br*/'Aporte',
        /*pt-pt*/'Contribuição',
        /*en-us*/'Contribution',
        /*es-es*/'Aporte'
    ]),
    valorAporteEmpresa: traduzir([
        /*pt-br*/'Aporte Empresa',
        /*pt-pt*/'Contribuição Empresa',
        /*en-us*/'Company Contribution',
        /*es-es*/'Aporte Empresa'
    ]),
    tipoPeriodicidadeAporteDividendos: traduzir([
        /*pt-br*/'Periodicidade',
        /*pt-pt*/'Periodicidade',
        /*en-us*/'Periodicity',
        /*es-es*/'Periodicidad'
    ]),
    tipoPeriodicidadeAporteDividendosAbreviado: traduzir([
        /*pt-br*/'Period.',
        /*pt-pt*/'Period.',
        /*en-us*/'Period.',
        /*es-es*/'Period.'
    ]),
    aporteAteAposentadoria: traduzir([
        /*pt-br*/'O aporte será feita até a aposentadoria',
        /*pt-pt*/'A contribuição será feita até à reforma',
        /*en-us*/'The contribution will be made until retirement',
        /*es-es*/'El aporte se realizará hasta la jubilación'
    ]),
    aporteAteAposentadoriaAbreviado: traduzir([
        /*pt-br*/'Aporte até a aposentadoria',
        /*pt-pt*/'Contribuição até à reforma',
        /*en-us*/'Contributions Until Retirement',
        /*es-es*/'Aportes hasta la Jubilación'
    ]),
    aporteOriundoReceitaMensal: traduzir([
        /*pt-br*/'O aporte é oriundo da receita',
        /*pt-pt*/'A contribuição provém da receita',
        /*en-us*/'The contribution comes from income',
        /*es-es*/'El aporte proviene de los ingresos'
    ]),
    aporteOriundoReceitaMensalAbreviado: traduzir([
        /*pt-br*/'Aporte oriundo receita mensal',
        /*pt-pt*/'Contrib. rend. mensal',
        /*en-us*/'Monthly Income Contrib.',
        /*es-es*/'Aporte ing. mensuales'
    ]),
    aporteOriundoRealocacaoCarteiraInvestimentos: traduzir([
        /*pt-br*/'O aporte é oriundo de uma realocação da Carteira de Investimentos',
        /*pt-pt*/'A contribuição provém de uma realocação da Carteira de Investimentos',
        /*en-us*/'The contribution comes from a reallocation of the Investment Portfolio',
        /*es-es*/'El aporte proviene de una reasignación de la Cartera de Inversiones'
    ]),
    idRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos: traduzir([
        /*pt-br*/'Recurso Financeiro Origem',
        /*pt-pt*/'Recurso Financeiro de Origem',
        /*en-us*/'Source Financial Resource',
        /*es-es*/'Recurso Financiero de Origen'
    ]),
    naoConsiderarGarantiaMorteInvalidez: traduzir([
        /*pt-br*/'Não considerar como Garantia na Morte/Invalidez',
        /*pt-pt*/'Não considerar como Garantia na Morte/Invalidez',
        /*en-us*/'Do not consider as Guarantee in Death/Disability',
        /*es-es*/'No considerar como Garantía en Muerte/Invalidez'
    ]),
    naoConsiderarGarantiaMorte: traduzir([
        /*pt-br*/'Não considerar como Garantia na Morte',
        /*pt-pt*/'Não considerar como Garantia na Morte',
        /*en-us*/'Do not consider as Guarantee in Death',
        /*es-es*/'No considerar como Garantía en Muerte'
    ]),
    naoConsiderarGarantiaInvalidez: traduzir([
        /*pt-br*/'Não considerar como Garantia na Invalidez',
        /*pt-pt*/'Não considerar como Garantia na Invalidez',
        /*en-us*/'Do not consider as Guarantee in Disability',
        /*es-es*/'No considerar como Garantía en Invalidez'
    ]),
    percRentabilidadeAnual: traduzir([
        /*pt-br*/'% Rentabilidade Anual',
        /*pt-pt*/'% Rentabilidade Anual',
        /*en-us*/'% Annual Profitability',
        /*es-es*/'% Rentabilidad Anual'
    ]),
    percRentabilidadeAnualCurto: traduzir([
        /*pt-br*/'% Rentab.',
        /*pt-pt*/'% Rentab.',
        /*en-us*/'% Return',
        /*es-es*/'% Rentab.'
    ]),
    taxaAnual: traduzir([
        /*pt-br*/'Taxa Anual (%)',
        /*pt-pt*/'Taxa Anual (%)',
        /*en-us*/'Annual Rate (%)',
        /*es-es*/'Tasa Anual (%)'
    ]),
    dataInicioRecursoFinanceiro: traduzir([
        /*pt-br*/'Início',
        /*pt-pt*/'Início',
        /*en-us*/'Home',
        /*es-es*/'Inicio'
    ]),
    percRentabilidadeMes: traduzir([
        /*pt-br*/'% Rentabilidade Mês',
        /*pt-pt*/'% Rentabilidade do Mês',
        /*en-us*/'Monthly Return %',
        /*es-es*/'% Rentabilidad del Mes'
    ]),
    percCDIMes: traduzir([
        /*pt-br*/'% CDI Mês',
        /*pt-pt*/'% CDI do Mês',
        /*en-us*/'Monthly CDI %',
        /*es-es*/'% CDI del Mes'
    ]),
    percRentabilidadeMesAbreviado: traduzir([
        /*pt-br*/'% Rentab. Mês',
        /*pt-pt*/'% Rentab. do Mês',
        /*en-us*/'Monthly Return %',
        /*es-es*/'% Rentab. del Mes'
    ]),
    percCDI: traduzir([
        /*pt-br*/'% CDI',
        /*pt-pt*/'% CDI',
        /*en-us*/'CDI %',
        /*es-es*/'% CDI'
    ]),
    percRentabilidadeAno: traduzir([
        /*pt-br*/'% Rentabilidade Ano',
        /*pt-pt*/'% Rentabilidade do Ano',
        /*en-us*/'Annual Return %',
        /*es-es*/'% Rentabilidad del Año'
    ]),
    percCDIAno: traduzir([
        /*pt-br*/'% CDI Ano',
        /*pt-pt*/'% CDI do Ano',
        /*en-us*/'Annual CDI %',
        /*es-es*/'% CDI del Año'
    ]),
    percRentabilidadeAnoAbreviado: traduzir([
        /*pt-br*/'% Rentab. Ano',
        /*pt-pt*/'% Rentab. do Ano',
        /*en-us*/'Annual Return %',
        /*es-es*/'% Rentab. del Año'
    ]),
    percRentabilidade12M: traduzir([
        /*pt-br*/'% Rentabilidade 12M',
        /*pt-pt*/'% Rentabilidade do 12M',
        /*en-us*/'12M Return %',
        /*es-es*/'% Rentabilidad 12M'
    ]),
    percCDI12M: traduzir([
        /*pt-br*/'% CDI 12M',
        /*pt-pt*/'% CDI do 12M',
        /*en-us*/'12M CDI %',
        /*es-es*/'% CDI 12M'
    ]),
    percRentabilidade12MAbreviado: traduzir([
        /*pt-br*/'% Rentab. 12M',
        /*pt-pt*/'% Rentab. do 12M',
        /*en-us*/'12M Return %',
        /*es-es*/'% Rentab. 12M'
    ]),
    percRentabilidade24M: traduzir([
        /*pt-br*/'% Rentabilidade 24M',
        /*pt-pt*/'% Rentabilidade do 24M',
        /*en-us*/'24M Return %',
        /*es-es*/'% Rentabilidad 24M'
    ]),
    percCDI24M: traduzir([
        /*pt-br*/'% CDI 24M',
        /*pt-pt*/'% CDI do 24M',
        /*en-us*/'24M CDI %',
        /*es-es*/'% CDI 24M'
    ]),
    percRentabilidade24MAbreviado: traduzir([
        /*pt-br*/'% Rentab. 24M',
        /*pt-pt*/'% Rentab. do 24M',
        /*en-us*/'24M Return %',
        /*es-es*/'% Rentab. 24M'
    ]),
    vencimento: traduzir([
        /*pt-br*/'Vencimento',
        /*pt-pt*/'Vencimento',
        /*en-us*/'Maturity',
        /*es-es*/'Vencimiento'
    ]),
    instituicao: traduzir([
        /*pt-br*/'Instituição',
        /*pt-pt*/'Instituição',
        /*en-us*/'Institution',
        /*es-es*/'Institución'
    ]),
    nomeAcao: traduzir([
        /*pt-br*/'Nome da Ação',
        /*pt-pt*/'Nome da Acção',
        /*en-us*/'Stock Name',
        /*es-es*/'Nombre de la Acción'
    ]),
    tipoRegimeTributacao: traduzir([
        /*pt-br*/'Regime Tributação',
        /*pt-pt*/'Regime de Tributação',
        /*en-us*/'Tax Regime',
        /*es-es*/'Régimen Tributario'
    ]),
    nomeFundo: traduzir([
        /*pt-br*/'Nome do Fundo',
        /*pt-pt*/'Nome do Fundo',
        /*en-us*/'Fund Name',
        /*es-es*/'Nombre del Fondo'
    ]),
    cnpjFundo: traduzir([
        /*pt-br*/'CNPJ do Fundo',
        /*pt-pt*/'NIPC do Fundo',
        /*en-us*/'Fund Tax ID',
        /*es-es*/'CNPJ del Fondo'
    ]),
    valorReservadoPVSQuebraEspecial: traduzir([
        /*pt-br*/'Valor Reservado<br/>Projeto de<br/>Vida/Sonho',
        /*pt-pt*/'Valor Reservado<br/>Projecto de<br/>Vida/Sonho',
        /*en-us*/'Reserved Value<br/>Life Project/<br/>Dream',
        /*es-es*/'Valor Reservado<br/>Proyecto de<br/>Vida/Sueño'
    ]),
    saldoNaoReservadoQuebraEspecial: traduzir([
        /*pt-br*/'Saldo Não<br/>Reservado',
        /*pt-pt*/'Saldo Não<br/>Reservado',
        /*en-us*/'Unreserved<br/>Balance',
        /*es-es*/'Saldo No<br/>Reservado'
    ]),

    planejamentoEspecializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Planejamento Especialização / Período Sabático',
        /*pt-pt*/'Planeamento Especialização / Período Sabático',
        /*en-us*/'Specialization / Sabbatical Period Planning',
        /*es-es*/'Planificación Especialización / Período Sabático'
    ]),
    especializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Especialização / Período Sabático',
        /*pt-pt*/'Especialização / Período Sabático',
        /*en-us*/'Specialization / Sabbatical Period',
        /*es-es*/'Especialización / Período Sabático'
    ]),
    antesEspecializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Antes da Especialização / Período Sabático',
        /*pt-pt*/'Antes da Especialização / Período Sabático',
        /*en-us*/'Before Specialization / Sabbatical Period',
        /*es-es*/'Antes de la Especialización / Período Sabático'
    ]),
    duranteEspecializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Durante a Especialização / Período Sabático',
        /*pt-pt*/'Durante a Especialização / Período Sabático',
        /*en-us*/'During Specialization / Sabbatical Period',
        /*es-es*/'Durante la Especialización / Período Sabático'
    ]),
    depoisEspecializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Depois da Especialização / Período Sabático',
        /*pt-pt*/'Depois da Especialização / Período Sabático',
        /*en-us*/'After Specialization / Sabbatical Period',
        /*es-es*/'Después de la Especialización / Período Sabático'
    ]),
    saldo: traduzir([
        /*pt-br*/'Saldo',
        /*pt-pt*/'Saldo',
        /*en-us*/'Balance',
        /*es-es*/'Saldo'
    ]),
    antes: traduzir([
        /*pt-br*/'Antes',
        /*pt-pt*/'Antes',
        /*en-us*/'Before',
        /*es-es*/'Antes'
    ]),
    durante: traduzir([
        /*pt-br*/'Durante',
        /*pt-pt*/'Durante',
        /*en-us*/'During',
        /*es-es*/'Durante'
    ]),
    depois: traduzir([
        /*pt-br*/'Depois',
        /*pt-pt*/'Depois',
        /*en-us*/'After',
        /*es-es*/'Después'
    ]),
    planejamento: traduzir([
        /*pt-br*/'Planejamento',
        /*pt-pt*/'Planeamento',
        /*en-us*/'Planning',
        /*es-es*/'Planificación'
    ]),
    fluxoCaixa: traduzir([
        /*pt-br*/'Fluxo de Caixa',
        /*pt-pt*/'Fluxo de Caixa',
        /*en-us*/'Cash Flow',
        /*es-es*/'Flujo de Caja'
    ]),

    instituicaoFinanceira: traduzir([
        /*pt-br*/'Instituição Financeira',
        /*pt-pt*/'Instituição Financeira',
        /*en-us*/'Financial Institution',
        /*es-es*/'Institución Financiera'
    ]),

    cotacao: traduzir([
        /*pt-br*/'Cotação',
        /*pt-pt*/'Cotação',
        /*en-us*/'Quote',
        /*es-es*/'Cotización'
    ]),
    resumoCotacao: traduzir([
        /*pt-br*/'Resumo da Cotação',
        /*pt-pt*/'Resumo da Cotação',
        /*en-us*/'Quote Summary',
        /*es-es*/'Resumen de Cotización'
    ]),
    protecaoSucessaoVitalicia: traduzir([
        /*pt-br*/'Tabela de Evolução da Sucessão Patrimonial',
        /*pt-pt*/'Tabela de Evolução da Sucessão Patrimonial',
        /*en-us*/'Estate Succession Evolution Table',
        /*es-es*/'Tabla de Evolución de la Sucesión Patrimonial'
    ]),
    tabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Tabela de Evolução do Valor de Resgate',
        /*pt-pt*/'Tabela de Evolução do Valor de Resgate',
        /*en-us*/'Surrender Value Evolution Table',
        /*es-es*/'Tabla de Evolución del Valor de Rescate'
    ]),
    tabelaEvolucaoCS: traduzir([
        /*pt-br*/'Tabela de Evolução do Capital Segurado',
        /*pt-pt*/'Tabela de Evolução do Capital Seguro',
        /*en-us*/'Insured Capital Evolution Table',
        /*es-es*/'Tabla de Evolución del Capital Asegurado'
    ]),
    tabelaEvolucaoCancelamentoApolice: traduzir([
        /*pt-br*/'Tabela de Evolução do Cancelamento da Apólice',
        /*pt-pt*/'Tabela de Evolução do Cancelamento da Apólice',
        /*en-us*/'Policy Cancellation Evolution Table',
        /*es-es*/'Tabla de Evolución de Cancelación de la Póliza'
    ]),
    comparacaoPreco: traduzir([
        /*pt-br*/'Comparação de Preço',
        /*pt-pt*/'Comparação de Preço',
        /*en-us*/'Price Comparison',
        /*es-es*/'Comparación de Precio'
    ]),
    valorPremioAnualizadoAcumulado: traduzir([
        /*pt-br*/'Prêmio Anualizado Acumulado',
        /*pt-pt*/'Prémio Anualizado Acumulado',
        /*en-us*/'Accumulated Annualized Premium',
        /*es-es*/'Prima Anualizada Acumulada'
    ]),
    valorPremioAnualizadoInvestido: traduzir([
        /*pt-br*/'Prêmio Anualizado Investido',
        /*pt-pt*/'Prémio Anualizado Investido',
        /*en-us*/'Invested Annualized Premium',
        /*es-es*/'Prima Anualizada Invertida'
    ]),
    valorResgate: traduzir([
        /*pt-br*/'Valor Resgate',
        /*pt-pt*/'Valor Resgate',
        /*en-us*/'Surrender Value',
        /*es-es*/'Valor de Rescate'
    ]),
    valorSaldado: traduzir([
        /*pt-br*/'Valor Saldado',
        /*pt-pt*/'Valor Saldado',
        /*en-us*/'Paid-up Value',
        /*es-es*/'Valor Saldado'
    ]),
    beneficioProlongado: traduzir([
        /*pt-br*/'Benefício Prolongado',
        /*pt-pt*/'Benefício Prolongado',
        /*en-us*/'Extended Benefit',
        /*es-es*/'Beneficio Prolongado'
    ]),

    links: traduzir([
        /*pt-br*/'Links',
        /*pt-pt*/'Links',
        /*en-us*/'Links',
        /*es-es*/'Enlaces'
    ]),
    proposta: traduzir([
        /*pt-br*/'Proposta',
        /*pt-pt*/'Proposta',
        /*en-us*/'Proposal',
        /*es-es*/'Propuesta'
    ]),
    apolice: traduzir([
        /*pt-br*/'Apólice',
        /*pt-pt*/'Apólice',
        /*en-us*/'Policy',
        /*es-es*/'Póliza'
    ]),
    seguroVida: traduzir([
        /*pt-br*/'Seguro de Vida',
        /*pt-pt*/'Seguro de Vida',
        /*en-us*/'Life Insurance',
        /*es-es*/'Seguro de Vida'
    ]),
    nomeLiderUnidade: traduzir([
        /*pt-br*/'LU',
        /*pt-pt*/'LU',
        /*en-us*/'UL',
        /*es-es*/'LU'
    ]),
    nomeConsultor: traduzir([
        /*pt-br*/'Consultor',
        /*pt-pt*/'Consultor',
        /*en-us*/'Consultant',
        /*es-es*/'Consultor'
    ]),
    numeroApolice: traduzir([
        /*pt-br*/'Número da Apólice',
        /*pt-pt*/'Número da Apólice',
        /*en-us*/'Policy Number',
        /*es-es*/'Número de Póliza'
    ]),
    seguradora: traduzir([
        /*pt-br*/'Seguradora',
        /*pt-pt*/'Seguradora',
        /*en-us*/'Insurance Company',
        /*es-es*/'Aseguradora'
    ]),
    seguradoraOutras: traduzir([
        /*pt-br*/'Seguradora - Outras',
        /*pt-pt*/'Seguradora - Outras',
        /*en-us*/'Insurance Company - Others',
        /*es-es*/'Aseguradora - Otras'
    ]),
    formaPagamento: traduzir([
        /*pt-br*/'Forma Pagamento',
        /*pt-pt*/'Forma de Pagamento',
        /*en-us*/'Payment Method',
        /*es-es*/'Forma de Pago'
    ]),
    dataEmissao: traduzir([
        /*pt-br*/'Data de Emissão',
        /*pt-pt*/'Data de Emissão',
        /*en-us*/'Issue Date',
        /*es-es*/'Fecha de Emisión'
    ]),
    anoMesEmissao: traduzir([
        /*pt-br*/'Ano Mês de Emissão',
        /*pt-pt*/'Ano Mês de Emissão',
        /*en-us*/'Issue Year Month',
        /*es-es*/'Año Mes de Emisión'
    ]),
    diaMesEmissao: traduzir([
        /*pt-br*/'Dia/Mês de Emissão',
        /*pt-pt*/'Dia/Mês de Emissão',
        /*en-us*/'Day/Month of Issue',
        /*es-es*/'Día/Mes de Emisión'
    ]),
    dataAssinatura: traduzir([
        /*pt-br*/'Data Assinatura',
        /*pt-pt*/'Data de Assinatura',
        /*en-us*/'Signature Date',
        /*es-es*/'Fecha de Firma'
    ]),
    anoMesAssinatura: traduzir([
        /*pt-br*/'Ano Mês Assinatura',
        /*pt-pt*/'Ano Mês de Assinatura',
        /*en-us*/'Signature Year Month',
        /*es-es*/'Año Mes de Firma'
    ]),
    dataUltimaAlteracao: traduzir([
        /*pt-br*/'Data Última Alteração',
        /*pt-pt*/'Data Última Alteração',
        /*en-us*/'Last Change Date',
        /*es-es*/'Fecha Última Modificación'
    ]),
    anoMesUltimaAlteracao: traduzir([
        /*pt-br*/'Ano Mês Última Alteração',
        /*pt-pt*/'Ano Mês Última Alteração',
        /*en-us*/'Last Change Year Month',
        /*es-es*/'Año Mes Última Modificación'
    ]),
    statusProposta: traduzir([
        /*pt-br*/'Status Proposta',
        /*pt-pt*/'Estado da Proposta',
        /*en-us*/'Proposal Status',
        /*es-es*/'Estado de Propuesta'
    ]),
    statusApolice: traduzir([
        /*pt-br*/'Status Apólice',
        /*pt-pt*/'Estado da Apólice',
        /*en-us*/'Policy Status',
        /*es-es*/'Estado de Póliza'
    ]),
    numeroCotacao: traduzir([
        /*pt-br*/'Número da Cotação',
        /*pt-pt*/'Número da Cotação',
        /*en-us*/'Quote Number',
        /*es-es*/'Número de Cotización'
    ]),
    dataCotacao: traduzir([
        /*pt-br*/'Data da Cotação',
        /*pt-pt*/'Data da Cotação',
        /*en-us*/'Quote Date',
        /*es-es*/'Fecha de Cotización'
    ]),
    utilizarApenasComparacaoPreco: traduzir([
        /*pt-br*/'Utilizar apenas para comparação de preço',
        /*pt-pt*/'Utilizar apenas para comparação de preço',
        /*en-us*/'Use only for price comparison',
        /*es-es*/'Utilizar solo para comparación de precio'
    ]),
    numeroProposta: traduzir([
        /*pt-br*/'Número da Proposta',
        /*pt-pt*/'Número da Proposta',
        /*en-us*/'Proposal Number',
        /*es-es*/'Número de Propuesta'
    ]),
    estimativa: traduzir([
        /*pt-br*/'Estimativa',
        /*pt-pt*/'Estimativa',
        /*en-us*/'Estimate',
        /*es-es*/'Estimación'
    ]),
    producaoPropria: traduzir([
        /*pt-br*/'Produção Própria',
        /*pt-pt*/'Produção Própria',
        /*en-us*/'Own Production',
        /*es-es*/'Producción Propia'
    ]),
    rendaSegurado: traduzir([
        /*pt-br*/'Renda',
        /*pt-pt*/'Renda',
        /*en-us*/'Income',
        /*es-es*/'Renta'
    ]),
    mapaPropostas: traduzir([
        /*pt-br*/'Mapa de Propostas',
        /*pt-pt*/'Mapa de Propostas',
        /*en-us*/'Proposals Map',
        /*es-es*/'Mapa de Propuestas'
    ]),
    pendentesMesAtual2Meses: traduzir([
        /*pt-br*/'Pendentes Mês Atual + 2 Meses',
        /*pt-pt*/'Pendentes Mês Actual + 2 Meses',
        /*en-us*/'Pending Current Month + 2 Months',
        /*es-es*/'Pendientes Mes Actual + 2 Meses'
    ]),
    pagasMesAtual: traduzir([
        /*pt-br*/'Pagas Mês Atual',
        /*pt-pt*/'Pagas Mês Actual',
        /*en-us*/'Paid Current Month',
        /*es-es*/'Pagadas Mes Actual'
    ]),

    coberturas: traduzir([
        /*pt-br*/'Coberturas',
        /*pt-pt*/'Coberturas',
        /*en-us*/'Coverages',
        /*es-es*/'Coberturas'
    ]),
    cobertura: traduzir([
        /*pt-br*/'Cobertura',
        /*pt-pt*/'Cobertura',
        /*en-us*/'Coverage',
        /*es-es*/'Cobertura'
    ]),
    grupoCoberturaSeguroVida: traduzir([
        /*pt-br*/'Grupo Cobertura',
        /*pt-pt*/'Grupo de Cobertura',
        /*en-us*/'Coverage Group',
        /*es-es*/'Grupo de Cobertura'
    ]),
    tipoCoberturaSeguroVida: traduzir([
        /*pt-br*/'Tipo Cobertura',
        /*pt-pt*/'Tipo de Cobertura',
        /*en-us*/'Coverage Type',
        /*es-es*/'Tipo de Cobertura'
    ]),
    valorCS: traduzir([
        /*pt-br*/'Capital Segurado',
        /*pt-pt*/'Capital Seguro',
        /*en-us*/'Insured Capital',
        /*es-es*/'Capital Asegurado'
    ]),
    valorRenda: traduzir([
        /*pt-br*/'Renda Mensal',
        /*pt-pt*/'Renda Mensal',
        /*en-us*/'Monthly Income',
        /*es-es*/'Renta Mensual'
    ]),
    valorDiaria: traduzir([
        /*pt-br*/'Valor da Diária',
        /*pt-pt*/'Valor da Diária',
        /*en-us*/'Daily Allowance Value',
        /*es-es*/'Valor del Subsidio Diario'
    ]),
    dataTerminoCobertura: traduzir([
        /*pt-br*/'Data Término Cobertura',
        /*pt-pt*/'Data Término de Cobertura',
        /*en-us*/'Coverage End Date',
        /*es-es*/'Fecha Fin de Cobertura'
    ]),
    tipoPrazoRecebtoRenda: traduzir([
        /*pt-br*/'Prazo Recebto. Renda',
        /*pt-pt*/'Prazo Recebimento Renda',
        /*en-us*/'Income Receipt Term',
        /*es-es*/'Plazo Recibo Renta'
    ]),
    valorPremio: traduzir([
        /*pt-br*/'Prêmio',
        /*pt-pt*/'Prémio',
        /*en-us*/'Premium',
        /*es-es*/'Prima'
    ]),
    tipoPeriodicidadePagtoPremio: traduzir([
        /*pt-br*/'Periodicidade Prêmio',
        /*pt-pt*/'Periodicidade Prémio',
        /*en-us*/'Premium Periodicity',
        /*es-es*/'Periodicidad Prima'
    ]),
    valorCSSobrevivencia: traduzir([
        /*pt-br*/'CS Sobrevivência',
        /*pt-pt*/'CS Sobrevivência',
        /*en-us*/'Survival IC',
        /*es-es*/'CS Supervivencia'
    ]),
    tempoCoberturaSeguroVida: traduzir([
        /*pt-br*/'Tempo Cobertura',
        /*pt-pt*/'Tempo de Cobertura',
        /*en-us*/'Coverage Time',
        /*es-es*/'Tiempo de Cobertura'
    ]),
    statusCobertura: traduzir([
        /*pt-br*/'Status Cobertura',
        /*pt-pt*/'Estado da Cobertura',
        /*en-us*/'Coverage Status',
        /*es-es*/'Estado de Cobertura'
    ]),
    descricaoCobertura: traduzir([
        /*pt-br*/'Descrição da Cobertura',
        /*pt-pt*/'Descrição da Cobertura',
        /*en-us*/'Coverage Description',
        /*es-es*/'Descripción de Cobertura'
    ]),
    valorPremioLiquido: traduzir([
        /*pt-br*/'Prêmio Líquido',
        /*pt-pt*/'Prémio Líquido',
        /*en-us*/'Net Premium',
        /*es-es*/'Prima Neta'
    ]),
    valorIof: traduzir([
        /*pt-br*/'Valor IOF',
        /*pt-pt*/'Valor IOF',
        /*en-us*/'IOF Value',
        /*es-es*/'Valor IOF'
    ]),
    classeAjusteRisco: traduzir([
        /*pt-br*/'Classe de Ajuste/Risco',
        /*pt-pt*/'Classe de Ajuste/Risco',
        /*en-us*/'Adjustment/Risk Class',
        /*es-es*/'Clase de Ajuste/Riesgo'
    ]),
    valorPremioExtra: traduzir([
        /*pt-br*/'Valor Prêmio Extra',
        /*pt-pt*/'Valor Prémio Extra',
        /*en-us*/'Extra Premium Value',
        /*es-es*/'Valor Prima Extra'
    ]),
    duracaoPremioExtra: traduzir([
        /*pt-br*/'Duração Prêmio Extra',
        /*pt-pt*/'Duração Prémio Extra',
        /*en-us*/'Extra Premium Duration',
        /*es-es*/'Duración Prima Extra'
    ]),
    valorRendaMensal: traduzir([
        /*pt-br*/'Valor Renda Mensal',
        /*pt-pt*/'Valor Renda Mensal',
        /*en-us*/'Monthly Income Value',
        /*es-es*/'Valor Renta Mensual'
    ]),
    morteQualquerCausa: traduzir([
        /*pt-br*/'Morte Qualquer Causa',
        /*pt-pt*/'Morte Qualquer Causa',
        /*en-us*/'Death Any Cause',
        /*es-es*/'Muerte Cualquier Causa'
    ]),
    morteAcidental: traduzir([
        /*pt-br*/'Morte Acidental',
        /*pt-pt*/'Morte Acidental',
        /*en-us*/'Accidental Death',
        /*es-es*/'Muerte Accidental'
    ]),
    valorPremioTotal: traduzir([
        /*pt-br*/'Prêmio Total',
        /*pt-pt*/'Prémio Total',
        /*en-us*/'Total Premium',
        /*es-es*/'Prima Total'
    ]),
    valorPremioAnualizado: traduzir([
        /*pt-br*/'Prêmio Anualizado',
        /*pt-pt*/'Prémio Anualizado',
        /*en-us*/'Annualized Premium',
        /*es-es*/'Prima Anualizada'
    ]),

    banco: traduzir([
        /*pt-br*/'Banco',
        /*pt-pt*/'Banco',
        /*en-us*/'Bank',
        /*es-es*/'Banco'
    ]),
    agencia: traduzir([
        /*pt-br*/'Agência',
        /*pt-pt*/'Agência',
        /*en-us*/'Branch',
        /*es-es*/'Sucursal'
    ]),
    conta: traduzir([
        /*pt-br*/'Conta',
        /*pt-pt*/'Conta',
        /*en-us*/'Account',
        /*es-es*/'Cuenta'
    ]),
    prazoPagto: traduzir([
        /*pt-br*/'Prazo Pagamento',
        /*pt-pt*/'Prazo de Pagamento',
        /*en-us*/'Payment Term',
        /*es-es*/'Plazo de Pago'
    ]),
    diaVencimento: traduzir([
        /*pt-br*/'Dia Vencimento',
        /*pt-pt*/'Dia de Vencimento',
        /*en-us*/'Due Day',
        /*es-es*/'Día de Vencimiento'
    ]),
    numeroParcela: traduzir([
        /*pt-br*/'Número Parcela',
        /*pt-pt*/'Número da Prestação',
        /*en-us*/'Installment Number',
        /*es-es*/'Número de Cuota'
    ]),
    numeroParcelaFaturada: traduzir([
        /*pt-br*/'Número Parcela Faturada',
        /*pt-pt*/'Número da Prestação Faturada',
        /*en-us*/'Invoiced Installment Number',
        /*es-es*/'Número de Cuota Facturada'
    ]),
    statusParcela: traduzir([
        /*pt-br*/'Status Parcela',
        /*pt-pt*/'Estado da Prestação',
        /*en-us*/'Installment Status',
        /*es-es*/'Estado de Cuota'
    ]),
    tipoBaixaParcela: traduzir([
        /*pt-br*/'Tipo Baixa',
        /*pt-pt*/'Tipo de Baixa',
        /*en-us*/'Write-off Type',
        /*es-es*/'Tipo de Baja'
    ]),
    dataVencimento: traduzir([
        /*pt-br*/'Data Vencimento',
        /*pt-pt*/'Data de Vencimento',
        /*en-us*/'Due Date',
        /*es-es*/'Fecha de Vencimiento'
    ]),
    anoMesVencimento: traduzir([
        /*pt-br*/'Ano Mês de Vencimento',
        /*pt-pt*/'Ano Mês de Vencimento',
        /*en-us*/'Due Year Month',
        /*es-es*/'Año Mes de Vencimiento'
    ]),
    dataCompetencia: traduzir([
        /*pt-br*/'Data Competência',
        /*pt-pt*/'Data de Competência',
        /*en-us*/'Competency Date',
        /*es-es*/'Fecha de Competencia'
    ]),
    dataInicioVigencia: traduzir([
        /*pt-br*/'Data Início Vigência',
        /*pt-pt*/'Data Início de Vigência',
        /*en-us*/'Effective Start Date',
        /*es-es*/'Fecha Inicio de Vigencia'
    ]),
    dataFimVigencia: traduzir([
        /*pt-br*/'Data Fim Vigência',
        /*pt-pt*/'Data Fim de Vigência',
        /*en-us*/'Effective End Date',
        /*es-es*/'Fecha Fin de Vigencia'
    ]),
    dataPagamento: traduzir([
        /*pt-br*/'Data Pagamento',
        /*pt-pt*/'Data de Pagamento',
        /*en-us*/'Payment Date',
        /*es-es*/'Fecha de Pago'
    ]),
    anoMesPagamento: traduzir([
        /*pt-br*/'Ano Mês de Pagamento',
        /*pt-pt*/'Ano Mês de Pagamento',
        /*en-us*/'Payment Year Month',
        /*es-es*/'Año Mes de Pago'
    ]),
    dataApropriacao: traduzir([
        /*pt-br*/'Data Apropriação',
        /*pt-pt*/'Data de Apropriação',
        /*en-us*/'Appropriation Date',
        /*es-es*/'Fecha de Apropiación'
    ]),
    valorAPagar: traduzir([
        /*pt-br*/'Valor à Pagar',
        /*pt-pt*/'Valor a Pagar',
        /*en-us*/'Amount to Pay',
        /*es-es*/'Valor a Pagar'
    ]),
    valorPago: traduzir([
        /*pt-br*/'Valor Pago',
        /*pt-pt*/'Valor Pago',
        /*en-us*/'Amount Paid',
        /*es-es*/'Valor Pagado'
    ]),

    dataGeracaoComissao: traduzir([
        /*pt-br*/'Data Geração Comissão',
        /*pt-pt*/'Data de Geração da Comissão',
        /*en-us*/'Commission Generation Date',
        /*es-es*/'Fecha de Generación de Comisión'
    ]),
    dataGeracaoComissaoInicial: traduzir([
        /*pt-br*/'Data Geração Comissão Inicial',
        /*pt-pt*/'Data de Geração da Comissão Inicial',
        /*en-us*/'Initial Commission Generation Date',
        /*es-es*/'Fecha de Generación de la Comisión Inicial'
    ]),
    dataGeracaoComissaoFinal: traduzir([
        /*pt-br*/'Data Geração Comissão Final',
        /*pt-pt*/'Data de Geração da Comissão Final',
        /*en-us*/'Final Commission Generation Date',
        /*es-es*/'Fecha de Generación de la Comisión Final'
    ]),
    atualizarCorretorSegurosAssessorInvestimentosComissao: traduzir([
        /*pt-br*/'Atualizar Corretor de Seguros e Assessor de Investimentos da Comissão',
        /*pt-pt*/'Atualizar Corretor de Seguros e Assessor de Investimentos da Comissão',
        /*en-us*/'Update Insurance Broker and Investment Advisor Commission',
        /*es-es*/'Actualizar Corredor de Seguros y Asesor de Inversiones de la Comisión'
    ]),
    notaFiscalSeguradora: traduzir([
        /*pt-br*/'Nota Fiscal',
        /*pt-pt*/'Documento Fiscal',
        /*en-us*/'Tax Invoice',
        /*es-es*/'Factura Fiscal'
    ]),
    percImpostos: traduzir([
        /*pt-br*/'% Impostos',
        /*pt-pt*/'% Impostos',
        /*en-us*/'% Taxes',
        /*es-es*/'% Impuestos'
    ]),
    valorImpostos: traduzir([
        /*pt-br*/'Valor Impostos',
        /*pt-pt*/'Valor dos Impostos',
        /*en-us*/'Tax Amount',
        /*es-es*/'Importe de Impuestos'
    ]),
    valorComissaoCorretorSeguros: traduzir([
        /*pt-br*/'Valor Comissao Corretor de Seguros',
        /*pt-pt*/'Valor da Comissão do Corretor de Seguros',
        /*en-us*/'Insurance Broker Commission Amount',
        /*es-es*/'Importe de la Comisión del Corredor de Seguros'
    ]),
    valorComissaoCorretorSeguros2: traduzir([
        /*pt-br*/'Valor Comissao Corretor de Seguros 2',
        /*pt-pt*/'Valor da Comissão do Corretor de Seguros 2',
        /*en-us*/'Insurance Broker Commission Amount 2',
        /*es-es*/'Importe de la Comisión del Corredor de Seguros 2'
    ]),
    valorComissaoAgenteAssessorInvestimentos: traduzir([
        /*pt-br*/'Valor Comissao Assessor Investimentos',
        /*pt-pt*/'Valor da Comissão do Consultor de Investimentos',
        /*en-us*/'Investment Advisor Commission Amount',
        /*es-es*/'Importe de la Comisión del Asesor de Inversiones'
    ]),
    atualizarNotaFiscalSeguradora: traduzir([
        /*pt-br*/'Atualizar Nota Fiscal',
        /*pt-pt*/'Atualizar Documento Fiscal',
        /*en-us*/'Update Tax Invoice',
        /*es-es*/'Actualizar Factura Fiscal'
    ]),
    anoMesGeracaoComissao: traduzir([
        /*pt-br*/'Ano Mês Geração Comissão',
        /*pt-pt*/'Ano Mês Geração da Comissão',
        /*en-us*/'Commission Generation Year Month',
        /*es-es*/'Año Mes Generación de Comisión'
    ]),
    valorBaseCalculoComissao: traduzir([
        /*pt-br*/'Base Cálculo Comissão',
        /*pt-pt*/'Base de Cálculo da Comissão',
        /*en-us*/'Commission Calculation Base',
        /*es-es*/'Base de Cálculo de Comisión'
    ]),
    percAngariacao: traduzir([
        /*pt-br*/'% Angariação',
        /*pt-pt*/'% Angariação',
        /*en-us*/'% Acquisition',
        /*es-es*/'% Captación'
    ]),
    valorAngariacao: traduzir([
        /*pt-br*/'Angariação',
        /*pt-pt*/'Angariação',
        /*en-us*/'Acquisition',
        /*es-es*/'Captación'
    ]),
    percAngariacaoCalculado: traduzir([
        /*pt-br*/'% Angariação Calculado',
        /*pt-pt*/'% Angariação Calculado',
        /*en-us*/'% Calculated Acquisition',
        /*es-es*/'% Captación Calculado'
    ]),
    valorAngariacaoCalculado: traduzir([
        /*pt-br*/'Angariação Calculado',
        /*pt-pt*/'Angariação Calculado',
        /*en-us*/'Calculated Acquisition',
        /*es-es*/'Captación Calculado'
    ]),
    percComissao: traduzir([
        /*pt-br*/'% Comissão',
        /*pt-pt*/'% Comissão',
        /*en-us*/'% Commission',
        /*es-es*/'% Comisión'
    ]),
    valorComissao: traduzir([
        /*pt-br*/'Comissão',
        /*pt-pt*/'Comissão',
        /*en-us*/'Commission',
        /*es-es*/'Comisión'
    ]),
    percComissaoCalculado: traduzir([
        /*pt-br*/'% Comissão Calculado',
        /*pt-pt*/'% Comissão Calculado',
        /*en-us*/'% Calculated Commission',
        /*es-es*/'% Comisión Calculado'
    ]),
    valorComissaoCalculado: traduzir([
        /*pt-br*/'Comissão Calculado',
        /*pt-pt*/'Comissão Calculado',
        /*en-us*/'Calculated Commission',
        /*es-es*/'Comisión Calculado'
    ]),
    percEstorno: traduzir([
        /*pt-br*/'% Estorno',
        /*pt-pt*/'% Estorno',
        /*en-us*/'% Reversal',
        /*es-es*/'% Reversión'
    ]),
    valorEstorno: traduzir([
        /*pt-br*/'Estorno',
        /*pt-pt*/'Estorno',
        /*en-us*/'Reversal',
        /*es-es*/'Reversión'
    ]),
    percComissaoCoCorretagem: traduzir([
        /*pt-br*/'% Comissão Co-Corretagem',
        /*pt-pt*/'% Comissão Co-Corretagem',
        /*en-us*/'% Co-Brokerage Commission',
        /*es-es*/'% Comisión Co-Correduría'
    ]),
    valorComissaoCoCorretagem: traduzir([
        /*pt-br*/'Comissão Co-Corretagem',
        /*pt-pt*/'Comissão Co-Corretagem',
        /*en-us*/'Co-Brokerage Commission',
        /*es-es*/'Comisión Co-Correduría'
    ]),
    percComissaoSubtotal: traduzir([
        /*pt-br*/'% Subtotal',
        /*pt-pt*/'% Subtotal',
        /*en-us*/'% Subtotal',
        /*es-es*/'% Subtotal'
    ]),
    valorComissaoSubtotal: traduzir([
        /*pt-br*/'Subtotal',
        /*pt-pt*/'Subtotal',
        /*en-us*/'Subtotal',
        /*es-es*/'Subtotal'
    ]),
    percComissaoSubtotalCalculado: traduzir([
        /*pt-br*/'% Comissão Subtotal Calculado',
        /*pt-pt*/'% Comissão Subtotal Calculado',
        /*en-us*/'% Calculated Subtotal Commission',
        /*es-es*/'% Comisión Subtotal Calculado'
    ]),
    valorComissaoSubtotalCalculado: traduzir([
        /*pt-br*/'Comissão Subtotal Calculado',
        /*pt-pt*/'Comissão Subtotal Calculado',
        /*en-us*/'Calculated Subtotal Commission',
        /*es-es*/'Comisión Subtotal Calculado'
    ]),
    percIncentivo: traduzir([
        /*pt-br*/'% Incentivo',
        /*pt-pt*/'% Incentivo',
        /*en-us*/'% Incentive',
        /*es-es*/'% Incentivo'
    ]),
    valorIncentivo: traduzir([
        /*pt-br*/'Incentivo',
        /*pt-pt*/'Incentivo',
        /*en-us*/'Incentive',
        /*es-es*/'Incentivo'
    ]),
    percBonificacao: traduzir([
        /*pt-br*/'% Bonificacao',
        /*pt-pt*/'% Bonificação',
        /*en-us*/'% Bonus',
        /*es-es*/'% Bonificación'
    ]),
    valorBonificacao: traduzir([
        /*pt-br*/'Bonificacao',
        /*pt-pt*/'Bonificação',
        /*en-us*/'Bonus',
        /*es-es*/'Bonificación'
    ]),
    percComissaoTotalCalculado: traduzir([
        /*pt-br*/'% Comissão Total Calculado',
        /*pt-pt*/'% Comissão Total Calculado',
        /*en-us*/'% Total Calculated Commission',
        /*es-es*/'% Comisión Total Calculado'
    ]),
    valorComissaoTotalCalculado: traduzir([
        /*pt-br*/'Comissão Total Calculado',
        /*pt-pt*/'Comissão Total Calculado',
        /*en-us*/'Total Calculated Commission',
        /*es-es*/'Comisión Total Calculado'
    ]),
    valorComissaoTotal: traduzir([
        /*pt-br*/'Comissão Total',
        /*pt-pt*/'Comissão Total',
        /*en-us*/'Total Commission',
        /*es-es*/'Comisión Total'
    ]),
    tipoComissao: traduzir([
        /*pt-br*/'Tipo Comissão',
        /*pt-pt*/'Tipo de Comissão',
        /*en-us*/'Commission Type',
        /*es-es*/'Tipo de Comisión'
    ]),
    tipoVerificacaoCalculoComissao: traduzir([
        /*pt-br*/'Tipo Verificação Cálculo',
        /*pt-pt*/'Tipo de Verificação de Cálculo',
        /*en-us*/'Calculation Verification Type',
        /*es-es*/'Tipo de Verificación de Cálculo'
    ]),
    numeroCobertura: traduzir([
        /*pt-br*/'Número Cobertura',
        /*pt-pt*/'Número da Cobertura',
        /*en-us*/'Coverage Number',
        /*es-es*/'Número de Cobertura'
    ]),
    codigoCobertura: traduzir([
        /*pt-br*/'Código Cobertura',
        /*pt-pt*/'Código da Cobertura',
        /*en-us*/'Coverage Code',
        /*es-es*/'Código de Cobertura'
    ]),

    solicitacaoArquivo: traduzir([
        /*pt-br*/'Solicitação de Arquivos',
        /*pt-pt*/'Solicitação de Ficheiros',
        /*en-us*/'File Request',
        /*es-es*/'Solicitud de Archivos'
    ]),
    tipoSolicitacaoArquivo: traduzir([
        /*pt-br*/'Tipo Solicitação Arquivo',
        /*pt-pt*/'Tipo de Solicitação de Ficheiro',
        /*en-us*/'File Request Type',
        /*es-es*/'Tipo de Solicitud de Archivo'
    ]),

    percResp: traduzir([
        /*pt-br*/'% Responsabilidade',
        /*pt-pt*/'% Responsabilidade',
        /*en-us*/'% Responsibility',
        /*es-es*/'% Responsabilidad'
    ]),
    idadeDataSimulacao: traduzir([
        /*pt-br*/'Idade Data Simulação',
        /*pt-pt*/'Idade Data de Simulação',
        /*en-us*/'Age at Simulation Date',
        /*es-es*/'Edad Fecha de Simulación'
    ]),
    idadeDataSimulacaoQuebraEspecial: traduzir([
        /*pt-br*/'Idade Data<br/>Simulação',
        /*pt-pt*/'Idade Data<br/>de Simulação',
        /*en-us*/'Age at<br/>Simulation Date',
        /*es-es*/'Edad Fecha<br/>de Simulación'
    ]),
    idadeVaiAposentar: traduzir([
        /*pt-br*/'Vai trabalhar até',
        /*pt-pt*/'Vai trabalhar até',
        /*en-us*/'Will work until',
        /*es-es*/'Trabajará hasta'
    ]),
    idadeVaiAposentarQuebraEspecial: traduzir([
        /*pt-br*/'Vai trabalhar<br/>até',
        /*pt-pt*/'Vai trabalhar<br/>até',
        /*en-us*/'Will work<br/>until',
        /*es-es*/'Trabajará<br/>hasta'
    ]),
    idadeInicioInss: traduzir([
        /*pt-br*/'Idade Início INSS',
        /*pt-pt*/'Idade Início Segurança Social',
        /*en-us*/'Social Security Start Age',
        /*es-es*/'Edad Inicio Seguridad Social'
    ]),
    idadeExpectativaVida: traduzir([
        /*pt-br*/'Expectativa de Vida',
        /*pt-pt*/'Esperança de Vida',
        /*en-us*/'Life Expectancy',
        /*es-es*/'Expectativa de Vida'
    ]),
    idadeExpectativaVidaQuebraEspecial: traduzir([
        /*pt-br*/'Expectativa<br/>de Vida',
        /*pt-pt*/'Esperança<br/>de Vida',
        /*en-us*/'Life<br/>Expectancy',
        /*es-es*/'Expectativa<br/>de Vida'
    ]),
    idadeSimulacaoMorte: traduzir([
        /*pt-br*/'Cobrir ' + AuthService.obterTextoMorte() + ' Até',
        /*pt-pt*/'Cobrir ' + AuthService.obterTextoMorte() + ' Até',
        /*en-us*/'Cover ' + AuthService.obterTextoMorte() + ' Until',
        /*es-es*/'Cubrir ' + AuthService.obterTextoMorte() + ' Hasta'
    ]),
    idadeSimulacaoMorteQuebraEspecial: traduzir([
        /*pt-br*/'Cobrir<br/>' + AuthService.obterTextoMorte() + ' Até',
        /*pt-pt*/'Cobrir<br/>' + AuthService.obterTextoMorte() + ' Até',
        /*en-us*/'Cover<br/>' + AuthService.obterTextoMorte() + ' Until',
        /*es-es*/'Cubrir<br/>' + AuthService.obterTextoMorte() + ' Hasta'
    ]),
    tipoParametros: traduzir([
        /*pt-br*/'Parâmetros',
        /*pt-pt*/'Parâmetros',
        /*en-us*/'Parameters',
        /*es-es*/'Parámetros'
    ]),
    alterarIdadesAutomaticas: traduzir([
        /*pt-br*/'Alterar Idades Automáticas',
        /*pt-pt*/'Alterar Idades Automáticas',
        /*en-us*/'Change Automatic Ages',
        /*es-es*/'Cambiar Edades Automáticas'
    ]),
    alterarPercRespAutomatico: traduzir([
        /*pt-br*/'Alterar % Responsabilidade Automático',
        /*pt-pt*/'Alterar % Responsabilidade Automático',
        /*en-us*/'Change Automatic % Responsibility',
        /*es-es*/'Cambiar % Responsabilidad Automático'
    ]),
    alterarValoresAutomaticos: traduzir([
        /*pt-br*/'Alterar Valores Automáticos',
        /*pt-pt*/'Alterar Valores Automáticos',
        /*en-us*/'Change Automatic Values',
        /*es-es*/'Cambiar Valores Automáticos'
    ]),



    alertaCamposObrigatorios: traduzir([
        /*pt-br*/'Existem campos obrigatórios e/ou importantes que não foram preenchidos e que podem impactar o resultado do Estudo',
        /*pt-pt*/'Existem campos obrigatórios e/ou importantes que não foram preenchidos e que podem impactar o resultado do Estudo',
        /*en-us*/'There are mandatory and/or important fields that have not been filled out and may impact the Study results',
        /*es-es*/'Existen campos obligatorios e/o importantes que no han sido completados y pueden impactar el resultado del Estudio'
    ]),
    espacoAlertaCamposObrigatorios: traduzir([
        /*pt-br*/'&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp',
        /*pt-pt*/'&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp',
        /*en-us*/'&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp',
        /*es-es*/'&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp'
    ]),

    tipoInventario: traduzir([
        /*pt-br*/'Tipo Inventário',
        /*pt-pt*/'Tipo de Inventário',
        /*en-us*/'Inventory Type',
        /*es-es*/'Tipo de Inventario'
    ]),
    sucessaoVitalicia: traduzir([
        /*pt-br*/'Sucessão Patrimonial',
        /*pt-pt*/'Sucessão Patrimonial',
        /*en-us*/'Estate Succession',
        /*es-es*/'Sucesión Patrimonial'
    ]),
    informacoesTipoRegimeBens: traduzir([
        /*pt-br*/'Informações Regime de Bens',
        /*pt-pt*/'Informações dos Regime de Bens',
        /*en-us*/'Property Regime Information',
        /*es-es*/'Información de las Régimen de Bienes'
    ]),
    informacoesUfsInventario: traduzir([
        /*pt-br*/'Informações UFs Inventário',
        /*pt-pt*/'Informações dos Distritos do Inventário',
        /*en-us*/'Inventory States Information',
        /*es-es*/'Información de las Provincias del Inventario'
    ]),
    projecaoSucessaoVitalicia: traduzir([
        /*pt-br*/'Projeção da Sucessão Patrimonial: Custo do Inventário',
        /*pt-pt*/'Projeção da Sucessão Patrimonial: Custo do Inventário',
        /*en-us*/'Estate Succession Projection: Probate Cost',
        /*es-es*/'Proyección de la Sucesión Patrimonial: Costo del Inventario'
    ]),
    percDespesasAdvocaticias: traduzir([
        /*pt-br*/'% Despesas Advocatícias',
        /*pt-pt*/'% Despesas de Advogados',
        /*en-us*/'% Legal Expenses',
        /*es-es*/'% Gastos de Abogados'
    ]),
    despesasAdvocaticias: traduzir([
        /*pt-br*/'Despesas Advocatícias',
        /*pt-pt*/'Despesas de Advogados',
        /*en-us*/'Legal Expenses',
        /*es-es*/'Gastos de Abogados'
    ]),
    percCustasJudiciais: traduzir([
        /*pt-br*/'% Custas Judiciais / Cartoriais',
        /*pt-pt*/'% Custas Judiciais / Notariais',
        /*en-us*/'% Court / Notarial Costs',
        /*es-es*/'% Costas Judiciales / Notariales'
    ]),
    custasJudiciais: traduzir([
        /*pt-br*/'Custas Judiciais / Cartoriais',
        /*pt-pt*/'Custas Judiciais / Notariais',
        /*en-us*/'Court / Notarial Costs',
        /*es-es*/'Costas Judiciales / Notariales'
    ]),
    percDespesasAdvocaticiasCustasJudiciaisQuebraEspecial: traduzir([
        /*pt-br*/'% Advogado<br/>+ Custas',
        /*pt-pt*/'% Advogado<br/>+ Custas',
        /*en-us*/'% Legal<br/>+ Costs',
        /*es-es*/'% Abogado<br/>+ Costas'
    ]),
    itcmd: traduzir([
        /*pt-br*/'ITCMD',
        /*pt-pt*/'ITCMD',
        /*en-us*/'ITCMD',
        /*es-es*/'ITCMD'
    ]),
    percItcmd: traduzir([
        /*pt-br*/'% ITCMD',
        /*pt-pt*/'% ITCMD',
        /*en-us*/'% ITCMD',
        /*es-es*/'% ITCMD'
    ]),
    percItcmdQuebraEspecial: traduzir([
        /*pt-br*/'%<br/>ITCMD',
        /*pt-pt*/'%<br/>ITCMD',
        /*en-us*/'%<br/>ITCMD',
        /*es-es*/'%<br/>ITCMD'
    ]),
    emergencial: traduzir([
        /*pt-br*/'Emergencial',
        /*pt-pt*/'Emergencial',
        /*en-us*/'Emergency',
        /*es-es*/'Emergencial'
    ]),
    mesesEmergencial: traduzir([
        /*pt-br*/'Meses Emergencial',
        /*pt-pt*/'Meses de Emergencial',
        /*en-us*/'Emergency Months',
        /*es-es*/'Meses de Emergencial'
    ]),
    inventario: traduzir([
        /*pt-br*/'Inventário',
        /*pt-pt*/'Inventário',
        /*en-us*/'Inventory',
        /*es-es*/'Inventario'
    ]),
    composicaoInventario: traduzir([
        /*pt-br*/'Composição do Inventário',
        /*pt-pt*/'Composição do Inventário',
        /*en-us*/'Inventory Composition',
        /*es-es*/'Composición del Inventario'
    ]),
    sucessaoVitaliciaOpcoesAporteImediato: traduzir([
        /*pt-br*/'Sucessão Patrimonial: OPÇÕES DE APORTE IMEDIATO',
        /*pt-pt*/'Sucessão Patrimonial: OPÇÕES DE ENTRADA IMEDIATA',
        /*en-us*/'Estate Succession: IMMEDIATE CONTRIBUTION OPTIONS',
        /*es-es*/'Sucesión Patrimonial: OPCIONES DE APORTE INMEDIATO'
    ]),
    sucessaoVitaliciaOpcoes: traduzir([
        /*pt-br*/'Sucessão Patrimonial: OPÇÕES',
        /*pt-pt*/'Sucessão Patrimonial: OPÇÕES',
        /*en-us*/'Estate Succession: OPTIONS',
        /*es-es*/'Sucesión Patrimonial: OPCIONES'
    ]),
    necessidade: traduzir([
        /*pt-br*/'Necessidade',
        /*pt-pt*/'Necessidade',
        /*en-us*/'Need',
        /*es-es*/'Necesidad'
    ]),
    saldoAtual: traduzir([
        /*pt-br*/'Saldo Atual',
        /*pt-pt*/'Saldo Actual',
        /*en-us*/'Current Balance',
        /*es-es*/'Saldo Actual'
    ]),
    aporteComplementar: traduzir([
        /*pt-br*/'Aporte Complementar',
        /*pt-pt*/'Contribuição Complementar',
        /*en-us*/'Complementary Contribution',
        /*es-es*/'Aporte Complementario'
    ]),
    premioAnual: traduzir([
        /*pt-br*/'Prêmio Anual',
        /*pt-pt*/'Prémio Anual',
        /*en-us*/'Annual Premium',
        /*es-es*/'Prima Anual'
    ]),
    premioAnualPercCarteira: traduzir([
        /*pt-br*/'Prêmio Anual<br/>(% Carteira)',
        /*pt-pt*/'Prémio Anual<br/>(% Carteira)',
        /*en-us*/'Annual Premium<br/>(% Portfolio)',
        /*es-es*/'Prima Anual<br/>(% Cartera)'
    ]),
    valorCSAtual: traduzir([
        /*pt-br*/'Capital Segurado Atual',
        /*pt-pt*/'Capital Seguro Actual',
        /*en-us*/'Current Insured Capital',
        /*es-es*/'Capital Asegurado Actual'
    ]),
    valorCSComplementar: traduzir([
        /*pt-br*/'Capital Segurado Compl.',
        /*pt-pt*/'Capital Seguro Compl.',
        /*en-us*/'Complementary Insured Capital',
        /*es-es*/'Capital Asegurado Compl.'
    ]),

    dadosCadastrais: traduzir([
        /*pt-br*/'Dados Cadastrais',
        /*pt-pt*/'Dados de Registo',
        /*en-us*/'Registration Data',
        /*es-es*/'Datos de Registro'
    ]),
    perfilCliente: traduzir([
        /*pt-br*/'Perfil do Cliente',
        /*pt-pt*/'Perfil do Cliente',
        /*en-us*/'Client Profile',
        /*es-es*/'Perfil del Cliente'
    ]),
    tipoPoliticaInvestimento: traduzir([
        /*pt-br*/'Política de Investimento',
        /*pt-pt*/'Política de Investimento',
        /*en-us*/'Investment Policy',
        /*es-es*/'Política de Inversión'
    ]),
    perguntas: traduzir([
        /*pt-br*/'Perguntas',
        /*pt-pt*/'Perguntas',
        /*en-us*/'Questions',
        /*es-es*/'Preguntas'
    ]),
    motivo: traduzir([
        /*pt-br*/'Motivo',
        /*pt-pt*/'Motivo',
        /*en-us*/'Reason',
        /*es-es*/'Motivo'
    ]),
    prazoAnos: traduzir([
        /*pt-br*/'Prazo (Anos)',
        /*pt-pt*/'Prazo (Anos)',
        /*en-us*/'Term (Years)',
        /*es-es*/'Plazo (Años)'
    ]),
    comentario: traduzir([
        /*pt-br*/'Comentários',
        /*pt-pt*/'Comentários',
        /*en-us*/'Comments',
        /*es-es*/'Comentarios'
    ]),

    institucional: traduzir([
        /*pt-br*/'Institucional',
        /*pt-pt*/'Institucional',
        /*en-us*/'Institutional',
        /*es-es*/'Institucional'
    ]),

    expandir: traduzir([
        /*pt-br*/'Expandir',
        /*pt-pt*/'Expandir',
        /*en-us*/'Expand',
        /*es-es*/'Expandir'
    ]),

    cenario: traduzir([
        /*pt-br*/'Cenário',
        /*pt-pt*/'Cenário',
        /*en-us*/'Scenario',
        /*es-es*/'Escenario'
    ]),
    cenarios: traduzir([
        /*pt-br*/'Cenários',
        /*pt-pt*/'Cenários',
        /*en-us*/'Scenarios',
        /*es-es*/'Escenarios'
    ]),
    cenarioPrincipal: traduzir([
        /*pt-br*/'Cenário Principal: Cenário da versão $1$ que deve ser utilizado na Comparação de Estudos',
        /*pt-pt*/'Cenário Principal: Cenário da versão $1$ que deve ser utilizado na Comparação de Estudos',
        /*en-us*/'Main Scenario: Scenario of version $1$ to be used in the Study Comparison',
        /*es-es*/'Escenario Principal: Escenario de la versión $1$ que debe utilizarse en la Comparación de Estudios'
    ]),
    cenarioPrincipalAbreviado: traduzir([
        /*pt-br*/'Cenário Principal',
        /*pt-pt*/'Cenário Principal',
        /*en-us*/'Main Scenario',
        /*es-es*/'Escenario Principal'
    ]),
    naoExibirComparacaoCenarios: traduzir([
        /*pt-br*/'Não exibir na Comparação de Cenários',
        /*pt-pt*/'Não mostrar na Comparação de Cenários',
        /*en-us*/'Do not display in Scenario Comparison',
        /*es-es*/'No mostrar en la Comparación de Escenarios'
    ]),
    naoExibirComparacaoEstudos: traduzir([
        /*pt-br*/'Não exibir na Comparação de Estudos',
        /*pt-pt*/'Não exibir na Comparação de Estudos',
        /*en-us*/'Do not display in Study Comparison',
        /*es-es*/'No mostrar en la Comparación de Estudios'
    ]),
    parametros: traduzir([
        /*pt-br*/'Parâmetros',
        /*pt-pt*/'Parâmetros',
        /*en-us*/'Parameters',
        /*es-es*/'Parámetros'
    ]),

    cenariosTaxas: traduzir([
        /*pt-br*/'Cenários e Taxas',
        /*pt-pt*/'Cenários e Taxas',
        /*en-us*/'Scenarios and Rates',
        /*es-es*/'Escenarios y Tasas'
    ]),
    taxas: traduzir([
        /*pt-br*/'Taxas',
        /*pt-pt*/'Taxas',
        /*en-us*/'Rates',
        /*es-es*/'Tasas'
    ]),
    taxaCDIAnual: traduzir([
        /*pt-br*/'% CDI Anual',
        /*pt-pt*/'% CDI Anual',
        /*en-us*/'% Annual CDI',
        /*es-es*/'% CDI Anual'
    ]),
    taxaCDIAnualQuebraEspecial: traduzir([
        /*pt-br*/'% CDI<br/>Anual',
        /*pt-pt*/'% CDI<br/>Anual',
        /*en-us*/'% Annual<br/>CDI',
        /*es-es*/'% CDI<br/>Anual'
    ]),
    retornoCDI: traduzir([
        /*pt-br*/'% Retorno sobre o CDI',
        /*pt-pt*/'% Retorno sobre o CDI',
        /*en-us*/'% Return on CDI',
        /*es-es*/'% Retorno sobre el CDI'
    ]),
    retornoCDIQuebraEspecial: traduzir([
        /*pt-br*/'% Retorno<br/>sobre o CDI',
        /*pt-pt*/'% Retorno<br/>sobre o CDI',
        /*en-us*/'% Return<br/>on CDI',
        /*es-es*/'% Retorno<br/>sobre el CDI'
    ]),
    taxaJurosAnual: traduzir([
        /*pt-br*/'% Taxa Juros Anual',
        /*pt-pt*/'% Taxa de Juro Anual',
        /*en-us*/'% Annual Interest Rate',
        /*es-es*/'% Tasa de Interés Anual'
    ]),
    taxaJuros: traduzir([
        /*pt-br*/'Taxa de Juros',
        /*pt-pt*/'Taxa de Juro',
        /*en-us*/'Interest Rate',
        /*es-es*/'Tasa de Interés'
    ]),
    taxaJurosQuebraEspecial: traduzir([
        /*pt-br*/'Taxa de<br/>Juros',
        /*pt-pt*/'Taxa de<br/>Juro',
        /*en-us*/'Interest<br/>Rate',
        /*es-es*/'Tasa de<br/>Interés'
    ]),
    tipoMomentoTributacaoIR: traduzir([
        /*pt-br*/'Momento Tributação I.R.',
        /*pt-pt*/'Momento de Tributação I.R.',
        /*en-us*/'Income Tax Taxation Moment',
        /*es-es*/'Momento de Tributación I.R.'
    ]),
    percIR: traduzir([
        /*pt-br*/'% Imposto de Renda',
        /*pt-pt*/'% Imposto sobre o Rendimento',
        /*en-us*/'% Income Tax',
        /*es-es*/'% Impuesto sobre la Renta'
    ]),
    tempoMinimoEntreAportesResgatesCalculoIRAnos: traduzir([
        /*pt-br*/'Tempo mínimo entre Aportes e Resgates (Anos)',
        /*pt-pt*/'Tempo mínimo entre Contribuições e Resgates (Anos)',
        /*en-us*/'Minimum time between Contributions and Withdrawals (Years)',
        /*es-es*/'Tiempo mínimo entre Aportes y Rescates (Años)'
    ]),
    taxaInflacaoAnual: traduzir([
        /*pt-br*/'% Inflação Anual',
        /*pt-pt*/'% Inflação Anual',
        /*en-us*/'% Annual Inflation',
        /*es-es*/'% Inflación Anual'
    ]),
    taxaInflacaoAnualQuebraEspecial: traduzir([
        /*pt-br*/'% Inflação<br/>Anual',
        /*pt-pt*/'% Inflação<br/>Anual',
        /*en-us*/'% Annual<br/>Inflation',
        /*es-es*/'% Inflación<br/>Anual'
    ]),
    taxaInflacao: traduzir([
        /*pt-br*/'Inflação',
        /*pt-pt*/'Inflação',
        /*en-us*/'Inflation',
        /*es-es*/'Inflación'
    ]),
    taxaRetornoAnualReal: traduzir([
        /*pt-br*/'% Retorno Anual Real',
        /*pt-pt*/'% Retorno Anual Real',
        /*en-us*/'% Real Annual Return',
        /*es-es*/'% Retorno Anual Real'
    ]),
    taxaRetornoAnualRealQuebraEspecial: traduzir([
        /*pt-br*/'% Retorno<br/>Anual Real',
        /*pt-pt*/'% Retorno<br/>Anual Real',
        /*en-us*/'% Real<br/>Annual Return',
        /*es-es*/'% Retorno<br/>Anual Real'
    ]),
    taxaRetornoRealAnual: traduzir([
        /*pt-br*/'% Retorno Real Anual',
        /*pt-pt*/'% Retorno Real Anual',
        /*en-us*/'% Annual Real Return',
        /*es-es*/'% Retorno Real Anual'
    ]),
    taxaJurosAnualFgts: traduzir([
        /*pt-br*/'% Taxa Juros Anual FGTS',
        /*pt-pt*/'% Taxa de Juro Anual FGTS',
        /*en-us*/'% Annual Interest Rate FGTS',
        /*es-es*/'% Tasa de Interés Anual FGTS'
    ]),
    taxaJurosAnualFgtsQuebraEspecial: traduzir([
        /*pt-br*/'% Taxa Juros<br/>Anual FGTS',
        /*pt-pt*/'% Taxa de Juro<br/>Anual FGTS',
        /*en-us*/'% Annual Interest<br/>Rate FGTS',
        /*es-es*/'% Tasa de Interés<br/>Anual FGTS'
    ]),
    taxaRetornoAnualFgtsReal: traduzir([
        /*pt-br*/'% Retorno Anual FGTS Real',
        /*pt-pt*/'% Retorno Anual FGTS Real',
        /*en-us*/'% Real Annual FGTS Return',
        /*es-es*/'% Retorno Anual FGTS Real'
    ]),
    taxaRetornoAnualFgtsRealQuebraEspecial: traduzir([
        /*pt-br*/'% Retorno Anual<br/>FGTS Real',
        /*pt-pt*/'% Retorno Anual<br/>FGTS Real',
        /*en-us*/'% Real Annual<br/>FGTS Return',
        /*es-es*/'% Retorno Anual<br/>FGTS Real'
    ]),
    comSemDiaDiaEstudo: traduzir([
        /*pt-br*/'Com/Sem DiaDia',
        /*pt-pt*/'Com/Sem DiaDia',
        /*en-us*/'With/Without DayToDay',
        /*es-es*/'Con/Sin DíaDía'
    ]),
    dataSimulacaoEstudo: traduzir([
        /*pt-br*/'Data da Simulação',
        /*pt-pt*/'Data da Simulação',
        /*en-us*/'Simulation Date',
        /*es-es*/'Fecha de Simulación'
    ]),
    dataEstudo: traduzir([
        /*pt-br*/'Data do Estudo',
        /*pt-pt*/'Data do Estudo',
        /*en-us*/'Study Date',
        /*es-es*/'Fecha del Estudio'
    ]),
    dataUltimoEstudo: traduzir([
        /*pt-br*/'Data do Último Estudo',
        /*pt-pt*/'Data do Último Estudo',
        /*en-us*/'Last Study Date',
        /*es-es*/'Fecha del Último Estudio'
    ]),
    dataSimulacaoEstudoQuebraEspecial: traduzir([
        /*pt-br*/'Data da<br/>Simulação',
        /*pt-pt*/'Data da<br/>Simulação',
        /*en-us*/'Simulation<br/>Date',
        /*es-es*/'Fecha de<br/>Simulación'
    ]),
    utilizarPercRentabilidadeAnualRecursosFinanceiros: traduzir([
        /*pt-br*/'Utilizar "% Rentabilidade Anual" de cada Recurso Financeiro, quando informado',
        /*pt-pt*/'Utilizar "% Rentabilidade Anual" de cada Recurso Financeiro, quando informado',
        /*en-us*/'Use "% Annual Profitability" of each Financial Resource, when informed',
        /*es-es*/'Utilizar "% Rentabilidad Anual" de cada Recurso Financiero, cuando se informe'
    ]),
    diferenciarTaxasAposAposentadoria: traduzir([
        /*pt-br*/'Diferenciar Taxas após Aposentadoria',
        /*pt-pt*/'Diferenciar Taxas após Reforma',
        /*en-us*/'Differentiate Rates after Retirement',
        /*es-es*/'Diferenciar Tasas después de la Jubilación'
    ]),
    idades: traduzir([
        /*pt-br*/'Idades',
        /*pt-pt*/'Idades',
        /*en-us*/'Ages',
        /*es-es*/'Edades'
    ]),
    periodo: traduzir([
        /*pt-br*/'Período',
        /*pt-pt*/'Período',
        /*en-us*/'Period',
        /*es-es*/'Período'
    ]),
    ateAposentadoria: traduzir([
        /*pt-br*/'Até Aposentadoria',
        /*pt-pt*/'Até à Reforma',
        /*en-us*/'Until Retirement',
        /*es-es*/'Hasta la Jubilación'
    ]),
    aposAposentadoria: traduzir([
        /*pt-br*/'Após Aposentadoria',
        /*pt-pt*/'Após a Reforma',
        /*en-us*/'After Retirement',
        /*es-es*/'Después de la Jubilación'
    ]),
    invalidez: traduzir([
        /*pt-br*/'Invalidez',
        /*pt-pt*/'Invalidez',
        /*en-us*/'Disability',
        /*es-es*/'Invalidez'
    ]),

    revisaoDados: traduzir([
        /*pt-br*/'Revisão dos Dados',
        /*pt-pt*/'Revisão dos Dados',
        /*en-us*/'Data Review',
        /*es-es*/'Revisión de Datos'
    ]),

    exclusoes: traduzir([
        /*pt-br*/'Exclusões',
        /*pt-pt*/'Exclusões',
        /*en-us*/'Exclusions',
        /*es-es*/'Exclusiones'
    ]),
    exclusaoFamiliares: traduzir([
        /*pt-br*/'Desconsiderar Familiares',
        /*pt-pt*/'Desconsiderar Familiares',
        /*en-us*/'Disregard Family Members',
        /*es-es*/'Descartar Familiares'
    ]),
    familiarASerExcluido: traduzir([
        /*pt-br*/'Familiar a ser Desconsiderado',
        /*pt-pt*/'Familiar a ser Desconsiderado',
        /*en-us*/'Family Member to be Disregarded',
        /*es-es*/'Familiar a ser Descartado'
    ]),

    exclusaoDespesasGarantias: traduzir([
        /*pt-br*/'Desconsiderar Despesas e Garantias',
        /*pt-pt*/'Desconsiderar Despesas e Garantias',
        /*en-us*/'Disregard Expenses and Guarantees',
        /*es-es*/'Descartar Gastos y Garantías'
    ]),
    despesaGarantiaASerExcluida: traduzir([
        /*pt-br*/'Despesa/Garantia a ser Desconsiderada',
        /*pt-pt*/'Despesa/Garantia a ser Desconsiderada',
        /*en-us*/'Expense/Guarantee to be Disregarded',
        /*es-es*/'Gasto/Garantía a ser Descartado'
    ]),

    configuracaoGestaoPatrimonial: traduzir([
        /*pt-br*/'Gestão Patrimonial',
        /*pt-pt*/'Gestão Patrimonial',
        /*en-us*/'Wealth Management',
        /*es-es*/'Gestión Patrimonial'
    ]),
    exibirTabelaEvolucaoValorResgateCarteiraInvestimentos: traduzir([
        /*pt-br*/'Exibir a Tabela de Evolução Valor Resgate na Carteira de Investimentos',
        /*pt-pt*/'Exibir a Tabela de Evolução Valor Resgate na Carteira de Investimentos',
        /*en-us*/'Display Redemption Value Evolution Table in Investment Portfolio',
        /*es-es*/'Mostrar la Tabla de Evolución Valor Rescate en la Cartera de Inversiones'
    ]),
    exibirCapitalSeguradoCarteiraInvestimentos: traduzir([
        /*pt-br*/'Exibir o Capital Segurado Vida Inteira na Carteira de Investimentos',
        /*pt-pt*/'Exibir o Capital Segurado Vida Inteira na Carteira de Investimentos',
        /*en-us*/'Display Whole Life Insured Capital in Investment Portfolio',
        /*es-es*/'Mostrar el Capital Asegurado Vida Entera en la Cartera de Inversiones'
    ]),
    premioVidaInteiraOriundoCarteiraInvestimentos: traduzir([
        /*pt-br*/'Prêmio do Vida Inteira é oriundo da Carteira de Investimentos',
        /*pt-pt*/'Prémio do Vida Inteira é oriundo da Carteira de Investimentos',
        /*en-us*/'Whole Life Premium comes from Investment Portfolio',
        /*es-es*/'Prima del Vida Entera proviene de la Cartera de Inversiones'
    ]),
    idRecursoFinanceiroOrigemOrigemPremioVidaInteira: traduzir([
        /*pt-br*/'Recurso Financeiro Origem para Pagamento Prêmio Vida Inteira',
        /*pt-pt*/'Recurso Financeiro Origem para Pagamento Prémio Vida Inteira',
        /*en-us*/'Source Financial Resource for Whole Life Premium Payment',
        /*es-es*/'Recurso Financiero Origen para Pago Prima Vida Entera'
    ]),
    idadeSimularResgateVidaInteira: traduzir([
        /*pt-br*/'Idade para simular o Resgate do Vida Inteira $1$',
        /*pt-pt*/'Idade para simular o Resgate do Vida Inteira $1$',
        /*en-us*/'Age to simulate Whole Life Redemption $1$',
        /*es-es*/'Edad para simular el Rescate del Vida Entera $1$'
    ]),
    aplicarTaxaInflacaoSimulacaoResgateVidaInteira: traduzir([
        /*pt-br*/'Aplicar Inflação na Simulação do Resgate do Vida Inteira',
        /*pt-pt*/'Aplicar Inflação na Simulação do Resgate do Vida Inteira',
        /*en-us*/'Apply Inflation in Whole Life Redemption Simulation',
        /*es-es*/'Aplicar Inflación en la Simulación del Rescate del Vida Entera'
    ]),
    aplicarTaxaInflacaoCarteiraInvestimentos: traduzir([
        /*pt-br*/'Aplicar Inflação na Carteira de Investimentos',
        /*pt-pt*/'Aplicar Inflação na Carteira de Investimentos',
        /*en-us*/'Apply Inflation in Investment Portfolio',
        /*es-es*/'Aplicar Inflación en la Cartera de Inversiones'
    ]),
    exibirResumoSeguroVidaCotacao: traduzir([
        /*pt-br*/'Exibir o Resumo da Cotação do Seguro de Vida',
        /*pt-pt*/'Exibir o Resumo da Cotação do Seguro de Vida',
        /*en-us*/'Display Life Insurance Quote Summary',
        /*es-es*/'Mostrar el Resumen de la Cotización del Seguro de Vida'
    ]),
    exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado: traduzir([
        /*pt-br*/'Exibir o % Prêmio Anualizado Acumulado em relação ao Capital Segurado',
        /*pt-pt*/'Exibir o % Prémio Anualizado Acumulado em relação ao Capital Segurado',
        /*en-us*/'Display % Accumulated Annualized Premium in relation to Insured Capital',
        /*es-es*/'Mostrar el % Prima Anualizada Acumulada en relación al Capital Asegurado'
    ]),
    exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira: traduzir([
        /*pt-br*/'Exibir o Valor de Resgate somente a partir da quitação do Seguro Vida Inteira',
        /*pt-pt*/'Exibir o Valor de Resgate somente a partir da quitação do Seguro Vida Inteira',
        /*en-us*/'Display Redemption Value only after Whole Life Insurance settlement',
        /*es-es*/'Mostrar el Valor de Rescate solo a partir del finiquito del Seguro Vida Entera'
    ]),
    aplicarTaxaInflacaoTabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Aplicar Inflação na Tabela de Evolução Valor Resgate',
        /*pt-pt*/'Aplicar Inflação na Tabela de Evolução Valor Resgate',
        /*en-us*/'Apply Inflation in Redemption Value Evolution Table',
        /*es-es*/'Aplicar Inflación en la Tabla de Evolución Valor Rescate'
    ]),
    calcularPremioAnualizadoAcumuladoSomaSimples: traduzir([
        /*pt-br*/'Calcular o Prêmio Anualizado Acumulado pela soma simples do Prêmio Anualizado corrigido pela Inflação em cada ano, para que o cálculo fique com o mesmo critério das planilhas normalmente utilizadas no mercado (Observação: Essa não é a forma mais precisa de fazer a soma, pois soma o prêmio pago em tempos diferentes, o que pode gerar uma distorção na análise, e por isso, o uso deste parâmetro não recomendado)',
        /*pt-pt*/'Calcular o Prémio Anualizado Acumulado pela soma simples do Prémio Anualizado corrigido pela Inflação em cada ano, para que o cálculo fique com o mesmo critério das folhas de cálculo normalmente utilizadas no mercado (Observação: Esta não é a forma mais precisa de fazer a soma, pois soma o prémio pago em tempos diferentes, o que pode gerar uma distorção na análise, e por isso, o uso deste parâmetro não é recomendado)',
        /*en-us*/'Calculate Accumulated Annualized Premium by simple sum of Inflation-adjusted Annualized Premium each year, so the calculation follows the same criteria as spreadsheets commonly used in the market (Note: This is not the most accurate way to sum, as it adds premiums paid at different times, which can generate distortion in the analysis, therefore this parameter is not recommended)',
        /*es-es*/'Calcular la Prima Anualizada Acumulada por suma simple de la Prima Anualizada corregida por la Inflación en cada año, para que el cálculo quede con el mismo criterio de las hojas de cálculo normalmente utilizadas en el mercado (Observación: Esta no es la forma más precisa de hacer la suma, pues suma la prima pagada en tiempos diferentes, lo que puede generar una distorsión en el análisis, y por eso, el uso de este parámetro no es recomendado)'
    ]),
    exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao: traduzir([
        /*pt-br*/'Exibir também a Tabela de Evolução Valor Resgate sem a correção pela Inflação',
        /*pt-pt*/'Exibir também a Tabela de Evolução Valor Resgate sem a correcção pela Inflação',
        /*en-us*/'Also display Redemption Value Evolution Table without Inflation adjustment',
        /*es-es*/'Mostrar también la Tabla de Evolución Valor Rescate sin la corrección por la Inflación'
    ]),
    exibirTabelaEvolucaoCS: traduzir([
        /*pt-br*/'Exibir a Tabela de Evolução do Capital Segurado',
        /*pt-pt*/'Exibir a Tabela de Evolução do Capital Segurado',
        /*en-us*/'Display Insured Capital Evolution Table',
        /*es-es*/'Mostrar la Tabla de Evolución del Capital Asegurado'
    ]),
    limitarQtdeAnosExibidosGraficosTabelasEvolucao: traduzir([
        /*pt-br*/'Limitar a quantidade de anos exibidos nos gráficos',
        /*pt-pt*/'Limitar a quantidade de anos exibidos nos gráficos',
        /*en-us*/'Limit the number of years displayed in charts',
        /*es-es*/'Limitar la cantidad de años mostrados en los gráficos'
    ]),
    exibirTabelaEvolucaoCancelamentoApolice: traduzir([
        /*pt-br*/'Exibir a Tabela de Evolução do Cancelamento da Apólice',
        /*pt-pt*/'Exibir a Tabela de Evolução do Cancelamento da Apólice',
        /*en-us*/'Display Policy Cancellation Evolution Table',
        /*es-es*/'Mostrar la Tabla de Evolución de la Cancelación de la Póliza'
    ]),
    exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira: traduzir([
        /*pt-br*/'Exibir o gráfico "Análise Investimento x Seguro Vida Inteira"',
        /*pt-pt*/'Exibir o gráfico "Análise Investimento x Seguro Vida Inteira"',
        /*en-us*/'Display "Investment vs Whole Life Insurance Analysis" chart',
        /*es-es*/'Mostrar el gráfico "Análisis Inversión vs Seguro Vida Entera"'
    ]),
    graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR: traduzir([
        /*pt-br*/'Momento Tributação I.R.',
        /*pt-pt*/'Momento Tributação I.R.',
        /*en-us*/'Income Tax Timing',
        /*es-es*/'Momento Tributación I.R.'
    ]),
    graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercIR: traduzir([
        /*pt-br*/'% Imposto de Renda',
        /*pt-pt*/'% Imposto de Renda',
        /*en-us*/'% Income Tax',
        /*es-es*/'% Impuesto sobre la Renta'
    ]),
    graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais: traduzir([
        /*pt-br*/'Considerar o custo com Despesas Advocatícias e Custas Judiciais',
        /*pt-pt*/'Considerar o custo com Despesas de Advocacia e Custas Judiciais',
        /*en-us*/'Consider the cost of Legal Expenses and Court Costs',
        /*es-es*/'Considerar el costo con Gastos de Abogacía y Costas Judiciales'
    ]),
    graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd: traduzir([
        /*pt-br*/'Considerar o custo com o ITCMD',
        /*pt-pt*/'Considerar o custo com o ITCMD',
        /*en-us*/'Consider ITCMD cost',
        /*es-es*/'Considerar el costo con el ITCMD'
    ]),
    graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercDesagio: traduzir([
        /*pt-br*/'% Desagio',
        /*pt-pt*/'% Deságio',
        /*en-us*/'% Discount',
        /*es-es*/'% Descuento'
    ]),
    exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira: traduzir([
        /*pt-br*/'Exibir o gráfico "Análise Previdência Privada x Seguro Vida Inteira"',
        /*pt-pt*/'Exibir o gráfico "Análise Previdência Privada x Seguro Vida Inteira"',
        /*en-us*/'Display "Private Pension vs Whole Life Insurance Analysis" chart',
        /*es-es*/'Mostrar el gráfico "Análisis Previsión Privada vs Seguro Vida Entera"'
    ]),
    incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia: traduzir([
        /*pt-br*/'Incluir sugestão de Previdência Privada ou Seguro Vida Inteira para Sucessão Patrimonial',
        /*pt-pt*/'Incluir sugestão de Plano Poupança-Reforma ou Seguro de Vida Inteira para Sucessão Patrimonial',
        /*en-us*/'Include Private Pension or Whole Life Insurance Suggestion for Estate Succession',
        /*es-es*/'Incluir sugerencia de Plan de Pensiones Privado o Seguro de Vida Entera para Sucesión Patrimonial'
    ]),
    utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia: traduzir([
        /*pt-br*/'Utilizar a Previdência Privada para deduzir a necessidade de Sucessão Patrimonial',
        /*pt-pt*/'Utilizar o Plano Poupança-Reforma para deduzir a necessidade de Sucessão Patrimonial',
        /*en-us*/'Use Private Pension to Deduct Estate Succession Need',
        /*es-es*/'Utilizar el Plan de Pensiones Privado para deducir la necesidad de Sucesión Patrimonial'
    ]),

    configuracaoAcumulacao: traduzir([
        /*pt-br*/'Acumulação',
        /*pt-pt*/'Acumulação',
        /*en-us*/'Accumulation',
        /*es-es*/'Acumulación'
    ]),
    calcularAporteAtingirMetaRecursosFinanceirosInicioAposentadoria: traduzir([
        /*pt-br*/'Calcular aporte necessário para atingir meta de Recursos Financeiros no início da aposentadoria',
        /*pt-pt*/'Calcular aporte necessário para atingir meta de Recursos Financeiros no início da reforma',
        /*en-us*/'Calculate contribution needed to reach Financial Resources goal at retirement start',
        /*es-es*/'Calcular aporte necesario para alcanzar meta de Recursos Financieros al inicio de la jubilación'
    ]),
    valorMeta: traduzir([
        /*pt-br*/'Valor da Meta',
        /*pt-pt*/'Valor da Meta',
        /*en-us*/'Goal Value',
        /*es-es*/'Valor de la Meta'
    ]),
    metaInicioAposentadoria: traduzir([
        /*pt-br*/'Meta $1$',
        /*pt-pt*/'Meta $1$',
        /*en-us*/'Goal $1$',
        /*es-es*/'Meta $1$'
    ]),
    aplicarEconomiaReceitaMensalAteAposentadoriaReservaAposentadoria: traduzir([
        /*pt-br*/'Aplicar a Economia da Receita Mensal, que ocorrerem até a aposentadoria, na Reserva da Aposentadoria',
        /*pt-pt*/'Aplicar a Economia da Receita Mensal, que ocorrerem até à reforma, na Reserva da Reforma',
        /*en-us*/'Apply Monthly Income Savings, occurring until retirement, to Retirement Reserve',
        /*es-es*/'Aplicar la Economía de los Ingresos Mensuales, que ocurran hasta la jubilación, en la Reserva de Jubilación'
    ]),
    economiaReceitaMensal: traduzir([
        /*pt-br*/'Economia Receita Mensal',
        /*pt-pt*/'Economia Receita Mensal',
        /*en-us*/'Monthly Income Savings',
        /*es-es*/'Economía Ingresos Mensuales'
    ]),
    deduzirComplementoReceitaMensalAteAposentadoriaReservaAposentadoria: traduzir([
        /*pt-br*/'Deduzir o Complemento da Receita Mensal, que ocorrerem até a aposentadoria, da Reserva da Aposentadoria',
        /*pt-pt*/'Deduzir o Complemento da Receita Mensal, que ocorrerem até à reforma, da Reserva da Reforma',
        /*en-us*/'Deduct Monthly Income Supplement, occurring until retirement, from Retirement Reserve',
        /*es-es*/'Deducir el Complemento de los Ingresos Mensuales, que ocurran hasta la jubilación, de la Reserva de Jubilación'
    ]),
    naoExibirOpcaoAporteUnico: traduzir([
        /*pt-br*/'Não exibir a opção de Aporte Único',
        /*pt-pt*/'Não exibir a opção de Aporte Único',
        /*en-us*/'Do not display Single Contribution option',
        /*es-es*/'No mostrar la opción de Aporte Único'
    ]),
    utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira: traduzir([
        /*pt-br*/'Utilizar versão simplificada do Gráfico Diagnóstico Aposentadoria & Independência Financeira: somente com opções de aporte',
        /*pt-pt*/'Utilizar versão simplificada do Gráfico Diagnóstico Reforma & Independência Financeira: somente com opções de aporte',
        /*en-us*/'Use simplified version of Retirement & Financial Independence Diagnostic Chart: only with contribution options',
        /*es-es*/'Utilizar versión simplificada del Gráfico Diagnóstico Jubilación e Independencia Financiera: solo con opciones de aporte'
    ]),
    naoExibirHipotesesRetornoRealAposentadoria: traduzir([
        /*pt-br*/'Não exibir o gráfico de hipóteses de retorno real para Aposentadoria',
        /*pt-pt*/'Não exibir o gráfico de hipóteses de retorno real para Reforma',
        /*en-us*/'Do not display real return hypotheses chart for Retirement',
        /*es-es*/'No mostrar el gráfico de hipótesis de retorno real para Jubilación'
    ]),
    calcularHipotesesRetornoRealAposentadoriaViverRentabilidade: traduzir([
        /*pt-br*/'Calcular gráfico de hipóteses de retorno real para Aposentadoria para viver de rentabilidade',
        /*pt-pt*/'Calcular gráfico de hipóteses de retorno real para Reforma para viver de rentabilidade',
        /*en-us*/'Calculate real return hypotheses chart for Retirement to live off profitability',
        /*es-es*/'Calcular gráfico de hipótesis de retorno real para Jubilación para vivir de rentabilidad'
    ]),

    exibirRecursosFinanceirosTipoRecursoFinanceiroVersusInstituicao: traduzir([
        /*pt-br*/'Exibir Recursos Financeiros: Tipo de Recurso Financeiro x Instituição no Relatório',
        /*pt-pt*/'Mostrar Recursos Financeiros: Tipo de Recurso Financeiro x Instituição no Relatório',
        /*en-us*/'Display Financial Resources: Financial Resource Type vs Institution in the Report',
        /*es-es*/'Mostrar Recursos Financieros: Tipo de Recurso Financiero vs Institución en el Informe'
    ]),

    naoCalcularAportesNecessariosRealizacaoPVS: traduzir([
        /*pt-br*/'Não calcular os aportes necessários para a realização dos Projetos de Vida/Sonho',
        /*pt-pt*/'Não calcular os aportes necessários para a realização dos Projectos de Vida/Sonho',
        /*en-us*/'Do not calculate contributions needed for Life/Dream Projects realization',
        /*es-es*/'No calcular los aportes necesarios para la realización de los Proyectos de Vida/Sueño'
    ]),
    naoConsiderarValorAcumulacaoJaRealizadoPVS: traduzir([
        /*pt-br*/'Não considerar os valores já acumulados para Projetos de Vida/Sonho',
        /*pt-pt*/'Não considerar os valores já acumulados para Projectos de Vida/Sonho',
        /*en-us*/'Do not consider values already accumulated for Life/Dream Projects',
        /*es-es*/'No considerar los valores ya acumulados para Proyectos de Vida/Sueño'
    ]),
    exibirHipotesesRetornoRealProjetoVidaSonho: traduzir([
        /*pt-br*/'Exibir os gráficos de hipóteses de retorno real para Projeto de Vida/Sonho',
        /*pt-pt*/'Exibir os gráficos de hipóteses de retorno real para Projecto de Vida/Sonho',
        /*en-us*/'Display real return hypotheses charts for Life/Dream Project',
        /*es-es*/'Mostrar los gráficos de hipótesis de retorno real para Proyecto de Vida/Sueño'
    ]),
    naoExibirAcumulacaoAposentadoriaProjetoVidaSonho: traduzir([
        /*pt-br*/'Não exibir a sugestão de acumulação para Aposentadoria e Projeto de Vida/Sonho no Resumo',
        /*pt-pt*/'Não exibir a sugestão de acumulação para Reforma e Projecto de Vida/Sonho no Resumo',
        /*en-us*/'Do not display accumulation suggestion for Retirement and Life/Dream Project in Summary',
        /*es-es*/'No mostrar la sugerencia de acumulación para Jubilación y Proyecto de Vida/Sueño en el Resumen'
    ]),



    previdenciaPrivada: traduzir([
        /*pt-br*/'Previdência Privada',
        /*pt-pt*/'Previdência Privada',
        /*en-us*/'Private Pension',
        /*es-es*/'Previsión Privada'
    ]),
    analiseBeneficiosPrevidenciaPrivada: traduzir([
        /*pt-br*/'Análise dos Benefícios da Previdência Privada',
        /*pt-pt*/'Análise dos Benefícios da Previdência Privada',
        /*en-us*/'Private Pension Benefits Analysis',
        /*es-es*/'Análisis de los Beneficios de la Previsión Privada'
    ]),
    contribuiINSSRPPSOuAposentador: traduzir([
        /*pt-br*/'Contribui para o INSS/RPPS ou já é aposentado?',
        /*pt-pt*/'Contribui para a Segurança Social ou já está reformado?',
        /*en-us*/'Contributes to Social Security or is already retired?',
        /*es-es*/'¿Contribuye a la Seguridad Social o ya está jubilado?'
    ]),
    sugestao: traduzir([
        /*pt-br*/'Sugestão:',
        /*pt-pt*/'Sugestão:',
        /*en-us*/'Suggestion:',
        /*es-es*/'Sugerencia:'
    ]),
    beneficio: traduzir([
        /*pt-br*/'Benefício:',
        /*pt-pt*/'Benefício:',
        /*en-us*/'Benefit:',
        /*es-es*/'Beneficio:'
    ]),
    beneficioSemPrevidenciaPrivada: traduzir([
        /*pt-br*/'Sem Aporte Previdênvia Privada',
        /*pt-pt*/'Sem Aporte Previdência Privada',
        /*en-us*/'Without Private Pension Contribution',
        /*es-es*/'Sin Aporte Previsión Privada'
    ]),
    beneficioComPrevidenciaPrivada: traduzir([
        /*pt-br*/'Com Aporte $1$',
        /*pt-pt*/'Com Aporte $1$',
        /*en-us*/'With Contribution $1$',
        /*es-es*/'Con Aporte $1$'
    ]),
    ir: traduzir([
        /*pt-br*/'Imposto de Renda',
        /*pt-pt*/'Imposto de Renda',
        /*en-us*/'Income Tax',
        /*es-es*/'Impuesto sobre la Renta'
    ]),
    rentabilidade: traduzir([
        /*pt-br*/'Rentabilidade',
        /*pt-pt*/'Rentabilidade',
        /*en-us*/'Profitability',
        /*es-es*/'Rentabilidad'
    ]),
    consumirReserva: traduzir([
        /*pt-br*/'Consumir Reserva (retirada = $1$)',
        /*pt-pt*/'Consumir Reserva (retirada = $1$)',
        /*en-us*/'Consume Reserve (withdrawal = $1$)',
        /*es-es*/'Consumir Reserva (retiro = $1$)'
    ]),
    preservarReserva: traduzir([
        /*pt-br*/'Preservar Reserva (retirada = $1$)',
        /*pt-pt*/'Preservar Reserva (retirada = $1$)',
        /*en-us*/'Preserve Reserve (withdrawal = $1$)',
        /*es-es*/'Preservar Reserva (retiro = $1$)'
    ]),
    fundamento: traduzir([
        /*pt-br*/'Fundamento:',
        /*pt-pt*/'Fundamento:',
        /*en-us*/'Foundation:',
        /*es-es*/'Fundamento:'
    ]),
    simulacao: traduzir([
        /*pt-br*/'Simulação',
        /*pt-pt*/'Simulação',
        /*en-us*/'Simulation',
        /*es-es*/'Simulación'
    ]),
    vantagens: traduzir([
        /*pt-br*/'Vantagens:',
        /*pt-pt*/'Vantagens:',
        /*en-us*/'Advantages:',
        /*es-es*/'Ventajas:'
    ]),
    rendaTributavelAnual: traduzir([
        /*pt-br*/'Renda Tributável Anual',
        /*pt-pt*/'Renda Tributável Anual',
        /*en-us*/'Annual Taxable Income',
        /*es-es*/'Renta Gravable Anual'
    ]),
    baseCalculoIr: traduzir([
        /*pt-br*/'Base Cálculo IR',
        /*pt-pt*/'Base Cálculo IR',
        /*en-us*/'Income Tax Calculation Base',
        /*es-es*/'Base Cálculo IR'
    ]),
    despesaDetutivelAnualSemPrevidenciaPrivada: traduzir([
        /*pt-br*/'Despesa Dedutível Anual sem Previdência Privada',
        /*pt-pt*/'Despesa Dedutível Anual sem Previdência Privada',
        /*en-us*/'Annual Deductible Expense without Private Pension',
        /*es-es*/'Gasto Deducible Anual sin Previsión Privada'
    ]),
    simularAportePGBLInferiorMaximoPossivel: traduzir([
        /*pt-br*/'Simular aporte no PGBL inferior ao máximo possível (12%)',
        /*pt-pt*/'Simular contribuição no PGBL inferior ao máximo possível (12%)',
        /*en-us*/'Simulate a PGBL contribution below the maximum allowed (12%)',
        /*es-es*/'Simular una aportación al PGBL inferior al máximo permitido (12%)'
    ]),
    aporteAnualPGBL: traduzir([
        /*pt-br*/'Aporte Anual PGBL',
        /*pt-pt*/'Contribuição Anual PGBL',
        /*en-us*/'Annual PGBL Contribution',
        /*es-es*/'Aportación Anual PGBL'
    ]),
    aporteMensalPGBL: traduzir([
        /*pt-br*/'Aporte Mensal PGBL',
        /*pt-pt*/'Contribuição Mensal PGBL',
        /*en-us*/'Monthly PGBL Contribution',
        /*es-es*/'Aportación Mensual PGBL'
    ]),
    aportePortabilidadeInicial: traduzir([
        /*pt-br*/'Aporte/ Portabilidade Inicial',
        /*pt-pt*/'Aporte/ Portabilidade Inicial',
        /*en-us*/'Initial Contribution/Portability',
        /*es-es*/'Aporte/Portabilidad Inicial'
    ]),
    aporteRegularMensal: traduzir([
        /*pt-br*/'Aporte Regular Mensal',
        /*pt-pt*/'Aporte Regular Mensal',
        /*en-us*/'Regular Monthly Contribution',
        /*es-es*/'Aporte Regular Mensual'
    ]),
    rentabilidade12Meses: traduzir([
        /*pt-br*/'Rentabilidade<br/>12 Meses',
        /*pt-pt*/'Rentabilidade<br/>12 Meses',
        /*en-us*/'Profitability<br/>12 Months',
        /*es-es*/'Rentabilidad<br/>12 Meses'
    ]),
    rentabilidade24Meses: traduzir([
        /*pt-br*/'Rentabilidade<br/>24 Meses',
        /*pt-pt*/'Rentabilidade<br/>24 Meses',
        /*en-us*/'Profitability<br/>24 Months',
        /*es-es*/'Rentabilidad<br/>24 Meses'
    ]),
    taxaAdministracao: traduzir([
        /*pt-br*/'Taxa Administração',
        /*pt-pt*/'Taxa Administração',
        /*en-us*/'Administration Fee',
        /*es-es*/'Tasa Administración'
    ]),
    taxaAdministracaoAbreviado: traduzir([
        /*pt-br*/'% Taxa Adm.',
        /*pt-pt*/'% Taxa Adm.',
        /*en-us*/'% Admin Fee',
        /*es-es*/'% Tasa Adm.'
    ]),

    configuracaoProtecao: traduzir([
        /*pt-br*/'Proteção',
        /*pt-pt*/'Protecção',
        /*en-us*/'Protection',
        /*es-es*/'Protección'
    ]),
    naoAplicarTaxaJurosSeguroVida: traduzir([
        /*pt-br*/'Não aplicar as Taxas de Juros no cálculo do Seguro de Vida',
        /*pt-pt*/'Não aplicar as Taxas de Juro no cálculo do Seguro de Vida',
        /*en-us*/'Do not apply Interest Rates in Life Insurance calculation',
        /*es-es*/'No aplicar las Tasas de Interés en el cálculo del Seguro de Vida'
    ]),
    naoExibirProtecaoRiscos: traduzir([
        /*pt-br*/'Não exibir a sugestão de Proteçao de Riscos',
        /*pt-pt*/'Não exibir a sugestão de Protecção de Riscos',
        /*en-us*/'Do not display Risk Protection suggestion',
        /*es-es*/'No mostrar la sugerencia de Protección de Riesgos'
    ]),
    exibirMorteAte: traduzir([
        /*pt-br*/'Exibir Morte Até',
        /*pt-pt*/'Exibir Morte Até',
        /*en-us*/'Display Death Until',
        /*es-es*/'Mostrar Muerte Hasta'
    ]),
    naoExibirMorteVitalicia: traduzir([
        /*pt-br*/'Não exibir Morte Vitalícia',
        /*pt-pt*/'Não exibir Morte Vitalícia',
        /*en-us*/'Do not display Life Death',
        /*es-es*/'No mostrar Muerte Vitalicia'
    ]),
    naoExibirMorteSucessaoVitalicia: traduzir([
        /*pt-br*/'Não exibir Morte Sucessão Patrimonial',
        /*pt-pt*/'Não exibir Morte Sucessão Patrimonial',
        /*en-us*/'Do Not Show Death Estate Succession',
        /*es-es*/'No mostrar Muerte Sucesión Patrimonial'
    ]),
    naoExibirCobertura: traduzir([
        /*pt-br*/'Não exibir',
        /*pt-pt*/'Não exibir',
        /*en-us*/'Do not display',
        /*es-es*/'No mostrar'
    ]),
    naoExibirDITDITA: traduzir([
        /*pt-br*/'Não exibir DIT e/ou DITA',
        /*pt-pt*/'Não exibir DIT e/ou DITA',
        /*en-us*/'Do not display DIT and/or DITA',
        /*es-es*/'No mostrar DIT y/o DITA'
    ]),
    naoExibirDoencasGraves: traduzir([
        /*pt-br*/'Não exibir Doenças Graves',
        /*pt-pt*/'Não exibir Doenças Graves',
        /*en-us*/'Do not display Critical Illness',
        /*es-es*/'No mostrar Enfermedades Graves'
    ]),
    despesasAdicionaisDoencasGraves: traduzir([
        /*pt-br*/'Despesas Adicionais (médicas, etc) Doenças Graves',
        /*pt-pt*/'Despesas Adicionais (médicas, etc) Doenças Graves',
        /*en-us*/'Additional Expenses (medical, etc) Critical Illness',
        /*es-es*/'Gastos Adicionales (médicos, etc) Enfermedades Graves'
    ]),
    naoExibirInvalidez: traduzir([
        /*pt-br*/'Não exibir Invalidez',
        /*pt-pt*/'Não exibir Invalidez',
        /*en-us*/'Do not display Disability',
        /*es-es*/'No mostrar Invalidez'
    ]),
    naoExibirFuneral: traduzir([
        /*pt-br*/'Não exibir Funeral',
        /*pt-pt*/'Não exibir Funeral',
        /*en-us*/'Do not display Funeral',
        /*es-es*/'No mostrar Funeral'
    ]),
    tonarInvalidezDefaultCalculoProtecao: traduzir([
        /*pt-br*/'Tornar a Invalidez Default para o Cálculo de Proteção',
        /*pt-pt*/'Tornar a Invalidez predefinida para o Cálculo de Proteção',
        /*en-us*/'Set Disability as default for Protection Calculation',
        /*es-es*/'Establecer la Invalidez como predeterminada para el Cálculo de Protección'
    ]),
    naoExibirDespesasAcumuladasSemDiaDia: traduzir([
        /*pt-br*/'Não exibir a opção "Sem o Dia a Dia" do gráfico "Despesas Acumuladas ao longo do tempo".',
        /*pt-pt*/'Não exibir a opção "Sem o Dia a Dia" do gráfico "Despesas Acumuladas ao longo do tempo".',
        /*en-us*/'Do not display "Without Day-to-Day" option from "Accumulated Expenses over time" chart.',
        /*es-es*/'No mostrar la opción "Sin el Día a Día" del gráfico "Gastos Acumulados a lo largo del tiempo".'
    ]),
    exibirProjecaoSucessaoVitaliciaAteIdade: traduzir([
        /*pt-br*/'Exibir a Projeção da Sucessão Patrimonial até a Idade',
        /*pt-pt*/'Exibir a Projeção da Sucessão Patrimonial até à Idade',
        /*en-us*/'Show Estate Succession Projection Until Age',
        /*es-es*/'Mostrar la Proyección de la Sucesión Patrimonial hasta la Edad'
    ]),

    paginaAdicional: traduzir([
        /*pt-br*/'Página Adicional',
        /*pt-pt*/'Página Adicional',
        /*en-us*/'Additional Page',
        /*es-es*/'Página Adicional'
    ]),

    configuracaoRelatorio: traduzir([
        /*pt-br*/'Relatório',
        /*pt-pt*/'Relatório',
        /*en-us*/'Report',
        /*es-es*/'Informe'
    ]),
    configuracaoRelatorioTitulo: traduzir([
        /*pt-br*/'Configuração do Relatório',
        /*pt-pt*/'Configuração do Relatório',
        /*en-us*/'Report Configuration',
        /*es-es*/'Configuración del Informe'
    ]),
    detalhado: traduzir([
        /*pt-br*/'Detalhado',
        /*pt-pt*/'Detalhado',
        /*en-us*/'Detailed',
        /*es-es*/'Detallado'
    ]),
    resumido: traduzir([
        /*pt-br*/'Resumido',
        /*pt-pt*/'Resumido',
        /*en-us*/'Summary',
        /*es-es*/'Resumido'
    ]),
    disposicaoRelatorio: traduzir([
        /*pt-br*/'Disposição do Relatório',
        /*pt-pt*/'Disposição do Relatório',
        /*en-us*/'Report Layout',
        /*es-es*/'Disposición del Informe'
    ]), 
    imprimir: traduzir([
        /*pt-br*/'Imprimir',
        /*pt-pt*/'Imprimir',
        /*en-us*/'Print',
        /*es-es*/'Imprimir'
    ]),
    naoImprimir: traduzir([
        /*pt-br*/'Não Imprimir',
        /*pt-pt*/'Não Imprimir',
        /*en-us*/'Do not Print',
        /*es-es*/'No Imprimir'
    ]),

    exibir: traduzir([
        /*pt-br*/'Exibir',
        /*pt-pt*/'Exibir',
        /*en-us*/'Display',
        /*es-es*/'Mostrar'
    ]),
    naoExibir: traduzir([
        /*pt-br*/'Não Exibir',
        /*pt-pt*/'Não Exibir',
        /*en-us*/'Do not Display',
        /*es-es*/'No Mostrar'
    ]),

    agrupar: traduzir([
        /*pt-br*/'Agrupar',
        /*pt-pt*/'Agrupar',
        /*en-us*/'Group',
        /*es-es*/'Agrupar'
    ]),
    naoAgrupar: traduzir([
        /*pt-br*/'Não Agrupar',
        /*pt-pt*/'Não Agrupar',
        /*en-us*/'Do not Group',
        /*es-es*/'No Agrupar'
    ]),
    saltarPaginaQuebra: traduzir([
        /*pt-br*/'Saltar página a cada quebra de $campo$',
        /*pt-pt*/'Saltar página a cada quebra de $campo$',
        /*en-us*/'Skip page at each $campo$ break',
        /*es-es*/'Saltar página en cada quiebre de $campo$'
    ]),
    gerarPDFQuebra: traduzir([
        /*pt-br*/'Gerar PDF separado a cada quebra de $campo$',
        /*pt-pt*/'Gerar PDF separado a cada quebra de $campo$',
        /*en-us*/'Generate separate PDF at each $campo$ break',
        /*es-es*/'Generar PDF separado en cada quiebre de $campo$'
    ]),
    enviarPDFEmail: traduzir([
        /*pt-br*/'Enviar PDF por E-mail para cada $campo$',
        /*pt-pt*/'Enviar PDF por E-mail para cada $campo$',
        /*en-us*/'Send PDF by Email for each $campo$',
        /*es-es*/'Enviar PDF por Email para cada $campo$'
    ]),
    assuntoEmail: traduzir([
        /*pt-br*/'Assunto do E-mail',
        /*pt-pt*/'Assunto do E-mail',
        /*en-us*/'Email Subject',
        /*es-es*/'Asunto del Email'
    ]),
    textoEmail: traduzir([
        /*pt-br*/'Texto do E-mail',
        /*pt-pt*/'Texto do E-mail',
        /*en-us*/'Email Text',
        /*es-es*/'Texto del Email'
    ]),

    relatoriosGraficos: traduzir([
        /*pt-br*/'Gráficos e Relatórios',
        /*pt-pt*/'Gráficos e Relatórios',
        /*en-us*/'Charts and Reports',
        /*es-es*/'Gráficos e Informes'
    ]),

    simulacaoFinanceira: traduzir([
        /*pt-br*/'Simulação Financeira',
        /*pt-pt*/'Simulação Financeira',
        /*en-us*/'Financial Simulation',
        /*es-es*/'Simulación Financiera'
    ]),
    taxaJurosInflacao: traduzir([
        /*pt-br*/'Taxa de Juros e Inflação',
        /*pt-pt*/'Taxa de Juro e Inflação',
        /*en-us*/'Interest Rate and Inflation',
        /*es-es*/'Tasa de Interés e Inflación'
    ]),
    aposentadoriaExpectativaVida: traduzir([
        /*pt-br*/'Aposentadoria e Expectativa de Vida',
        /*pt-pt*/'Reforma e Expectativa de Vida',
        /*en-us*/'Retirement and Life Expectancy',
        /*es-es*/'Jubilación y Expectativa de Vida'
    ]),
    evolucaoReservaFinanceira: traduzir([
        /*pt-br*/'Evolução da Reserva Financeira',
        /*pt-pt*/'Evolução da Reserva Financeira',
        /*en-us*/'Financial Reserve Evolution',
        /*es-es*/'Evolución de la Reserva Financiera'
    ]),
    planejamentoAposentadoria: traduzir([
        /*pt-br*/'Planejamento da Aposentadoria',
        /*pt-pt*/'Planeamento da Reforma',
        /*en-us*/'Retirement Planning',
        /*es-es*/'Planificación de la Jubilación'
    ]),
    percPoupanca: traduzir([
        /*pt-br*/'% Poupança',
        /*pt-pt*/'% Poupança',
        /*en-us*/'% Savings',
        /*es-es*/'% Ahorro'
    ]),
    retiradaReservaManterPadraoVidaDesejadoAposentadoria: traduzir([
        /*pt-br*/'<b>Retirada da Reserva para manter<br/>Padrão de vida desejado </b>na aposentadoria',
        /*pt-pt*/'<b>Retirada da Reserva para manter<br/>Padrão de vida desejado </b>na reforma',
        /*en-us*/'<b>Reserve Withdrawal to maintain<br/>Desired lifestyle </b>in retirement',
        /*es-es*/'<b>Retiro de la Reserva para mantener<br/>Estándar de vida deseado </b>en la jubilación'
    ]),
    aportesMensaisParaAtingirPadraoVidaDesejado: traduzir([
        /*pt-br*/'<b>Aportes mensais até aposentadoria</b><br/>para atingir o padrão de vida desejado',
        /*pt-pt*/'<b>Aportes mensais até à reforma</b><br/>para atingir o padrão de vida desejado',
        /*en-us*/'<b>Monthly contributions until retirement</b><br/>to achieve desired lifestyle',
        /*es-es*/'<b>Aportes mensuales hasta la jubilación</b><br/>para alcanzar el estándar de vida deseado'
    ]),
    estrategiasPossiveis: traduzir([
        /*pt-br*/'Estratégias Possíveis',
        /*pt-pt*/'Estratégias Possíveis',
        /*en-us*/'Possible Strategies',
        /*es-es*/'Estrategias Posibles'
    ]),
    preservarReservaViverRentabilidade: traduzir([
        /*pt-br*/'<b>Preservar a Reserva</b><br/>e viver de rentabilidade',
        /*pt-pt*/'<b>Preservar a Reserva</b><br/>e viver de rentabilidade',
        /*en-us*/'<b>Preserve the Reserve</b><br/>and live off profitability',
        /*es-es*/'<b>Preservar la Reserva</b><br/>y vivir de rentabilidad'
    ]),
    consumirReservaAte: traduzir([
        /*pt-br*/'<b>Consumir a Reserva</b><br/>até $1$ anos',
        /*pt-pt*/'<b>Consumir a Reserva</b><br/>até $1$ anos',
        /*en-us*/'<b>Consume the Reserve</b><br/>until $1$ years',
        /*es-es*/'<b>Consumir la Reserva</b><br/>hasta $1$ años'
    ]),
    aporteMensalAdicional: traduzir([
        /*pt-br*/'<b>Aporte mensal</b> adicional',
        /*pt-pt*/'<b>Aporte mensal</b> adicional',
        /*en-us*/'<b>Monthly contribution</b> additional',
        /*es-es*/'<b>Aporte mensual</b> adicional'
    ]),
    aporteUnicoAdicional: traduzir([
        /*pt-br*/'<b>Aporte único</b> adicional',
        /*pt-pt*/'<b>Aporte único</b> adicional',
        /*en-us*/'<b>Single contribution</b> additional',
        /*es-es*/'<b>Aporte único</b> adicional'
    ]),
    reservaInicioAposentadoriaComAportes: traduzir([
        /*pt-br*/'<b>Reserva</b> aos <b>$1$</b> com aportes adicionais',
        /*pt-pt*/'<b>Reserva</b> aos <b>$1$</b> com aportes adicionais',
        /*en-us*/'<b>Reserve</b> at <b>$1$</b> with additional contributions',
        /*es-es*/'<b>Reserva</b> a los <b>$1$</b> con aportes adicionales'
    ]),
    retiradaMaximaSemNovosAportesAdicionais: traduzir([
        /*pt-br*/'<b>Retirada máxima</b> sem novos aportes adicionais',
        /*pt-pt*/'<b>Retirada máxima</b> sem novos aportes adicionais',
        /*en-us*/'<b>Maximum withdrawal</b> without new additional contributions',
        /*es-es*/'<b>Retiro máximo</b> sin nuevos aportes adicionales'
    ]),
    cliqueParaAdicionarAutomaticamenteAporteMensal: traduzir([
        /*pt-br*/'Clique para adicionar automaticamente o aporte sugerido ao Aporte Mensal',
        /*pt-pt*/'Clique para adicionar automaticamente o aporte sugerido ao Aporte Mensal',
        /*en-us*/'Click to automatically add suggested contribution to Monthly Contribution',
        /*es-es*/'Haga clic para agregar automáticamente el aporte sugerido al Aporte Mensual'
    ]),
    cliqueParaAtribuirAutomaticamenteRetiradaMensal: traduzir([
        /*pt-br*/'Clique para atribuir automaticamente o Retirada Mensal',
        /*pt-pt*/'Clique para atribuir automaticamente a Retirada Mensal',
        /*en-us*/'Click to automatically assign Monthly Withdrawal',
        /*es-es*/'Haga clic para asignar automáticamente el Retiro Mensual'
    ]),
    cliqueParaAtribuirAutomaticamenteAporteUnico: traduzir([
        /*pt-br*/'Clique para atribuir automaticamente o Aporte Único',
        /*pt-pt*/'Clique para atribuir automaticamente o Aporte Único',
        /*en-us*/'Click to automatically assign Single Contribution',
        /*es-es*/'Haga clic para asignar automáticamente el Aporte Único'
    ]),
    
    aportesRetiradasPlanejados: traduzir([
        /*pt-br*/'Aportes e Retiradas Planejados',
        /*pt-pt*/'Aportes e Retiradas Planeados',
        /*en-us*/'Planned Contributions and Withdrawals',
        /*es-es*/'Aportes y Retiros Planificados'
    ]),
    aportesRetiradasMensais: traduzir([
        /*pt-br*/'Aportes e Retiradas Mensais',
        /*pt-pt*/'Aportes e Retiradas Mensais',
        /*en-us*/'Monthly Contributions and Withdrawals',
        /*es-es*/'Aportes y Retiros Mensuales'
    ]),
    aporteMensal: traduzir([
        /*pt-br*/'Aporte Mensal',
        /*pt-pt*/'Aporte Mensal',
        /*en-us*/'Monthly Contribution',
        /*es-es*/'Aporte Mensual'
    ]),
    aporteTotal: traduzir([
        /*pt-br*/'Aporte Total',
        /*pt-pt*/'Aporte Total',
        /*en-us*/'Total Contribution',
        /*es-es*/'Aporte Total'
    ]),
    aporteMedio: traduzir([
        /*pt-br*/'Aporte Médio',
        /*pt-pt*/'Aporte Médio',
        /*en-us*/'Average Contribution',
        /*es-es*/'Aporte Promedio'
    ]),
    percReajusteAporteMensal: traduzir([
        /*pt-br*/'% Reajuste Aporte Mensal',
        /*pt-pt*/'% Reajuste Aporte Mensal',
        /*en-us*/'% Monthly Contribution Adjustment',
        /*es-es*/'% Reajuste Aporte Mensual'
    ]),
    aumentoAporteMensal: traduzir([
        /*pt-br*/'Aumento Aporte Mensal',
        /*pt-pt*/'Aumento Aporte Mensal',
        /*en-us*/'Monthly Contribution Increase',
        /*es-es*/'Aumento Aporte Mensual'
    ]),
    anosReajusteAporteMensal: traduzir([
        /*pt-br*/'Reajustar Aporte Mensal a cada X Anos',
        /*pt-pt*/'Reajustar Aporte Mensal a cada X Anos',
        /*en-us*/'Adjust Monthly Contribution every X Years',
        /*es-es*/'Reajustar Aporte Mensual cada X Años'
    ]),
    anosAumentoAporteMensal: traduzir([
        /*pt-br*/'Aumentar Aporte Mensal a cada X Anos',
        /*pt-pt*/'Aumentar Aporte Mensal a cada X Anos',
        /*en-us*/'Increase Monthly Contribution every X Years',
        /*es-es*/'Aumentar Aporte Mensual cada X Años'
    ]),
    aporteMensalEvolucaoInflacaoQuebraEspecial: traduzir([
        /*pt-br*/'Aporte Mensal<br/>Evolução Inflação',
        /*pt-pt*/'Aporte Mensal<br/>Evolução Inflação',
        /*en-us*/'Monthly Contribution<br/>Inflation Evolution',
        /*es-es*/'Aporte Mensual<br/>Evolución Inflación'
    ]),
    aporteMedioEvolucaoInflacaoQuebraEspecial: traduzir([
        /*pt-br*/'Aporte Medio<br/>Evolução Inflação',
        /*pt-pt*/'Aporte Médio<br/>Evolução Inflação',
        /*en-us*/'Average Contribution<br/>Inflation Evolution',
        /*es-es*/'Aporte Promedio<br/>Evolución Inflación'
    ]),
    retiradaMensal: traduzir([
        /*pt-br*/'Retirada Mensal',
        /*pt-pt*/'Retirada Mensal',
        /*en-us*/'Monthly Withdrawal',
        /*es-es*/'Retiro Mensual'
    ]),
    retiradaTotal: traduzir([
        /*pt-br*/'Retirada Total',
        /*pt-pt*/'Retirada Total',
        /*en-us*/'Total Withdrawal',
        /*es-es*/'Retiro Total'
    ]),
    retiradaMedia: traduzir([
        /*pt-br*/'Retirada Média',
        /*pt-pt*/'Retirada Média',
        /*en-us*/'Average Withdrawal',
        /*es-es*/'Retiro Promedio'
    ]),
    percReajusteRetiradaMensal: traduzir([
        /*pt-br*/'% Reajuste Retirada Mensal',
        /*pt-pt*/'% Reajuste Retirada Mensal',
        /*en-us*/'% Monthly Withdrawal Adjustment',
        /*es-es*/'% Reajuste Retiro Mensual'
    ]),
    aumentoRetiradaMensal: traduzir([
        /*pt-br*/'Aumento Retirada Mensal',
        /*pt-pt*/'Aumento Retirada Mensal',
        /*en-us*/'Monthly Withdrawal Increase',
        /*es-es*/'Aumento Retiro Mensual'
    ]),
    anosReajusteRetiradaMensal: traduzir([
        /*pt-br*/'Reajustar Retirada Mensal a cada X Anos',
        /*pt-pt*/'Reajustar Retirada Mensal a cada X Anos',
        /*en-us*/'Adjust Monthly Withdrawal every X Years',
        /*es-es*/'Reajustar Retiro Mensual cada X Años'
    ]),
    anosAumentoRetiradaMensal: traduzir([
        /*pt-br*/'Aumentar Retirada Mensal a cada X Anos',
        /*pt-pt*/'Aumentar Retirada Mensal a cada X Anos',
        /*en-us*/'Increase Monthly Withdrawal every X Years',
        /*es-es*/'Aumentar Retiro Mensual cada X Años'
    ]),
    retiradaMensalEvolucaoInflacaoQuebraEspecial: traduzir([
        /*pt-br*/'Retirada Mensal<br/>Evolução Inflação',
        /*pt-pt*/'Retirada Mensal<br/>Evolução Inflação',
        /*en-us*/'Monthly Withdrawal<br/>Inflation Evolution',
        /*es-es*/'Retiro Mensual<br/>Evolución Inflación'
    ]),
    retiradaMediaEvolucaoInflacaoQuebraEspecial: traduzir([
        /*pt-br*/'Retirada Media<br/>Evolução Inflação',
        /*pt-pt*/'Retirada Média<br/>Evolução Inflação',
        /*en-us*/'Average Withdrawal<br/>Inflation Evolution',
        /*es-es*/'Retiro Promedio<br/>Evolución Inflación'
    ]),
    retornoFinanceiro: traduzir([
        /*pt-br*/'Retorno',
        /*pt-pt*/'Retorno',
        /*en-us*/'Return',
        /*es-es*/'Retorno'
    ]),
    aportesRetiradasAnuaisUnicos: traduzir([
        /*pt-br*/'Aportes e Retiradas Anuais ou Únicos',
        /*pt-pt*/'Aportes e Retiradas Anuais ou Únicos',
        /*en-us*/'Annual or Single Contributions and Withdrawals',
        /*es-es*/'Aportes y Retiros Anuales o Únicos'
    ]),
    idadeFinalOpcional: traduzir([
        /*pt-br*/'Idade Final (opcional)',
        /*pt-pt*/'Idade Final (opcional)',
        /*en-us*/'Final Age (optional)',
        /*es-es*/'Edad Final (opcional)'
    ]),
    mesOpcional: traduzir([
        /*pt-br*/'Mês (opc.)',
        /*pt-pt*/'Mês (opc.)',
        /*en-us*/'Month (opt.)',
        /*es-es*/'Mes (opc.)'
    ]),
    aporteAnual: traduzir([
        /*pt-br*/'Aporte Anual',
        /*pt-pt*/'Aporte Anual',
        /*en-us*/'Annual Contribution',
        /*es-es*/'Aporte Anual'
    ]),
    retiradaAnual: traduzir([
        /*pt-br*/'Retirada Anual',
        /*pt-pt*/'Retirada Anual',
        /*en-us*/'Annual Withdrawal',
        /*es-es*/'Retiro Anual'
    ]),
    anosExibicaoRelatorioEvolucaoReservaFinanceira: traduzir([
        /*pt-br*/'Exibir a Evolução da Reserva Financeira nos relatórios a cada',
        /*pt-pt*/'Exibir a Evolução da Reserva Financeira nos relatórios a cada',
        /*en-us*/'Display Financial Reserve Evolution in reports every',
        /*es-es*/'Mostrar la Evolución de la Reserva Financiera en los informes cada'
    ]),
    anoAnos: traduzir([
        /*pt-br*/'Ano(s)',
        /*pt-pt*/'Ano(s)',
        /*en-us*/'Year(s)',
        /*es-es*/'Año(s)'
    ]),
    comeco: traduzir([
        /*pt-br*/'Começo',
        /*pt-pt*/'Começo',
        /*en-us*/'Beginning',
        /*es-es*/'Comienzo'
    ]),
    evolucaoInflacao: traduzir([
        /*pt-br*/'Evolução Inflação',
        /*pt-pt*/'Evolução Inflação',
        /*en-us*/'Inflation Evolution',
        /*es-es*/'Evolución Inflación'
    ]),
    aporteRetiradaAnual: traduzir([
        /*pt-br*/'Aporte/Retirada Anual',
        /*pt-pt*/'Aporte/Retirada Anual',
        /*en-us*/'Annual Contribution/Withdrawal',
        /*es-es*/'Aporte/Retiro Anual'
    ]),
    rendimentoMensal: traduzir([
        /*pt-br*/'Rendimento Mensal',
        /*pt-pt*/'Rendimento Mensal',
        /*en-us*/'Monthly Yield',
        /*es-es*/'Rendimiento Mensual'
    ]),
    rendimentoTotal: traduzir([
        /*pt-br*/'Rendimento Total',
        /*pt-pt*/'Rendimento Total',
        /*en-us*/'Total Yield',
        /*es-es*/'Rendimiento Total'
    ]),
    rendimentoMedio: traduzir([
        /*pt-br*/'Rendimento Médio',
        /*pt-pt*/'Rendimento Médio',
        /*en-us*/'Average Yield',
        /*es-es*/'Rendimiento Promedio'
    ]),
    final: traduzir([
        /*pt-br*/'Final',
        /*pt-pt*/'Final',
        /*en-us*/'Final',
        /*es-es*/'Final'
    ]),
    exibirEvolucaoAporteMensalInflacao: traduzir([
        /*pt-br*/'Exibir Evolução Aporte Mensal pela Inflação',
        /*pt-pt*/'Exibir Evolução Aporte Mensal pela Inflação',
        /*en-us*/'Display Monthly Contribution Evolution by Inflation',
        /*es-es*/'Mostrar Evolución Aporte Mensual por la Inflación'
    ]),
    exibirEvolucaoRetiradaMensalInflacao: traduzir([
        /*pt-br*/'Exibir Evolução Retirada Mensal pela Inflação',
        /*pt-pt*/'Exibir Evolução Retirada Mensal pela Inflação',
        /*en-us*/'Display Monthly Withdrawal Evolution by Inflation',
        /*es-es*/'Mostrar Evolución Retiro Mensual por la Inflación'
    ]),
    exibirEvolucaoRecursosFinanceirosFinalInflacao: traduzir([
        /*pt-br*/'Exibir Evolução Recursos Financeiros Final pela Inflação',
        /*pt-pt*/'Mostrar Evolução dos Recursos Financeiros Finais pela Inflação',
        /*en-us*/'Show Evolution of Final Financial Resources Adjusted for Inflation',
        /*es-es*/'Mostrar Evolución de los Recursos Financieros Finales Ajustados por la Inflación'
    ]),
    exibirCapacidadePoupancaRelatorio: traduzir([
        /*pt-br*/'Exibir Capacidade de Poupança no Relatório',
        /*pt-pt*/'Exibir Capacidade de Poupança no Relatório',
        /*en-us*/'Display Savings Capacity in Report',
        /*es-es*/'Mostrar Capacidad de Ahorro en el Informe'
    ]),
    exibirAportesRetiradasPlanejadosRelatorio: traduzir([
        /*pt-br*/'Exibir Aportes e Retiradas Planejados no Relatório',
        /*pt-pt*/'Exibir Aportes e Retiradas Planeados no Relatório',
        /*en-us*/'Display Planned Contributions and Withdrawals in Report',
        /*es-es*/'Mostrar Aportes y Retiros Planificados en el Informe'
    ]),
    naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira: traduzir([
        /*pt-br*/'Não exibir o gráfico Diagnóstico Aposentadoria & Independência Financeira no Relatório',
        /*pt-pt*/'Não exibir o gráfico Diagnóstico Reforma & Independência Financeira no Relatório',
        /*en-us*/'Do not display Retirement & Financial Independence Diagnostic chart in Report',
        /*es-es*/'No mostrar el gráfico Diagnóstico Jubilación e Independencia Financiera en el Informe'
    ]),
    naoExibirEvolucaoReservaFinanceira: traduzir([
        /*pt-br*/'Não exibir a Evolução da Reserva Financeira',
        /*pt-pt*/'Não exibir a Evolução da Reserva Financeira',
        /*en-us*/'Do not display Financial Reserve Evolution',
        /*es-es*/'No mostrar la Evolución de la Reserva Financiera'
    ]),
    exibirProtecaoSugeridaRelatorio: traduzir([
        /*pt-br*/'Exibir Proteção Sugerida no Relatório',
        /*pt-pt*/'Exibir Protecção Sugerida no Relatório',
        /*en-us*/'Display Suggested Protection in Report',
        /*es-es*/'Mostrar Protección Sugerida en el Informe'
    ]),
    exibirSucessaoVitaliciaRelatorio: traduzir([
        /*pt-br*/'Exibir Sucessão Patrimonial no Relatório',
        /*pt-pt*/'Exibir Sucessão Patrimonial no Relatório',
        /*en-us*/'Show Estate Succession in Report',
        /*es-es*/'Mostrar Sucesión Patrimonial en el Informe'
    ]),
    exibirComparacaoCenariosRelatorio: traduzir([
        /*pt-br*/'Exibir Comparação de Cenários no Relatório',
        /*pt-pt*/'Exibir Comparação de Cenários no Relatório',
        /*en-us*/'Display Scenario Comparison in Report',
        /*es-es*/'Mostrar Comparación de Escenarios en el Informe'
    ]),
    exibirComparacaoCenariosRelatorioSemTabelaGrafico: traduzir([
        /*pt-br*/'Exibir Comparação de Cenários no Relatório sem a Tabela do Gráfico',
        /*pt-pt*/'Exibir Comparação de Cenários no Relatório sem a Tabela do Gráfico',
        /*en-us*/'Display Scenario Comparison in Report without Chart Table',
        /*es-es*/'Mostrar Comparación de Escenarios en el Informe sin la Tabla del Gráfico'
    ]),
    exibirComparacaoEstudosRelatorio: traduzir([
        /*pt-br*/'Exibir Comparação de Estudos no Relatório',
        /*pt-pt*/'Exibir Comparação de Estudos no Relatório',
        /*en-us*/'Display Study Comparison in Report',
        /*es-es*/'Mostrar Comparación de Estudios en el Informe'
    ]),
    exibirConsideracoesFinaisRelatorio: traduzir([
        /*pt-br*/'Exibir $1$ no Relatório',
        /*pt-pt*/'Exibir $1$ no Relatório',
        /*en-us*/'Display $1$ in Report',
        /*es-es*/'Mostrar $1$ en el Informe'
    ]),

    configuracaoSimulacaoFinanceira: traduzir([
        /*pt-br*/'Configuração da Simulação Financeira',
        /*pt-pt*/'Configuração da Simulação Financeira',
        /*en-us*/'Financial Simulation Configuration',
        /*es-es*/'Configuración de la Simulación Financiera'
    ]),

    mapaFinanceiro: traduzir([
        /*pt-br*/'Mapa Financeiro',
        /*pt-pt*/'Mapa Financeiro',
        /*en-us*/'Financial Map',
        /*es-es*/'Mapa Financiero'
    ]),
    graficoMapaFinanceiro: traduzir([
        /*pt-br*/'Gráfico do Mapa Financeiro',
        /*pt-pt*/'Gráfico do Mapa Financeiro',
        /*en-us*/'Financial Map Chart',
        /*es-es*/'Gráfico del Mapa Financiero'
    ]),
    incluirMapaFinanceiroRelatorioCliente: traduzir([
        /*pt-br*/'Incluir o Mapa Financeiro no Relatório do Cliente',
        /*pt-pt*/'Incluir o Mapa Financeiro no Relatório do Cliente',
        /*en-us*/'Include Financial Map in Client Report',
        /*es-es*/'Incluir el Mapa Financiero en el Informe del Cliente'
    ]),

    valorMensal: traduzir([
        /*pt-br*/'Valor Mensal',
        /*pt-pt*/'Valor Mensal',
        /*en-us*/'Monthly Value',
        /*es-es*/'Valor Mensual'
    ]),
    valorMensalAtual: traduzir([
        /*pt-br*/'Valor Mensal Atual',
        /*pt-pt*/'Valor Mensal Actual',
        /*en-us*/'Current Monthly Value',
        /*es-es*/'Valor Mensual Actual'
    ]),
    valorMensalAtualQuebraEspecial: traduzir([
        /*pt-br*/'Valor Mensal<br/>Atual',
        /*pt-pt*/'Valor Mensal<br/>Actual',
        /*en-us*/'Monthly Value<br/>Current',
        /*es-es*/'Valor Mensual<br/>Actual'
    ]),
    valorNaAposentadoriaMensalQuebraEspecial: traduzir([
        /*pt-br*/'Valor Mensal<br/>Aposentadoria',
        /*pt-pt*/'Valor Mensal<br/>Reforma',
        /*en-us*/'Monthly Value<br/>Retirement',
        /*es-es*/'Valor Mensual<br/>Jubilación'
    ]),
    valorEstimado: traduzir([
        /*pt-br*/'Valor Estimado',
        /*pt-pt*/'Valor Estimado',
        /*en-us*/'Estimated Value',
        /*es-es*/'Valor Estimado'
    ]),
    valorAporteDividendosContribuicao: traduzir([
        /*pt-br*/'Aporte/ Dividendos/ Contribuição',
        /*pt-pt*/'Aporte/ Dividendos/ Contribuição',
        /*en-us*/'Contribution/ Dividends/ Contribution',
        /*es-es*/'Aporte/ Dividendos/ Contribución'
    ]),
    total: traduzir([
        /*pt-br*/'TOTAL',
        /*pt-pt*/'TOTAL',
        /*en-us*/'TOTAL',
        /*es-es*/'TOTAL'
    ]),
    responsabilidades: traduzir([
        /*pt-br*/'Responsabilidades',
        /*pt-pt*/'Responsabilidades',
        /*en-us*/'Responsibilities',
        /*es-es*/'Responsabilidades'
    ]),
    garantias: traduzir([
        /*pt-br*/'Garantias',
        /*pt-pt*/'Garantias',
        /*en-us*/'Guarantees',
        /*es-es*/'Garantías'
    ]),
    anosProteger: traduzir([
        /*pt-br*/'Anos a Proteger',
        /*pt-pt*/'Anos a Proteger',
        /*en-us*/'Years to Protect',
        /*es-es*/'Años a Proteger'
    ]),
    anosProtegidos: traduzir([
        /*pt-br*/'Anos Protegidos',
        /*pt-pt*/'Anos Protegidos',
        /*en-us*/'Protected Years',
        /*es-es*/'Años Protegidos'
    ]),

    dia: traduzir([
        /*pt-br*/'dia',
        /*pt-pt*/'dia',
        /*en-us*/'day',
        /*es-es*/'día'
    ]),
    dias: traduzir([
        /*pt-br*/'dias',
        /*pt-pt*/'dias',
        /*en-us*/'days',
        /*es-es*/'días'
    ]),
    vitalicio: traduzir([
        /*pt-br*/'Vitalício',
        /*pt-pt*/'Vitalício',
        /*en-us*/'Life',
        /*es-es*/'Vitalicio'
    ]),

    atual: traduzir([
        /*pt-br*/'Atual',
        /*pt-pt*/'Actual',
        /*en-us*/'Current',
        /*es-es*/'Actual'
    ]),
    ideal: traduzir([
        /*pt-br*/'Ideal',
        /*pt-pt*/'Ideal',
        /*en-us*/'Ideal',
        /*es-es*/'Ideal'
    ]),

    abertura: traduzir([
        /*pt-br*/'Abertura',
        /*pt-pt*/'Abertura',
        /*en-us*/'Opening',
        /*es-es*/'Apertura'
    ]),
    oQueEsperarDesseTrabalho: traduzir([
        /*pt-br*/'O que esperar desse trabalho?',
        /*pt-pt*/'O que esperar deste trabalho?',
        /*en-us*/'What to expect from this work?',
        /*es-es*/'¿Qué esperar de este trabajo?'
    ]),
    conferenciaDados: traduzir([
        /*pt-br*/'Conferência de Dados',
        /*pt-pt*/'Conferência de Dados',
        /*en-us*/'Data Review',
        /*es-es*/'Conferencia de Datos'
    ]),
    conferenciaDadosClienteConjugeFamiliares: traduzir([
        /*pt-br*/'Conferência de Dados - Cliente, Cônjuge e Familiares',
        /*pt-pt*/'Conferência de Dados - Cliente, Cônjuge e Familiares',
        /*en-us*/'Data Review - Client, Spouse and Family',
        /*es-es*/'Conferencia de Datos - Cliente, Cónyuge y Familiares'
    ]),
    conferenciaDadosClienteConjugeFamiliaresObjetivos: traduzir([
        /*pt-br*/'Conferência de Dados - Cliente, Cônjuge e Familiares + Objetivos',
        /*pt-pt*/'Conferência de Dados - Cliente, Cônjuge e Familiares + Objectivos',
        /*en-us*/'Data Review - Client, Spouse and Family + Objectives',
        /*es-es*/'Conferencia de Datos - Cliente, Cónyuge y Familiares + Objetivos'
    ]),
    conferenciaDadosClienteConjugeFamiliaresTaxas: traduzir([
        /*pt-br*/'Conferência de Dados - Cliente, Cônjuge e Familiares + Taxas',
        /*pt-pt*/'Conferência de Dados - Cliente, Cônjuge e Familiares + Taxas',
        /*en-us*/'Data Review - Client, Spouse and Family + Rates',
        /*es-es*/'Conferencia de Datos - Cliente, Cónyuge y Familiares + Tasas'
    ]),
    conclusao: traduzir([
        /*pt-br*/'Conclusão',
        /*pt-pt*/'Conclusão',
        /*en-us*/'Conclusion',
        /*es-es*/'Conclusión'
    ]),

    despesasTotais: traduzir([
        /*pt-br*/'Despesas Totais',
        /*pt-pt*/'Despesas Totais',
        /*en-us*/'Total Expenses',
        /*es-es*/'Gastos Totales'
    ]),
    garantiasAtuais: traduzir([
        /*pt-br*/'Garantias Atuais',
        /*pt-pt*/'Garantias Actuais',
        /*en-us*/'Current Guarantees',
        /*es-es*/'Garantías Actuales'
    ]),
    garantiasTotais: traduzir([
        /*pt-br*/'Garantias Totais',
        /*pt-pt*/'Garantias Totais',
        /*en-us*/'Total Guarantees',
        /*es-es*/'Garantías Totales'
    ]),

    necessidadeProtecao: traduzir([
        /*pt-br*/'Necessidade de Proteção',
        /*pt-pt*/'Necessidade de Protecção',
        /*en-us*/'Protection Need',
        /*es-es*/'Necesidad de Protección'
    ]),

    selecionarCenariosTipoMorteInvalidez: traduzir([
        /*pt-br*/'Selecionar Cenários e Tipo de Morte/Invalidez (Cenário Atual = $1$)',
        /*pt-pt*/'Seleccionar Cenários e Tipo de Morte/Invalidez (Cenário Actual = $1$)',
        /*en-us*/'Select Scenarios and Death/Disability Type (Current Scenario = $1$)',
        /*es-es*/'Seleccionar Escenarios y Tipo de Muerte/Invalidez (Escenario Actual = $1$)'
    ]),
    selecionarCenarios: traduzir([
        /*pt-br*/'Selecionar Cenários',
        /*pt-pt*/'Seleccionar Cenários',
        /*en-us*/'Select Scenarios',
        /*es-es*/'Seleccionar Escenarios'
    ]),
    selecionarCenariosComDescricao: traduzir([
        /*pt-br*/'Selecionar Cenários (Atual = $1$)',
        /*pt-pt*/'Seleccionar Cenários (Actual = $1$)',
        /*en-us*/'Select Scenarios (Current = $1$)',
        /*es-es*/'Seleccionar Escenarios (Actual = $1$)'
    ]),
    selecionarTipoMorteInvalidez: traduzir([
        /*pt-br*/'Selecionar Tipo de Morte/Invalidez',
        /*pt-pt*/'Seleccionar Tipo de Morte/Invalidez',
        /*en-us*/'Select Death/Disability Type',
        /*es-es*/'Seleccionar Tipo de Muerte/Invalidez'
    ]),

    acumulacao: traduzir([
        /*pt-br*/'Acumulação',
        /*pt-pt*/'Acumulação',
        /*en-us*/'Accumulation',
        /*es-es*/'Acumulación'
    ]),
    aposentadoria: 'Aposentadoria',

    protecao: traduzir([
        /*pt-br*/'Proteção',
        /*pt-pt*/'Protecção',
        /*en-us*/'Protection',
        /*es-es*/'Protección'
    ]),

    protecaoSugerida: traduzir([
        /*pt-br*/'Proteção Sugerida',
        /*pt-pt*/'Proteção Sugerida',
        /*en-us*/'Suggested Protection',
        /*es-es*/'Protección Sugerida'
    ]),
    valorCSAdicional: traduzir([
        /*pt-br*/'Capital Segurado Adicional',
        /*pt-pt*/ 'Capital Seguro Adicional',
        /*en-us*/ 'Additional Insured Capital',
        /*es-es*/ 'Capital Asegurado Adicional'
    ]),
    perpetuarPatrimonio: traduzir([
        /*pt-br*/'Perpetuar Patrimônio',
        /*pt-pt*/'Perpetuar Património',
        /*en-us*/'Perpetuate Assets',
        /*es-es*/'Perpetuar Patrimonio'
    ]),
    proporcionarConfortoFamilia: traduzir([
        /*pt-br*/'Proporcionar Conforto para a Família',
        /*pt-pt*/'Proporcionar Conforto para a Família',
        /*en-us*/'Provide Family Comfort',
        /*es-es*/'Proporcionar Comodidad a la Familia'
    ]),
    vendaImobilizado: traduzir([
        /*pt-br*/'Venda Imobilizado',
        /*pt-pt*/'Venda de Activos Fixos',
        /*en-us*/'Fixed Assets Sale',
        /*es-es*/'Venta de Activos Fijos'
    ]),
    protecaoEmVida: traduzir([
        /*pt-br*/'Proteção em Vida',
        /*pt-pt*/'Proteção em Vida',
        /*en-us*/'Life Protection',
        /*es-es*/'Protección en Vida'
    ]),
    DIT: traduzir([
        /*pt-br*/'DIT',
        /*pt-pt*/'DIT',
        /*en-us*/'DIT',
        /*es-es*/'DIT'
    ]),
    DITA: traduzir([
        /*pt-br*/'DITA',
        /*pt-pt*/'DITA',
        /*en-us*/'DITA',
        /*es-es*/'DITA'
    ]),
    doencasGraves: traduzir([
        /*pt-br*/'Doenças Graves',
        /*pt-pt*/'Doenças Graves',
        /*en-us*/'Serious Illnesses',
        /*es-es*/'Enfermedades Graves'
    ]),
    funeral: traduzir([
        /*pt-br*/'Funeral',
        /*pt-pt*/'Funeral',
        /*en-us*/'Funeral',
        /*es-es*/'Funeral'
    ]),

    diagnosticoAposentadoria: traduzir([
        /*pt-br*/'Diagnóstico: Aposentadoria',
        /*pt-pt*/'Diagnóstico: Reforma',
        /*en-us*/'Retirement: Diagnosis',
        /*es-es*/'Diagnóstico: Jubilación'
    ]),

    hipotesesRetornoReal: traduzir([
        /*pt-br*/'Aporte mensal por hipóteses de retorno real',
        /*pt-pt*/'Contribuição mensal por hipóteses de retorno real',
        /*en-us*/'Monthly contribution by real return hypotheses',
        /*es-es*/'Aporte mensual por hipótesis de retorno real'
    ]),

    capacidadePoupanca: traduzir([
        /*pt-br*/'Capacidade de Poupança',
        /*pt-pt*/'Capacidade de Poupança',
        /*en-us*/'Savings Capacity',
        /*es-es*/'Capacidad de Ahorro'
    ]),
    receitaMensalMediaAtual: traduzir([
        /*pt-br*/'Receita Mensal Atual',
        /*pt-pt*/'Receita Mensal Actual',
        /*en-us*/'Current Monthly Income',
        /*es-es*/'Ingreso Mensual Actual'
    ]),
    despesaMensalMediaAtual: traduzir([
        /*pt-br*/'Despesa Mensal Atual',
        /*pt-pt*/'Despesa Mensal Actual',
        /*en-us*/'Current Monthly Expense',
        /*es-es*/'Gasto Mensual Actual'
    ]),
    capacidadePoupancaMensalMediaAtual: traduzir([
        /*pt-br*/'Capacidade de Poupança Atual',
        /*pt-pt*/'Capacidade de Poupança Actual',
        /*en-us*/'Current Savings Capacity',
        /*es-es*/'Capacidad de Ahorro Actual'
    ]),
    retornoReal: traduzir([
        /*pt-br*/'Retorno Real',
        /*pt-pt*/'Retorno Real',
        /*en-us*/'Real Return',
        /*es-es*/'Retorno Real'
    ]),
    retornoRealAteAposAposentadoria: traduzir([
        /*pt-br*/'(Até Aposentadoria / Após)',
        /*pt-pt*/'(Até à Reforma / Após)',
        /*en-us*/'(Until Retirement / After)',
        /*es-es*/'(Hasta Jubilación / Después)'
    ]),
    valorPresenteReservaInicioAposentadoria: traduzir([
        /*pt-br*/'Reserva Início Aposentadoria',
        /*pt-pt*/'Reserva Início Reforma',
        /*en-us*/'Reserve at Retirement Start',
        /*es-es*/'Reserva Inicio Jubilación'
    ]),
    valorPresenteNecessidadesInicioAposentadoria: traduzir([
        /*pt-br*/'Necessidades Início Aposentadoria',
        /*pt-pt*/'Necessidades Início Reforma',
        /*en-us*/'Needs at Retirement Start',
        /*es-es*/'Necesidades Inicio Jubilación'
    ]),
    valorPresenteDeficitReservaInicioAposentadoria: traduzir([
        /*pt-br*/'Déficit Reserva Início Aposentadoria',
        /*pt-pt*/'Défice Reserva Início Reforma',
        /*en-us*/'Reserve Deficit at Retirement Start',
        /*es-es*/'Déficit Reserva Inicio Jubilación'
    ]),
    valorPresenteSuperavitReservaInicioAposentadoria: traduzir([
        /*pt-br*/'Superávit Reserva Início Aposentadoria',
        /*pt-pt*/'Superavit Reserva Início Reforma',
        /*en-us*/'Reserve Surplus at Retirement Start',
        /*es-es*/'Superávit Reserva Inicio Jubilación'
    ]),
    idadeLimiteReservaAposentadoria: traduzir([
        /*pt-br*/'Idade Limite Reserva Aposentadoria',
        /*pt-pt*/'Idade Limite Reserva Reforma',
        /*en-us*/'Age Limit Retirement Reserve',
        /*es-es*/'Edad Límite Reserva Jubilación'
    ]),
    ateMaisXAnos: traduzir([
        /*pt-br*/'+ de $1$',
        /*pt-pt*/'+ de $1$',
        /*en-us*/'+ of $1$',
        /*es-es*/'+ de $1$'
    ]),
    grauIndependenciaFinanceira: traduzir([
        /*pt-br*/'Independência Financeira até $1$ anos',
        /*pt-pt*/'Independência Financeira até $1$ anos',
        /*en-us*/'Financial Independence up to $1$ years',
        /*es-es*/'Independencia Financiera hasta $1$ años'
    ]),
    economiaInventarioCotacaoSeguroVidaInteira: traduzir([
        /*pt-br*/'Cotação Vida Inteira: Economia Inventário',
        /*pt-pt*/'Cotação Vida Inteira: Economia Inventário',
        /*en-us*/'Whole Life Quote: Inventory Savings',
        /*es-es*/'Cotización Vida Entera: Ahorro de Inventario'
    ]),

    necessidadeAposentadoria: traduzir([
        /*pt-br*/'Necessidades na Aposentadoria',
        /*pt-pt*/'Necessidades na Reforma',
        /*en-us*/'Retirement Needs',
        /*es-es*/'Necesidades en la Jubilación'
    ]),
    necessidadeAposentadoriaDespesasNaoCobertas: traduzir([
        /*pt-br*/'(Despesas não Cobertas pela Receita Prevista)',
        /*pt-pt*/'(Despesas não Cobertas pela Receita Prevista)',
        /*en-us*/'(Expenses not Covered by Expected Income)',
        /*es-es*/'(Gastos no Cubiertos por Ingresos Previstos)'
    ]),
    idadeDe: traduzir([
        /*pt-br*/'De',
        /*pt-pt*/'De',
        /*en-us*/'From',
        /*es-es*/'De'
    ]),
    idadeAte: traduzir([
        /*pt-br*/'Até',
        /*pt-pt*/'Até',
        /*en-us*/'To',
        /*es-es*/'Hasta'
    ]),
    receitaAposentadoriaMensal: traduzir([
        /*pt-br*/'Receita',
        /*pt-pt*/'Receita',
        /*en-us*/'Income',
        /*es-es*/'Ingreso'
    ]),
    despesaAposentadoriaMensal: traduzir([
        /*pt-br*/'Despesa',
        /*pt-pt*/'Despesa',
        /*en-us*/'Expense',
        /*es-es*/'Gasto'
    ]),
    despesasExcedentesMensal: traduzir([
        /*pt-br*/'Despesas Excedentes',
        /*pt-pt*/'Despesas Excedentes',
        /*en-us*/'Excess Expenses',
        /*es-es*/'Gastos Excedentes'
    ]),
    despesasExcedentesMensalAposentadoria: traduzir([
        /*pt-br*/'Despesas Excedentes Aposentadoria',
        /*pt-pt*/'Despesas Excedentes Reforma',
        /*en-us*/'Retirement Excess Expenses',
        /*es-es*/'Gastos Excedentes Jubilación'
    ]),

    aportePlanejadoAposentadoria: traduzir([
        /*pt-br*/'Aportes Planejados para a Aposentadoria',
        /*pt-pt*/'Contribuições Planeadas para a Reforma',
        /*en-us*/'Planned Retirement Contributions',
        /*es-es*/'Aportes Planificados para la Jubilación'
    ]),

    grafico: traduzir([
        /*pt-br*/'Gráfico',
        /*pt-pt*/'Gráfico',
        /*en-us*/'Chart',
        /*es-es*/'Gráfico'
    ]),
    seriesAreaBar: traduzir([
        /*pt-br*/'Série para evitar viar Área quando séries são barra e só tem 1 série',
        /*pt-pt*/'Série para evitar mostrar Área quando séries são barra e só tem 1 série',
        /*en-us*/'Series to avoid showing Area when series are bar and there is only 1 series',
        /*es-es*/'Serie para evitar mostrar Área cuando las series son barras y solo hay 1 serie'
    ]),

    media: traduzir([
        /*pt-br*/'Média',
        /*pt-pt*/'Média',
        /*en-us*/'Average',
        /*es-es*/'Promedio'
    ]),

    receitaAnual: traduzir([
        /*pt-br*/'Receita',
        /*pt-pt*/'Receita',
        /*en-us*/'Income',
        /*es-es*/'Ingreso'
    ]),
    receitaAnualLongoTempo: traduzir([
        /*pt-br*/'Previsão de Receitas',
        /*pt-pt*/'Previsão de Receitas',
        /*en-us*/'Income Forecast',
        /*es-es*/'Previsión de Ingresos'
    ]),
    tipoReceita: traduzir([
        /*pt-br*/'Receita',
        /*pt-pt*/'Receita',
        /*en-us*/'Income',
        /*es-es*/'Ingreso'
    ]),
    despesaAnual: traduzir([
        /*pt-br*/'Despesa',
        /*pt-pt*/'Despesa',
        /*en-us*/'Expense',
        /*es-es*/'Gasto'
    ]),
    despesaAnualLongoTempo: traduzir([
        /*pt-br*/'Previsão de Despesas',
        /*pt-pt*/'Previsão de Despesas',
        /*en-us*/'Expense Forecast',
        /*es-es*/'Previsión de Gastos'
    ]),
    tipoDespesa: traduzir([
        /*pt-br*/'Despesa',
        /*pt-pt*/'Despesa',
        /*en-us*/'Expense',
        /*es-es*/'Gasto'
    ]),
    consumoReservaAposentadoria: traduzir([
        /*pt-br*/'Consumo da Reserva da Aposentadoria',
        /*pt-pt*/'Consumo da Reserva da Reforma',
        /*en-us*/'Retirement Reserve Consumption',
        /*es-es*/'Consumo de la Reserva de Jubilación'
    ]),
    retiradaReservaAposentadoriaComplementoReceitaMensal: traduzir([
        /*pt-br*/'Retirada Reserva Aposentadoria p/ complementar Receita Mensal',
        /*pt-pt*/'Levantamento Reserva Reforma p/ complementar Receita Mensal',
        /*en-us*/'Retirement Reserve Withdrawal to supplement Monthly Income',
        /*es-es*/'Retiro Reserva Jubilación p/ complementar Ingreso Mensual'
    ]),
    aporteProjetoVidaSonhoAnual: traduzir([
        /*pt-br*/'Aporte Projeto de Vida/Sonho',
        /*pt-pt*/'Contribuição Projecto de Vida/Sonho',
        /*en-us*/'Life Project/Dream Contribution',
        /*es-es*/'Aporte Proyecto de Vida/Sueño'
    ]),
    aporteAposentadoriaAnual: traduzir([
        /*pt-br*/'Aporte Aposentadoria',
        /*pt-pt*/'Contribuição Reforma',
        /*en-us*/'Retirement Contribution',
        /*es-es*/'Aporte Jubilación'
    ]),
    aporteAposentadoriaEconomiaReceitaMensalAnual: traduzir([
        /*pt-br*/'Aporte Aposentadoria c/ economia da Receita Mensal',
        /*pt-pt*/'Contribuição Reforma c/ economia da Receita Mensal',
        /*en-us*/'Retirement Contribution with Monthly Income savings',
        /*es-es*/'Aporte Jubilación c/ ahorro del Ingreso Mensual'
    ]),
    aporteAtingirMetaInicioAposentadoriaAnual: traduzir([
        /*pt-br*/'Aporte Atingir Meta Início Aposentadoria',
        /*pt-pt*/'Contribuição Atingir Meta Início Reforma',
        /*en-us*/'Contribution to Reach Retirement Start Goal',
        /*es-es*/'Aporte Alcanzar Meta Inicio Jubilación'
    ]),
    balancoAnual: traduzir([
        /*pt-br*/'Balanço',
        /*pt-pt*/'Balanço',
        /*en-us*/'Balance',
        /*es-es*/'Balance'
    ]),
    balancoReceitaDespesaAnual: traduzir([
        /*pt-br*/'Capacidade de Poupança e Necessidades na Aposentadoria',
        /*pt-pt*/'Capacidade de Poupança e Necessidades na Reforma',
        /*en-us*/'Savings Capacity and Retirement Needs',
        /*es-es*/'Capacidad de Ahorro y Necesidades en la Jubilación'
    ]),
    liquidezFinanceiraAcumulada: traduzir([
        /*pt-br*/'Liquidez Financeira Acumulada',
        /*pt-pt*/'Liquidez Financeira Acumulada',
        /*en-us*/'Accumulated Financial Liquidity',
        /*es-es*/'Liquidez Financiera Acumulada'
    ]),
    liquidezFinanceiraAcumuladaSuperavit: traduzir([
        /*pt-br*/'Liquidez Financeira Acumulada Superávit',
        /*pt-pt*/'Liquidez Financeira Acumulada Superavit',
        /*en-us*/'Accumulated Financial Liquidity Surplus',
        /*es-es*/'Liquidez Financiera Acumulada Superávit'
    ]),
    liquidezFinanceiraAcumuladaDeficit: traduzir([
        /*pt-br*/'Liquidez Financeira Acumulada Déficit',
        /*pt-pt*/'Liquidez Financeira Acumulada Défice',
        /*en-us*/'Accumulated Financial Liquidity Deficit',
        /*es-es*/'Liquidez Financiera Acumulada Déficit'
    ]),
    despesasAcumuladasLongoTempo: traduzir([
        /*pt-br*/'Despesas Acumuladas ao longo do tempo',
        /*pt-pt*/'Despesas Acumuladas ao longo do tempo',
        /*en-us*/'Accumulated Expenses over time',
        /*es-es*/'Gastos Acumulados a lo largo del tiempo'
    ]),
    diagnosticoAposentadoriaDepositosParaAposentadoria: traduzir([
        /*pt-br*/'Depósitos para a Aposentadoria',
        /*pt-pt*/'Depósitos para a Reforma',
        /*en-us*/'Retirement Deposits',
        /*es-es*/'Depósitos para la Jubilación'
    ]),
    tipoDiagnosticoAposentadoriaChart: traduzir([
        /*pt-br*/'Situação Atual / Situação Ideal',
        /*pt-pt*/'Situação Actual / Situação Ideal',
        /*en-us*/'Current Situation / Ideal Situation',
        /*es-es*/'Situación Actual / Situación Ideal'
    ]),
    versus: traduzir([
        /*pt-br*/' x ',
        /*pt-pt*/' x ',
        /*en-us*/' vs ',
        /*es-es*/' vs '
    ]),

    analisePatrimonial: traduzir([
        /*pt-br*/'Análise Patrimonial',
        /*pt-pt*/'Análise Patrimonial',
        /*en-us*/'Asset Analysis',
        /*es-es*/'Análisis Patrimonial'
    ]),
    analisePatrimonialSemAlavancagem: traduzir([
        /*pt-br*/'Análise Patrimonial - Sem Alavancagem',
        /*pt-pt*/'Análise Patrimonial - Sem Alavancagem',
        /*en-us*/'Balance Sheet Analysis - Unleveraged',
        /*es-es*/'Análisis Patrimonial - Sin Apalancamiento'
    ]),
    ativos: traduzir([
        /*pt-br*/'Ativos',
        /*pt-pt*/'Activos',
        /*en-us*/'Assets',
        /*es-es*/'Activos'
    ]),
    ativosExterior: traduzir([
        /*pt-br*/'Exterior',
        /*pt-pt*/'Exterior',
        /*en-us*/'Abroad',
        /*es-es*/'Exterior'
    ]),
    ativosInventariar: traduzir([
        /*pt-br*/'ATIVOS A INVENTARIAR',
        /*pt-pt*/'ACTIVOS A INVENTARIAR',
        /*en-us*/'ASSETS TO INVENTORY',
        /*es-es*/'ACTIVOS A INVENTARIAR'
    ]),
    passivos: traduzir([
        /*pt-br*/'Passivos',
        /*pt-pt*/'Passivos',
        /*en-us*/'Liabilities',
        /*es-es*/'Pasivos'
    ]),
    ativosMenosPassivos: traduzir([
        /*pt-br*/'Saldo Patrimonial',
        /*pt-pt*/'Saldo Patrimonial',
        /*en-us*/'Net Worth',
        /*es-es*/'Patrimonio Neto'
    ]),
    criCraDebenture: traduzir([
        /*pt-br*/'CRI, CRA e Debênture',
        /*pt-pt*/'CRI, CRA e Debênture',
        /*en-us*/'CRI, CRA e Debênture',
        /*es-es*/'CRI, CRA e Debênture'
    ]),

    diagnosticoAposentadoriaIndependenciaFinanceira: traduzir([
        /*pt-br*/'Diagnóstico: Aposentadoria & Independência Financeira',
        /*pt-pt*/'Diagnóstico: Reforma & Independência Financeira',
        /*en-us*/'Retirement: Diagnosis & Financial Independence',
        /*es-es*/'Diagnóstico: Jubilación & Independencia Financiera'
    ]),
    reservaSuperavit: traduzir([
        /*pt-br*/'Reserva',
        /*pt-pt*/'Reserva',
        /*en-us*/'Reserve',
        /*es-es*/'Reserva'
    ]),
    situacaoAtualManterPadraoVidaSemNovosAportes: traduzir([
        /*pt-br*/'Manter Padrão de Vida sem Novos Aportes',
        /*pt-pt*/'Manter Padrão de Vida sem Novas Contribuições',
        /*en-us*/'Maintain Lifestyle without New Contributions',
        /*es-es*/'Mantener Nivel de Vida sin Nuevos Aportes'
    ]),
    reservaDeficit: traduzir([
        /*pt-br*/'Reserva Déficit',
        /*pt-pt*/'Reserva Déficit',
        /*en-us*/'Deficit Reserve',
        /*es-es*/'Reserva Déficit'
    ]),
    situacaoRealSuperavit: traduzir([
        /*pt-br*/'Situação Real Superávit',
        /*pt-pt*/'Situação Real Superavit',
        /*en-us*/'Real Surplus Situation',
        /*es-es*/'Situación Real Superávit'
    ]),
    situacaoRealDeficit: traduzir([
        /*pt-br*/'Situação Real Déficit',
        /*pt-pt*/'Situação Real Défice',
        /*en-us*/'Real Deficit Situation',
        /*es-es*/'Situación Real Déficit'
    ]),
    aporteMensalPreservarReserva: traduzir([
        /*pt-br*/'+ $1$ = Aporte mensal p/manter padrão de vida e preservar reserva',
        /*pt-pt*/'+ $1$ = Contribuição mensal p/manter padrão de vida e preservar reserva',
        /*en-us*/'+ $1$ = Monthly contribution to maintain lifestyle and preserve reserve',
        /*es-es*/'+ $1$ = Aporte mensual p/mantener nivel de vida y preservar reserva'
    ]),
    aporteMensalConsumirReserva: traduzir([
        /*pt-br*/'+ $1$ = Aporte mensal p/manter padrão de vida e consumir reserva',
        /*pt-pt*/'+ $1$ = Contribuição mensal p/manter padrão de vida e consumir reserva',
        /*en-us*/'+ $1$ = Monthly contribution to maintain lifestyle and consume reserve',
        /*es-es*/'+ $1$ = Aporte mensual p/mantener nivel de vida y consumir reserva'
    ]),
    retiradaMensalMaximaPreservarReserva: traduzir([
        /*pt-br*/'$1$ = Retirada mensal máxima p/preservar reserva sem novos aportes',
        /*pt-pt*/'$1$ = Levantamento mensal máximo p/preservar reserva sem novas contribuições',
        /*en-us*/'$1$ = Maximum monthly withdrawal to preserve reserve without new contributions',
        /*es-es*/'$1$ = Retiro mensual máximo p/preservar reserva sin nuevos aportes'
    ]),
    retiradaMensalMaximaConsumirReserva: traduzir([
        /*pt-br*/'$1$ = Retirada mensal máxima p/consumir reserva sem novos aportes',
        /*pt-pt*/'$1$ = Levantamento mensal máximo p/consumir reserva sem novas contribuições',
        /*en-us*/'$1$ = Maximum monthly withdrawal to consume reserve without new contributions',
        /*es-es*/'$1$ = Retiro mensual máximo p/consumir reserva sin nuevos aportes'
    ]),


    resumo: traduzir([
        /*pt-br*/'Resumo',
        /*pt-pt*/'Resumo',
        /*en-us*/'Summary',
        /*es-es*/'Resumen'
    ]),
    comparacaoFinanciamentos: traduzir([
        /*pt-br*/'Comparação Financiamentos',
        /*pt-pt*/'Comparação Financiamentos',
        /*en-us*/'Financing Comparison',
        /*es-es*/'Comparación Financiamientos'
    ]),
    financiamentoSugerido: traduzir([
        /*pt-br*/'Financiamento Sugerido',
        /*pt-pt*/'Financiamento Sugerido',
        /*en-us*/'Suggested Financing',
        /*es-es*/'Financiamiento Sugerido'
    ]),
    financiamentoAlternativo: traduzir([
        /*pt-br*/'Financiamento Alternativo',
        /*pt-pt*/'Financiamento Alternativo',
        /*en-us*/'Alternative Financing',
        /*es-es*/'Financiamiento Alternativo'
    ]),
    analiseFinanciamentoSugerido: traduzir([
        /*pt-br*/'Análise do Financiamento Sugerido',
        /*pt-pt*/'Análise do Financiamento Sugerido',
        /*en-us*/'Suggested Financing Analysis',
        /*es-es*/'Análisis del Financiamiento Sugerido'
    ]),
    mesAnoPagoMesmoTempo: traduzir([
        /*pt-br*/'O financiamento sugerido será pago ao mesmo tempo que o alternativo? Se sim, até que Mês/Ano?',
        /*pt-pt*/'O financiamento sugerido será pago ao mesmo tempo que o alternativo? Se sim, até que Mês/Ano?',
        /*en-us*/'Will the suggested financing be paid at the same time as the alternative? If so, until which Month/Year?',
        /*es-es*/'¿El financiamiento sugerido se pagará al mismo tiempo que el alternativo? Si es así, ¿hasta qué Mes/Año?'
    ]),
    valorPagtoFinanciamentoAVista: traduzir([
        /*pt-br*/'Comparar também a possibilidade de pagamento à vista com recursos da reserva financeira',
        /*pt-pt*/'Comparar também a possibilidade de pagamento à vista com recursos da reserva financeira',
        /*en-us*/'Also compare the possibility of cash payment with financial reserve resources',
        /*es-es*/'Comparar también la posibilidad de pago al contado con recursos de la reserva financiera'
    ]),
    valorPagtoParcelasFinanciamentoReceitaMensal: traduzir([
        /*pt-br*/'Analisar a possibilidade de manter parte da reserva financeira aplicada, considerando o pagamento de parcelas com a receita mensal',
        /*pt-pt*/'Analisar a possibilidade de manter parte da reserva financeira aplicada, considerando o pagamento de prestações com a receita mensal',
        /*en-us*/'Analyze the possibility of keeping part of the financial reserve invested, considering installment payments with monthly income',
        /*es-es*/'Analizar la posibilidad de mantener parte de la reserva financiera invertida, considerando el pago de cuotas con los ingresos mensuales'
    ]),
    valorAVista: traduzir([
        /*pt-br*/'Valor à Vista',
        /*pt-pt*/'Valor à Vista',
        /*en-us*/'Cash Value',
        /*es-es*/'Valor al Contado'
    ]),
    mesAnoPagtoFinanciamentoAVista: traduzir([
        /*pt-br*/'Mês/Ano Valor à Vista (Opcional)',
        /*pt-pt*/'Mês/Ano Valor à Vista (Opcional)',
        /*en-us*/'Month/Year Cash Value (Optional)',
        /*es-es*/'Mes/Año Valor al Contado (Opcional)'
    ]),
    valorManterAplicado: traduzir([
        /*pt-br*/'Valor Manter Aplicado',
        /*pt-pt*/'Valor Manter Aplicado',
        /*en-us*/'Value to Keep Invested',
        /*es-es*/'Valor Mantener Invertido'
    ]),
    saldoPagtoFinanciamentoSugeridoAVistaPositivo: traduzir([
        /*pt-br*/'Saldo Pagto.Financiamento Sugerido à Vista (+)',
        /*pt-pt*/'Saldo Pagto.Financiamento Sugerido à Vista (+)',
        /*en-us*/'Suggested Cash Financing Payment Balance (+)',
        /*es-es*/'Saldo Pago Financiamiento Sugerido al Contado (+)'
    ]),
    saldoPagtoFinanciamentoSugeridoAVistaNegativo: traduzir([
        /*pt-br*/'Saldo Pagto.Financiamento Sugerido à Vista (-)',
        /*pt-pt*/'Saldo Pagto.Financiamento Sugerido à Vista (-)',
        /*en-us*/'Suggested Cash Financing Payment Balance (-)',
        /*es-es*/'Saldo Pago Financiamiento Sugerido al Contado (-)'
    ]),
    saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo: traduzir([
        /*pt-br*/'Saldo Pagto.Parcelas Financiamento Sugerido Receita Mensal (+)',
        /*pt-pt*/'Saldo Pagto.Prestações Financiamento Sugerido Receita Mensal (+)',
        /*en-us*/'Suggested Financing Installment Payment Balance Monthly Income (+)',
        /*es-es*/'Saldo Pago Cuotas Financiamiento Sugerido Ingreso Mensual (+)'
    ]),
    saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo: traduzir([
        /*pt-br*/'Saldo Pagto.Parcelas Financiamento Sugerido Receita Mensal (-)',
        /*pt-pt*/'Saldo Pagto.Prestações Financiamento Sugerido Receita Mensal (-)',
        /*en-us*/'Suggested Financing Installment Payment Balance Monthly Income (-)',
        /*es-es*/'Saldo Pago Cuotas Financiamiento Sugerido Ingreso Mensual (-)'
    ]),
    saldoPagtoFinanciamentoSugeridoAVistaQuebraEspecial: traduzir([
        /*pt-br*/'Saldo Pagto.<br/>Financ. Sugerido<br/>à Vista',
        /*pt-pt*/'Saldo Pagto.<br/>Financ. Sugerido<br/>à Vista',
        /*en-us*/'Payment Balance<br/>Suggested Financing<br/>Cash',
        /*es-es*/'Saldo Pago<br/>Financ. Sugerido<br/>al Contado'
    ]),
    saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalQuebraEspecial: traduzir([
        /*pt-br*/'Saldo Pagto.Parc.<br/>Financ. Sugerido<br/>Receita Mensal',
        /*pt-pt*/'Saldo Pagto.Prest.<br/>Financ. Sugerido<br/>Receita Mensal',
        /*en-us*/'Installment Payment Balance<br/>Suggested Financing<br/>Monthly Income',
        /*es-es*/'Saldo Pago Cuotas<br/>Financ. Sugerido<br/>Ingreso Mensual'
    ]),
    graficoEcomoniaFinanciamentoSugerido: traduzir([
        /*pt-br*/'Economia',
        /*pt-pt*/'Economia',
        /*en-us*/'Savings',
        /*es-es*/'Ahorro'
    ]),
    graficoPerdaFinanciamentoSugerido: traduzir([
        /*pt-br*/'Perda',
        /*pt-pt*/'Perda',
        /*en-us*/'Loss',
        /*es-es*/'Pérdida'
    ]),
    parcela: traduzir([
        /*pt-br*/'Parcela',
        /*pt-pt*/'Prestação',
        /*en-us*/'Installment',
        /*es-es*/'Cuota'
    ]),
    mesAno: traduzir([
        /*pt-br*/'Mês/Ano',
        /*pt-pt*/'Mês/Ano',
        /*en-us*/'Month/Year',
        /*es-es*/'Mes/Año'
    ]),
    economiaPerda: traduzir([
        /*pt-br*/'Economia/Perda',
        /*pt-pt*/'Economia/Perda',
        /*en-us*/'Savings/Loss',
        /*es-es*/'Ahorro/Pérdida'
    ]),

    comparacaoCenarios: traduzir([
        /*pt-br*/'Comparação de Cenários',
        /*pt-pt*/'Comparação de Cenários',
        /*en-us*/'Scenario de Comparison',
        /*es-es*/'Comparación de Escenarios'
    ]),
    estudos: traduzir([
        /*pt-br*/'Estudos',
        /*pt-pt*/'Estudos',
        /*en-us*/'Studies',
        /*es-es*/'Estudios'
    ]),
    comparacaoEstudos: traduzir([
        /*pt-br*/'Comparação Estudos',
        /*pt-pt*/'Comparação Estudos',
        /*en-us*/'Study Comparison',
        /*es-es*/'Comparación de Estudios'
    ]),
    versao: traduzir([
        /*pt-br*/'Versão',
        /*pt-pt*/'Versão',
        /*en-us*/'Version',
        /*es-es*/'Versión'
    ]),
    ultimaVersao: traduzir([
        /*pt-br*/'Última Versão',
        /*pt-pt*/'Última Versão',
        /*en-us*/'Latest Version',
        /*es-es*/'Última Versión'
    ]),
    evolucaoRecursosFinanceiros: traduzir([
        /*pt-br*/'Evolução dos Recursos Financeiros',
        /*pt-pt*/'Evolução dos Recursos Financeiros',
        /*en-us*/'Financial Resources Evolution',
        /*es-es*/'Evolución de los Recursos Financieros'
    ]),

    parametrosGestaoPatrimonial: traduzir([
        /*pt-br*/'Parâmetros: Gestão Patrimonial',
        /*pt-pt*/'Parâmetros: Gestão Patrimonial',
        /*en-us*/'Parameters: Asset Management',
        /*es-es*/'Parámetros: Gestión Patrimonial'
    ]),
    gestaoPatrimonial: traduzir([
        /*pt-br*/'Gestão Patrimonial',
        /*pt-pt*/'Gestão Patrimonial',
        /*en-us*/'Asset Management',
        /*es-es*/'Gestión Patrimonial'
    ]),
    gestaoPatrimonialVisao: traduzir([
        /*pt-br*/'Visão',
        /*pt-pt*/'Visão',
        /*en-us*/'Vision',
        /*es-es*/'Visión'
    ]),
    gestaoPatrimonialEstruturaFamiliar: traduzir([
        /*pt-br*/'Estrutura Familiar',
        /*pt-pt*/'Estrutura Familiar',
        /*en-us*/'Family Structure',
        /*es-es*/'Estructura Familiar'
    ]),
    gestaoPatrimonialFluxoCaixa: traduzir([
        /*pt-br*/'Fluxo de Caixa',
        /*pt-pt*/'Fluxo de Caixa',
        /*en-us*/'Cash Flow',
        /*es-es*/'Flujo de Caja'
    ]),
    gestaoPatrimonialResumoPatrimonial: traduzir([
        /*pt-br*/'Resumo Patrimonial',
        /*pt-pt*/'Resumo Patrimonial',
        /*en-us*/'Asset Summary',
        /*es-es*/'Resumen Patrimonial'
    ]),
    gestaoPatrimonialSucessao: traduzir([
        /*pt-br*/'Sucessão',
        /*pt-pt*/'Sucessão',
        /*en-us*/'Succession',
        /*es-es*/'Sucesión'
    ]),
    gestaoPatrimonialEstrategiasFinanceiras: traduzir([
        /*pt-br*/'Estratégias Financeiras',
        /*pt-pt*/'Estratégias Financeiras',
        /*en-us*/'Financial Strategies',
        /*es-es*/'Estrategias Financieras'
    ]),
    gestaoPatrimonialProjecaoFutura: traduzir([
        /*pt-br*/'Projeção Futura',
        /*pt-pt*/'Projeção Futura',
        /*en-us*/'Future Projection',
        /*es-es*/'Proyección Futura'
    ]),
    gestaoPatrimonialEstrategias: traduzir([
        /*pt-br*/'Estratégias',
        /*pt-pt*/'Estratégias',
        /*en-us*/'Strategies',
        /*es-es*/'Estrategias'
    ]),
    gestaoPatrimonialPlanejamento: traduzir([
        /*pt-br*/'Planejamento',
        /*pt-pt*/'Planeamento',
        /*en-us*/'Planning',
        /*es-es*/'Planificación'
    ]),

    carteiraInvestimentos: traduzir([
        /*pt-br*/'Carteira de Investimentos',
        /*pt-pt*/'Carteira de Investimentos',
        /*en-us*/'Investment Portfolio',
        /*es-es*/'Cartera de Inversiones'
    ]),
    analiseInvestimentoVersusSeguroVidaInteira: traduzir([
        /*pt-br*/'Análise Investimento x Seguro Vida Inteira',
        /*pt-pt*/'Análise Investimento x Seguro Vida Inteira',
        /*en-us*/'Investment vs Whole Life Insurance Analysis',
        /*es-es*/'Análisis Inversión vs Seguro de Vida Entera'
    ]),
    analisePrevidênciaPrivadaVersusSeguroVidaInteira: traduzir([
        /*pt-br*/'Análise Previdência Privada x Seguro Vida Inteira',
        /*pt-pt*/'Análise Previdência Privada x Seguro Vida Inteira',
        /*en-us*/'Private Pension vs Whole Life Insurance Analysis',
        /*es-es*/'Análisis Previsión Privada vs Seguro de Vida Entera'
    ]),

    elaboradoPor: traduzir([
        /*pt-br*/'Elaborado por:',
        /*pt-pt*/'Elaborado por:',
        /*en-us*/'Prepared by:',
        /*es-es*/'Elaborado por:'
    ]),
    disclaimer: traduzir([
        /*pt-br*/'Disclaimer',
        /*pt-pt*/'Disclaimer',
        /*en-us*/'Disclaimer',
        /*es-es*/'Aviso Legal'
    ]),

    aiFT: traduzir([
        /*pt-br*/'Análises e Informações',
        /*pt-pt*/'Análises e Informações',
        /*en-us*/'Analysis and Information',
        /*es-es*/'Análisis e Información'
    ]),
    aiFTHTML: traduzir([
        /*pt-br*/'<b>A</b>nálises e <b>I</b>nformações',
        /*pt-pt*/'<b>A</b>nálises e <b>I</b>nformações',
        /*en-us*/'<b>A</b>nalysis and <b>I</b>nformation',
        /*es-es*/'<b>A</b>nálisis e <b>I</b>nformación'
    ]),

    dataPrevista: traduzir([
        /*pt-br*/'Data Prevista',
        /*pt-pt*/'Data Prevista',
        /*en-us*/'Expected Date',
        /*es-es*/'Fecha Prevista'
    ]),
    dataResolucao: traduzir([
        /*pt-br*/'Data da Resolução',
        /*pt-pt*/'Data da Resolução',
        /*en-us*/'Resolution Date',
        /*es-es*/'Fecha de Resolución'
    ]),

    tabFintracksFormList1Configuracao: traduzir([
        /*pt-br*/'1. Configuração',
        /*pt-pt*/'1. Configuração',
        /*en-us*/'1. Configuration',
        /*es-es*/'1. Configuración'
    ]),
    tabFintracksFormList2Usuario: traduzir([
        /*pt-br*/'2. Usuário',
        /*pt-pt*/'2. Utilizador',
        /*en-us*/'2. User',
        /*es-es*/'2. Usuario'
    ]),
    tabFintracksFormList3Cliente: traduzir([
        /*pt-br*/'3. Cliente',
        /*pt-pt*/'3. Cliente',
        /*en-us*/'3. Client',
        /*es-es*/'3. Cliente'
    ]),
    tabFintracksFormList4Cobranca: traduzir([
        /*pt-br*/'4. Cobrança',
        /*pt-pt*/'4. Cobrança',
        /*en-us*/'4. Billing',
        /*es-es*/'4. Cobranza'
    ]),
    tabFintracksFormList5Aporte: traduzir([
        /*pt-br*/'5. Aportes',
        /*pt-pt*/'5. Contribuições',
        /*en-us*/'5. Contributions',
        /*es-es*/'5. Aportes'
    ]),

    cobranca: traduzir([
        /*pt-br*/'Cobrança',
        /*pt-pt*/'Cobrança',
        /*en-us*/'Billing',
        /*es-es*/'Cobranza'
    ]),



    buttonEntrar: traduzir([
        /*pt-br*/'Entrar',
        /*pt-pt*/'Entrar',
        /*en-us*/'Sign In',
        /*es-es*/'Ingresar'
    ]),
    buttonSair: traduzir([
        /*pt-br*/'Sair',
        /*pt-pt*/'Sair',
        /*en-us*/'Sign Out',
        /*es-es*/'Salir'
    ]),
    buttonCadastreSe: traduzir([
        /*pt-br*/'Ainda não é um guia financeiro? Cadastre-se',
        /*pt-pt*/'Ainda não é um guia financeiro? Registe-se',
        /*en-us*/'Not a financial advisor yet? Register',
        /*es-es*/'¿Aún no es un guía financiero? Regístrese'
    ]),
    buttonEsqueceuSenha: traduzir([
        /*pt-br*/'Esqueceu a senha?',
        /*pt-pt*/'Esqueceu a palavra-passe?',
        /*en-us*/'Forgot password?',
        /*es-es*/'¿Olvidó la contraseña?'
    ]),
    buttonCadastrar: traduzir([
        /*pt-br*/'Cadastrar',
        /*pt-pt*/'Registar',
        /*en-us*/'Register',
        /*es-es*/'Registrar'
    ]),
    buttonAssinar: traduzir([
        /*pt-br*/'Assinar',
        /*pt-pt*/'Assinar',
        /*en-us*/'Subscribe',
        /*es-es*/'Suscribir'
    ]),
    buttonCancelar: traduzir([
        /*pt-br*/'Cancelar',
        /*pt-pt*/'Cancelar',
        /*en-us*/'Cancel',
        /*es-es*/'Cancelar'
    ]),
    buttonSalvarSenha: traduzir([
        /*pt-br*/'Salvar Senha',
        /*pt-pt*/'Guardar Palavra-passe',
        /*en-us*/'Save Password',
        /*es-es*/'Guardar Contraseña'
    ]),

    buttonRealizarAssinatura: traduzir([
        /*pt-br*/'Realizar Assinatura',
        /*pt-pt*/'Realizar Assinatura',
        /*en-us*/'Subscribe Now',
        /*es-es*/'Realizar Suscripción'
    ]),
    buttonAlterarCartaoCredito: traduzir([
        /*pt-br*/'Alterar Cartão de Crédito',
        /*pt-pt*/'Alterar Cartão de Crédito',
        /*en-us*/'Change Credit Card',
        /*es-es*/'Cambiar Tarjeta de Crédito'
    ]),

    buttonAlterarCor: traduzir([
        /*pt-br*/'Alterar Cor',
        /*pt-pt*/'Alterar Cor',
        /*en-us*/'Change Color',
        /*es-es*/'Cambiar Color'
    ]),

    buttonAdicionarCliente: traduzir([
        /*pt-br*/'+ Cliente',
        /*pt-pt*/'+ Cliente',
        /*en-us*/'+ Client',
        /*es-es*/'+ Cliente'
    ]),
    buttonAdicionarExemplo: traduzir([
        /*pt-br*/'+ Exemplo',
        /*pt-pt*/'+ Exemplo',
        /*en-us*/'+ Example',
        /*es-es*/'+ Ejemplo'
    ]),
    buttonNovoUsuario: traduzir([
        /*pt-br*/'Novo Usuário',
        /*pt-pt*/'Novo Utilizador',
        /*en-us*/'New User',
        /*es-es*/'Nuevo Usuario'
    ]),
    buttonNovoParceiro: traduzir([
        /*pt-br*/'Novo Parceiro',
        /*pt-pt*/'Novo Parceiro',
        /*en-us*/'New Partner',
        /*es-es*/'Nuevo Socio'
    ]),
    buttonDuplicar: traduzir([
        /*pt-br*/'Duplicar',
        /*pt-pt*/'Duplicar',
        /*en-us*/'Duplicate',
        /*es-es*/'Duplicar'
    ]),
    buttonImportarXLSX: traduzir([
        /*pt-br*/'Importar XLSX',
        /*pt-pt*/'Importar XLSX',
        /*en-us*/'Import XLSX',
        /*es-es*/'Importar XLSX'
    ]),
    buttonExportarXLSX: traduzir([
        /*pt-br*/'Exportar XLSX',
        /*pt-pt*/'Exportar XLSX',
        /*en-us*/'Export XLSX',
        /*es-es*/'Exportar XLSX'
    ]),
    buttonExportarUmXLSXParaCada: traduzir([
        /*pt-br*/'Exportar um XLSX para cada',
        /*pt-pt*/'Exportar um XLSX para cada',
        /*en-us*/'Export one XLSX for each',
        /*es-es*/'Exportar un XLSX para cada'
    ]),
    buttonIntegracao: traduzir([
        /*pt-br*/'Integração',
        /*pt-pt*/'Integração',
        /*en-us*/'Integration',
        /*es-es*/'Integración'
    ]),
    buttonExcluirMarcados: traduzir([
        /*pt-br*/'Excluir Marcados',
        /*pt-pt*/'Excluir Marcados',
        /*en-us*/'Delete Selected',
        /*es-es*/'Eliminar Marcados'
    ]),
    buttonTransferirMarcados: traduzir([
        /*pt-br*/'Transferir Marcados',
        /*pt-pt*/'Transferir Selecionados',
        /*en-us*/'Transfer Selected',
        /*es-es*/'Transferir Seleccionados'
    ]),
    buttonUploadArquivos: traduzir([
        /*pt-br*/'Upload Arquivos',
        /*pt-pt*/'Carregar Ficheiros',
        /*en-us*/'Upload Files',
        /*es-es*/'Subir Archivos'
    ]),
    buttonProcessarArquivosPendentes: traduzir([
        /*pt-br*/'Processar Arquivos Pendentes',
        /*pt-pt*/'Processar Ficheiros Pendentes',
        /*en-us*/'Process Pending Files',
        /*es-es*/'Procesar Archivos Pendientes'
    ]),
    buttonProcessarArquivosMarcados: traduzir([
        /*pt-br*/'Processar Arquivos Marcados',
        /*pt-pt*/'Processar Ficheiros Marcados',
        /*en-us*/'Process Selected Files',
        /*es-es*/'Procesar Archivos Marcados'
    ]),
    buttonAtualizarStatusArquivos: traduzir([
        /*pt-br*/'Atualizar Status Arquivos',
        /*pt-pt*/'Actualizar Estado Ficheiros',
        /*en-us*/'Update File Status',
        /*es-es*/'Actualizar Estado Archivos'
    ]),
    buttonAtualizarComissao: traduzir([
        /*pt-br*/'Atualizar Comissão',
        /*pt-pt*/'Atualizar Comissão',
        /*en-us*/'Update Commission',
        /*es-es*/'Actualizar Comisión'
    ]),
    buttonVisualizarErrosProcessamento: traduzir([
        /*pt-br*/'Visualizar Erros',
        /*pt-pt*/'Visualizar Erros',
        /*en-us*/'View Errors',
        /*es-es*/'Ver Errores'
    ]),
    buttonBaixarArquivo: traduzir([
        /*pt-br*/'Baixar Arquivo',
        /*pt-pt*/'Transferir Ficheiro',
        /*en-us*/'Download File',
        /*es-es*/'Descargar Archivo'
    ]),
    buttonUploadTabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Upload Tabela Evolução Valor Resgate',
        /*pt-pt*/'Carregar Tabela Evolução Valor Resgate',
        /*en-us*/'Upload Redemption Value Evolution Table',
        /*es-es*/'Subir Tabla Evolución Valor Rescate'
    ]),
    buttonUploadParcelas: traduzir([
        /*pt-br*/'Upload Parcelas',
        /*pt-pt*/'Carregar Prestações',
        /*en-us*/'Upload Installments',
        /*es-es*/'Subir Cuotas'
    ]),
    buttonTransferir: traduzir([
        /*pt-br*/'Transferir',
        /*pt-pt*/'Transferir',
        /*en-us*/'Transfer',
        /*es-es*/'Transferir'
    ]),
    buttonFiltrar: traduzir([
        /*pt-br*/'Filtrar',
        /*pt-pt*/'Filtrar',
        /*en-us*/'Filter',
        /*es-es*/'Filtrar'
    ]),
    buttonCalcular: traduzir([
        /*pt-br*/'Calcular',
        /*pt-pt*/'Calcular',
        /*en-us*/'Calculate',
        /*es-es*/'Calcular'
    ]),
    buttonProcessar: traduzir([
        /*pt-br*/'Processar',
        /*pt-pt*/'Processar',
        /*en-us*/'Process',
        /*es-es*/'Procesar'
    ]),
    buttonBaixarModeloXLSXImportacaoClientes: traduzir([
        /*pt-br*/'Baixar Modelo XLSX para Importação de Clientes',
        /*pt-pt*/'Descarregar Modelo XLSX para Importação de Clientes',
        /*en-us*/'Download XLSX Template for Client Import',
        /*es-es*/'Descargar Plantilla XLSX para Importación de Clientes'
    ]),
    modeloXLSXImportacaoClientes: traduzir([
        /*pt-br*/'Modelo de Importação de Clientes',
        /*pt-pt*/'Modelo de Importação de Clientes',
        /*en-us*/'Client Import Template',
        /*es-es*/'Plantilla de Importación de Clientes'
    ]),
    buttonSubmitSalvar: traduzir([
        /*pt-br*/'Salvar',
        /*pt-pt*/'Guardar',
        /*en-us*/'Save',
        /*es-es*/'Guardar'
    ]),
    buttonFechar: traduzir([
        /*pt-br*/'Fechar',
        /*pt-pt*/'Fechar',
        /*en-us*/'Close',
        /*es-es*/'Cerrar'
    ]),
    buttonSalvarFechar: traduzir([
        /*pt-br*/'Salvar e Fechar',
        /*pt-pt*/'Guardar e Fechar',
        /*en-us*/'Save and Close',
        /*es-es*/'Guardar Y Cerrar'
    ]),
    buttonCompartilhar: traduzir([
        /*pt-br*/'Compartilhar',
        /*pt-pt*/'Partilhar',
        /*en-us*/'Share',
        /*es-es*/'Compartir'
    ]),
    buttonCopiar: traduzir([
        /*pt-br*/'Copiar',
        /*pt-pt*/'Copiar',
        /*en-us*/'Copy',
        /*es-es*/'Copiar'
    ]),

    buttonGerarLinkCliente: traduzir([
        /*pt-br*/'Gerar link para o Cliente',
        /*pt-pt*/'Gerar ligação para o Cliente',
        /*en-us*/'Generate Client Link',
        /*es-es*/'Generar enlace para el Cliente'
    ]),
    buttonGerarLinkCaptacaoLeads: traduzir([
        /*pt-br*/'Gerar link captação leads',
        /*pt-pt*/'Gerar ligação captação leads',
        /*en-us*/'Generate Lead Capture Link',
        /*es-es*/'Generar enlace captación leads'
    ]),
    buttonGerarLinkCaptacaoLeadsMidiasSociais: traduzir([
        /*pt-br*/'Gerar link captação leads nas mídias sociais',
        /*pt-pt*/'Gerar ligação captação leads nas redes sociais',
        /*en-us*/'Generate Social Media Lead Capture Link',
        /*es-es*/'Generar enlace captación leads en redes sociales'
    ]),
    buttonConfigurarNavegacaoTelaClientes: traduzir([
        /*pt-br*/'Configurar Navegação da Tela de Clientes',
        /*pt-pt*/'Configurar Navegação do Ecrã de Clientes',
        /*en-us*/'Configure Client Screen Navigation',
        /*es-es*/'Configurar Navegación de Pantalla de Clientes'
    ]),
    buttonConfigurarWhiteLabel: traduzir([
        /*pt-br*/'Configurar White Label',
        /*pt-pt*/'Configurar White Label',
        /*en-us*/'Configure White Label',
        /*es-es*/'Configurar White Label'
    ]),
    buttonConfigurarIntegracaoSeguradoras: traduzir([
        /*pt-br*/'Configurar Integração com as Seguradoras',
        /*pt-pt*/'Configurar Integração com as Seguradoras',
        /*en-us*/'Configure Insurance Company Integration',
        /*es-es*/'Configurar Integración con Aseguradoras'
    ]),
    buttonAlterarConfiguracaoRelatorio: traduzir([
        /*pt-br*/'Alterar Configuração Relatório',
        /*pt-pt*/'Alterar Configuração Relatório',
        /*en-us*/'Change Report Configuration',
        /*es-es*/'Cambiar Configuración de Informe'
    ]),


    
    processando: traduzir([
        /*pt-br*/'Processando ...',
        /*pt-pt*/'A processar ...',
        /*en-us*/'Processing ...',
        /*es-es*/'Procesando ...'
    ]),

    buttonGerarTokenIntegracao: traduzir([
        /*pt-br*/'Gerar Token Integração',
        /*pt-pt*/'Gerar Token Integração',
        /*en-us*/'Generate Integration Token',
        /*es-es*/'Generar Token de Integración'
    ]),

    buttonIncluirCnpjEmpresa: traduzir([
        /*pt-br*/'+ Cnpj da Empresa',
        /*pt-pt*/'+ CNPJ da Empresa',
        /*en-us*/'+ Company CNPJ',
        /*es-es*/'+ CNPJ de Empresa'
    ]),
    buttonIncluirWhiteLabel: traduzir([
        /*pt-br*/'+ White Label',
        /*pt-pt*/'+ White Label',
        /*en-us*/'+ White Label',
        /*es-es*/'+ White Label'
    ]),
    buttonIncluirFilialUnidade: traduzir([
        /*pt-br*/'+ Filial/Unidade',
        /*pt-pt*/'+ Filial/Unidade',
        /*en-us*/'+ Branch/Unit',
        /*es-es*/'+ Sucursal/Unidad'
    ]),
    buttonIncluirFunil: traduzir([
        /*pt-br*/'+ Funil',
        /*pt-pt*/'+ Funil',
        /*en-us*/'+ Funnel',
        /*es-es*/'+ Embudo'
    ]),
    buttonIncluirFunilEtapa: traduzir([
        /*pt-br*/'+ Etapa',
        /*pt-pt*/'+ Etapa',
        /*en-us*/'+ Stage',
        /*es-es*/'+ Etapa'
    ]),
    buttonIncluirUsuario: traduzir([
        /*pt-br*/'+ Usuário',
        /*pt-pt*/'+ Utilizador',
        /*en-us*/'+ User',
        /*es-es*/'+ Usuario'
    ]),
    buttonIncluirSeguradora: traduzir([
        /*pt-br*/'+ Seguradora',
        /*pt-pt*/'+ Seguradora',
        /*en-us*/'+ Insurance Company',
        /*es-es*/'+ Aseguradora'
    ]),

    buttonImportarLogo: traduzir([
        /*pt-br*/'Logo',
        /*pt-pt*/'Logótipo',
        /*en-us*/'Logo',
        /*es-es*/'Logo'
    ]),
    buttonImportarLogoLoginSidenav: traduzir([
        /*pt-br*/'Logo Login / Menu (Opcional)',
        /*pt-pt*/'Logótipo Login / Menu (Opcional)',
        /*en-us*/'Login / Menu Logo (Optional)',
        /*es-es*/'Logo Login / Menú (Opcional)'
    ]),
    buttonImportarBackground: traduzir([
        /*pt-br*/'Imagem de Fundo (Opcional)',
        /*pt-pt*/'Imagem de Fundo (Opcional)',
        /*en-us*/'Background Image (Optional)',
        /*es-es*/'Imagen de Fondo (Opcional)'
    ]),
    buttonImportarBackgroundCapaRelatorio: traduzir([
        /*pt-br*/'Imagem Capa Relat.Retrato (Opcional)',
        /*pt-pt*/'Imagem Capa Relat.Retrato (Opcional)',
        /*en-us*/'Portrait Report Cover Image (Optional)',
        /*es-es*/'Imagen Portada Informe Retrato (Opcional)'
    ]),
    buttonImportarBackgroundCapaRelatorioPaisagem: traduzir([
        /*pt-br*/'Imagem Capa Relat.Paisagem (Opcional)',
        /*pt-pt*/'Imagem Capa Relat.Paisagem (Opcional)',
        /*en-us*/'Landscape Report Cover Image (Optional)',
        /*es-es*/'Imagen Portada Informe Paisaje (Opcional)'
    ]),
    buttonImportarBackgroundPaginaRelatorio: traduzir([
        /*pt-br*/'Imagem Página Relat.Retrato (Opcional)',
        /*pt-pt*/'Imagem Página Relat.Retrato (Opcional)',
        /*en-us*/'Portrait Report Page Image (Optional)',
        /*es-es*/'Imagen Página Informe Retrato (Opcional)'
    ]),
    buttonImportarBackgroundPaginaRelatorioPaisagem: traduzir([
        /*pt-br*/'Imagem Página Relat.Paisagem (Opcional)',
        /*pt-pt*/'Imagem Página Relat.Paisagem (Opcional)',
        /*en-us*/'Landscape Report Page Image (Optional)',
        /*es-es*/'Imagen Página Informe Paisaje (Opcional)'
    ]),

    buttonIncluirPerfilUsuario: traduzir([
        /*pt-br*/'+ Perfil/Usuário',
        /*pt-pt*/'+ Perfil/Utilizador',
        /*en-us*/'+ Profile/User',
        /*es-es*/'+ Perfil/Usuario'
    ]),

    buttonIncluirCor: traduzir([
        /*pt-br*/'+ Cor',
        /*pt-pt*/'+ Cor',
        /*en-us*/'+ Color',
        /*es-es*/'+ Color'
    ]),

    buttonIncluirTipoPendencia: traduzir([
        /*pt-br*/'+ Tipo de Pendência',
        /*pt-pt*/'+ Tipo de Pendência',
        /*en-us*/'+ Pending Type',
        /*es-es*/'+ Tipo de Pendencia'
    ]),

    buttonCarregarPDF: traduzir([
        /*pt-br*/'Carregar PDF',
        /*pt-pt*/'Carregar PDF',
        /*en-us*/'Load PDF',
        /*es-es*/'Cargar PDF'
    ]),

    buttonIncluirSeguradoraVigencia: traduzir([
        /*pt-br*/'Incluir Seguradora / Vigência',
        /*pt-pt*/'Incluir Seguradora / Vigência',
        /*en-us*/'Include Insurance Company / Validity',
        /*es-es*/'Incluir Aseguradora / Vigencia'
    ]),
    buttonIncluirFaixaComissao: traduzir([
        /*pt-br*/'Incluir Faixa de Comissão',
        /*pt-pt*/'Incluir Faixa de Comissão',
        /*en-us*/'Include Commission Range',
        /*es-es*/'Incluir Rango de Comisión'
    ]),
    buttonIncluirPrazoCS: traduzir([
        /*pt-br*/'Incluir Prazo / Capital Segurado',
        /*pt-pt*/'Incluir Prazo / Capital Segurado',
        /*en-us*/'Include Term / Insured Capital',
        /*es-es*/'Incluir Plazo / Capital Asegurado'
    ]),
    buttonIncluirComissao: traduzir([
        /*pt-br*/'Incluir % Comissao',
        /*pt-pt*/'Incluir % Comissão',
        /*en-us*/'Include % Commission',
        /*es-es*/'Incluir % Comisión'
    ]),

    buttonIncluirFormulario: traduzir([
        /*pt-br*/'+ Formulário',
        /*pt-pt*/'+ Formulário',
        /*en-us*/'+ Form',
        /*es-es*/'+ Formulario'
    ]),
    buttonIncluirTemplate: traduzir([
        /*pt-br*/'+ Template',
        /*pt-pt*/'+ Modelo',
        /*en-us*/'+ Template',
        /*es-es*/'+ Plantilla'
    ]),
    buttonIncluirPagina: traduzir([
        /*pt-br*/'+ Pagina',
        /*pt-pt*/'+ Página',
        /*en-us*/'+ Page',
        /*es-es*/'+ Página'
    ]),
    buttonIncluirPaginaAPartirDeUmaExistente: traduzir([
        /*pt-br*/'+ Pagina a partir de uma Existente',
        /*pt-pt*/'+ Página a partir de uma Existente',
        /*en-us*/'+ Page from Existing One',
        /*es-es*/'+ Página a partir de una Existente'
    ]),
    buttonIncluirItemPagina: traduzir([
        /*pt-br*/'+ Item na Pagina',
        /*pt-pt*/'+ Item na Página',
        /*en-us*/'+ Page Item',
        /*es-es*/'+ Item en la Página'
    ]),
    buttonIncluirItemGestaoPatrimonial: traduzir([
        /*pt-br*/'+ Item',
        /*pt-pt*/'+ Item',
        /*en-us*/'+ Item',
        /*es-es*/'+ Item'
    ]),

    buttonIncluirTipoInvestimento: traduzir([
        /*pt-br*/'+ Tipo de Investimento',
        /*pt-pt*/'+ Tipo de Investimento',
        /*en-us*/'+ Investment Type',
        /*es-es*/'+ Tipo de Inversión'
    ]),

    buttonIncluirTipoPilar: traduzir([
        /*pt-br*/'+ Pilar',
        /*pt-pt*/'+ Pilar',
        /*en-us*/'+ Pillar',
        /*es-es*/'+ Pilar'
    ]),

    buttonIncluirFiltro: traduzir([
        /*pt-br*/'+ Filtro',
        /*pt-pt*/'+ Filtro',
        /*en-us*/'+ Filter',
        /*es-es*/'+ Filtro'
    ]),

    buttonAtualizarDashboard: traduzir([
        /*pt-br*/'Atualizar o Dashboard',
        /*pt-pt*/'Actualizar o Dashboard',
        /*en-us*/'Update Dashboard',
        /*es-es*/'Actualizar Dashboard'
    ]),

    buttonIncluirVersao: traduzir([
        /*pt-br*/'+ Versão',
        /*pt-pt*/'+ Versão',
        /*en-us*/'+ Version',
        /*es-es*/'+ Versión'
    ]),

    buttonIncluirFamiliar: traduzir([
        /*pt-br*/'+ Familiar',
        /*pt-pt*/'+ Familiar',
        /*en-us*/'+ Family Member',
        /*es-es*/'+ Familiar'
    ]),
    buttonIncluirEndereco: traduzir([
        /*pt-br*/'+ Endereço',
        /*pt-pt*/'+ Morada',
        /*en-us*/'+ Address',
        /*es-es*/'+ Dirección'
    ]),
    buttonBuscarEndereco: traduzir([
        /*pt-br*/'Buscar Endereço',
        /*pt-pt*/'Procurar Morada',
        /*en-us*/'Search Address',
        /*es-es*/'Buscar Dirección'
    ]),
    buttonIncluirContato: traduzir([
        /*pt-br*/'+ Telefone, E-mail, ...',
        /*pt-pt*/'+ Telefone, E-mail, ...',
        /*en-us*/'+ Phone, Email, ...',
        /*es-es*/'+ Teléfono, Email, ...'
    ]),
    buttonIncluirContaInvestimentos: traduzir([
        /*pt-br*/'+ Conta de Investimentos',
        /*pt-pt*/'+ Conta de Investimentos',
        /*en-us*/'+ Investment Account',
        /*es-es*/'+ Cuenta de Inversiones'
    ]),

    buttonIncluirEsporteHobbyRisco: traduzir([
        /*pt-br*/'+ Esporte/Hobby de Risco',
        /*pt-pt*/'+ Desporto/Hobby de Risco',
        /*en-us*/'+ Risk Sport/Hobby',
        /*es-es*/'+ Deporte/Hobby de Riesgo'
    ]),
    buttonIncluirCondicaoSaude: traduzir([
        /*pt-br*/'+ Condição de Saúde',
        /*pt-pt*/'+ Condição de Saúde',
        /*en-us*/'+ Health Condition',
        /*es-es*/'+ Condición de Salud'
    ]),
    buttonIncluirHistoricoSaudeFamiliares: traduzir([
        /*pt-br*/'+ Histórico de Saúde Familiares',
        /*pt-pt*/'+ Histórico de Saúde Familiares',
        /*en-us*/'+ Family Health History',
        /*es-es*/'+ Historial de Salud Familiar'
    ]),

    buttonIncluirReceitaMensal: traduzir([
        /*pt-br*/'+ Receita Mensal',
        /*pt-pt*/'+ Receita Mensal',
        /*en-us*/'+ Monthly Income',
        /*es-es*/'+ Ingreso Mensual'
    ]),
    buttonIncluirDiaDia: traduzir([
        /*pt-br*/'+ Despesa do Dia a Dia',
        /*pt-pt*/'+ Despesa do Dia a Dia',
        /*en-us*/'+ Daily Expense',
        /*es-es*/'+ Gasto del Día a Día'
    ]),
    buttonIncluirEducacao: traduzir([
        /*pt-br*/'+ Etapa de Educação',
        /*pt-pt*/'+ Etapa de Educação',
        /*en-us*/'+ Education Stage',
        /*es-es*/'+ Etapa de Educación'
    ]),
    buttonIncluirFinanciamento: traduzir([
        /*pt-br*/'+ Financiamento',
        /*pt-pt*/'+ Financiamento',
        /*en-us*/'+ Financing',
        /*es-es*/'+ Financiamiento'
    ]),
    buttonIncluirParcelasAdicionais: traduzir([
        /*pt-br*/'+ Parcela',
        /*pt-pt*/'+ Prestação',
        /*en-us*/'+ Installment',
        /*es-es*/'+ Cuota'
    ]),
    buttonIncluirConsorcio: traduzir([
        /*pt-br*/'+ Consórcio',
        /*pt-pt*/'+ Consórcio',
        /*en-us*/'+ Consortium',
        /*es-es*/'+ Consorcio'
    ]),
    buttonIncluirProjetoVidaSonho: traduzir([
        /*pt-br*/'+ Projeto de Vida/Sonho',
        /*pt-pt*/'+ Projecto de Vida/Sonho',
        /*en-us*/'+ Life Project/Dream',
        /*es-es*/'+ Proyecto de Vida/Sueño'
    ]),


    buttonIncluirPatrimonioImobilizado: traduzir([
        /*pt-br*/'+ Patrimônio Imobilizado',
        /*pt-pt*/'+ Património Imobiliário',
        /*en-us*/'+ Real Estate Asset',
        /*es-es*/'+ Patrimonio Inmobiliario'
    ]),
    buttonIncluirRecursosFinanceiros: traduzir([
        /*pt-br*/'+ Recurso Financeiro',
        /*pt-pt*/'+ Recurso Financeiro',
        /*en-us*/'+ Financial Resource',
        /*es-es*/'+ Recurso Financiero'
    ]),
    buttonIncluirSeguroVidaCotacao: traduzir([
        /*pt-br*/'+ Cotação',
        /*pt-pt*/'+ Cotação',
        /*en-us*/'+ Quote',
        /*es-es*/'+ Cotización'
    ]),
    buttonIncluirSeguroVidaProposta: traduzir([
        /*pt-br*/'+ Proposta',
        /*pt-pt*/'+ Proposta',
        /*en-us*/'+ Proposal',
        /*es-es*/'+ Propuesta'
    ]),
    buttonIncluirSeguroVidaApolice: traduzir([
        /*pt-br*/'+ Apólice',
        /*pt-pt*/'+ Apólice',
        /*en-us*/'+ Policy',
        /*es-es*/'+ Póliza'
    ]),
    buttonIncluirSeguroVidaCobertura: traduzir([
        /*pt-br*/'+ Cobertura',
        /*pt-pt*/'+ Cobertura',
        /*en-us*/'+ Coverage',
        /*es-es*/'+ Cobertura'
    ]),

    buttonIncluirSolicitacaoArquivo: traduzir([
        /*pt-br*/'+ Solicitação de Arquivo',
        /*pt-pt*/'+ Solicitação de Ficheiro',
        /*en-us*/'+ File Request',
        /*es-es*/'+ Solicitud de Documentos'
    ]),

    buttonIncluirSimulacao: traduzir([
        /*pt-br*/'+ Simulação',
        /*pt-pt*/'+ Simulação',
        /*en-us*/'+ Simulation',
        /*es-es*/'+ Simulación'
    ]),
    buttonIncluirAporte: traduzir([
        /*pt-br*/'+ Aporte',
        /*pt-pt*/'+ Aporte',
        /*en-us*/'+ Contribution',
        /*es-es*/'+ Aporte'
    ]),

    buttonIncluirSimulacaoConsorcio: traduzir([
        /*pt-br*/'+ Simulação de Consórcio',
        /*pt-pt*/'+ Simulação de Consórcio',
        /*en-us*/'+ Consortium Simulation',
        /*es-es*/'+ Simulación de Consorcio'
    ]),

    buttonIncluirConsideracaoFinal: traduzir([
        /*pt-br*/'+ mais uma Página',
        /*pt-pt*/'+ mais uma Página',
        /*en-us*/'+ Another Page',
        /*es-es*/'+ otra Página'
    ]),

    buttonGerarLancamentosPlanejamentoEspecializacaoPeriodoSabatico: traduzir([
        /*pt-br*/'Gerar Lançamentos do Planejamento da Especialização/Período Sabático',
        /*pt-pt*/'Gerar Lançamentos do Planeamento da Especialização/Período Sabático',
        /*en-us*/'Generate Specialization/Sabbatical Period Planning Entries',
        /*es-es*/'Generar Asientos del Planificación de Especialización/Período Sabático'
    ]),

    buttonConcluir: traduzir([
        /*pt-br*/'Concluir',
        /*pt-pt*/'Concluir',
        /*en-us*/'Complete',
        /*es-es*/'Completar'
    ]),
    buttonConcluirEtapa: traduzir([
        /*pt-br*/'Concluir Etapa',
        /*pt-pt*/'Concluir Etapa',
        /*en-us*/'Complete Stage',
        /*es-es*/'Completar Etapa'
    ]),
    buttonVoltar: traduzir([
        /*pt-br*/'Voltar',
        /*pt-pt*/'Voltar',
        /*en-us*/'Back',
        /*es-es*/'Volver'
    ]),
    buttonProximo: traduzir([
        /*pt-br*/'Próximo',
        /*pt-pt*/'Próximo',
        /*en-us*/'Next',
        /*es-es*/'Siguiente'
    ]),

    buttonCopiaEducacaoFilhaoBaseOutraosFilhaos: traduzir([
        /*pt-br*/'Copiar valores da Educação de $1 para $2',
        /*pt-pt*/'Copiar valores da Educação de $1 para $2',
        /*en-us*/'Copy Education values from $1 to $2',
        /*es-es*/'Copiar valores de Educación de $1 para $2'
    ]),

    buttonIncluirCenario: traduzir([
        /*pt-br*/'+ Cenário',
        /*pt-pt*/'+ Cenário',
        /*en-us*/'+ Scenario',
        /*es-es*/'+ Escenario'
    ]),
    buttonAlterarCenario: traduzir([
        /*pt-br*/'Alterar o Cenário',
        /*pt-pt*/'Alterar o Cenário',
        /*en-us*/'Modify Scenario',
        /*es-es*/'Modificar el Escenario'
    ]),
    buttonExcluirCenario: traduzir([
        /*pt-br*/'Excluir o Cenário',
        /*pt-pt*/'Excluir o Cenário',
        /*en-us*/'Delete Scenario',
        /*es-es*/'Eliminar el Escenario'
    ]),
    buttonConfiguracoesAdicionais: traduzir([
        /*pt-br*/'Configurações Adicionais',
        /*pt-pt*/'Definições Adicionais',
        /*en-us*/'Additional Settings',
        /*es-es*/'Configuraciones Adicionales'
    ]),

    buttonAlterarTodos: traduzir([
        /*pt-br*/'Alterar Todos',
        /*pt-pt*/'Alterar Todos',
        /*en-us*/'Modify All',
        /*es-es*/'Modificar Todos'
    ]),
    buttonAlterarTodosFamiliaresInventario: traduzir([
        /*pt-br*/'Alterar Todos Familiares Inventário',
        /*pt-pt*/'Alterar Todos Familiares Inventário',
        /*en-us*/'Modify All Family Members Inventory',
        /*es-es*/'Modificar Todos los Familiares Inventario'
    ]),

    buttonIncluirExclusaoFamiliar: traduzir([
        /*pt-br*/'+ Familiar a ser Desconsiderado',
        /*pt-pt*/'+ Familiar a ser Desconsiderado',
        /*en-us*/'+ Family Member to be Excluded',
        /*es-es*/'+ Familiar a ser Desconsiderado'
    ]),

    buttonIncluirExclusaoReceitaDespesa: traduzir([
        /*pt-br*/'+ Receita/Despesa/Patrimônio a ser Desconsiderada',
        /*pt-pt*/'+ Rendimento/Despesa/Património a Desconsiderar',
        /*en-us*/'+ Income/Expense/Asset to Be Disregarded',
        /*es-es*/'+ Ingreso/Gasto/Patrimonio a Excluir'
    ]),

    buttonVisualizarSucessaoVitalicia: traduzir([
        /*pt-br*/'Sucessão Patrimonial',
        /*pt-pt*/'Sucessão Patrimonial',
        /*en-us*/'Estate Succession',
        /*es-es*/'Sucesión Patrimonial'
    ]),
    buttonVisualizarEstrategiasFinanceiras: traduzir([
        /*pt-br*/'Estratégias Financeiras',
        /*pt-pt*/'Estratégias Financeiras',
        /*en-us*/'Financial Strategies',
        /*es-es*/'Estrategias Financieras'
    ]),
    buttonVisualizarEvolucaoReservaFinanceira: traduzir([
        /*pt-br*/'Evolução da Reserva Financeira',
        /*pt-pt*/'Evolução da Reserva Financeira',
        /*en-us*/'Financial Reserve Evolution',
        /*es-es*/'Evolución de la Reserva Financiera'
    ]),
    buttonExcluirTabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Excluir Tabela de Evolução do Valor de Resgate',
        /*pt-pt*/'Excluir Tabela de Evolução do Valor de Resgate',
        /*en-us*/'Delete Redemption Value Evolution Table',
        /*es-es*/'Eliminar Tabla de Evolución del Valor de Rescate'
    ]),
    buttonVisualizarTabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Visualizar Tabela de Evolução do Valor de Resgate',
        /*pt-pt*/'Visualizar Tabela de Evolução do Valor de Resgate',
        /*en-us*/'View Redemption Value Evolution Table',
        /*es-es*/'Visualizar Tabla de Evolución del Valor de Rescate'
    ]),
    buttonVisualizarDiagnosticoAposentadoriaIndependenciaFinanceira: traduzir([
        /*pt-br*/'Gráfico Diagnóstico Aposentadoria',
        /*pt-pt*/'Gráfico Diagnóstico Aposentação',
        /*en-us*/'Retirement Diagnostic Chart',
        /*es-es*/'Gráfico Diagnóstico Jubilación'
    ]),
    buttonReinicializarCenarios: traduzir([
        /*pt-br*/'Reinicializar Cenários',
        /*pt-pt*/'Reinicializar Cenários',
        /*en-us*/'Reset Scenarios',
        /*es-es*/'Restablecer escenarios'
    ]),
    confirmaReinicializacaoCenarios: traduzir([
        /*pt-br*/'Confirma a Reinicialização dos Cenários',
        /*pt-pt*/'Confirma a Reinicialização dos Cenários',
        /*en-us*/'Confirm Scenario Reset',
        /*es-es*/'Confirmar el restablecimiento de escenarios'
    ]),
    buttonReordenarCenarios: traduzir([
        /*pt-br*/'Reordenar Cenários',
        /*pt-pt*/'Reordenar Cenários',
        /*en-us*/'Reorder Scenarios',
        /*es-es*/'Reordenar Escenarios'
    ]),
    buttonVisualizarComparacaoCenarios: traduzir([
        /*pt-br*/'Comparação de Cenários',
        /*pt-pt*/'Comparação de Cenários',
        /*en-us*/'Scenario Comparison',
        /*es-es*/'Comparación de Escenarios'
    ]),
    buttonVisualizarComparacaoEstudos: traduzir([
        /*pt-br*/'Comparação de Estudos',
        /*pt-pt*/'Comparação de Estudos',
        /*en-us*/'Study Comparison',
        /*es-es*/'Comparación de Estudios'
    ]),
    buttonDetalhesCotacaoSeguroVidaSucessaoVitalicia: traduzir([
        /*pt-br*/'Cotação de Seguro de Vida para Sucessão Patrimonial',
        /*pt-pt*/'Cotação de Seguro de Vida para Sucessão Patrimonial',
        /*en-us*/'Life Insurance Quote for Estate Succession',
        /*es-es*/'Cotización de Seguro de Vida para Sucesión Patrimonial'
    ]),
    buttonDadosBasicos: traduzir([
        /*pt-br*/'Dados Básicos',
        /*pt-pt*/'Dados Básicos',
        /*en-us*/'Basic Data',
        /*es-es*/'Datos Básicos'
    ]),
    buttonVisualizarGrafico: traduzir([
        /*pt-br*/'Visualizar Gráfico',
        /*pt-pt*/'Visualizar Gráfico',
        /*en-us*/'View Chart',
        /*es-es*/'Visualizar Gráfico'
    ]),
    buttonVisualizarTabela: traduzir([
        /*pt-br*/'Visualizar Tabela',
        /*pt-pt*/'Visualizar Tabela',
        /*en-us*/'View Table',
        /*es-es*/'Visualizar Tabla'
    ]),
    buttonVisualizarApolices: traduzir([
        /*pt-br*/'Visualizar as Apólices',
        /*pt-pt*/'Visualizar as Apólices',
        /*en-us*/'View Policies',
        /*es-es*/'Ver Pólizas'
    ]),
    buttonVisualizarResumo: traduzir([
        /*pt-br*/'Visualizar Resumo',
        /*pt-pt*/'Visualizar Resumo',
        /*en-us*/'View Summary',
        /*es-es*/'Visualizar Resumen'
    ]),
    buttonVisualizarParcelas: traduzir([
        /*pt-br*/'Visualizar Parcelas',
        /*pt-pt*/'Visualizar Parcelas',
        /*en-us*/'View Installments',
        /*es-es*/'Ver cuotas'
    ]),
    buttonVisualizarIncluirComparacaoFinanciamento: traduzir([
        /*pt-br*/'Incluir na Comparação',
        /*pt-pt*/'Incluir na Comparação',
        /*en-us*/'Include in Comparison',
        /*es-es*/'Incluir en la Comparación'
    ]),
    buttonAlterarParametros: traduzir([
        /*pt-br*/'Alterar Parâmetros',
        /*pt-pt*/'Alterar Parâmetros',
        /*en-us*/'Modify Parameters',
        /*es-es*/'Modificar Parámetros'
    ]),
    buttonAlterarHipotesesFinanceiras: traduzir([
        /*pt-br*/'Alterar Hipóteses Financeiras',
        /*pt-pt*/'Alterar Hipóteses Financeiras',
        /*en-us*/'Modify Financial Assumptions',
        /*es-es*/'Modificar Hipótesis Financieras'
    ]),
    buttonIncluirAporteRetiradaMensal: traduzir([
        /*pt-br*/'+ Aporte/Retirada Mensal',
        /*pt-pt*/'+ Aporte/Retirada Mensal',
        /*en-us*/'+ Monthly Contribution/Withdrawal',
        /*es-es*/'+ Aporte/Retiro Mensual'
    ]),
    buttonIncluirAporteRetiradaAnual: traduzir([
        /*pt-br*/'+ Aporte/Retirada Anual',
        /*pt-pt*/'+ Aporte/Retirada Anual',
        /*en-us*/'+ Annual Contribution/Withdrawal',
        /*es-es*/'+ Aporte/Retiro Anual'
    ]),

    buttonVisualizarGraficoMapaFinanceiro: traduzir([
        /*pt-br*/'Visualizar o Gráfico do Mapa Financeiro',
        /*pt-pt*/'Visualizar o Gráfico do Mapa Financeiro',
        /*en-us*/'View Financial Map Chart',
        /*es-es*/'Visualizar el Gráfico del Mapa Financiero'
    ]),

    buttonFundosPrevidenciaPrivada: traduzir([
        /*pt-br*/'Fundos Previdência',
        /*pt-pt*/'Fundos Previdência',
        /*en-us*/'Pension Funds',
        /*es-es*/'Fondos de Previsión'
    ]),

    

    buttonVisualizarPDF: traduzir([
        /*pt-br*/'Visualizar o PDF',
        /*pt-pt*/'Visualizar o PDF',
        /*en-us*/'View PDF',
        /*es-es*/'Visualizar el PDF'
    ]),
    buttonVisualizarPDFInstitucional: traduzir([
        /*pt-br*/'Institucional',
        /*pt-pt*/'Institucional',
        /*en-us*/'Institutional',
        /*es-es*/'Institucional'
    ]),
    buttonVisualizarPDFTipoCarteiraInvestimento: traduzir([
        /*pt-br*/'Visualizar PDF do Tipo da Carteira',
        /*pt-pt*/'Visualizar PDF do Tipo da Carteira',
        /*en-us*/'View Portfolio Type PDF',
        /*es-es*/'Visualizar PDF del Tipo de Cartera'
    ]),
    buttonVisualizarPDFTipoPoliticaInvestimento: traduzir([
        /*pt-br*/'Visualizar PDF da Política de Investimento',
        /*pt-pt*/'Visualizar PDF da Política de Investimento',
        /*en-us*/'View Investment Policy PDF',
        /*es-es*/'Visualizar PDF de la Política de Inversión'
    ]),

    buttonReobterTemplate: traduzir([
        /*pt-br*/'Reobter o Template',
        /*pt-pt*/'Reobter o Modelo',
        /*en-us*/'Get Template Again',
        /*es-es*/'Recargar la Plantilla'
    ]),

    buttonDetalhesCalculo: traduzir([
        /*pt-br*/'Detalhes do Cálculo',
        /*pt-pt*/'Detalhes do Cálculo',
        /*en-us*/'Calculation Details',
        /*es-es*/'Detalles del Cálculo'
    ]),

    buttonVerTabelaEvolucaoValorResgate: traduzir([
        /*pt-br*/'Ver Tabela Resgate',
        /*pt-pt*/'Ver Tabela do Resgate',
        /*en-us*/'View Redemption Table',
        /*es-es*/'Ver Tabla de Rescate'
    ]),
    buttonVerTabelaEvolucaoCS: traduzir([
        /*pt-br*/'Ver Tabela Capital Segurado',
        /*pt-pt*/'Ver Tabela de Capital Seguro',
        /*en-us*/'View Insured Capital Table',
        /*es-es*/'Ver Tabla de Capital Asegurado'
    ]),
    buttonVerTabelaEvolucaoCancelamentoApolice: traduzir([
        /*pt-br*/'Ver Tabela Cancelamento',
        /*pt-pt*/'Ver Tabela de Cancelamento',
        /*en-us*/'View Cancellation Table',
        /*es-es*/'Ver Tabla de Cancelación'
    ]),

    buttonVerResumoParcelas: traduzir([
        /*pt-br*/'Ver Resumo Parcelas',
        /*pt-pt*/'Ver Resumo das Prestações',
        /*en-us*/'View Installment Summary',
        /*es-es*/'Ver Resumen de Cuotas'
    ]),
    buttonVerParcelasMesAMes: traduzir([
        /*pt-br*/'Ver Parcelas Mês a Mês',
        /*pt-pt*/'Ver Parcelas Mês a Mês',
        /*en-us*/'View Month-by-Month Installments',
        /*es-es*/'Ver Cuotas Mes a Mes'
    ]),

    buttonAtualizarCamposCalculadosConfiguracaoNovaVersao: traduzir([
        /*pt-br*/'Atualizar campos calculados Configuração',
        /*pt-pt*/'Atualizar campos calculados Configuração',
        /*en-us*/'Update Configuration Calculated Fields',
        /*es-es*/'Actualizar campos calculados Configuración'
    ]),
    buttonAtualizarCamposCalculadosClienteNovaVersao: traduzir([
        /*pt-br*/'Atualizar campos calculados Clientes',
        /*pt-pt*/'Atualizar campos calculados Clientes',
        /*en-us*/'Update Client Calculated Fields',
        /*es-es*/'Actualizar campos calculados Clientes'
    ]),
    buttonAtualizarCamposCalculadosUsuarioNovaVersao: traduzir([
        /*pt-br*/'Atualizar campos calculados Usuários',
        /*pt-pt*/'Atualizar campos calculados Utilizadores',
        /*en-us*/'Update User Calculated Fields',
        /*es-es*/'Actualizar campos calculados Usuarios'
    ]),

    buttonGerarCobranca: traduzir([
        /*pt-br*/'Gerar Cobrança',
        /*pt-pt*/'Gerar Cobrança',
        /*en-us*/'Generate Billing',
        /*es-es*/'Generar Cobranza'
    ]),
    buttonEfetuarCobranca: traduzir([
        /*pt-br*/'Efetuar Cobrança',
        /*pt-pt*/'Efetuar Cobrança',
        /*en-us*/'Process Billing',
        /*es-es*/'Efectuar Cobranza'
    ]),
    buttonAcompanharCobranca: traduzir([
        /*pt-br*/'Acompanhar Cobrança',
        /*pt-pt*/'Acompanhar Cobrança',
        /*en-us*/'Track Billing',
        /*es-es*/'Seguir Cobranza'
    ]),
    buttonCalcularVariavel: traduzir([
        /*pt-br*/'Calcular Variável',
        /*pt-pt*/'Calcular Variável',
        /*en-us*/'Calculate Variable',
        /*es-es*/'Calcular Variable'
    ]),

    buttonEnviarLembreteAporte: traduzir([
        /*pt-br*/'Enviar lembretes dos Aportes',
        /*pt-pt*/'Enviar lembretes dos Aportes',
        /*en-us*/'Send Contribution Reminders',
        /*es-es*/'Enviar recordatorios de los Aportes'
    ]),

    buttonGerarPDF: traduzir([
        /*pt-br*/'Gerar PDF',
        /*pt-pt*/'Gerar PDF',
        /*en-us*/'Generate PDF',
        /*es-es*/'Generar PDF'
    ]),
    buttonGerarPDFEnviarEmail: traduzir([
        /*pt-br*/'Gerar PDF / Enviar E-mail',
        /*pt-pt*/'Gerar PDF / Enviar E-mail',
        /*en-us*/'Generate PDF / Send Email',
        /*es-es*/'Generar PDF / Enviar Correo'
    ]),

    buttonIncluirPendencia: traduzir([
        /*pt-br*/'+ Pendência',
        /*pt-pt*/'+ Pendência',
        /*en-us*/'+ Pending Item',
        /*es-es*/'+ Pendencia'
    ]),

    buttonIncluirAnotacao: traduzir([
        /*pt-br*/'+ Anotação',
        /*pt-pt*/'+ Anotação',
        /*en-us*/'+ Note',
        /*es-es*/'+ Anotación'
    ]),

    iconButtonEditar: traduzir([
        /*pt-br*/'Editar',
        /*pt-pt*/'Editar',
        /*en-us*/'Edit',
        /*es-es*/'Editar'
    ]),
    iconButtonVerDetalhes: traduzir([
        /*pt-br*/'Ver Detalhes',
        /*pt-pt*/'Ver Detalhes',
        /*en-us*/'View Details',
        /*es-es*/'Ver Detalles'
    ]),
    iconButtonCopiar: traduzir([
        /*pt-br*/'Copiar',
        /*pt-pt*/'Copiar',
        /*en-us*/'Copy',
        /*es-es*/'Copiar'
    ]),
    iconButtonDuplicar: traduzir([
        /*pt-br*/'Duplicar',
        /*pt-pt*/'Duplicar',
        /*en-us*/'Duplicate',
        /*es-es*/'Duplicar'
    ]),
    iconButtonTransferir: traduzir([
        /*pt-br*/'Transferir',
        /*pt-pt*/'Transferir',
        /*en-us*/'Transfer',
        /*es-es*/'Transferir'
    ]),
    iconButtonClearEntradaDados: traduzir([
        /*pt-br*/'Excluir',
        /*pt-pt*/'Excluir',
        /*en-us*/'Delete',
        /*es-es*/'Eliminar'
    ]),
    iconButtonClearDialog: traduzir([
        /*pt-br*/'Fechar',
        /*pt-pt*/'Fechar',
        /*en-us*/'Close',
        /*es-es*/'Cerrar'
    ]),
    iconButtonClear: traduzir([
        /*pt-br*/'Limpar',
        /*pt-pt*/'Limpar',
        /*en-us*/'Clear',
        /*es-es*/'Limpiar'
    ]),
    iconButtonVersao: traduzir([
        /*pt-br*/'Versões',
        /*pt-pt*/'Versões',
        /*en-us*/'Versions',
        /*es-es*/'Versiones'
    ]),
    iconButtonModoApresentacao: traduzir([
        /*pt-br*/'Modo Apresentação',
        /*pt-pt*/'Modo Apresentação',
        /*en-us*/'Presentation Mode',
        /*es-es*/'Modo Presentación'
    ]),
    modoApresentacaoPaginaAnterior: traduzir([
        /*pt-br*/'Página Anterior',
        /*pt-pt*/'Página Anterior',
        /*en-us*/'Previous Page',
        /*es-es*/'Página Anterior'
    ]),
    modoApresentacaoProximaPagina: traduzir([
        /*pt-br*/'Próxima Página',
        /*pt-pt*/'Próxima Página',
        /*en-us*/'Next Page',
        /*es-es*/'Página Siguiente'
    ]),
    iconButtonFiltrar: traduzir([
        /*pt-br*/'Filtro',
        /*pt-pt*/'Filtro',
        /*en-us*/'Filter',
        /*es-es*/'Filtro'
    ]),
    iconButtonImprimir: traduzir([
        /*pt-br*/'Imprimir',
        /*pt-pt*/'Imprimir',
        /*en-us*/'Print',
        /*es-es*/'Imprimir'
    ]),
    iconButtonExpandMore: traduzir([
        /*pt-br*/'Expandir',
        /*pt-pt*/'Expandir',
        /*en-us*/'Expand',
        /*es-es*/'Expandir'
    ]),
    iconButtonExpandMoreAll: traduzir([
        /*pt-br*/'Expandir Todos',
        /*pt-pt*/'Expandir Todos',
        /*en-us*/'Expand All',
        /*es-es*/'Expandir Todos'
    ]),
    iconButtonExpandLess: traduzir([
        /*pt-br*/'Minimizar',
        /*pt-pt*/'Minimizar',
        /*en-us*/'Minimize',
        /*es-es*/'Minimizar'
    ]),
    iconButtonExpandLessAll: traduzir([
        /*pt-br*/'Minimizar Todos',
        /*pt-pt*/'Minimizar Todos',
        /*en-us*/'Minimize All',
        /*es-es*/'Minimizar Todos'
    ]),
    iconButtonWhatsApp: traduzir([
        /*pt-br*/'WhatsApp',
        /*pt-pt*/'WhatsApp',
        /*en-us*/'WhatsApp',
        /*es-es*/'WhatsApp'
    ]),

    confirmaExclusao: traduzir([
        /*pt-br*/'Confirma exclusão ?',
        /*pt-pt*/'Confirma exclusão?',
        /*en-us*/'Confirm deletion?',
        /*es-es*/'¿Confirma eliminación?'
    ]),
    sim: traduzir([
        /*pt-br*/'Sim',
        /*pt-pt*/'Sim',
        /*en-us*/'Yes',
        /*es-es*/'Sí'
    ]),
    nao: traduzir([
        /*pt-br*/'Não',
        /*pt-pt*/'Não',
        /*en-us*/'No',
        /*es-es*/'No'
    ]),
    ok: traduzir([
        /*pt-br*/'OK',
        /*pt-pt*/'OK',
        /*en-us*/'OK',
        /*es-es*/'OK'
    ]),

    paginaAnterior: traduzir([
        /*pt-br*/'Página Anterior',
        /*pt-pt*/'Página Anterior',
        /*en-us*/'Previous Page',
        /*es-es*/'Página Anterior'
    ]),
    proximaPagina: traduzir([
        /*pt-br*/'Próxima Página',
        /*pt-pt*/'Próxima Página',
        /*en-us*/'Next Page',
        /*es-es*/'Página Siguiente'
    ]),
    zoomOut: traduzir([
        /*pt-br*/'Reduzir o Zoom',
        /*pt-pt*/'Reduzir o Zoom',
        /*en-us*/'Zoom Out',
        /*es-es*/'Reducir Zoom'
    ]),
    zoomIn: traduzir([
        /*pt-br*/'Aumentar Zoom',
        /*pt-pt*/'Aumentar Zoom',
        /*en-us*/'Zoom In',
        /*es-es*/'Aumentar Zoom'
    ]),
    downloadPDF: traduzir([
        /*pt-br*/'Download PDF',
        /*pt-pt*/'Descarregar PDF',
        /*en-us*/'Download PDF',
        /*es-es*/'Descargar PDF'
    ]),
    imprimirPDF: traduzir([
        /*pt-br*/'Imprimir PDF',
        /*pt-pt*/'Imprimir PDF',
        /*en-us*/'Print PDF',
        /*es-es*/'Imprimir PDF'
    ]),

    MUIDataTableNoMatch: traduzir([
        /*pt-br*/'Nenhum registro foi encontrado',
        /*pt-pt*/'Nenhum registo foi encontrado',
        /*en-us*/'No records found',
        /*es-es*/'No se encontraron registros'
    ]),
    MUIDataTableToolTip: traduzir([
        /*pt-br*/'Ordenação',
        /*pt-pt*/'Ordenação',
        /*en-us*/'Sort',
        /*es-es*/'Ordenar'
    ]),
    MUIDataTableColumnHeaderTooltip: traduzir([
        /*pt-br*/'Ordenador por',
        /*pt-pt*/'Ordenar por',
        /*en-us*/'Sort by',
        /*es-es*/'Ordenar por'
    ]),
    MUIDataTablePaginationNext: traduzir([
        /*pt-br*/'Próxima Página',
        /*pt-pt*/'Próxima Página',
        /*en-us*/'Next Page',
        /*es-es*/'Página Siguiente'
    ]),
    MUIDataTablePaginationPrevious: traduzir([
        /*pt-br*/'Página Anterior',
        /*pt-pt*/'Página Anterior',
        /*en-us*/'Previous Page',
        /*es-es*/'Página Anterior'
    ]),
    MUIDataTablePaginationRowsPerPage: traduzir([
        /*pt-br*/'Linhas por Página:',
        /*pt-pt*/'Linhas por Página:',
        /*en-us*/'Rows per page:',
        /*es-es*/'Filas por página:'
    ]),
    MUIDataTablePaginationDisplayRows: traduzir([
        /*pt-br*/'de',
        /*pt-pt*/'de',
        /*en-us*/'of',
        /*es-es*/'de'
    ]),
    MUIDataTablePaginationJumpToPage: traduzir([
        /*pt-br*/'Ir para página:',
        /*pt-pt*/'Ir para página:',
        /*en-us*/'Go to page:',
        /*es-es*/'Ir a página:'
    ]),
    MUIDataTableToolbarSearch: traduzir([
        /*pt-br*/'Pesquisa',
        /*pt-pt*/'Pesquisa',
        /*en-us*/'Search',
        /*es-es*/'Buscar'
    ]),
    MUIDataTableToolbarDownloadCsv: traduzir([
        /*pt-br*/'Download CSV',
        /*pt-pt*/'Descarregar CSV',
        /*en-us*/'Download CSV',
        /*es-es*/'Descargar CSV'
    ]),
    MUIDataTableToolbarPrint: traduzir([
        /*pt-br*/'Imprimir',
        /*pt-pt*/'Imprimir',
        /*en-us*/'Print',
        /*es-es*/'Imprimir'
    ]),
    MUIDataTableToolbarViewColumns: traduzir([
        /*pt-br*/'Ver Colunas',
        /*pt-pt*/'Ver Colunas',
        /*en-us*/'View Columns',
        /*es-es*/'Ver Columnas'
    ]),
    MUIDataTableToolbarFilterTable: traduzir([
        /*pt-br*/'Filtrar',
        /*pt-pt*/'Filtrar',
        /*en-us*/'Filter',
        /*es-es*/'Filtrar'
    ]),
    MUIDataTableFilterAll: traduzir([
        /*pt-br*/'Todos',
        /*pt-pt*/'Todos',
        /*en-us*/'All',
        /*es-es*/'Todos'
    ]),
    MUIDataTableFilterTitle: traduzir([
        /*pt-br*/'Filtros',
        /*pt-pt*/'Filtros',
        /*en-us*/'Filters',
        /*es-es*/'Filtros'
    ]),
    MUIDataTableFilterReset: traduzir([
        /*pt-br*/'Limpar',
        /*pt-pt*/'Limpar',
        /*en-us*/'Reset',
        /*es-es*/'Limpiar'
    ]),
    MUIDataTableViewColumnsTitle: traduzir([
        /*pt-br*/'Mostrar Colunas',
        /*pt-pt*/'Mostrar Colunas',
        /*en-us*/'Show Columns',
        /*es-es*/'Mostrar Columnas'
    ]),
    MUIDataTableViewColumnsTitleAria: traduzir([
        /*pt-br*/'Mostrar/Esconder Colunas da Tabela',
        /*pt-pt*/'Mostrar/Esconder Colunas da Tabela',
        /*en-us*/'Show/Hide Table Columns',
        /*es-es*/'Mostrar/Ocultar Columnas de la Tabla'
    ]),
    MUIDataTableSelectedRowsText: traduzir([
        /*pt-br*/'linha(s) selecionadas',
        /*pt-pt*/'linha(s) selecionadas',
        /*en-us*/'row(s) selected',
        /*es-es*/'fila(s) seleccionadas'
    ]),
    MUIDataTableSelectedRowsDelete: traduzir([
        /*pt-br*/'Deletar',
        /*pt-pt*/'Eliminar',
        /*en-us*/'Delete',
        /*es-es*/'Eliminar'
    ]),
    MUIDataTableSelectedRowseleteAria: traduzir([
        /*pt-br*/'Deleta Linhas Selecionadas',
        /*pt-pt*/'Eliminar Linhas Selecionadas',
        /*en-us*/'Delete Selected Rows',
        /*es-es*/'Eliminar Filas Seleccionadas'
    ]),

    MultiSelectAllItemsAreSelected: traduzir([
        /*pt-br*/'Todos $1$ foram selecionados',
        /*pt-pt*/'Todos $1$ foram selecionados',
        /*en-us*/'All $1$ are selected',
        /*es-es*/'Todos $1$ están seleccionados'
    ]),
    MultiSelectClearSearch: traduzir([
        /*pt-br*/'Limpar Pesquisa',
        /*pt-pt*/'Limpar Pesquisa',
        /*en-us*/'Clear Search',
        /*es-es*/'Limpiar Búsqueda'
    ]),
    MultiSelectClearSelected: traduzir([
        /*pt-br*/'Limpar Selecionados',
        /*pt-pt*/'Limpar Selecionados',
        /*en-us*/'Clear Selected',
        /*es-es*/'Limpiar Seleccionados'
    ]),
    MultiSelectNoOptions: traduzir([
        /*pt-br*/'Nenhuma opção',
        /*pt-pt*/'Nenhuma opção',
        /*en-us*/'No options',
        /*es-es*/'Sin opciones'
    ]),
    MultiSelectSearch: traduzir([
        /*pt-br*/'Pesquisar',
        /*pt-pt*/'Pesquisar',
        /*en-us*/'Search',
        /*es-es*/'Buscar'
    ]),
    MultiSelectSelectAll: traduzir([
        /*pt-br*/'Selecionar Todos',
        /*pt-pt*/'Selecionar Todos',
        /*en-us*/'Select All',
        /*es-es*/'Seleccionar Todos'
    ]),
    MultiSelectSelectAllFiltered: traduzir([
        /*pt-br*/'Selecionar Todos (Filtrados)',
        /*pt-pt*/'Selecionar Todos (Filtrados)',
        /*en-us*/'Select All (Filtered)',
        /*es-es*/'Seleccionar Todos (Filtrados)'
    ]),
    MultiSelectCreate: traduzir([
        /*pt-br*/'Criar',
        /*pt-pt*/'Criar',
        /*en-us*/'Create',
        /*es-es*/'Crear'
    ]),

    impressao: traduzir([
        /*pt-br*/'(impressão)',
        /*pt-pt*/'(impressão)',
        /*en-us*/'(print)',
        /*es-es*/'(impresión)'
    ]),



    //MESSAGE
    //-------
    messageAlertaInformacoesNaoSalvas: traduzir([
        /*pt-br*/'Existem informações que não foram salvas. Você quer sair sem salvar?',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    messageObrigatorio: traduzir([
        /*pt-br*/'obrigatório',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    messageCampoImportanteITCMD: traduzir([
        /*pt-br*/'importante para a obtenção da alíquota do ITCMD no cálculo do Inventário',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
    messageCampoDesejavel: traduzir([
        /*pt-br*/'desejável',
        /*pt-pt*/'',
        /*en-us*/'',
        /*es-es*/''
    ]),
}

export default LABEL